import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  BlogPostComponentsDynamicZoneInput: any;
  Date: any;
  DateTime: any;
  GameBookingSlotRulesDynamicZoneInput: any;
  GameScheduledPriceDynamicZoneInput: any;
  I18NLocaleCode: any;
  JSON: any;
  MenuPageLeftColumnContentDynamicZoneInput: any;
  MenuPageRightColumnContentDynamicZoneInput: any;
  PageComponentsDynamicZoneInput: any;
  ProductScheduledPriceDynamicZoneInput: any;
  ReactionsReactionCountEntity: any;
  ReactionsReactionStateEntity: any;
  ReusableComponentComponentsDynamicZoneInput: any;
  RoomBookingSlotRulesDynamicZoneInput: any;
  Time: any;
  Upload: any;
  UsersPermissionsUserBookingSlotRulesDynamicZoneInput: any;
};

export type AccessCard = {
  __typename?: 'AccessCard';
  createdAt?: Maybe<Scalars['DateTime']>;
  credit_changes?: Maybe<CreditChangeRelationResponseCollection>;
  owner?: Maybe<UsersPermissionsUserEntityResponse>;
  publishedAt?: Maybe<Scalars['DateTime']>;
  rfid: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};


export type AccessCardCredit_ChangesArgs = {
  filters?: InputMaybe<CreditChangeFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type AccessCardEntity = {
  __typename?: 'AccessCardEntity';
  attributes?: Maybe<AccessCard>;
  id?: Maybe<Scalars['ID']>;
};

export type AccessCardEntityResponse = {
  __typename?: 'AccessCardEntityResponse';
  data?: Maybe<AccessCardEntity>;
};

export type AccessCardEntityResponseCollection = {
  __typename?: 'AccessCardEntityResponseCollection';
  data: Array<AccessCardEntity>;
  meta: ResponseCollectionMeta;
};

export type AccessCardFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<AccessCardFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  credit_changes?: InputMaybe<CreditChangeFiltersInput>;
  id?: InputMaybe<IdFilterInput>;
  not?: InputMaybe<AccessCardFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<AccessCardFiltersInput>>>;
  owner?: InputMaybe<UsersPermissionsUserFiltersInput>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  rfid?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type AccessCardInput = {
  credit_changes?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  owner?: InputMaybe<Scalars['ID']>;
  publishedAt?: InputMaybe<Scalars['DateTime']>;
  rfid?: InputMaybe<Scalars['String']>;
};

export type AccessCardRelationResponseCollection = {
  __typename?: 'AccessCardRelationResponseCollection';
  data: Array<AccessCardEntity>;
};

export type AccessGroup = {
  __typename?: 'AccessGroup';
  access_minutes: Scalars['Int'];
  createdAt?: Maybe<Scalars['DateTime']>;
  games?: Maybe<GameRelationResponseCollection>;
  publishedAt?: Maybe<Scalars['DateTime']>;
  title: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
  user_access_groups?: Maybe<UserAccessGroupRelationResponseCollection>;
};


export type AccessGroupGamesArgs = {
  filters?: InputMaybe<GameFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type AccessGroupUser_Access_GroupsArgs = {
  filters?: InputMaybe<UserAccessGroupFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type AccessGroupEntity = {
  __typename?: 'AccessGroupEntity';
  attributes?: Maybe<AccessGroup>;
  id?: Maybe<Scalars['ID']>;
};

export type AccessGroupEntityResponse = {
  __typename?: 'AccessGroupEntityResponse';
  data?: Maybe<AccessGroupEntity>;
};

export type AccessGroupEntityResponseCollection = {
  __typename?: 'AccessGroupEntityResponseCollection';
  data: Array<AccessGroupEntity>;
  meta: ResponseCollectionMeta;
};

export type AccessGroupFiltersInput = {
  access_minutes?: InputMaybe<IntFilterInput>;
  and?: InputMaybe<Array<InputMaybe<AccessGroupFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  games?: InputMaybe<GameFiltersInput>;
  id?: InputMaybe<IdFilterInput>;
  not?: InputMaybe<AccessGroupFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<AccessGroupFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  title?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  user_access_groups?: InputMaybe<UserAccessGroupFiltersInput>;
};

export type AccessGroupInput = {
  access_minutes?: InputMaybe<Scalars['Int']>;
  games?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']>;
  title?: InputMaybe<Scalars['String']>;
  user_access_groups?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

export type AccessGroupRelationResponseCollection = {
  __typename?: 'AccessGroupRelationResponseCollection';
  data: Array<AccessGroupEntity>;
};

export type Achievement = {
  __typename?: 'Achievement';
  createdAt?: Maybe<Scalars['DateTime']>;
  name: Scalars['String'];
  points_to_allocate?: Maybe<Scalars['Int']>;
  slug?: Maybe<Scalars['String']>;
  type: Enum_Achievement_Type;
  updatedAt?: Maybe<Scalars['DateTime']>;
  user_achievements?: Maybe<UserAchievementRelationResponseCollection>;
};


export type AchievementUser_AchievementsArgs = {
  filters?: InputMaybe<UserAchievementFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type AchievementEntity = {
  __typename?: 'AchievementEntity';
  attributes?: Maybe<Achievement>;
  id?: Maybe<Scalars['ID']>;
};

export type AchievementEntityResponse = {
  __typename?: 'AchievementEntityResponse';
  data?: Maybe<AchievementEntity>;
};

export type AchievementEntityResponseCollection = {
  __typename?: 'AchievementEntityResponseCollection';
  data: Array<AchievementEntity>;
  meta: ResponseCollectionMeta;
};

export type AchievementFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<AchievementFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<AchievementFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<AchievementFiltersInput>>>;
  points_to_allocate?: InputMaybe<IntFilterInput>;
  slug?: InputMaybe<StringFilterInput>;
  type?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  user_achievements?: InputMaybe<UserAchievementFiltersInput>;
};

export type AchievementInput = {
  name?: InputMaybe<Scalars['String']>;
  points_to_allocate?: InputMaybe<Scalars['Int']>;
  slug?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Enum_Achievement_Type>;
  user_achievements?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

export type AchievementRelationResponseCollection = {
  __typename?: 'AchievementRelationResponseCollection';
  data: Array<AchievementEntity>;
};

export type ActiveCampaignAcContactTag = {
  __typename?: 'ActiveCampaignAcContactTag';
  acId?: Maybe<Scalars['String']>;
  contact?: Maybe<ContactEntityResponse>;
  createdAt?: Maybe<Scalars['DateTime']>;
  tag?: Maybe<ActiveCampaignAcTagEntityResponse>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ActiveCampaignAcTag = {
  __typename?: 'ActiveCampaignAcTag';
  acId?: Maybe<Scalars['String']>;
  auto_assign_on_action?: Maybe<Enum_Activecampaignactag_Auto_Assign_On_Action>;
  auto_remove_on_action?: Maybe<Enum_Activecampaignactag_Auto_Remove_On_Action>;
  camp_memb_avatars?: Maybe<CampaignMemberAvatarRelationResponseCollection>;
  camp_memb_avatars_remove?: Maybe<CampaignMemberAvatarRelationResponseCollection>;
  campaign_member_statuses?: Maybe<CrmCampaignMemberStatusRelationResponseCollection>;
  campaign_member_statuses_remove?: Maybe<CrmCampaignMemberStatusRelationResponseCollection>;
  contacts?: Maybe<ContactRelationResponseCollection>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crm_task_feedbacks?: Maybe<CrmTaskFeedbackRelationResponseCollection>;
  crm_task_feedbacks_remove?: Maybe<CrmTaskFeedbackRelationResponseCollection>;
  description?: Maybe<Scalars['String']>;
  games?: Maybe<GameRelationResponseCollection>;
  name: Scalars['String'];
  notification_requests?: Maybe<NotificationsNotificationRequestRelationResponseCollection>;
  products?: Maybe<ProductRelationResponseCollection>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  users?: Maybe<UsersPermissionsUserRelationResponseCollection>;
};


export type ActiveCampaignAcTagCamp_Memb_AvatarsArgs = {
  filters?: InputMaybe<CampaignMemberAvatarFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type ActiveCampaignAcTagCamp_Memb_Avatars_RemoveArgs = {
  filters?: InputMaybe<CampaignMemberAvatarFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type ActiveCampaignAcTagCampaign_Member_StatusesArgs = {
  filters?: InputMaybe<CrmCampaignMemberStatusFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type ActiveCampaignAcTagCampaign_Member_Statuses_RemoveArgs = {
  filters?: InputMaybe<CrmCampaignMemberStatusFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type ActiveCampaignAcTagContactsArgs = {
  filters?: InputMaybe<ContactFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type ActiveCampaignAcTagCrm_Task_FeedbacksArgs = {
  filters?: InputMaybe<CrmTaskFeedbackFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type ActiveCampaignAcTagCrm_Task_Feedbacks_RemoveArgs = {
  filters?: InputMaybe<CrmTaskFeedbackFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type ActiveCampaignAcTagGamesArgs = {
  filters?: InputMaybe<GameFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type ActiveCampaignAcTagNotification_RequestsArgs = {
  filters?: InputMaybe<NotificationsNotificationRequestFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type ActiveCampaignAcTagProductsArgs = {
  filters?: InputMaybe<ProductFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type ActiveCampaignAcTagUsersArgs = {
  filters?: InputMaybe<UsersPermissionsUserFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ActiveCampaignAcTagEntity = {
  __typename?: 'ActiveCampaignAcTagEntity';
  attributes?: Maybe<ActiveCampaignAcTag>;
  id?: Maybe<Scalars['ID']>;
};

export type ActiveCampaignAcTagEntityResponse = {
  __typename?: 'ActiveCampaignAcTagEntityResponse';
  data?: Maybe<ActiveCampaignAcTagEntity>;
};

export type ActiveCampaignAcTagEntityResponseCollection = {
  __typename?: 'ActiveCampaignAcTagEntityResponseCollection';
  data: Array<ActiveCampaignAcTagEntity>;
  meta: ResponseCollectionMeta;
};

export type ActiveCampaignAcTagFiltersInput = {
  acId?: InputMaybe<StringFilterInput>;
  and?: InputMaybe<Array<InputMaybe<ActiveCampaignAcTagFiltersInput>>>;
  auto_assign_on_action?: InputMaybe<StringFilterInput>;
  auto_remove_on_action?: InputMaybe<StringFilterInput>;
  camp_memb_avatars?: InputMaybe<CampaignMemberAvatarFiltersInput>;
  camp_memb_avatars_remove?: InputMaybe<CampaignMemberAvatarFiltersInput>;
  campaign_member_statuses?: InputMaybe<CrmCampaignMemberStatusFiltersInput>;
  campaign_member_statuses_remove?: InputMaybe<CrmCampaignMemberStatusFiltersInput>;
  contacts?: InputMaybe<ContactFiltersInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  crm_task_feedbacks?: InputMaybe<CrmTaskFeedbackFiltersInput>;
  crm_task_feedbacks_remove?: InputMaybe<CrmTaskFeedbackFiltersInput>;
  description?: InputMaybe<StringFilterInput>;
  games?: InputMaybe<GameFiltersInput>;
  id?: InputMaybe<IdFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ActiveCampaignAcTagFiltersInput>;
  notification_requests?: InputMaybe<NotificationsNotificationRequestFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ActiveCampaignAcTagFiltersInput>>>;
  products?: InputMaybe<ProductFiltersInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  users?: InputMaybe<UsersPermissionsUserFiltersInput>;
};

export type ActiveCampaignAcTagRelationResponseCollection = {
  __typename?: 'ActiveCampaignAcTagRelationResponseCollection';
  data: Array<ActiveCampaignAcTagEntity>;
};

export type ActiveCampaignAcUserTag = {
  __typename?: 'ActiveCampaignAcUserTag';
  acId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  tag?: Maybe<ActiveCampaignAcTagEntityResponse>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<UsersPermissionsUserEntityResponse>;
};

export type Allergen = {
  __typename?: 'Allergen';
  createdAt?: Maybe<Scalars['DateTime']>;
  ingredients?: Maybe<IngredientRelationResponseCollection>;
  name: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};


export type AllergenIngredientsArgs = {
  filters?: InputMaybe<IngredientFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type AllergenEntity = {
  __typename?: 'AllergenEntity';
  attributes?: Maybe<Allergen>;
  id?: Maybe<Scalars['ID']>;
};

export type AllergenEntityResponse = {
  __typename?: 'AllergenEntityResponse';
  data?: Maybe<AllergenEntity>;
};

export type AllergenEntityResponseCollection = {
  __typename?: 'AllergenEntityResponseCollection';
  data: Array<AllergenEntity>;
  meta: ResponseCollectionMeta;
};

export type AllergenFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<AllergenFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  ingredients?: InputMaybe<IngredientFiltersInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<AllergenFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<AllergenFiltersInput>>>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type AllergenInput = {
  ingredients?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  name?: InputMaybe<Scalars['String']>;
};

export type AllergenRelationResponseCollection = {
  __typename?: 'AllergenRelationResponseCollection';
  data: Array<AllergenEntity>;
};

export type BleDevice = {
  __typename?: 'BleDevice';
  createdAt?: Maybe<Scalars['DateTime']>;
  mac: Scalars['String'];
  model: Enum_Bledevice_Model;
  publishedAt?: Maybe<Scalars['DateTime']>;
  title: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<UsersPermissionsUserEntityResponse>;
};

export type BleDeviceEntity = {
  __typename?: 'BleDeviceEntity';
  attributes?: Maybe<BleDevice>;
  id?: Maybe<Scalars['ID']>;
};

export type BleDeviceEntityResponse = {
  __typename?: 'BleDeviceEntityResponse';
  data?: Maybe<BleDeviceEntity>;
};

export type BleDeviceEntityResponseCollection = {
  __typename?: 'BleDeviceEntityResponseCollection';
  data: Array<BleDeviceEntity>;
  meta: ResponseCollectionMeta;
};

export type BleDeviceFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<BleDeviceFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  mac?: InputMaybe<StringFilterInput>;
  model?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<BleDeviceFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<BleDeviceFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  title?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  user?: InputMaybe<UsersPermissionsUserFiltersInput>;
};

export type BleDeviceInput = {
  mac?: InputMaybe<Scalars['String']>;
  model?: InputMaybe<Enum_Bledevice_Model>;
  publishedAt?: InputMaybe<Scalars['DateTime']>;
  title?: InputMaybe<Scalars['String']>;
  user?: InputMaybe<Scalars['ID']>;
};

export type BleFloor = {
  __typename?: 'BleFloor';
  ble_gateways?: Maybe<BleGatewayRelationResponseCollection>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  path_loss?: Maybe<Scalars['Float']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
  rooms?: Maybe<RoomRelationResponseCollection>;
  svg_map?: Maybe<UploadFileEntityResponse>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};


export type BleFloorBle_GatewaysArgs = {
  filters?: InputMaybe<BleGatewayFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type BleFloorRoomsArgs = {
  filters?: InputMaybe<RoomFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type BleFloorEntity = {
  __typename?: 'BleFloorEntity';
  attributes?: Maybe<BleFloor>;
  id?: Maybe<Scalars['ID']>;
};

export type BleFloorEntityResponse = {
  __typename?: 'BleFloorEntityResponse';
  data?: Maybe<BleFloorEntity>;
};

export type BleFloorEntityResponseCollection = {
  __typename?: 'BleFloorEntityResponseCollection';
  data: Array<BleFloorEntity>;
  meta: ResponseCollectionMeta;
};

export type BleFloorFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<BleFloorFiltersInput>>>;
  ble_gateways?: InputMaybe<BleGatewayFiltersInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  description?: InputMaybe<StringFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<BleFloorFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<BleFloorFiltersInput>>>;
  path_loss?: InputMaybe<FloatFilterInput>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  rooms?: InputMaybe<RoomFiltersInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type BleFloorInput = {
  ble_gateways?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  description?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  path_loss?: InputMaybe<Scalars['Float']>;
  publishedAt?: InputMaybe<Scalars['DateTime']>;
  rooms?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  svg_map?: InputMaybe<Scalars['ID']>;
};

export type BleGateway = {
  __typename?: 'BleGateway';
  ble_floor?: Maybe<BleFloorEntityResponse>;
  createdAt?: Maybe<Scalars['DateTime']>;
  mac: Scalars['String'];
  positionX?: Maybe<Scalars['Float']>;
  positionY?: Maybe<Scalars['Float']>;
  positionZ?: Maybe<Scalars['Float']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
  referenceRSSI?: Maybe<Scalars['Float']>;
  title: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type BleGatewayEntity = {
  __typename?: 'BleGatewayEntity';
  attributes?: Maybe<BleGateway>;
  id?: Maybe<Scalars['ID']>;
};

export type BleGatewayEntityResponse = {
  __typename?: 'BleGatewayEntityResponse';
  data?: Maybe<BleGatewayEntity>;
};

export type BleGatewayEntityResponseCollection = {
  __typename?: 'BleGatewayEntityResponseCollection';
  data: Array<BleGatewayEntity>;
  meta: ResponseCollectionMeta;
};

export type BleGatewayFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<BleGatewayFiltersInput>>>;
  ble_floor?: InputMaybe<BleFloorFiltersInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  mac?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<BleGatewayFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<BleGatewayFiltersInput>>>;
  positionX?: InputMaybe<FloatFilterInput>;
  positionY?: InputMaybe<FloatFilterInput>;
  positionZ?: InputMaybe<FloatFilterInput>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  referenceRSSI?: InputMaybe<FloatFilterInput>;
  title?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type BleGatewayInput = {
  ble_floor?: InputMaybe<Scalars['ID']>;
  mac?: InputMaybe<Scalars['String']>;
  positionX?: InputMaybe<Scalars['Float']>;
  positionY?: InputMaybe<Scalars['Float']>;
  positionZ?: InputMaybe<Scalars['Float']>;
  publishedAt?: InputMaybe<Scalars['DateTime']>;
  referenceRSSI?: InputMaybe<Scalars['Float']>;
  title?: InputMaybe<Scalars['String']>;
};

export type BleGatewayRelationResponseCollection = {
  __typename?: 'BleGatewayRelationResponseCollection';
  data: Array<BleGatewayEntity>;
};

export type BleGroup = {
  __typename?: 'BleGroup';
  createdAt?: Maybe<Scalars['DateTime']>;
  title: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
  users?: Maybe<UsersPermissionsUserRelationResponseCollection>;
};


export type BleGroupUsersArgs = {
  filters?: InputMaybe<UsersPermissionsUserFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type BleGroupEntity = {
  __typename?: 'BleGroupEntity';
  attributes?: Maybe<BleGroup>;
  id?: Maybe<Scalars['ID']>;
};

export type BleGroupEntityResponse = {
  __typename?: 'BleGroupEntityResponse';
  data?: Maybe<BleGroupEntity>;
};

export type BleGroupEntityResponseCollection = {
  __typename?: 'BleGroupEntityResponseCollection';
  data: Array<BleGroupEntity>;
  meta: ResponseCollectionMeta;
};

export type BleGroupFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<BleGroupFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  not?: InputMaybe<BleGroupFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<BleGroupFiltersInput>>>;
  title?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  users?: InputMaybe<UsersPermissionsUserFiltersInput>;
};

export type BleGroupInput = {
  title?: InputMaybe<Scalars['String']>;
  users?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

export type BleGroupRelationResponseCollection = {
  __typename?: 'BleGroupRelationResponseCollection';
  data: Array<BleGroupEntity>;
};

export type BlogCategory = {
  __typename?: 'BlogCategory';
  blog_posts?: Maybe<BlogPostRelationResponseCollection>;
  createdAt?: Maybe<Scalars['DateTime']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
  slug: Scalars['String'];
  title: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};


export type BlogCategoryBlog_PostsArgs = {
  filters?: InputMaybe<BlogPostFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type BlogCategoryEntity = {
  __typename?: 'BlogCategoryEntity';
  attributes?: Maybe<BlogCategory>;
  id?: Maybe<Scalars['ID']>;
};

export type BlogCategoryEntityResponse = {
  __typename?: 'BlogCategoryEntityResponse';
  data?: Maybe<BlogCategoryEntity>;
};

export type BlogCategoryEntityResponseCollection = {
  __typename?: 'BlogCategoryEntityResponseCollection';
  data: Array<BlogCategoryEntity>;
  meta: ResponseCollectionMeta;
};

export type BlogCategoryFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<BlogCategoryFiltersInput>>>;
  blog_posts?: InputMaybe<BlogPostFiltersInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  not?: InputMaybe<BlogCategoryFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<BlogCategoryFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  slug?: InputMaybe<StringFilterInput>;
  title?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type BlogCategoryInput = {
  blog_posts?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']>;
  slug?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

export type BlogCategoryRelationResponseCollection = {
  __typename?: 'BlogCategoryRelationResponseCollection';
  data: Array<BlogCategoryEntity>;
};

export type BlogPost = {
  __typename?: 'BlogPost';
  author?: Maybe<UsersPermissionsUserEntityResponse>;
  author_image?: Maybe<UploadFileEntityResponse>;
  blog_categories?: Maybe<BlogCategoryRelationResponseCollection>;
  components?: Maybe<Array<Maybe<BlogPostComponentsDynamicZone>>>;
  createdAt?: Maybe<Scalars['DateTime']>;
  info_text?: Maybe<Scalars['String']>;
  media?: Maybe<UploadFileRelationResponseCollection>;
  media_mobile?: Maybe<UploadFileRelationResponseCollection>;
  publishedAt?: Maybe<Scalars['DateTime']>;
  seo?: Maybe<ComponentSharedSeo>;
  slug: Scalars['String'];
  title: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};


export type BlogPostBlog_CategoriesArgs = {
  filters?: InputMaybe<BlogCategoryFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type BlogPostMediaArgs = {
  filters?: InputMaybe<UploadFileFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type BlogPostMedia_MobileArgs = {
  filters?: InputMaybe<UploadFileFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type BlogPostComponentsDynamicZone = ComponentCmsDataAnimatedCardSection | ComponentCmsDataAuthorsListSection | ComponentCmsDataBlogArticles | ComponentCmsDataCaptureContact | ComponentCmsDataDarkBgImageSection | ComponentCmsDataDarkImageContent | ComponentCmsDataDarkTextBoxSection | ComponentCmsDataDarkVersusContent | ComponentCmsDataEventsListSection | ComponentCmsDataFaq | ComponentCmsDataFooterSection | ComponentCmsDataFormGroup | ComponentCmsDataHeaderSection | ComponentCmsDataHeroSection | ComponentCmsDataHeroSectionSlider | ComponentCmsDataHeroSectionTwo | ComponentCmsDataIconCardsSection | ComponentCmsDataImageCardsSection | ComponentCmsDataImageGallery | ComponentCmsDataInteractiveImageMap | ComponentCmsDataLightTopImgSection | ComponentCmsDataPriceSection | ComponentCmsDataProductsList | ComponentCmsDataReusable | ComponentCmsDataReviewsSection | ComponentCmsDataRichText | ComponentCmsDataRichTextHtml | ComponentCmsDataScheduleMeeting | ComponentCmsDataScrollListSection | ComponentCmsDataScrollToSection | ComponentCmsDataSingleTitleSection | ComponentCmsDataSlider | ComponentCmsDataSubscriptionPopup | ComponentCmsDataTextAndImageSection | ComponentCmsDataVideoSection | Error;

export type BlogPostEntity = {
  __typename?: 'BlogPostEntity';
  attributes?: Maybe<BlogPost>;
  id?: Maybe<Scalars['ID']>;
};

export type BlogPostEntityResponse = {
  __typename?: 'BlogPostEntityResponse';
  data?: Maybe<BlogPostEntity>;
};

export type BlogPostEntityResponseCollection = {
  __typename?: 'BlogPostEntityResponseCollection';
  data: Array<BlogPostEntity>;
  meta: ResponseCollectionMeta;
};

export type BlogPostFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<BlogPostFiltersInput>>>;
  author?: InputMaybe<UsersPermissionsUserFiltersInput>;
  blog_categories?: InputMaybe<BlogCategoryFiltersInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  info_text?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<BlogPostFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<BlogPostFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  seo?: InputMaybe<ComponentSharedSeoFiltersInput>;
  slug?: InputMaybe<StringFilterInput>;
  title?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type BlogPostInput = {
  author?: InputMaybe<Scalars['ID']>;
  author_image?: InputMaybe<Scalars['ID']>;
  blog_categories?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  components?: InputMaybe<Array<Scalars['BlogPostComponentsDynamicZoneInput']>>;
  info_text?: InputMaybe<Scalars['String']>;
  media?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  media_mobile?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']>;
  seo?: InputMaybe<ComponentSharedSeoInput>;
  slug?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

export type BlogPostRelationResponseCollection = {
  __typename?: 'BlogPostRelationResponseCollection';
  data: Array<BlogPostEntity>;
};

export type BooleanFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  contains?: InputMaybe<Scalars['Boolean']>;
  containsi?: InputMaybe<Scalars['Boolean']>;
  endsWith?: InputMaybe<Scalars['Boolean']>;
  eq?: InputMaybe<Scalars['Boolean']>;
  eqi?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Boolean']>;
  gte?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  lt?: InputMaybe<Scalars['Boolean']>;
  lte?: InputMaybe<Scalars['Boolean']>;
  ne?: InputMaybe<Scalars['Boolean']>;
  nei?: InputMaybe<Scalars['Boolean']>;
  not?: InputMaybe<BooleanFilterInput>;
  notContains?: InputMaybe<Scalars['Boolean']>;
  notContainsi?: InputMaybe<Scalars['Boolean']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  notNull?: InputMaybe<Scalars['Boolean']>;
  null?: InputMaybe<Scalars['Boolean']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  startsWith?: InputMaybe<Scalars['Boolean']>;
};

export type Campaign = {
  __typename?: 'Campaign';
  acListId?: Maybe<Scalars['String']>;
  assign_crm_roles?: Maybe<CrmRoleRelationResponseCollection>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crm_campaign_members?: Maybe<CrmCampaignMemberRelationResponseCollection>;
  crm_tasks?: Maybe<CrmTaskRelationResponseCollection>;
  name: Scalars['String'];
  products?: Maybe<ProductRelationResponseCollection>;
  schedule_meeting?: Maybe<ComponentCrmDataCrmMeeting>;
  slug?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  users_with_roles?: Maybe<Array<Maybe<ComponentCrmDataCrmAccountRole>>>;
};


export type CampaignAssign_Crm_RolesArgs = {
  filters?: InputMaybe<CrmRoleFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type CampaignCrm_Campaign_MembersArgs = {
  filters?: InputMaybe<CrmCampaignMemberFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type CampaignCrm_TasksArgs = {
  filters?: InputMaybe<CrmTaskFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type CampaignProductsArgs = {
  filters?: InputMaybe<ProductFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type CampaignUsers_With_RolesArgs = {
  filters?: InputMaybe<ComponentCrmDataCrmAccountRoleFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type CampaignEntity = {
  __typename?: 'CampaignEntity';
  attributes?: Maybe<Campaign>;
  id?: Maybe<Scalars['ID']>;
};

export type CampaignEntityResponse = {
  __typename?: 'CampaignEntityResponse';
  data?: Maybe<CampaignEntity>;
};

export type CampaignEntityResponseCollection = {
  __typename?: 'CampaignEntityResponseCollection';
  data: Array<CampaignEntity>;
  meta: ResponseCollectionMeta;
};

export type CampaignFiltersInput = {
  acListId?: InputMaybe<StringFilterInput>;
  and?: InputMaybe<Array<InputMaybe<CampaignFiltersInput>>>;
  assign_crm_roles?: InputMaybe<CrmRoleFiltersInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  crm_campaign_members?: InputMaybe<CrmCampaignMemberFiltersInput>;
  crm_tasks?: InputMaybe<CrmTaskFiltersInput>;
  id?: InputMaybe<IdFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<CampaignFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<CampaignFiltersInput>>>;
  products?: InputMaybe<ProductFiltersInput>;
  schedule_meeting?: InputMaybe<ComponentCrmDataCrmMeetingFiltersInput>;
  slug?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  users_with_roles?: InputMaybe<ComponentCrmDataCrmAccountRoleFiltersInput>;
};

export type CampaignInput = {
  acListId?: InputMaybe<Scalars['String']>;
  assign_crm_roles?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  crm_campaign_members?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  crm_tasks?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  name?: InputMaybe<Scalars['String']>;
  products?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  schedule_meeting?: InputMaybe<ComponentCrmDataCrmMeetingInput>;
  slug?: InputMaybe<Scalars['String']>;
  users_with_roles?: InputMaybe<Array<InputMaybe<ComponentCrmDataCrmAccountRoleInput>>>;
};

export type CampaignMemberAvatar = {
  __typename?: 'CampaignMemberAvatar';
  campaign_members?: Maybe<CrmCampaignMemberRelationResponseCollection>;
  createdAt?: Maybe<Scalars['DateTime']>;
  name: Scalars['String'];
  publishedAt?: Maybe<Scalars['DateTime']>;
  tags?: Maybe<ActiveCampaignAcTagRelationResponseCollection>;
  tags_remove?: Maybe<ActiveCampaignAcTagRelationResponseCollection>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};


export type CampaignMemberAvatarCampaign_MembersArgs = {
  filters?: InputMaybe<CrmCampaignMemberFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type CampaignMemberAvatarTagsArgs = {
  filters?: InputMaybe<ActiveCampaignAcTagFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type CampaignMemberAvatarTags_RemoveArgs = {
  filters?: InputMaybe<ActiveCampaignAcTagFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type CampaignMemberAvatarEntity = {
  __typename?: 'CampaignMemberAvatarEntity';
  attributes?: Maybe<CampaignMemberAvatar>;
  id?: Maybe<Scalars['ID']>;
};

export type CampaignMemberAvatarEntityResponse = {
  __typename?: 'CampaignMemberAvatarEntityResponse';
  data?: Maybe<CampaignMemberAvatarEntity>;
};

export type CampaignMemberAvatarEntityResponseCollection = {
  __typename?: 'CampaignMemberAvatarEntityResponseCollection';
  data: Array<CampaignMemberAvatarEntity>;
  meta: ResponseCollectionMeta;
};

export type CampaignMemberAvatarFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<CampaignMemberAvatarFiltersInput>>>;
  campaign_members?: InputMaybe<CrmCampaignMemberFiltersInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<CampaignMemberAvatarFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<CampaignMemberAvatarFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  tags?: InputMaybe<ActiveCampaignAcTagFiltersInput>;
  tags_remove?: InputMaybe<ActiveCampaignAcTagFiltersInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type CampaignMemberAvatarInput = {
  campaign_members?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  name?: InputMaybe<Scalars['String']>;
  publishedAt?: InputMaybe<Scalars['DateTime']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  tags_remove?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

export type CampaignMemberAvatarRelationResponseCollection = {
  __typename?: 'CampaignMemberAvatarRelationResponseCollection';
  data: Array<CampaignMemberAvatarEntity>;
};

export type CampaignRelationResponseCollection = {
  __typename?: 'CampaignRelationResponseCollection';
  data: Array<CampaignEntity>;
};

export type CapturedContactInput = {
  crmCampaign?: InputMaybe<Scalars['ID']>;
  crmCampaignMemberStatus?: InputMaybe<Scalars['ID']>;
  crmRole?: InputMaybe<Scalars['ID']>;
  crmUsers?: InputMaybe<Array<InputMaybe<CrmUserRating>>>;
  email: Scalars['String'];
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  tag?: InputMaybe<Scalars['ID']>;
};

export type Classroom = {
  __typename?: 'Classroom';
  classroom_members?: Maybe<ClassroomMemberRelationResponseCollection>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  message_group?: Maybe<MessageGroupEntityResponse>;
  publishedAt?: Maybe<Scalars['DateTime']>;
  title: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};


export type ClassroomClassroom_MembersArgs = {
  filters?: InputMaybe<ClassroomMemberFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ClassroomEntity = {
  __typename?: 'ClassroomEntity';
  attributes?: Maybe<Classroom>;
  id?: Maybe<Scalars['ID']>;
};

export type ClassroomEntityResponse = {
  __typename?: 'ClassroomEntityResponse';
  data?: Maybe<ClassroomEntity>;
};

export type ClassroomEntityResponseCollection = {
  __typename?: 'ClassroomEntityResponseCollection';
  data: Array<ClassroomEntity>;
  meta: ResponseCollectionMeta;
};

export type ClassroomFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ClassroomFiltersInput>>>;
  classroom_members?: InputMaybe<ClassroomMemberFiltersInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  description?: InputMaybe<StringFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  message_group?: InputMaybe<MessageGroupFiltersInput>;
  not?: InputMaybe<ClassroomFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ClassroomFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  title?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type ClassroomInput = {
  classroom_members?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  description?: InputMaybe<Scalars['String']>;
  message_group?: InputMaybe<Scalars['ID']>;
  publishedAt?: InputMaybe<Scalars['DateTime']>;
  title?: InputMaybe<Scalars['String']>;
};

export type ClassroomMember = {
  __typename?: 'ClassroomMember';
  classroom?: Maybe<ClassroomEntityResponse>;
  createdAt?: Maybe<Scalars['DateTime']>;
  daily_tasks?: Maybe<DailyTaskClassroomMemberRelationResponseCollection>;
  public_name?: Maybe<Scalars['String']>;
  role?: Maybe<Enum_Classroommember_Role>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<UsersPermissionsUserEntityResponse>;
};


export type ClassroomMemberDaily_TasksArgs = {
  filters?: InputMaybe<DailyTaskClassroomMemberFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ClassroomMemberEntity = {
  __typename?: 'ClassroomMemberEntity';
  attributes?: Maybe<ClassroomMember>;
  id?: Maybe<Scalars['ID']>;
};

export type ClassroomMemberEntityResponse = {
  __typename?: 'ClassroomMemberEntityResponse';
  data?: Maybe<ClassroomMemberEntity>;
};

export type ClassroomMemberEntityResponseCollection = {
  __typename?: 'ClassroomMemberEntityResponseCollection';
  data: Array<ClassroomMemberEntity>;
  meta: ResponseCollectionMeta;
};

export type ClassroomMemberFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ClassroomMemberFiltersInput>>>;
  classroom?: InputMaybe<ClassroomFiltersInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  daily_tasks?: InputMaybe<DailyTaskClassroomMemberFiltersInput>;
  id?: InputMaybe<IdFilterInput>;
  not?: InputMaybe<ClassroomMemberFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ClassroomMemberFiltersInput>>>;
  public_name?: InputMaybe<StringFilterInput>;
  role?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  user?: InputMaybe<UsersPermissionsUserFiltersInput>;
};

export type ClassroomMemberInput = {
  classroom?: InputMaybe<Scalars['ID']>;
  daily_tasks?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  public_name?: InputMaybe<Scalars['String']>;
  role?: InputMaybe<Enum_Classroommember_Role>;
  user?: InputMaybe<Scalars['ID']>;
};

export type ClassroomMemberRelationResponseCollection = {
  __typename?: 'ClassroomMemberRelationResponseCollection';
  data: Array<ClassroomMemberEntity>;
};

export type Comment = {
  __typename?: 'Comment';
  author?: Maybe<UsersPermissionsUserEntityResponse>;
  children?: Maybe<CommentRelationResponseCollection>;
  createdAt?: Maybe<Scalars['DateTime']>;
  message?: Maybe<Scalars['String']>;
  parent?: Maybe<CommentEntityResponse>;
  publishedAt?: Maybe<Scalars['DateTime']>;
  reactions?: Maybe<ReactionsReactionCountResponse>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};


export type CommentChildrenArgs = {
  filters?: InputMaybe<CommentFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type CommentEntity = {
  __typename?: 'CommentEntity';
  attributes?: Maybe<Comment>;
  id?: Maybe<Scalars['ID']>;
};

export type CommentEntityResponse = {
  __typename?: 'CommentEntityResponse';
  data?: Maybe<CommentEntity>;
};

export type CommentEntityResponseCollection = {
  __typename?: 'CommentEntityResponseCollection';
  data: Array<CommentEntity>;
  meta: ResponseCollectionMeta;
};

export type CommentFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<CommentFiltersInput>>>;
  author?: InputMaybe<UsersPermissionsUserFiltersInput>;
  children?: InputMaybe<CommentFiltersInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  message?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<CommentFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<CommentFiltersInput>>>;
  parent?: InputMaybe<CommentFiltersInput>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type CommentInput = {
  author?: InputMaybe<Scalars['ID']>;
  children?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  message?: InputMaybe<Scalars['String']>;
  parent?: InputMaybe<Scalars['ID']>;
  publishedAt?: InputMaybe<Scalars['DateTime']>;
};

export type CommentRelationResponseCollection = {
  __typename?: 'CommentRelationResponseCollection';
  data: Array<CommentEntity>;
};

export type ComponentClassroomDailyTaskItem = {
  __typename?: 'ComponentClassroomDailyTaskItem';
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  response_collected?: Maybe<Scalars['String']>;
  response_to_collect?: Maybe<Enum_Componentclassroomdailytaskitem_Response_To_Collect>;
  title: Scalars['String'];
};

export type ComponentClassroomDailyTaskItemFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentClassroomDailyTaskItemFiltersInput>>>;
  description?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentClassroomDailyTaskItemFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentClassroomDailyTaskItemFiltersInput>>>;
  response_collected?: InputMaybe<StringFilterInput>;
  response_to_collect?: InputMaybe<StringFilterInput>;
  title?: InputMaybe<StringFilterInput>;
};

export type ComponentClassroomDailyTaskItemInput = {
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  response_collected?: InputMaybe<Scalars['String']>;
  response_to_collect?: InputMaybe<Enum_Componentclassroomdailytaskitem_Response_To_Collect>;
  title?: InputMaybe<Scalars['String']>;
};

export type ComponentCmsDataAnimatedCardSection = {
  __typename?: 'ComponentCmsDataAnimatedCardSection';
  button?: Maybe<ComponentCmsDataButton>;
  firstSectionImages: UploadFileRelationResponseCollection;
  id: Scalars['ID'];
  mainTitle: Scalars['String'];
  secondSectionImages?: Maybe<UploadFileRelationResponseCollection>;
  secondaryTitle?: Maybe<Scalars['String']>;
  topTitle?: Maybe<Scalars['String']>;
};


export type ComponentCmsDataAnimatedCardSectionFirstSectionImagesArgs = {
  filters?: InputMaybe<UploadFileFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type ComponentCmsDataAnimatedCardSectionSecondSectionImagesArgs = {
  filters?: InputMaybe<UploadFileFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComponentCmsDataAuthorsListSection = {
  __typename?: 'ComponentCmsDataAuthorsListSection';
  authors?: Maybe<UsersPermissionsUserRelationResponseCollection>;
  description?: Maybe<Scalars['String']>;
  displayAsSlider?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  mainTitle?: Maybe<Scalars['String']>;
  numberOfAuthorsToDisplay?: Maybe<Scalars['Int']>;
  showCategories?: Maybe<Scalars['Boolean']>;
  showSearch?: Maybe<Scalars['Boolean']>;
  topTitle?: Maybe<Scalars['String']>;
};


export type ComponentCmsDataAuthorsListSectionAuthorsArgs = {
  filters?: InputMaybe<UsersPermissionsUserFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComponentCmsDataBlogArticles = {
  __typename?: 'ComponentCmsDataBlogArticles';
  blogPosts?: Maybe<BlogPostRelationResponseCollection>;
  displayType: Enum_Componentcmsdatablogarticles_Displaytype;
  id: Scalars['ID'];
  numberOfArticles?: Maybe<Scalars['Int']>;
  showLastAdded: Scalars['Boolean'];
  size: Enum_Componentcmsdatablogarticles_Size;
};


export type ComponentCmsDataBlogArticlesBlogPostsArgs = {
  filters?: InputMaybe<BlogPostFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComponentCmsDataBoxCard = {
  __typename?: 'ComponentCmsDataBoxCard';
  id: Scalars['ID'];
  image?: Maybe<UploadFileEntityResponse>;
  mobileImage?: Maybe<UploadFileEntityResponse>;
  showMoreText?: Maybe<Scalars['String']>;
  text: Scalars['String'];
  title: Scalars['String'];
};

export type ComponentCmsDataBoxCardFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentCmsDataBoxCardFiltersInput>>>;
  not?: InputMaybe<ComponentCmsDataBoxCardFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentCmsDataBoxCardFiltersInput>>>;
  showMoreText?: InputMaybe<StringFilterInput>;
  text?: InputMaybe<StringFilterInput>;
  title?: InputMaybe<StringFilterInput>;
};

export type ComponentCmsDataBoxElement = {
  __typename?: 'ComponentCmsDataBoxElement';
  bottomText?: Maybe<Scalars['String']>;
  boxCards?: Maybe<Array<Maybe<ComponentCmsDataBoxCard>>>;
  boxText: Scalars['String'];
  boxTitle: Scalars['String'];
  id: Scalars['ID'];
  listTitle?: Maybe<Scalars['String']>;
};


export type ComponentCmsDataBoxElementBoxCardsArgs = {
  filters?: InputMaybe<ComponentCmsDataBoxCardFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComponentCmsDataBoxElementFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentCmsDataBoxElementFiltersInput>>>;
  bottomText?: InputMaybe<StringFilterInput>;
  boxCards?: InputMaybe<ComponentCmsDataBoxCardFiltersInput>;
  boxText?: InputMaybe<StringFilterInput>;
  boxTitle?: InputMaybe<StringFilterInput>;
  listTitle?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentCmsDataBoxElementFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentCmsDataBoxElementFiltersInput>>>;
};

export type ComponentCmsDataButton = {
  __typename?: 'ComponentCmsDataButton';
  color?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  text: Scalars['String'];
  textColor?: Maybe<Scalars['String']>;
  url: Scalars['String'];
};

export type ComponentCmsDataButtonFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentCmsDataButtonFiltersInput>>>;
  color?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentCmsDataButtonFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentCmsDataButtonFiltersInput>>>;
  text?: InputMaybe<StringFilterInput>;
  textColor?: InputMaybe<StringFilterInput>;
  url?: InputMaybe<StringFilterInput>;
};

export type ComponentCmsDataCaptureContact = {
  __typename?: 'ComponentCmsDataCaptureContact';
  backgroundImage?: Maybe<UploadFileEntityResponse>;
  buttonText?: Maybe<Scalars['String']>;
  countDownFrom?: Maybe<Scalars['Int']>;
  countdownTimer?: Maybe<Scalars['DateTime']>;
  crm_campaign?: Maybe<CampaignEntityResponse>;
  crm_cm_status?: Maybe<CrmCampaignMemberStatusEntityResponse>;
  crm_role?: Maybe<CrmRoleEntityResponse>;
  description?: Maybe<Scalars['String']>;
  formGroup?: Maybe<ComponentCmsDataFormGroup>;
  hideEmail?: Maybe<Scalars['Boolean']>;
  hideFirstName?: Maybe<Scalars['Boolean']>;
  hideImageOnMobile?: Maybe<Scalars['Boolean']>;
  hideLastName?: Maybe<Scalars['Boolean']>;
  hidePhoneNumber?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  isEmailRequired?: Maybe<Scalars['Boolean']>;
  isFirstNameRequired?: Maybe<Scalars['Boolean']>;
  isLastNameRequired?: Maybe<Scalars['Boolean']>;
  isPhoneNumberRequired?: Maybe<Scalars['Boolean']>;
  mainTitle?: Maybe<Scalars['String']>;
  media?: Maybe<UploadFileRelationResponseCollection>;
  redirectUrl?: Maybe<Scalars['String']>;
  subTitle?: Maybe<Scalars['String']>;
  tag?: Maybe<ActiveCampaignAcTagEntityResponse>;
  toBeAnnounced?: Maybe<Scalars['Boolean']>;
  topTitle?: Maybe<Scalars['String']>;
  users_with_rating?: Maybe<Array<Maybe<ComponentCrmDataCrmUserRating>>>;
};


export type ComponentCmsDataCaptureContactMediaArgs = {
  filters?: InputMaybe<UploadFileFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type ComponentCmsDataCaptureContactUsers_With_RatingArgs = {
  filters?: InputMaybe<ComponentCrmDataCrmUserRatingFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComponentCmsDataCountDownTimer = {
  __typename?: 'ComponentCmsDataCountDownTimer';
  description?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
};

export type ComponentCmsDataCountDownTimerFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentCmsDataCountDownTimerFiltersInput>>>;
  description?: InputMaybe<StringFilterInput>;
  endDate?: InputMaybe<DateTimeFilterInput>;
  not?: InputMaybe<ComponentCmsDataCountDownTimerFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentCmsDataCountDownTimerFiltersInput>>>;
};

export type ComponentCmsDataDarkBgImageSection = {
  __typename?: 'ComponentCmsDataDarkBgImageSection';
  backgroundImage?: Maybe<UploadFileEntityResponse>;
  button?: Maybe<ComponentCmsDataButton>;
  centerText?: Maybe<Scalars['Boolean']>;
  countDownTimer?: Maybe<ComponentCmsDataCountDownTimer>;
  id: Scalars['ID'];
  image?: Maybe<UploadFileEntityResponse>;
  mainTitle: Scalars['String'];
  mobileBackgroundImage?: Maybe<UploadFileEntityResponse>;
  mobileImage?: Maybe<UploadFileEntityResponse>;
  secondaryTitle: Scalars['String'];
};

export type ComponentCmsDataDarkImageContent = {
  __typename?: 'ComponentCmsDataDarkImageContent';
  backgroundImage?: Maybe<UploadFileEntityResponse>;
  buttonText?: Maybe<Scalars['String']>;
  buttonUrl?: Maybe<Scalars['String']>;
  countDownTimer?: Maybe<ComponentCmsDataCountDownTimer>;
  id: Scalars['ID'];
  left?: Maybe<ComponentCmsDataDarkImageSection>;
  mainTitle?: Maybe<Scalars['String']>;
  mobileBackgroundImage?: Maybe<UploadFileEntityResponse>;
  right?: Maybe<ComponentCmsDataDarkImageSection>;
};

export type ComponentCmsDataDarkImageItem = {
  __typename?: 'ComponentCmsDataDarkImageItem';
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  title?: Maybe<Scalars['String']>;
};

export type ComponentCmsDataDarkImageItemFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentCmsDataDarkImageItemFiltersInput>>>;
  description?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentCmsDataDarkImageItemFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentCmsDataDarkImageItemFiltersInput>>>;
  title?: InputMaybe<StringFilterInput>;
};

export type ComponentCmsDataDarkImageSection = {
  __typename?: 'ComponentCmsDataDarkImageSection';
  id: Scalars['ID'];
  items?: Maybe<Array<Maybe<ComponentCmsDataDarkImageItem>>>;
  title?: Maybe<Scalars['String']>;
};


export type ComponentCmsDataDarkImageSectionItemsArgs = {
  filters?: InputMaybe<ComponentCmsDataDarkImageItemFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComponentCmsDataDarkTextBoxSection = {
  __typename?: 'ComponentCmsDataDarkTextBoxSection';
  backgroundImage?: Maybe<UploadFileEntityResponse>;
  bottomTitle?: Maybe<Scalars['String']>;
  box?: Maybe<Scalars['Boolean']>;
  boxColor?: Maybe<Scalars['String']>;
  boxText?: Maybe<Scalars['String']>;
  boxTextColor?: Maybe<Scalars['String']>;
  boxTitle?: Maybe<Scalars['String']>;
  boxTitleColor?: Maybe<Scalars['String']>;
  button?: Maybe<ComponentCmsDataButton>;
  buttonTitleColor?: Maybe<Scalars['String']>;
  centerText?: Maybe<Scalars['Boolean']>;
  centerTextColor?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  mainTitle: Scalars['String'];
  mainTitleColor?: Maybe<Scalars['String']>;
  mobileBackgroundImage?: Maybe<UploadFileEntityResponse>;
  topTitle?: Maybe<Scalars['String']>;
  topTitleColor?: Maybe<Scalars['String']>;
};

export type ComponentCmsDataDarkVersusBox = {
  __typename?: 'ComponentCmsDataDarkVersusBox';
  id: Scalars['ID'];
  leftItem?: Maybe<ComponentCmsDataDarkVersusItem>;
  rightItem?: Maybe<ComponentCmsDataDarkVersusItem>;
  title?: Maybe<Scalars['String']>;
};

export type ComponentCmsDataDarkVersusBoxFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentCmsDataDarkVersusBoxFiltersInput>>>;
  leftItem?: InputMaybe<ComponentCmsDataDarkVersusItemFiltersInput>;
  not?: InputMaybe<ComponentCmsDataDarkVersusBoxFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentCmsDataDarkVersusBoxFiltersInput>>>;
  rightItem?: InputMaybe<ComponentCmsDataDarkVersusItemFiltersInput>;
  title?: InputMaybe<StringFilterInput>;
};

export type ComponentCmsDataDarkVersusContent = {
  __typename?: 'ComponentCmsDataDarkVersusContent';
  bottomImage?: Maybe<UploadFileEntityResponse>;
  buttonText?: Maybe<Scalars['String']>;
  buttonUrl?: Maybe<Scalars['String']>;
  countDownTimer?: Maybe<ComponentCmsDataCountDownTimer>;
  id: Scalars['ID'];
  items?: Maybe<Array<Maybe<ComponentCmsDataDarkVersusBox>>>;
  mainTitle?: Maybe<Scalars['String']>;
  mobileBottomImage?: Maybe<UploadFileEntityResponse>;
  scarcityTitle?: Maybe<Scalars['String']>;
  subtitle?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};


export type ComponentCmsDataDarkVersusContentItemsArgs = {
  filters?: InputMaybe<ComponentCmsDataDarkVersusBoxFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComponentCmsDataDarkVersusItem = {
  __typename?: 'ComponentCmsDataDarkVersusItem';
  content?: Maybe<Scalars['String']>;
  iconName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  title?: Maybe<Scalars['String']>;
};

export type ComponentCmsDataDarkVersusItemFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentCmsDataDarkVersusItemFiltersInput>>>;
  content?: InputMaybe<StringFilterInput>;
  iconName?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentCmsDataDarkVersusItemFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentCmsDataDarkVersusItemFiltersInput>>>;
  title?: InputMaybe<StringFilterInput>;
};

export type ComponentCmsDataEventsListSection = {
  __typename?: 'ComponentCmsDataEventsListSection';
  backgroundColor?: Maybe<Scalars['String']>;
  buttonText?: Maybe<Scalars['String']>;
  buttonUrl?: Maybe<Scalars['String']>;
  cats?: Maybe<EventCategoryRelationResponseCollection>;
  countDownTimer?: Maybe<ComponentCmsDataCountDownTimer>;
  countDownTitle?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  displayAsSlider?: Maybe<Scalars['Boolean']>;
  events?: Maybe<EventRelationResponseCollection>;
  fullWidth?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  largeCards?: Maybe<Scalars['Boolean']>;
  mainTitle?: Maybe<Scalars['String']>;
  numberOfEventsToDisplay?: Maybe<Scalars['Int']>;
  paddingTop?: Maybe<Scalars['Boolean']>;
  showAllCategoriesButton?: Maybe<Scalars['Boolean']>;
  showCategories?: Maybe<Scalars['Boolean']>;
  showSearch?: Maybe<Scalars['Boolean']>;
  topTitle?: Maybe<Scalars['String']>;
};


export type ComponentCmsDataEventsListSectionCatsArgs = {
  filters?: InputMaybe<EventCategoryFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type ComponentCmsDataEventsListSectionEventsArgs = {
  filters?: InputMaybe<EventFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComponentCmsDataFaq = {
  __typename?: 'ComponentCmsDataFaq';
  id: Scalars['ID'];
  items?: Maybe<Array<Maybe<ComponentCmsDataFaqItem>>>;
  title?: Maybe<Scalars['String']>;
};


export type ComponentCmsDataFaqItemsArgs = {
  filters?: InputMaybe<ComponentCmsDataFaqItemFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComponentCmsDataFaqItem = {
  __typename?: 'ComponentCmsDataFaqItem';
  answer: Scalars['String'];
  id: Scalars['ID'];
  question: Scalars['String'];
};

export type ComponentCmsDataFaqItemFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentCmsDataFaqItemFiltersInput>>>;
  answer?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentCmsDataFaqItemFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentCmsDataFaqItemFiltersInput>>>;
  question?: InputMaybe<StringFilterInput>;
};

export type ComponentCmsDataFooterColumn = {
  __typename?: 'ComponentCmsDataFooterColumn';
  content?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  title?: Maybe<Scalars['String']>;
};

export type ComponentCmsDataFooterColumnFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentCmsDataFooterColumnFiltersInput>>>;
  content?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentCmsDataFooterColumnFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentCmsDataFooterColumnFiltersInput>>>;
  title?: InputMaybe<StringFilterInput>;
};

export type ComponentCmsDataFooterIconLink = {
  __typename?: 'ComponentCmsDataFooterIconLink';
  iconName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  link?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
};

export type ComponentCmsDataFooterIconLinkFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentCmsDataFooterIconLinkFiltersInput>>>;
  iconName?: InputMaybe<StringFilterInput>;
  link?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentCmsDataFooterIconLinkFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentCmsDataFooterIconLinkFiltersInput>>>;
  text?: InputMaybe<StringFilterInput>;
};

export type ComponentCmsDataFooterSection = {
  __typename?: 'ComponentCmsDataFooterSection';
  bottomContent?: Maybe<Scalars['String']>;
  columns?: Maybe<Array<Maybe<ComponentCmsDataFooterColumn>>>;
  iconColumnTitle?: Maybe<Scalars['String']>;
  iconLinks?: Maybe<Array<Maybe<ComponentCmsDataFooterIconLink>>>;
  id: Scalars['ID'];
  leftText: Scalars['String'];
  rightText?: Maybe<Scalars['String']>;
};


export type ComponentCmsDataFooterSectionColumnsArgs = {
  filters?: InputMaybe<ComponentCmsDataFooterColumnFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type ComponentCmsDataFooterSectionIconLinksArgs = {
  filters?: InputMaybe<ComponentCmsDataFooterIconLinkFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComponentCmsDataFormField = {
  __typename?: 'ComponentCmsDataFormField';
  conditions?: Maybe<Array<Maybe<ComponentCmsDataFormFieldCondition>>>;
  id: Scalars['ID'];
  index: Scalars['Int'];
  label?: Maybe<Scalars['String']>;
  options?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  type?: Maybe<Enum_Componentcmsdataformfield_Type>;
};


export type ComponentCmsDataFormFieldConditionsArgs = {
  filters?: InputMaybe<ComponentCmsDataFormFieldConditionFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComponentCmsDataFormFieldCondition = {
  __typename?: 'ComponentCmsDataFormFieldCondition';
  id: Scalars['ID'];
  info: Scalars['String'];
  jump_to_index: Scalars['Int'];
  operation?: Maybe<Enum_Componentcmsdataformfieldcondition_Operation>;
  value?: Maybe<Scalars['String']>;
};

export type ComponentCmsDataFormFieldConditionFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentCmsDataFormFieldConditionFiltersInput>>>;
  info?: InputMaybe<StringFilterInput>;
  jump_to_index?: InputMaybe<IntFilterInput>;
  not?: InputMaybe<ComponentCmsDataFormFieldConditionFiltersInput>;
  operation?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentCmsDataFormFieldConditionFiltersInput>>>;
  value?: InputMaybe<StringFilterInput>;
};

export type ComponentCmsDataFormGroup = {
  __typename?: 'ComponentCmsDataFormGroup';
  ask_for_rfid?: Maybe<Scalars['Boolean']>;
  crm_campaign?: Maybe<CampaignEntityResponse>;
  crm_cm_status?: Maybe<CrmCampaignMemberStatusEntityResponse>;
  crm_role?: Maybe<CrmRoleEntityResponse>;
  house_videos?: Maybe<Array<Maybe<ComponentGeneralHouseWithVideo>>>;
  id: Scalars['ID'];
  number_of_random_questions?: Maybe<Scalars['Int']>;
  questions?: Maybe<Array<Maybe<ComponentCmsDataFormQuestion>>>;
  random_questions?: Maybe<Scalars['Boolean']>;
  redirectUrl?: Maybe<Scalars['String']>;
  show_start_screen?: Maybe<Scalars['Boolean']>;
  tag?: Maybe<ActiveCampaignAcTagEntityResponse>;
  thank_you_message?: Maybe<Scalars['String']>;
  thank_you_message_background?: Maybe<Scalars['String']>;
  thank_you_message_color?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  type?: Maybe<Enum_Componentcmsdataformgroup_Type>;
  users_with_rating?: Maybe<Array<Maybe<ComponentCrmDataCrmUserRating>>>;
};


export type ComponentCmsDataFormGroupHouse_VideosArgs = {
  filters?: InputMaybe<ComponentGeneralHouseWithVideoFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type ComponentCmsDataFormGroupQuestionsArgs = {
  filters?: InputMaybe<ComponentCmsDataFormQuestionFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type ComponentCmsDataFormGroupUsers_With_RatingArgs = {
  filters?: InputMaybe<ComponentCrmDataCrmUserRatingFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComponentCmsDataFormGroupFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentCmsDataFormGroupFiltersInput>>>;
  ask_for_rfid?: InputMaybe<BooleanFilterInput>;
  crm_campaign?: InputMaybe<CampaignFiltersInput>;
  crm_cm_status?: InputMaybe<CrmCampaignMemberStatusFiltersInput>;
  crm_role?: InputMaybe<CrmRoleFiltersInput>;
  house_videos?: InputMaybe<ComponentGeneralHouseWithVideoFiltersInput>;
  not?: InputMaybe<ComponentCmsDataFormGroupFiltersInput>;
  number_of_random_questions?: InputMaybe<IntFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentCmsDataFormGroupFiltersInput>>>;
  questions?: InputMaybe<ComponentCmsDataFormQuestionFiltersInput>;
  random_questions?: InputMaybe<BooleanFilterInput>;
  redirectUrl?: InputMaybe<StringFilterInput>;
  show_start_screen?: InputMaybe<BooleanFilterInput>;
  tag?: InputMaybe<ActiveCampaignAcTagFiltersInput>;
  thank_you_message?: InputMaybe<StringFilterInput>;
  thank_you_message_background?: InputMaybe<StringFilterInput>;
  thank_you_message_color?: InputMaybe<StringFilterInput>;
  title?: InputMaybe<StringFilterInput>;
  type?: InputMaybe<StringFilterInput>;
  users_with_rating?: InputMaybe<ComponentCrmDataCrmUserRatingFiltersInput>;
};

export type ComponentCmsDataFormGroupInput = {
  ask_for_rfid?: InputMaybe<Scalars['Boolean']>;
  crm_campaign?: InputMaybe<Scalars['ID']>;
  crm_cm_status?: InputMaybe<Scalars['ID']>;
  crm_role?: InputMaybe<Scalars['ID']>;
  house_videos?: InputMaybe<Array<InputMaybe<ComponentGeneralHouseWithVideoInput>>>;
  id?: InputMaybe<Scalars['ID']>;
  number_of_random_questions?: InputMaybe<Scalars['Int']>;
  questions?: InputMaybe<Array<InputMaybe<ComponentCmsDataFormQuestionInput>>>;
  random_questions?: InputMaybe<Scalars['Boolean']>;
  redirectUrl?: InputMaybe<Scalars['String']>;
  show_start_screen?: InputMaybe<Scalars['Boolean']>;
  tag?: InputMaybe<Scalars['ID']>;
  thank_you_message?: InputMaybe<Scalars['String']>;
  thank_you_message_background?: InputMaybe<Scalars['String']>;
  thank_you_message_color?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Enum_Componentcmsdataformgroup_Type>;
  users_with_rating?: InputMaybe<Array<InputMaybe<ComponentCrmDataCrmUserRatingInput>>>;
};

export type ComponentCmsDataFormQchoice = {
  __typename?: 'ComponentCmsDataFormQchoice';
  allocate_ach?: Maybe<AchievementRelationResponseCollection>;
  allocate_house?: Maybe<HouseEntityResponse>;
  allocate_tags?: Maybe<ActiveCampaignAcTagRelationResponseCollection>;
  calculate_rules?: Maybe<Enum_Componentcmsdataformqchoice_Calculate_Rules>;
  calculate_tags?: Maybe<ActiveCampaignAcTagRelationResponseCollection>;
  choice_big_button?: Maybe<Scalars['Boolean']>;
  choice_color?: Maybe<Scalars['String']>;
  choice_color_transparent?: Maybe<Scalars['Boolean']>;
  choice_media?: Maybe<UploadFileEntityResponse>;
  choice_shortcut?: Maybe<Scalars['String']>;
  choice_text?: Maybe<Scalars['String']>;
  display_delay: Scalars['Int'];
  feedback_media?: Maybe<UploadFileEntityResponse>;
  feedback_media_text?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  jump_condition_operation: Enum_Componentcmsdataformqchoice_Jump_Condition_Operation;
  jump_to_question_index: Scalars['Int'];
};


export type ComponentCmsDataFormQchoiceAllocate_AchArgs = {
  filters?: InputMaybe<AchievementFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type ComponentCmsDataFormQchoiceAllocate_TagsArgs = {
  filters?: InputMaybe<ActiveCampaignAcTagFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type ComponentCmsDataFormQchoiceCalculate_TagsArgs = {
  filters?: InputMaybe<ActiveCampaignAcTagFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComponentCmsDataFormQchoiceFiltersInput = {
  allocate_ach?: InputMaybe<AchievementFiltersInput>;
  allocate_house?: InputMaybe<HouseFiltersInput>;
  allocate_tags?: InputMaybe<ActiveCampaignAcTagFiltersInput>;
  and?: InputMaybe<Array<InputMaybe<ComponentCmsDataFormQchoiceFiltersInput>>>;
  calculate_rules?: InputMaybe<StringFilterInput>;
  calculate_tags?: InputMaybe<ActiveCampaignAcTagFiltersInput>;
  choice_big_button?: InputMaybe<BooleanFilterInput>;
  choice_color?: InputMaybe<StringFilterInput>;
  choice_color_transparent?: InputMaybe<BooleanFilterInput>;
  choice_shortcut?: InputMaybe<StringFilterInput>;
  choice_text?: InputMaybe<StringFilterInput>;
  display_delay?: InputMaybe<IntFilterInput>;
  feedback_media_text?: InputMaybe<StringFilterInput>;
  jump_condition_operation?: InputMaybe<StringFilterInput>;
  jump_to_question_index?: InputMaybe<IntFilterInput>;
  not?: InputMaybe<ComponentCmsDataFormQchoiceFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentCmsDataFormQchoiceFiltersInput>>>;
};

export type ComponentCmsDataFormQchoiceInput = {
  allocate_ach?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  allocate_house?: InputMaybe<Scalars['ID']>;
  allocate_tags?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  calculate_rules?: InputMaybe<Enum_Componentcmsdataformqchoice_Calculate_Rules>;
  calculate_tags?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  choice_big_button?: InputMaybe<Scalars['Boolean']>;
  choice_color?: InputMaybe<Scalars['String']>;
  choice_color_transparent?: InputMaybe<Scalars['Boolean']>;
  choice_media?: InputMaybe<Scalars['ID']>;
  choice_shortcut?: InputMaybe<Scalars['String']>;
  choice_text?: InputMaybe<Scalars['String']>;
  display_delay?: InputMaybe<Scalars['Int']>;
  feedback_media?: InputMaybe<Scalars['ID']>;
  feedback_media_text?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  jump_condition_operation?: InputMaybe<Enum_Componentcmsdataformqchoice_Jump_Condition_Operation>;
  jump_to_question_index?: InputMaybe<Scalars['Int']>;
};

export type ComponentCmsDataFormQuestion = {
  __typename?: 'ComponentCmsDataFormQuestion';
  allocate_ach?: Maybe<AchievementRelationResponseCollection>;
  allocate_house?: Maybe<HouseEntityResponse>;
  allocate_tags?: Maybe<ActiveCampaignAcTagRelationResponseCollection>;
  allow_other_choice?: Maybe<Scalars['Boolean']>;
  background_color?: Maybe<Scalars['String']>;
  center_text?: Maybe<Scalars['Boolean']>;
  choices?: Maybe<Array<Maybe<ComponentCmsDataFormQchoice>>>;
  description?: Maybe<Scalars['String']>;
  description_color?: Maybe<Scalars['String']>;
  desktop_layout?: Maybe<Enum_Componentcmsdataformquestion_Desktop_Layout>;
  feedback_media?: Maybe<UploadFileEntityResponse>;
  feedback_media_text?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  image?: Maybe<UploadFileEntityResponse>;
  image_position?: Maybe<Enum_Componentcmsdataformquestion_Image_Position>;
  index: Scalars['Int'];
  input_color?: Maybe<Scalars['String']>;
  input_placeholder?: Maybe<Scalars['String']>;
  is_required?: Maybe<Scalars['Boolean']>;
  is_transparent_button?: Maybe<Scalars['Boolean']>;
  mobile_layout?: Maybe<Enum_Componentcmsdataformquestion_Mobile_Layout>;
  next_question_index?: Maybe<Scalars['Int']>;
  nr_columns: Scalars['Int'];
  rate_user?: Maybe<UsersPermissionsUserRelationResponseCollection>;
  rate_user_role?: Maybe<CrmRoleRelationResponseCollection>;
  restart_form_timer: Scalars['Int'];
  send_review_to_google?: Maybe<Scalars['Boolean']>;
  size?: Maybe<Enum_Componentcmsdataformquestion_Size>;
  space_from_top?: Maybe<Scalars['Float']>;
  submit_button_color?: Maybe<Scalars['String']>;
  submit_button_sticky?: Maybe<Scalars['Boolean']>;
  submit_button_text: Scalars['String'];
  submit_button_text_color?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  title_color?: Maybe<Scalars['String']>;
  type?: Maybe<Enum_Componentcmsdataformquestion_Type>;
  use_recaptcha?: Maybe<Scalars['Boolean']>;
  vertical_alignment?: Maybe<Enum_Componentcmsdataformquestion_Vertical_Alignment>;
  video?: Maybe<UploadFileEntityResponse>;
};


export type ComponentCmsDataFormQuestionAllocate_AchArgs = {
  filters?: InputMaybe<AchievementFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type ComponentCmsDataFormQuestionAllocate_TagsArgs = {
  filters?: InputMaybe<ActiveCampaignAcTagFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type ComponentCmsDataFormQuestionChoicesArgs = {
  filters?: InputMaybe<ComponentCmsDataFormQchoiceFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type ComponentCmsDataFormQuestionRate_UserArgs = {
  filters?: InputMaybe<UsersPermissionsUserFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type ComponentCmsDataFormQuestionRate_User_RoleArgs = {
  filters?: InputMaybe<CrmRoleFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComponentCmsDataFormQuestionFiltersInput = {
  allocate_ach?: InputMaybe<AchievementFiltersInput>;
  allocate_house?: InputMaybe<HouseFiltersInput>;
  allocate_tags?: InputMaybe<ActiveCampaignAcTagFiltersInput>;
  allow_other_choice?: InputMaybe<BooleanFilterInput>;
  and?: InputMaybe<Array<InputMaybe<ComponentCmsDataFormQuestionFiltersInput>>>;
  background_color?: InputMaybe<StringFilterInput>;
  center_text?: InputMaybe<BooleanFilterInput>;
  choices?: InputMaybe<ComponentCmsDataFormQchoiceFiltersInput>;
  description?: InputMaybe<StringFilterInput>;
  description_color?: InputMaybe<StringFilterInput>;
  desktop_layout?: InputMaybe<StringFilterInput>;
  feedback_media_text?: InputMaybe<StringFilterInput>;
  image_position?: InputMaybe<StringFilterInput>;
  index?: InputMaybe<IntFilterInput>;
  input_color?: InputMaybe<StringFilterInput>;
  input_placeholder?: InputMaybe<StringFilterInput>;
  is_required?: InputMaybe<BooleanFilterInput>;
  is_transparent_button?: InputMaybe<BooleanFilterInput>;
  mobile_layout?: InputMaybe<StringFilterInput>;
  next_question_index?: InputMaybe<IntFilterInput>;
  not?: InputMaybe<ComponentCmsDataFormQuestionFiltersInput>;
  nr_columns?: InputMaybe<IntFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentCmsDataFormQuestionFiltersInput>>>;
  rate_user?: InputMaybe<UsersPermissionsUserFiltersInput>;
  rate_user_role?: InputMaybe<CrmRoleFiltersInput>;
  restart_form_timer?: InputMaybe<IntFilterInput>;
  send_review_to_google?: InputMaybe<BooleanFilterInput>;
  size?: InputMaybe<StringFilterInput>;
  space_from_top?: InputMaybe<FloatFilterInput>;
  submit_button_color?: InputMaybe<StringFilterInput>;
  submit_button_sticky?: InputMaybe<BooleanFilterInput>;
  submit_button_text?: InputMaybe<StringFilterInput>;
  submit_button_text_color?: InputMaybe<StringFilterInput>;
  title?: InputMaybe<StringFilterInput>;
  title_color?: InputMaybe<StringFilterInput>;
  type?: InputMaybe<StringFilterInput>;
  use_recaptcha?: InputMaybe<BooleanFilterInput>;
  vertical_alignment?: InputMaybe<StringFilterInput>;
};

export type ComponentCmsDataFormQuestionInput = {
  allocate_ach?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  allocate_house?: InputMaybe<Scalars['ID']>;
  allocate_tags?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  allow_other_choice?: InputMaybe<Scalars['Boolean']>;
  background_color?: InputMaybe<Scalars['String']>;
  center_text?: InputMaybe<Scalars['Boolean']>;
  choices?: InputMaybe<Array<InputMaybe<ComponentCmsDataFormQchoiceInput>>>;
  description?: InputMaybe<Scalars['String']>;
  description_color?: InputMaybe<Scalars['String']>;
  desktop_layout?: InputMaybe<Enum_Componentcmsdataformquestion_Desktop_Layout>;
  feedback_media?: InputMaybe<Scalars['ID']>;
  feedback_media_text?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  image?: InputMaybe<Scalars['ID']>;
  image_position?: InputMaybe<Enum_Componentcmsdataformquestion_Image_Position>;
  index?: InputMaybe<Scalars['Int']>;
  input_color?: InputMaybe<Scalars['String']>;
  input_placeholder?: InputMaybe<Scalars['String']>;
  is_required?: InputMaybe<Scalars['Boolean']>;
  is_transparent_button?: InputMaybe<Scalars['Boolean']>;
  mobile_layout?: InputMaybe<Enum_Componentcmsdataformquestion_Mobile_Layout>;
  next_question_index?: InputMaybe<Scalars['Int']>;
  nr_columns?: InputMaybe<Scalars['Int']>;
  rate_user?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  rate_user_role?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  restart_form_timer?: InputMaybe<Scalars['Int']>;
  send_review_to_google?: InputMaybe<Scalars['Boolean']>;
  size?: InputMaybe<Enum_Componentcmsdataformquestion_Size>;
  space_from_top?: InputMaybe<Scalars['Float']>;
  submit_button_color?: InputMaybe<Scalars['String']>;
  submit_button_sticky?: InputMaybe<Scalars['Boolean']>;
  submit_button_text?: InputMaybe<Scalars['String']>;
  submit_button_text_color?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  title_color?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Enum_Componentcmsdataformquestion_Type>;
  use_recaptcha?: InputMaybe<Scalars['Boolean']>;
  vertical_alignment?: InputMaybe<Enum_Componentcmsdataformquestion_Vertical_Alignment>;
  video?: InputMaybe<Scalars['ID']>;
};

export type ComponentCmsDataHeaderSection = {
  __typename?: 'ComponentCmsDataHeaderSection';
  button?: Maybe<ComponentCmsDataButton>;
  helloBarContent?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  image?: Maybe<UploadFileEntityResponse>;
  mobileImage?: Maybe<UploadFileEntityResponse>;
};

export type ComponentCmsDataHeroSection = {
  __typename?: 'ComponentCmsDataHeroSection';
  bgColor?: Maybe<Scalars['String']>;
  box?: Maybe<Scalars['Boolean']>;
  boxColor?: Maybe<Scalars['String']>;
  button?: Maybe<ComponentCmsDataButton>;
  countDownTimer?: Maybe<ComponentCmsDataCountDownTimer>;
  id: Scalars['ID'];
  image?: Maybe<UploadFileEntityResponse>;
  mainTitle: Scalars['String'];
  mobileImage?: Maybe<UploadFileEntityResponse>;
  secondaryTitle?: Maybe<Scalars['String']>;
  textColor?: Maybe<Scalars['String']>;
  textShadow?: Maybe<Scalars['Boolean']>;
  topTitle?: Maybe<Scalars['String']>;
};

export type ComponentCmsDataHeroSectionFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentCmsDataHeroSectionFiltersInput>>>;
  bgColor?: InputMaybe<StringFilterInput>;
  box?: InputMaybe<BooleanFilterInput>;
  boxColor?: InputMaybe<StringFilterInput>;
  button?: InputMaybe<ComponentCmsDataButtonFiltersInput>;
  countDownTimer?: InputMaybe<ComponentCmsDataCountDownTimerFiltersInput>;
  mainTitle?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentCmsDataHeroSectionFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentCmsDataHeroSectionFiltersInput>>>;
  secondaryTitle?: InputMaybe<StringFilterInput>;
  textColor?: InputMaybe<StringFilterInput>;
  textShadow?: InputMaybe<BooleanFilterInput>;
  topTitle?: InputMaybe<StringFilterInput>;
};

export type ComponentCmsDataHeroSectionSlider = {
  __typename?: 'ComponentCmsDataHeroSectionSlider';
  autoPlay?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  items?: Maybe<Array<Maybe<ComponentCmsDataHeroSection>>>;
  name: Scalars['String'];
};


export type ComponentCmsDataHeroSectionSliderItemsArgs = {
  filters?: InputMaybe<ComponentCmsDataHeroSectionFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComponentCmsDataHeroSectionTwo = {
  __typename?: 'ComponentCmsDataHeroSectionTwo';
  belowTitle?: Maybe<Scalars['String']>;
  bottomText?: Maybe<Scalars['String']>;
  button?: Maybe<ComponentCmsDataButton>;
  id: Scalars['ID'];
  image?: Maybe<UploadFileEntityResponse>;
  mainTitle: Scalars['String'];
  mobileImage?: Maybe<UploadFileEntityResponse>;
  textAfterButton?: Maybe<Scalars['Boolean']>;
  topText?: Maybe<Scalars['String']>;
};

export type ComponentCmsDataIconCard = {
  __typename?: 'ComponentCmsDataIconCard';
  iconName: Scalars['String'];
  id: Scalars['ID'];
  large?: Maybe<Scalars['Boolean']>;
  subTitle?: Maybe<Scalars['String']>;
  title: Scalars['String'];
};

export type ComponentCmsDataIconCardFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentCmsDataIconCardFiltersInput>>>;
  iconName?: InputMaybe<StringFilterInput>;
  large?: InputMaybe<BooleanFilterInput>;
  not?: InputMaybe<ComponentCmsDataIconCardFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentCmsDataIconCardFiltersInput>>>;
  subTitle?: InputMaybe<StringFilterInput>;
  title?: InputMaybe<StringFilterInput>;
};

export type ComponentCmsDataIconCardsSection = {
  __typename?: 'ComponentCmsDataIconCardsSection';
  backgroundColor?: Maybe<Scalars['String']>;
  button?: Maybe<Array<Maybe<ComponentCmsDataButton>>>;
  centerText?: Maybe<Scalars['Boolean']>;
  hasExclamationMark?: Maybe<Scalars['Boolean']>;
  iconCards: Array<Maybe<ComponentCmsDataIconCard>>;
  id: Scalars['ID'];
  mainTitle: Scalars['String'];
  showAppButton?: Maybe<Scalars['Boolean']>;
  subTitle: Scalars['String'];
  topTitle: Scalars['String'];
};


export type ComponentCmsDataIconCardsSectionButtonArgs = {
  filters?: InputMaybe<ComponentCmsDataButtonFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type ComponentCmsDataIconCardsSectionIconCardsArgs = {
  filters?: InputMaybe<ComponentCmsDataIconCardFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComponentCmsDataImageCard = {
  __typename?: 'ComponentCmsDataImageCard';
  backgroundColor?: Maybe<Scalars['String']>;
  buttonText?: Maybe<Scalars['String']>;
  buttonUrl?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  large?: Maybe<Scalars['Boolean']>;
  logo?: Maybe<UploadFileEntityResponse>;
  picture?: Maybe<UploadFileEntityResponse>;
  popup?: Maybe<Scalars['Boolean']>;
  popupRichText?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
  textColor?: Maybe<Scalars['String']>;
  title: Scalars['String'];
};

export type ComponentCmsDataImageCardFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentCmsDataImageCardFiltersInput>>>;
  backgroundColor?: InputMaybe<StringFilterInput>;
  buttonText?: InputMaybe<StringFilterInput>;
  buttonUrl?: InputMaybe<StringFilterInput>;
  large?: InputMaybe<BooleanFilterInput>;
  not?: InputMaybe<ComponentCmsDataImageCardFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentCmsDataImageCardFiltersInput>>>;
  popup?: InputMaybe<BooleanFilterInput>;
  popupRichText?: InputMaybe<StringFilterInput>;
  text?: InputMaybe<StringFilterInput>;
  textColor?: InputMaybe<StringFilterInput>;
  title?: InputMaybe<StringFilterInput>;
};

export type ComponentCmsDataImageCardsSection = {
  __typename?: 'ComponentCmsDataImageCardsSection';
  backgroundColor?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  items?: Maybe<Array<Maybe<ComponentCmsDataImageCard>>>;
  title?: Maybe<Scalars['String']>;
};


export type ComponentCmsDataImageCardsSectionItemsArgs = {
  filters?: InputMaybe<ComponentCmsDataImageCardFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComponentCmsDataImageGallery = {
  __typename?: 'ComponentCmsDataImageGallery';
  backgroundColor?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  items?: Maybe<Array<Maybe<ComponentCmsDataImageGalleryItem>>>;
};


export type ComponentCmsDataImageGalleryItemsArgs = {
  filters?: InputMaybe<ComponentCmsDataImageGalleryItemFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComponentCmsDataImageGalleryItem = {
  __typename?: 'ComponentCmsDataImageGalleryItem';
  category?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  image?: Maybe<UploadFileEntityResponse>;
  title?: Maybe<Scalars['String']>;
};

export type ComponentCmsDataImageGalleryItemFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentCmsDataImageGalleryItemFiltersInput>>>;
  category?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentCmsDataImageGalleryItemFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentCmsDataImageGalleryItemFiltersInput>>>;
  title?: InputMaybe<StringFilterInput>;
};

export type ComponentCmsDataImageMapCircle = {
  __typename?: 'ComponentCmsDataImageMapCircle';
  details?: Maybe<ComponentCmsDataImageMapDetail>;
  id: Scalars['ID'];
  position_x: Scalars['Float'];
  position_y: Scalars['Float'];
  radius: Scalars['Float'];
};

export type ComponentCmsDataImageMapCircleFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentCmsDataImageMapCircleFiltersInput>>>;
  details?: InputMaybe<ComponentCmsDataImageMapDetailFiltersInput>;
  not?: InputMaybe<ComponentCmsDataImageMapCircleFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentCmsDataImageMapCircleFiltersInput>>>;
  position_x?: InputMaybe<FloatFilterInput>;
  position_y?: InputMaybe<FloatFilterInput>;
  radius?: InputMaybe<FloatFilterInput>;
};

export type ComponentCmsDataImageMapDetail = {
  __typename?: 'ComponentCmsDataImageMapDetail';
  description?: Maybe<Scalars['String']>;
  hover_icon?: Maybe<UploadFileEntityResponse>;
  id: Scalars['ID'];
  image?: Maybe<UploadFileEntityResponse>;
  non_hover_icon?: Maybe<UploadFileEntityResponse>;
  title: Scalars['String'];
};

export type ComponentCmsDataImageMapDetailFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentCmsDataImageMapDetailFiltersInput>>>;
  description?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentCmsDataImageMapDetailFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentCmsDataImageMapDetailFiltersInput>>>;
  title?: InputMaybe<StringFilterInput>;
};

export type ComponentCmsDataInteractiveImageMap = {
  __typename?: 'ComponentCmsDataInteractiveImageMap';
  circles?: Maybe<Array<Maybe<ComponentCmsDataImageMapCircle>>>;
  id: Scalars['ID'];
  image: UploadFileEntityResponse;
  title: Scalars['String'];
};


export type ComponentCmsDataInteractiveImageMapCirclesArgs = {
  filters?: InputMaybe<ComponentCmsDataImageMapCircleFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComponentCmsDataLightTopImgSection = {
  __typename?: 'ComponentCmsDataLightTopImgSection';
  centerText?: Maybe<Scalars['Boolean']>;
  countDownTimer?: Maybe<ComponentCmsDataCountDownTimer>;
  id: Scalars['ID'];
  mainTitle?: Maybe<Scalars['String']>;
  mobileTopImage?: Maybe<UploadFileEntityResponse>;
  textContent?: Maybe<Scalars['String']>;
  topImage?: Maybe<UploadFileEntityResponse>;
  topTitle?: Maybe<Scalars['String']>;
};

export type ComponentCmsDataMenuPages = {
  __typename?: 'ComponentCmsDataMenuPages';
  id: Scalars['ID'];
  info?: Maybe<Scalars['String']>;
  menu?: Maybe<MenuEntityResponse>;
};

export type ComponentCmsDataPriceBenefit = {
  __typename?: 'ComponentCmsDataPriceBenefit';
  icon?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isBold?: Maybe<Scalars['Boolean']>;
  isGrayedOut?: Maybe<Scalars['Boolean']>;
  isIndented?: Maybe<Scalars['Boolean']>;
  text?: Maybe<Scalars['String']>;
};

export type ComponentCmsDataPriceBenefitFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentCmsDataPriceBenefitFiltersInput>>>;
  icon?: InputMaybe<StringFilterInput>;
  isBold?: InputMaybe<BooleanFilterInput>;
  isGrayedOut?: InputMaybe<BooleanFilterInput>;
  isIndented?: InputMaybe<BooleanFilterInput>;
  not?: InputMaybe<ComponentCmsDataPriceBenefitFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentCmsDataPriceBenefitFiltersInput>>>;
  text?: InputMaybe<StringFilterInput>;
};

export type ComponentCmsDataPriceItem = {
  __typename?: 'ComponentCmsDataPriceItem';
  buttonText?: Maybe<Scalars['String']>;
  buttonUrl?: Maybe<Scalars['String']>;
  centerItemMainTitleHoriz?: Maybe<Scalars['Boolean']>;
  centerPriceHoriz?: Maybe<Scalars['Boolean']>;
  centerpriceBenefitsHoriz?: Maybe<Scalars['Boolean']>;
  highlightTag?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  itemDescription?: Maybe<Scalars['String']>;
  itemMainTitle?: Maybe<Scalars['String']>;
  itemMainTitleColor?: Maybe<Scalars['String']>;
  itemTopTitle?: Maybe<Scalars['String']>;
  itemTopTitleColor?: Maybe<Scalars['String']>;
  monthlyDiscountedPrice?: Maybe<Scalars['String']>;
  monthlyRegularPrice?: Maybe<Scalars['String']>;
  monthlyUnderPriceText?: Maybe<Scalars['String']>;
  priceBenefits?: Maybe<Array<Maybe<ComponentCmsDataPriceBenefit>>>;
  yearlyDiscountedPrice?: Maybe<Scalars['String']>;
  yearlyRegularPrice?: Maybe<Scalars['String']>;
  yearlyUnderPriceText?: Maybe<Scalars['String']>;
};


export type ComponentCmsDataPriceItemPriceBenefitsArgs = {
  filters?: InputMaybe<ComponentCmsDataPriceBenefitFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComponentCmsDataPriceItemFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentCmsDataPriceItemFiltersInput>>>;
  buttonText?: InputMaybe<StringFilterInput>;
  buttonUrl?: InputMaybe<StringFilterInput>;
  centerItemMainTitleHoriz?: InputMaybe<BooleanFilterInput>;
  centerPriceHoriz?: InputMaybe<BooleanFilterInput>;
  centerpriceBenefitsHoriz?: InputMaybe<BooleanFilterInput>;
  highlightTag?: InputMaybe<StringFilterInput>;
  itemDescription?: InputMaybe<StringFilterInput>;
  itemMainTitle?: InputMaybe<StringFilterInput>;
  itemMainTitleColor?: InputMaybe<StringFilterInput>;
  itemTopTitle?: InputMaybe<StringFilterInput>;
  itemTopTitleColor?: InputMaybe<StringFilterInput>;
  monthlyDiscountedPrice?: InputMaybe<StringFilterInput>;
  monthlyRegularPrice?: InputMaybe<StringFilterInput>;
  monthlyUnderPriceText?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentCmsDataPriceItemFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentCmsDataPriceItemFiltersInput>>>;
  priceBenefits?: InputMaybe<ComponentCmsDataPriceBenefitFiltersInput>;
  yearlyDiscountedPrice?: InputMaybe<StringFilterInput>;
  yearlyRegularPrice?: InputMaybe<StringFilterInput>;
  yearlyUnderPriceText?: InputMaybe<StringFilterInput>;
};

export type ComponentCmsDataPriceSection = {
  __typename?: 'ComponentCmsDataPriceSection';
  centerTitle?: Maybe<Scalars['Boolean']>;
  countDownTimer?: Maybe<ComponentCmsDataCountDownTimer>;
  description?: Maybe<Scalars['String']>;
  descriptionColor?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  mainTitle?: Maybe<Scalars['String']>;
  mainTitleColor?: Maybe<Scalars['String']>;
  priceItems?: Maybe<Array<Maybe<ComponentCmsDataPriceItem>>>;
  priceItemsPerSlideWeb?: Maybe<Scalars['Int']>;
  sectionId?: Maybe<Scalars['String']>;
  shortDescription?: Maybe<Scalars['String']>;
  showAsSlider?: Maybe<Scalars['Boolean']>;
  showAsSliderWeb?: Maybe<Scalars['Boolean']>;
  topTitle?: Maybe<Scalars['String']>;
  topTitleColor?: Maybe<Scalars['String']>;
};


export type ComponentCmsDataPriceSectionPriceItemsArgs = {
  filters?: InputMaybe<ComponentCmsDataPriceItemFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComponentCmsDataProductsList = {
  __typename?: 'ComponentCmsDataProductsList';
  displayType: Enum_Componentcmsdataproductslist_Displaytype;
  groupByCategory?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  menu?: Maybe<MenuEntityResponse>;
  popupType?: Maybe<Enum_Componentcmsdataproductslist_Popuptype>;
  products?: Maybe<ProductRelationResponseCollection>;
  show?: Maybe<Scalars['JSON']>;
  showInPopup?: Maybe<Scalars['JSON']>;
  size: Enum_Componentcmsdataproductslist_Size;
};


export type ComponentCmsDataProductsListProductsArgs = {
  filters?: InputMaybe<ProductFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComponentCmsDataReusable = {
  __typename?: 'ComponentCmsDataReusable';
  id: Scalars['ID'];
  reusable_component?: Maybe<ReusableComponentEntityResponse>;
};

export type ComponentCmsDataReviewItem = {
  __typename?: 'ComponentCmsDataReviewItem';
  authorLocation?: Maybe<Scalars['String']>;
  authorName?: Maybe<Scalars['String']>;
  authorOccupations?: Maybe<Scalars['String']>;
  authorPicture?: Maybe<UploadFileEntityResponse>;
  content?: Maybe<Scalars['String']>;
  contentNrOfChars?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  showPictureAsCircle?: Maybe<Scalars['Boolean']>;
  title?: Maybe<Scalars['String']>;
};

export type ComponentCmsDataReviewItemFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentCmsDataReviewItemFiltersInput>>>;
  authorLocation?: InputMaybe<StringFilterInput>;
  authorName?: InputMaybe<StringFilterInput>;
  authorOccupations?: InputMaybe<StringFilterInput>;
  content?: InputMaybe<StringFilterInput>;
  contentNrOfChars?: InputMaybe<IntFilterInput>;
  not?: InputMaybe<ComponentCmsDataReviewItemFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentCmsDataReviewItemFiltersInput>>>;
  showPictureAsCircle?: InputMaybe<BooleanFilterInput>;
  title?: InputMaybe<StringFilterInput>;
};

export type ComponentCmsDataReviewsSection = {
  __typename?: 'ComponentCmsDataReviewsSection';
  box?: Maybe<Scalars['Boolean']>;
  boxColor?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  hideImage?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  itemBoxColor?: Maybe<Scalars['String']>;
  itemBoxTextColor?: Maybe<Scalars['String']>;
  mainTitle?: Maybe<Scalars['String']>;
  reviewItems?: Maybe<Array<Maybe<ComponentCmsDataReviewItem>>>;
  size?: Maybe<Enum_Componentcmsdatareviewssection_Size>;
  textColor?: Maybe<Scalars['String']>;
  topTitle?: Maybe<Scalars['String']>;
};


export type ComponentCmsDataReviewsSectionReviewItemsArgs = {
  filters?: InputMaybe<ComponentCmsDataReviewItemFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComponentCmsDataRichText = {
  __typename?: 'ComponentCmsDataRichText';
  backgroundImage?: Maybe<UploadFileEntityResponse>;
  center?: Maybe<Scalars['Boolean']>;
  fullWidth?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  mobileBackgroundImage?: Maybe<UploadFileEntityResponse>;
  text?: Maybe<Scalars['String']>;
  verticalWider?: Maybe<Scalars['Boolean']>;
};

export type ComponentCmsDataRichTextFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentCmsDataRichTextFiltersInput>>>;
  center?: InputMaybe<BooleanFilterInput>;
  fullWidth?: InputMaybe<BooleanFilterInput>;
  not?: InputMaybe<ComponentCmsDataRichTextFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentCmsDataRichTextFiltersInput>>>;
  text?: InputMaybe<StringFilterInput>;
  verticalWider?: InputMaybe<BooleanFilterInput>;
};

export type ComponentCmsDataRichTextHtml = {
  __typename?: 'ComponentCmsDataRichTextHtml';
  backgroundImage?: Maybe<UploadFileEntityResponse>;
  center?: Maybe<Scalars['Boolean']>;
  fullWidth?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  mobileBackgroundImage?: Maybe<UploadFileEntityResponse>;
  text?: Maybe<Scalars['String']>;
  verticalWider?: Maybe<Scalars['Boolean']>;
};

export type ComponentCmsDataRichTextInput = {
  backgroundImage?: InputMaybe<Scalars['ID']>;
  center?: InputMaybe<Scalars['Boolean']>;
  fullWidth?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['ID']>;
  mobileBackgroundImage?: InputMaybe<Scalars['ID']>;
  text?: InputMaybe<Scalars['String']>;
  verticalWider?: InputMaybe<Scalars['Boolean']>;
};

export type ComponentCmsDataScheduleMeeting = {
  __typename?: 'ComponentCmsDataScheduleMeeting';
  buffer?: Maybe<Scalars['Int']>;
  buttonText?: Maybe<Scalars['String']>;
  crm_campaign?: Maybe<CampaignEntityResponse>;
  crm_cm_status?: Maybe<CrmCampaignMemberStatusEntityResponse>;
  crm_role?: Maybe<CrmRoleEntityResponse>;
  description?: Maybe<Scalars['String']>;
  formGroups?: Maybe<Array<Maybe<ComponentCmsDataFormGroup>>>;
  id: Scalars['ID'];
  meetingDescription?: Maybe<Scalars['String']>;
  meetingDuration?: Maybe<Scalars['Int']>;
  redirectUrl?: Maybe<Scalars['String']>;
  requiredName?: Maybe<Scalars['Boolean']>;
  requiredPhone?: Maybe<Scalars['Boolean']>;
  subtitle?: Maybe<Scalars['String']>;
  tags?: Maybe<ActiveCampaignAcTagRelationResponseCollection>;
  tasks?: Maybe<Array<Maybe<ComponentCmsDataScheduleTask>>>;
  title: Scalars['String'];
  users_with_rating?: Maybe<Array<Maybe<ComponentCrmDataCrmUserRating>>>;
};


export type ComponentCmsDataScheduleMeetingFormGroupsArgs = {
  filters?: InputMaybe<ComponentCmsDataFormGroupFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type ComponentCmsDataScheduleMeetingTagsArgs = {
  filters?: InputMaybe<ActiveCampaignAcTagFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type ComponentCmsDataScheduleMeetingTasksArgs = {
  filters?: InputMaybe<ComponentCmsDataScheduleTaskFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type ComponentCmsDataScheduleMeetingUsers_With_RatingArgs = {
  filters?: InputMaybe<ComponentCrmDataCrmUserRatingFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComponentCmsDataScheduleTask = {
  __typename?: 'ComponentCmsDataScheduleTask';
  due_in?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  info?: Maybe<Scalars['String']>;
  isDueInAfterCreationDate?: Maybe<Scalars['Boolean']>;
  sendNotification?: Maybe<Scalars['Boolean']>;
  status?: Maybe<Enum_Componentcmsdatascheduletask_Status>;
  title?: Maybe<Scalars['String']>;
  type?: Maybe<Enum_Componentcmsdatascheduletask_Type>;
  updateDueInOnReschedule?: Maybe<Scalars['Boolean']>;
};

export type ComponentCmsDataScheduleTaskFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentCmsDataScheduleTaskFiltersInput>>>;
  due_in?: InputMaybe<IntFilterInput>;
  info?: InputMaybe<StringFilterInput>;
  isDueInAfterCreationDate?: InputMaybe<BooleanFilterInput>;
  not?: InputMaybe<ComponentCmsDataScheduleTaskFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentCmsDataScheduleTaskFiltersInput>>>;
  sendNotification?: InputMaybe<BooleanFilterInput>;
  status?: InputMaybe<StringFilterInput>;
  title?: InputMaybe<StringFilterInput>;
  type?: InputMaybe<StringFilterInput>;
  updateDueInOnReschedule?: InputMaybe<BooleanFilterInput>;
};

export type ComponentCmsDataScheduleTaskInput = {
  due_in?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  info?: InputMaybe<Scalars['String']>;
  isDueInAfterCreationDate?: InputMaybe<Scalars['Boolean']>;
  sendNotification?: InputMaybe<Scalars['Boolean']>;
  status?: InputMaybe<Enum_Componentcmsdatascheduletask_Status>;
  title?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Enum_Componentcmsdatascheduletask_Type>;
  updateDueInOnReschedule?: InputMaybe<Scalars['Boolean']>;
};

export type ComponentCmsDataScrollListSection = {
  __typename?: 'ComponentCmsDataScrollListSection';
  backgroundImage?: Maybe<UploadFileEntityResponse>;
  bottomSectionImage?: Maybe<UploadFileEntityResponse>;
  bottomSectionTitle?: Maybe<Scalars['String']>;
  boxes: Array<Maybe<ComponentCmsDataBoxElement>>;
  button?: Maybe<ComponentCmsDataButton>;
  countDownTimer?: Maybe<ComponentCmsDataCountDownTimer>;
  id: Scalars['ID'];
  mainTitle: Scalars['String'];
  mobileBackgroundImage?: Maybe<UploadFileEntityResponse>;
  mobileBottomSectionImage?: Maybe<UploadFileEntityResponse>;
  secondaryTitle?: Maybe<Scalars['String']>;
  shortDescription?: Maybe<Scalars['String']>;
  topTitle?: Maybe<Scalars['String']>;
};


export type ComponentCmsDataScrollListSectionBoxesArgs = {
  filters?: InputMaybe<ComponentCmsDataBoxElementFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComponentCmsDataScrollToSection = {
  __typename?: 'ComponentCmsDataScrollToSection';
  id: Scalars['ID'];
  sectionId?: Maybe<Scalars['String']>;
};

export type ComponentCmsDataSingleTitleSection = {
  __typename?: 'ComponentCmsDataSingleTitleSection';
  backgroundColor?: Maybe<Scalars['String']>;
  center?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  mainTitle?: Maybe<Scalars['String']>;
  subTitle?: Maybe<Scalars['String']>;
  textColor?: Maybe<Scalars['String']>;
  topTitle?: Maybe<Scalars['String']>;
};

export type ComponentCmsDataSlider = {
  __typename?: 'ComponentCmsDataSlider';
  centerText?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  items?: Maybe<Array<Maybe<ComponentCmsDataSliderItem>>>;
  popup?: Maybe<Scalars['Boolean']>;
  popupRichText?: Maybe<Scalars['String']>;
  subTitle?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  type?: Maybe<Enum_Componentcmsdataslider_Type>;
};


export type ComponentCmsDataSliderItemsArgs = {
  filters?: InputMaybe<ComponentCmsDataSliderItemFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComponentCmsDataSliderItem = {
  __typename?: 'ComponentCmsDataSliderItem';
  bigTopText?: Maybe<Scalars['Boolean']>;
  body?: Maybe<Scalars['String']>;
  bodyColor?: Maybe<Scalars['String']>;
  bodyNrOfChars?: Maybe<Scalars['Int']>;
  frameColor?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  image?: Maybe<UploadFileEntityResponse>;
  link?: Maybe<Scalars['String']>;
  mobileImage?: Maybe<UploadFileEntityResponse>;
  subtitleOverImage?: Maybe<Scalars['Boolean']>;
  title: Scalars['String'];
  titleColor?: Maybe<Scalars['String']>;
  titleNrOfChars?: Maybe<Scalars['Int']>;
  underTexColor?: Maybe<Scalars['String']>;
  underText?: Maybe<Scalars['String']>;
  underTextNrOfChars?: Maybe<Scalars['Int']>;
};

export type ComponentCmsDataSliderItemFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentCmsDataSliderItemFiltersInput>>>;
  bigTopText?: InputMaybe<BooleanFilterInput>;
  body?: InputMaybe<StringFilterInput>;
  bodyColor?: InputMaybe<StringFilterInput>;
  bodyNrOfChars?: InputMaybe<IntFilterInput>;
  frameColor?: InputMaybe<StringFilterInput>;
  link?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentCmsDataSliderItemFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentCmsDataSliderItemFiltersInput>>>;
  subtitleOverImage?: InputMaybe<BooleanFilterInput>;
  title?: InputMaybe<StringFilterInput>;
  titleColor?: InputMaybe<StringFilterInput>;
  titleNrOfChars?: InputMaybe<IntFilterInput>;
  underTexColor?: InputMaybe<StringFilterInput>;
  underText?: InputMaybe<StringFilterInput>;
  underTextNrOfChars?: InputMaybe<IntFilterInput>;
};

export type ComponentCmsDataSubscriptionItem = {
  __typename?: 'ComponentCmsDataSubscriptionItem';
  description: Scalars['String'];
  id: Scalars['ID'];
  image?: Maybe<UploadFileEntityResponse>;
  maskImage?: Maybe<Scalars['Boolean']>;
  mobileImage?: Maybe<UploadFileEntityResponse>;
  title: Scalars['String'];
  video?: Maybe<UploadFileEntityResponse>;
};

export type ComponentCmsDataSubscriptionItemFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentCmsDataSubscriptionItemFiltersInput>>>;
  description?: InputMaybe<StringFilterInput>;
  maskImage?: InputMaybe<BooleanFilterInput>;
  not?: InputMaybe<ComponentCmsDataSubscriptionItemFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentCmsDataSubscriptionItemFiltersInput>>>;
  title?: InputMaybe<StringFilterInput>;
};

export type ComponentCmsDataSubscriptionPopup = {
  __typename?: 'ComponentCmsDataSubscriptionPopup';
  buttonText: Scalars['String'];
  id: Scalars['ID'];
  items: Array<Maybe<ComponentCmsDataSubscriptionItem>>;
  priceItems: Array<Maybe<ComponentCmsDataSubscriptionPriceItem>>;
};


export type ComponentCmsDataSubscriptionPopupItemsArgs = {
  filters?: InputMaybe<ComponentCmsDataSubscriptionItemFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type ComponentCmsDataSubscriptionPopupPriceItemsArgs = {
  filters?: InputMaybe<ComponentCmsDataSubscriptionPriceItemFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComponentCmsDataSubscriptionPriceItem = {
  __typename?: 'ComponentCmsDataSubscriptionPriceItem';
  checkoutUrl: Scalars['String'];
  highlightText?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  price: Scalars['String'];
  subtitle: Scalars['String'];
  title: Scalars['String'];
};

export type ComponentCmsDataSubscriptionPriceItemFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentCmsDataSubscriptionPriceItemFiltersInput>>>;
  checkoutUrl?: InputMaybe<StringFilterInput>;
  highlightText?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentCmsDataSubscriptionPriceItemFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentCmsDataSubscriptionPriceItemFiltersInput>>>;
  price?: InputMaybe<StringFilterInput>;
  subtitle?: InputMaybe<StringFilterInput>;
  title?: InputMaybe<StringFilterInput>;
};

export type ComponentCmsDataTextAndImageSection = {
  __typename?: 'ComponentCmsDataTextAndImageSection';
  backgroundColor?: Maybe<Scalars['String']>;
  bigImageOnMobile?: Maybe<Scalars['Boolean']>;
  button?: Maybe<Array<Maybe<ComponentCmsDataButton>>>;
  countDownTimer?: Maybe<ComponentCmsDataCountDownTimer>;
  hideImageOnMobile?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  image?: Maybe<UploadFileEntityResponse>;
  imageBackgroundMask?: Maybe<UploadFileEntityResponse>;
  imageMask?: Maybe<UploadFileEntityResponse>;
  mainTitle: Scalars['String'];
  mainTitleColor?: Maybe<Scalars['String']>;
  maskImage?: Maybe<Scalars['Boolean']>;
  mobileImage?: Maybe<UploadFileEntityResponse>;
  mobileImageBackgroundMask?: Maybe<UploadFileEntityResponse>;
  mobileImageMask?: Maybe<UploadFileEntityResponse>;
  mobileUnderTextImage?: Maybe<UploadFileEntityResponse>;
  reverse?: Maybe<Scalars['Boolean']>;
  rounded?: Maybe<Scalars['Boolean']>;
  shadow?: Maybe<Scalars['Boolean']>;
  textContent: Scalars['String'];
  textContentColor?: Maybe<Scalars['String']>;
  topTitle?: Maybe<Scalars['String']>;
  topTitleColor?: Maybe<Scalars['String']>;
  underTextImage?: Maybe<UploadFileEntityResponse>;
  variation?: Maybe<Enum_Componentcmsdatatextandimagesection_Variation>;
};


export type ComponentCmsDataTextAndImageSectionButtonArgs = {
  filters?: InputMaybe<ComponentCmsDataButtonFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComponentCmsDataTextWithIcon = {
  __typename?: 'ComponentCmsDataTextWithIcon';
  icon: Scalars['String'];
  id: Scalars['ID'];
  text: Scalars['String'];
};

export type ComponentCmsDataVideoSection = {
  __typename?: 'ComponentCmsDataVideoSection';
  belowTitleText?: Maybe<Scalars['String']>;
  bottomText?: Maybe<Scalars['String']>;
  button?: Maybe<ComponentCmsDataButton>;
  centerVideo?: Maybe<Scalars['Boolean']>;
  countdownTimer?: Maybe<ComponentCmsDataCountDownTimer>;
  id: Scalars['ID'];
  mainTitle?: Maybe<Scalars['String']>;
  textAfterButton?: Maybe<Scalars['Boolean']>;
  topText?: Maybe<Scalars['String']>;
  video?: Maybe<UploadFileEntityResponse>;
  videoMobile?: Maybe<UploadFileEntityResponse>;
};

export type ComponentCmsSettingsPaymentSettings = {
  __typename?: 'ComponentCmsSettingsPaymentSettings';
  api_secret_key: Scalars['String'];
  enabled?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  live_mode?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  payment_method_id: Scalars['String'];
};

export type ComponentCmsSettingsScheduledLink = {
  __typename?: 'ComponentCmsSettingsScheduledLink';
  availability: Enum_Componentcmssettingsscheduledlink_Availability;
  enabled?: Maybe<Scalars['Boolean']>;
  endTime: Scalars['Time'];
  id: Scalars['ID'];
  link: Scalars['String'];
  startTime: Scalars['Time'];
};

export type ComponentCrmDataCrmAccountPercentage = {
  __typename?: 'ComponentCrmDataCrmAccountPercentage';
  display_name?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  percentage?: Maybe<Scalars['Float']>;
  roles?: Maybe<CrmRoleRelationResponseCollection>;
  user?: Maybe<UsersPermissionsUserEntityResponse>;
};


export type ComponentCrmDataCrmAccountPercentageRolesArgs = {
  filters?: InputMaybe<CrmRoleFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComponentCrmDataCrmAccountPercentageFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentCrmDataCrmAccountPercentageFiltersInput>>>;
  display_name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentCrmDataCrmAccountPercentageFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentCrmDataCrmAccountPercentageFiltersInput>>>;
  percentage?: InputMaybe<FloatFilterInput>;
  roles?: InputMaybe<CrmRoleFiltersInput>;
  user?: InputMaybe<UsersPermissionsUserFiltersInput>;
};

export type ComponentCrmDataCrmAccountPercentageInput = {
  display_name?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  percentage?: InputMaybe<Scalars['Float']>;
  roles?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  user?: InputMaybe<Scalars['ID']>;
};

export type ComponentCrmDataCrmAccountRole = {
  __typename?: 'ComponentCrmDataCrmAccountRole';
  id: Scalars['ID'];
  roles?: Maybe<CrmRoleRelationResponseCollection>;
  user?: Maybe<UsersPermissionsUserEntityResponse>;
};


export type ComponentCrmDataCrmAccountRoleRolesArgs = {
  filters?: InputMaybe<CrmRoleFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComponentCrmDataCrmAccountRoleFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentCrmDataCrmAccountRoleFiltersInput>>>;
  display_name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentCrmDataCrmAccountRoleFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentCrmDataCrmAccountRoleFiltersInput>>>;
  roles?: InputMaybe<CrmRoleFiltersInput>;
  user?: InputMaybe<UsersPermissionsUserFiltersInput>;
};

export type ComponentCrmDataCrmAccountRoleInput = {
  display_name?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  roles?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  user?: InputMaybe<Scalars['ID']>;
};

export type ComponentCrmDataCrmActions = {
  __typename?: 'ComponentCrmDataCrmActions';
  action_date?: Maybe<Scalars['DateTime']>;
  action_info?: Maybe<Scalars['String']>;
  action_name: Enum_Componentcrmdatacrmactions_Action_Name;
  id: Scalars['ID'];
};

export type ComponentCrmDataCrmActionsFiltersInput = {
  action_date?: InputMaybe<DateTimeFilterInput>;
  action_info?: InputMaybe<StringFilterInput>;
  action_name?: InputMaybe<StringFilterInput>;
  and?: InputMaybe<Array<InputMaybe<ComponentCrmDataCrmActionsFiltersInput>>>;
  display_name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentCrmDataCrmActionsFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentCrmDataCrmActionsFiltersInput>>>;
};

export type ComponentCrmDataCrmActionsInput = {
  action_date?: InputMaybe<Scalars['DateTime']>;
  action_info?: InputMaybe<Scalars['String']>;
  action_name?: InputMaybe<Enum_Componentcrmdatacrmactions_Action_Name>;
  display_name?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
};

export type ComponentCrmDataCrmAiPrompt = {
  __typename?: 'ComponentCrmDataCrmAiPrompt';
  ai_answer?: Maybe<Scalars['String']>;
  email_sent?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  prompt_text?: Maybe<Scalars['String']>;
  prompt_type?: Maybe<PromptTypeEntityResponse>;
};

export type ComponentCrmDataCrmAiPromptFiltersInput = {
  ai_answer?: InputMaybe<StringFilterInput>;
  and?: InputMaybe<Array<InputMaybe<ComponentCrmDataCrmAiPromptFiltersInput>>>;
  email_sent?: InputMaybe<BooleanFilterInput>;
  not?: InputMaybe<ComponentCrmDataCrmAiPromptFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentCrmDataCrmAiPromptFiltersInput>>>;
  prompt_text?: InputMaybe<StringFilterInput>;
  prompt_type?: InputMaybe<PromptTypeFiltersInput>;
};

export type ComponentCrmDataCrmAiPromptInput = {
  ai_answer?: InputMaybe<Scalars['String']>;
  email_sent?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['ID']>;
  prompt_text?: InputMaybe<Scalars['String']>;
  prompt_type?: InputMaybe<Scalars['ID']>;
};

export type ComponentCrmDataCrmAssignedUser = {
  __typename?: 'ComponentCrmDataCrmAssignedUser';
  assigned?: Maybe<UsersPermissionsUserRelationResponseCollection>;
  id: Scalars['ID'];
  user?: Maybe<UsersPermissionsUserEntityResponse>;
};


export type ComponentCrmDataCrmAssignedUserAssignedArgs = {
  filters?: InputMaybe<UsersPermissionsUserFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComponentCrmDataCrmAssignedUserFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentCrmDataCrmAssignedUserFiltersInput>>>;
  assigned?: InputMaybe<UsersPermissionsUserFiltersInput>;
  display_name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentCrmDataCrmAssignedUserFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentCrmDataCrmAssignedUserFiltersInput>>>;
  user?: InputMaybe<UsersPermissionsUserFiltersInput>;
};

export type ComponentCrmDataCrmAssignedUserInput = {
  assigned?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  display_name?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  user?: InputMaybe<Scalars['ID']>;
};

export type ComponentCrmDataCrmMeeting = {
  __typename?: 'ComponentCrmDataCrmMeeting';
  assigned_users?: Maybe<Array<Maybe<ComponentCrmDataCrmAssignedUser>>>;
  crm_cm_status?: Maybe<CrmCampaignMemberStatusEntityResponse>;
  crm_role?: Maybe<CrmRoleEntityResponse>;
  formGroups?: Maybe<Array<Maybe<ComponentCmsDataFormGroup>>>;
  id: Scalars['ID'];
  meetingDescription?: Maybe<Scalars['String']>;
  meetingDuration: Scalars['Int'];
  scheduleBuffer?: Maybe<Scalars['Int']>;
  tags?: Maybe<ActiveCampaignAcTagRelationResponseCollection>;
  tasks?: Maybe<Array<Maybe<ComponentCmsDataScheduleTask>>>;
  title: Scalars['String'];
  users_with_rating?: Maybe<Array<Maybe<ComponentCrmDataCrmUserRating>>>;
};


export type ComponentCrmDataCrmMeetingAssigned_UsersArgs = {
  filters?: InputMaybe<ComponentCrmDataCrmAssignedUserFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type ComponentCrmDataCrmMeetingFormGroupsArgs = {
  filters?: InputMaybe<ComponentCmsDataFormGroupFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type ComponentCrmDataCrmMeetingTagsArgs = {
  filters?: InputMaybe<ActiveCampaignAcTagFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type ComponentCrmDataCrmMeetingTasksArgs = {
  filters?: InputMaybe<ComponentCmsDataScheduleTaskFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type ComponentCrmDataCrmMeetingUsers_With_RatingArgs = {
  filters?: InputMaybe<ComponentCrmDataCrmUserRatingFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComponentCrmDataCrmMeetingFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentCrmDataCrmMeetingFiltersInput>>>;
  assigned_users?: InputMaybe<ComponentCrmDataCrmAssignedUserFiltersInput>;
  crm_cm_status?: InputMaybe<CrmCampaignMemberStatusFiltersInput>;
  crm_role?: InputMaybe<CrmRoleFiltersInput>;
  formGroups?: InputMaybe<ComponentCmsDataFormGroupFiltersInput>;
  meetingDescription?: InputMaybe<StringFilterInput>;
  meetingDuration?: InputMaybe<IntFilterInput>;
  not?: InputMaybe<ComponentCrmDataCrmMeetingFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentCrmDataCrmMeetingFiltersInput>>>;
  scheduleBuffer?: InputMaybe<IntFilterInput>;
  tags?: InputMaybe<ActiveCampaignAcTagFiltersInput>;
  tasks?: InputMaybe<ComponentCmsDataScheduleTaskFiltersInput>;
  title?: InputMaybe<StringFilterInput>;
  users_with_rating?: InputMaybe<ComponentCrmDataCrmUserRatingFiltersInput>;
};

export type ComponentCrmDataCrmMeetingInput = {
  assigned_users?: InputMaybe<Array<InputMaybe<ComponentCrmDataCrmAssignedUserInput>>>;
  crm_cm_status?: InputMaybe<Scalars['ID']>;
  crm_role?: InputMaybe<Scalars['ID']>;
  formGroups?: InputMaybe<Array<InputMaybe<ComponentCmsDataFormGroupInput>>>;
  id?: InputMaybe<Scalars['ID']>;
  meetingDescription?: InputMaybe<Scalars['String']>;
  meetingDuration?: InputMaybe<Scalars['Int']>;
  scheduleBuffer?: InputMaybe<Scalars['Int']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  tasks?: InputMaybe<Array<InputMaybe<ComponentCmsDataScheduleTaskInput>>>;
  title?: InputMaybe<Scalars['String']>;
  users_with_rating?: InputMaybe<Array<InputMaybe<ComponentCrmDataCrmUserRatingInput>>>;
};

export type ComponentCrmDataCrmMeetingRecording = {
  __typename?: 'ComponentCrmDataCrmMeetingRecording';
  id: Scalars['ID'];
  title: Scalars['String'];
  url: Scalars['String'];
};

export type ComponentCrmDataCrmMeetingRecordingFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentCrmDataCrmMeetingRecordingFiltersInput>>>;
  not?: InputMaybe<ComponentCrmDataCrmMeetingRecordingFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentCrmDataCrmMeetingRecordingFiltersInput>>>;
  title?: InputMaybe<StringFilterInput>;
  url?: InputMaybe<StringFilterInput>;
};

export type ComponentCrmDataCrmMeetingRecordingInput = {
  id?: InputMaybe<Scalars['ID']>;
  title?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
};

export type ComponentCrmDataCrmUserProfile = {
  __typename?: 'ComponentCrmDataCrmUserProfile';
  calendar_link?: Maybe<Scalars['String']>;
  crm_roles?: Maybe<CrmRoleRelationResponseCollection>;
  id: Scalars['ID'];
  personal_meeting_link?: Maybe<Scalars['String']>;
};


export type ComponentCrmDataCrmUserProfileCrm_RolesArgs = {
  filters?: InputMaybe<CrmRoleFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComponentCrmDataCrmUserProfileFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentCrmDataCrmUserProfileFiltersInput>>>;
  calendar_link?: InputMaybe<StringFilterInput>;
  crm_roles?: InputMaybe<CrmRoleFiltersInput>;
  not?: InputMaybe<ComponentCrmDataCrmUserProfileFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentCrmDataCrmUserProfileFiltersInput>>>;
  personal_meeting_link?: InputMaybe<StringFilterInput>;
};

export type ComponentCrmDataCrmUserProfileInput = {
  calendar_link?: InputMaybe<Scalars['String']>;
  crm_roles?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  id?: InputMaybe<Scalars['ID']>;
  personal_meeting_link?: InputMaybe<Scalars['String']>;
};

export type ComponentCrmDataCrmUserRating = {
  __typename?: 'ComponentCrmDataCrmUserRating';
  id: Scalars['ID'];
  rating: Scalars['Int'];
  user?: Maybe<UsersPermissionsUserEntityResponse>;
};

export type ComponentCrmDataCrmUserRatingFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentCrmDataCrmUserRatingFiltersInput>>>;
  not?: InputMaybe<ComponentCrmDataCrmUserRatingFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentCrmDataCrmUserRatingFiltersInput>>>;
  rating?: InputMaybe<IntFilterInput>;
  user?: InputMaybe<UsersPermissionsUserFiltersInput>;
};

export type ComponentCrmDataCrmUserRatingInput = {
  id?: InputMaybe<Scalars['ID']>;
  rating?: InputMaybe<Scalars['Int']>;
  user?: InputMaybe<Scalars['ID']>;
};

export type ComponentCrmDataUtmData = {
  __typename?: 'ComponentCrmDataUtmData';
  id: Scalars['ID'];
  utm_campaign?: Maybe<Scalars['String']>;
  utm_id?: Maybe<Scalars['String']>;
  utm_medium?: Maybe<Enum_Componentcrmdatautmdata_Utm_Medium>;
  utm_source?: Maybe<Enum_Componentcrmdatautmdata_Utm_Source>;
};

export type ComponentCrmDataUtmDataFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentCrmDataUtmDataFiltersInput>>>;
  not?: InputMaybe<ComponentCrmDataUtmDataFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentCrmDataUtmDataFiltersInput>>>;
  utm_campaign?: InputMaybe<StringFilterInput>;
  utm_id?: InputMaybe<StringFilterInput>;
  utm_medium?: InputMaybe<StringFilterInput>;
  utm_source?: InputMaybe<StringFilterInput>;
};

export type ComponentCrmDataUtmDataInput = {
  id?: InputMaybe<Scalars['ID']>;
  utm_campaign?: InputMaybe<Scalars['String']>;
  utm_id?: InputMaybe<Scalars['String']>;
  utm_medium?: InputMaybe<Enum_Componentcrmdatautmdata_Utm_Medium>;
  utm_source?: InputMaybe<Enum_Componentcrmdatautmdata_Utm_Source>;
};

export type ComponentGeneralCalendarBookingSlot = {
  __typename?: 'ComponentGeneralCalendarBookingSlot';
  active: Scalars['Boolean'];
  day: Scalars['Date'];
  end_time: Scalars['Time'];
  id: Scalars['ID'];
  slot_length?: Maybe<Scalars['Int']>;
  start_time: Scalars['Time'];
};

export type ComponentGeneralCalendarScheduledPrice = {
  __typename?: 'ComponentGeneralCalendarScheduledPrice';
  active: Scalars['Boolean'];
  end_date: Scalars['DateTime'];
  id: Scalars['ID'];
  price: Scalars['Float'];
  start_date: Scalars['DateTime'];
};

export type ComponentGeneralChanges = {
  __typename?: 'ComponentGeneralChanges';
  data?: Maybe<Scalars['JSON']>;
  date: Scalars['DateTime'];
  id: Scalars['ID'];
  info?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  user?: Maybe<UsersPermissionsUserEntityResponse>;
};

export type ComponentGeneralChangesFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentGeneralChangesFiltersInput>>>;
  data?: InputMaybe<JsonFilterInput>;
  date?: InputMaybe<DateTimeFilterInput>;
  info?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentGeneralChangesFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentGeneralChangesFiltersInput>>>;
  title?: InputMaybe<StringFilterInput>;
  user?: InputMaybe<UsersPermissionsUserFiltersInput>;
};

export type ComponentGeneralChangesInput = {
  data?: InputMaybe<Scalars['JSON']>;
  date?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['ID']>;
  info?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  user?: InputMaybe<Scalars['ID']>;
};

export type ComponentGeneralDailyBookingSlot = {
  __typename?: 'ComponentGeneralDailyBookingSlot';
  active: Scalars['Boolean'];
  day_of_week: Scalars['Int'];
  end_time: Scalars['Time'];
  id: Scalars['ID'];
  slot_length?: Maybe<Scalars['Int']>;
  start_time: Scalars['Time'];
};

export type ComponentGeneralDailyScheduledPrice = {
  __typename?: 'ComponentGeneralDailyScheduledPrice';
  active: Scalars['Boolean'];
  day_of_week: Scalars['Int'];
  end_time: Scalars['Time'];
  id: Scalars['ID'];
  price: Scalars['Float'];
  start_time: Scalars['Time'];
};

export type ComponentGeneralHouseWithVideo = {
  __typename?: 'ComponentGeneralHouseWithVideo';
  house?: Maybe<HouseEntityResponse>;
  id: Scalars['ID'];
  video: UploadFileEntityResponse;
};

export type ComponentGeneralHouseWithVideoFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentGeneralHouseWithVideoFiltersInput>>>;
  house?: InputMaybe<HouseFiltersInput>;
  not?: InputMaybe<ComponentGeneralHouseWithVideoFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentGeneralHouseWithVideoFiltersInput>>>;
};

export type ComponentGeneralHouseWithVideoInput = {
  house?: InputMaybe<Scalars['ID']>;
  id?: InputMaybe<Scalars['ID']>;
  video?: InputMaybe<Scalars['ID']>;
};

export type ComponentGeneralInvitations = {
  __typename?: 'ComponentGeneralInvitations';
  email?: Maybe<Scalars['String']>;
  first_name: Scalars['String'];
  id: Scalars['ID'];
  last_name?: Maybe<Scalars['String']>;
  number_of_adults?: Maybe<Scalars['Int']>;
  number_of_children?: Maybe<Scalars['Int']>;
  phone?: Maybe<Scalars['String']>;
  role: Enum_Componentgeneralinvitations_Role;
  status: Enum_Componentgeneralinvitations_Status;
  user?: Maybe<UsersPermissionsUserEntityResponse>;
};

export type ComponentGeneralInvitationsFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentGeneralInvitationsFiltersInput>>>;
  email?: InputMaybe<StringFilterInput>;
  first_name?: InputMaybe<StringFilterInput>;
  last_name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentGeneralInvitationsFiltersInput>;
  number_of_adults?: InputMaybe<IntFilterInput>;
  number_of_children?: InputMaybe<IntFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentGeneralInvitationsFiltersInput>>>;
  phone?: InputMaybe<StringFilterInput>;
  role?: InputMaybe<StringFilterInput>;
  status?: InputMaybe<StringFilterInput>;
  user?: InputMaybe<UsersPermissionsUserFiltersInput>;
};

export type ComponentGeneralInvitationsInput = {
  email?: InputMaybe<Scalars['String']>;
  first_name?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  last_name?: InputMaybe<Scalars['String']>;
  number_of_adults?: InputMaybe<Scalars['Int']>;
  number_of_children?: InputMaybe<Scalars['Int']>;
  phone?: InputMaybe<Scalars['String']>;
  role?: InputMaybe<Enum_Componentgeneralinvitations_Role>;
  status?: InputMaybe<Enum_Componentgeneralinvitations_Status>;
  user?: InputMaybe<Scalars['ID']>;
};

export type ComponentGeneralTable = {
  __typename?: 'ComponentGeneralTable';
  capacity: Scalars['Int'];
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type ComponentGeneralTableFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentGeneralTableFiltersInput>>>;
  capacity?: InputMaybe<IntFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentGeneralTableFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentGeneralTableFiltersInput>>>;
};

export type ComponentGeneralTableInput = {
  capacity?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
};

export type ComponentMenuCategoryItem = {
  __typename?: 'ComponentMenuCategoryItem';
  color?: Maybe<Scalars['String']>;
  description_dimension?: Maybe<Scalars['String']>;
  description_font?: Maybe<Scalars['String']>;
  entire_row?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  product_category?: Maybe<ProductCategoryEntityResponse>;
  title_dimension?: Maybe<Scalars['String']>;
  title_font?: Maybe<Scalars['String']>;
};

export type ComponentMenuEmptySpace = {
  __typename?: 'ComponentMenuEmptySpace';
  entire_row?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  size?: Maybe<Scalars['Int']>;
};

export type ComponentMenuPhoto = {
  __typename?: 'ComponentMenuPhoto';
  entire_row?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  media: UploadFileEntityResponse;
};

export type ComponentMenuProductItem = {
  __typename?: 'ComponentMenuProductItem';
  available?: Maybe<Scalars['Boolean']>;
  description_dimension?: Maybe<Scalars['String']>;
  description_font?: Maybe<Scalars['String']>;
  entire_row?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  price_per_100g?: Maybe<Scalars['Boolean']>;
  price_type?: Maybe<Enum_Componentmenuproductitem_Price_Type>;
  product?: Maybe<ProductEntityResponse>;
  show_picture?: Maybe<Scalars['Boolean']>;
  show_weight?: Maybe<Scalars['Boolean']>;
  space_1?: Maybe<Scalars['Int']>;
  space_2?: Maybe<Scalars['Int']>;
  space_3?: Maybe<Scalars['Int']>;
  space_4?: Maybe<Scalars['Int']>;
  title_dimension?: Maybe<Scalars['String']>;
  title_font?: Maybe<Scalars['String']>;
};

export type ComponentMenuProductWithQuantity = {
  __typename?: 'ComponentMenuProductWithQuantity';
  discount_amount?: Maybe<Scalars['Float']>;
  discount_percentage?: Maybe<Scalars['Float']>;
  id: Scalars['ID'];
  info?: Maybe<Scalars['String']>;
  preorder?: Maybe<Scalars['Boolean']>;
  product?: Maybe<ProductEntityResponse>;
  quantity: Scalars['Float'];
};

export type ComponentMenuProductWithQuantityFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentMenuProductWithQuantityFiltersInput>>>;
  discount_amount?: InputMaybe<FloatFilterInput>;
  discount_percentage?: InputMaybe<FloatFilterInput>;
  info?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentMenuProductWithQuantityFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentMenuProductWithQuantityFiltersInput>>>;
  preorder?: InputMaybe<BooleanFilterInput>;
  product?: InputMaybe<ProductFiltersInput>;
  quantity?: InputMaybe<FloatFilterInput>;
};

export type ComponentMenuProductWithQuantityInput = {
  discount_amount?: InputMaybe<Scalars['Float']>;
  discount_percentage?: InputMaybe<Scalars['Float']>;
  id?: InputMaybe<Scalars['ID']>;
  info?: InputMaybe<Scalars['String']>;
  preorder?: InputMaybe<Scalars['Boolean']>;
  product?: InputMaybe<Scalars['ID']>;
  quantity?: InputMaybe<Scalars['Float']>;
};

export type ComponentSharedMetaSocial = {
  __typename?: 'ComponentSharedMetaSocial';
  description: Scalars['String'];
  id: Scalars['ID'];
  image?: Maybe<UploadFileEntityResponse>;
  socialNetwork: Enum_Componentsharedmetasocial_Socialnetwork;
  title: Scalars['String'];
};

export type ComponentSharedMetaSocialFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentSharedMetaSocialFiltersInput>>>;
  description?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentSharedMetaSocialFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentSharedMetaSocialFiltersInput>>>;
  socialNetwork?: InputMaybe<StringFilterInput>;
  title?: InputMaybe<StringFilterInput>;
};

export type ComponentSharedMetaSocialInput = {
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  image?: InputMaybe<Scalars['ID']>;
  socialNetwork?: InputMaybe<Enum_Componentsharedmetasocial_Socialnetwork>;
  title?: InputMaybe<Scalars['String']>;
};

export type ComponentSharedSeo = {
  __typename?: 'ComponentSharedSeo';
  canonicalURL?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  keywords?: Maybe<Scalars['String']>;
  metaDescription: Scalars['String'];
  metaImage?: Maybe<UploadFileEntityResponse>;
  metaRobots?: Maybe<Scalars['String']>;
  metaSocial?: Maybe<Array<Maybe<ComponentSharedMetaSocial>>>;
  metaTitle: Scalars['String'];
  metaViewport?: Maybe<Scalars['String']>;
  structuredData?: Maybe<Scalars['JSON']>;
};


export type ComponentSharedSeoMetaSocialArgs = {
  filters?: InputMaybe<ComponentSharedMetaSocialFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComponentSharedSeoFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentSharedSeoFiltersInput>>>;
  canonicalURL?: InputMaybe<StringFilterInput>;
  keywords?: InputMaybe<StringFilterInput>;
  metaDescription?: InputMaybe<StringFilterInput>;
  metaRobots?: InputMaybe<StringFilterInput>;
  metaSocial?: InputMaybe<ComponentSharedMetaSocialFiltersInput>;
  metaTitle?: InputMaybe<StringFilterInput>;
  metaViewport?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentSharedSeoFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentSharedSeoFiltersInput>>>;
  structuredData?: InputMaybe<JsonFilterInput>;
};

export type ComponentSharedSeoInput = {
  canonicalURL?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  keywords?: InputMaybe<Scalars['String']>;
  metaDescription?: InputMaybe<Scalars['String']>;
  metaImage?: InputMaybe<Scalars['ID']>;
  metaRobots?: InputMaybe<Scalars['String']>;
  metaSocial?: InputMaybe<Array<InputMaybe<ComponentSharedMetaSocialInput>>>;
  metaTitle?: InputMaybe<Scalars['String']>;
  metaViewport?: InputMaybe<Scalars['String']>;
  structuredData?: InputMaybe<Scalars['JSON']>;
};

export type ComponentUserDataAddress = {
  __typename?: 'ComponentUserDataAddress';
  address_type: Enum_Componentuserdataaddress_Address_Type;
  apartment_number?: Maybe<Scalars['String']>;
  block_number?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  company_address?: Maybe<Scalars['String']>;
  company_identification_number?: Maybe<Scalars['String']>;
  company_name?: Maybe<Scalars['String']>;
  company_registration_number?: Maybe<Scalars['String']>;
  county?: Maybe<Scalars['String']>;
  first_name: Scalars['String'];
  floor_number?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  is_company?: Maybe<Scalars['Boolean']>;
  last_name: Scalars['String'];
  phone?: Maybe<Scalars['String']>;
  stair_number?: Maybe<Scalars['String']>;
  street?: Maybe<Scalars['String']>;
  street_number?: Maybe<Scalars['String']>;
  title: Scalars['String'];
};

export type ComponentUserDataAddressFiltersInput = {
  address_type?: InputMaybe<StringFilterInput>;
  and?: InputMaybe<Array<InputMaybe<ComponentUserDataAddressFiltersInput>>>;
  apartment_number?: InputMaybe<StringFilterInput>;
  block_number?: InputMaybe<StringFilterInput>;
  city?: InputMaybe<StringFilterInput>;
  company_address?: InputMaybe<StringFilterInput>;
  company_identification_number?: InputMaybe<StringFilterInput>;
  company_name?: InputMaybe<StringFilterInput>;
  company_registration_number?: InputMaybe<StringFilterInput>;
  county?: InputMaybe<StringFilterInput>;
  first_name?: InputMaybe<StringFilterInput>;
  floor_number?: InputMaybe<StringFilterInput>;
  is_company?: InputMaybe<BooleanFilterInput>;
  last_name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentUserDataAddressFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentUserDataAddressFiltersInput>>>;
  phone?: InputMaybe<StringFilterInput>;
  stair_number?: InputMaybe<StringFilterInput>;
  street?: InputMaybe<StringFilterInput>;
  street_number?: InputMaybe<StringFilterInput>;
  title?: InputMaybe<StringFilterInput>;
};

export type ComponentUserDataAddressInput = {
  address_type?: InputMaybe<Enum_Componentuserdataaddress_Address_Type>;
  apartment_number?: InputMaybe<Scalars['String']>;
  block_number?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  company_address?: InputMaybe<Scalars['String']>;
  company_identification_number?: InputMaybe<Scalars['String']>;
  company_name?: InputMaybe<Scalars['String']>;
  company_registration_number?: InputMaybe<Scalars['String']>;
  county?: InputMaybe<Scalars['String']>;
  first_name?: InputMaybe<Scalars['String']>;
  floor_number?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  is_company?: InputMaybe<Scalars['Boolean']>;
  last_name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  stair_number?: InputMaybe<Scalars['String']>;
  street?: InputMaybe<Scalars['String']>;
  street_number?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

export type ComponentUserDataNotificationSettings = {
  __typename?: 'ComponentUserDataNotificationSettings';
  id: Scalars['ID'];
  mobile?: Maybe<Scalars['Boolean']>;
  type?: Maybe<Scalars['String']>;
  web?: Maybe<Scalars['Boolean']>;
};

export type ComponentUserDataNotificationSettingsFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentUserDataNotificationSettingsFiltersInput>>>;
  mobile?: InputMaybe<BooleanFilterInput>;
  not?: InputMaybe<ComponentUserDataNotificationSettingsFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentUserDataNotificationSettingsFiltersInput>>>;
  type?: InputMaybe<StringFilterInput>;
  web?: InputMaybe<BooleanFilterInput>;
};

export type ComponentUserDataNotificationSettingsInput = {
  id?: InputMaybe<Scalars['ID']>;
  mobile?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Scalars['String']>;
  web?: InputMaybe<Scalars['Boolean']>;
};

export type Contact = {
  __typename?: 'Contact';
  acId?: Maybe<Scalars['String']>;
  age?: Maybe<Scalars['Int']>;
  completed_actions?: Maybe<Array<Maybe<ComponentCrmDataCrmActions>>>;
  contact_source?: Maybe<CrmContactSourceEntityResponse>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crm_campaign_members?: Maybe<CrmCampaignMemberRelationResponseCollection>;
  crm_contact_possible_duplicate_by?: Maybe<ContactEntityResponse>;
  crm_contact_possible_duplicate_of?: Maybe<ContactEntityResponse>;
  date?: Maybe<Scalars['DateTime']>;
  email: Scalars['String'];
  firstName?: Maybe<Scalars['String']>;
  form_submissions?: Maybe<EzformsSubmissionRelationResponseCollection>;
  info?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  tags?: Maybe<ActiveCampaignAcTagRelationResponseCollection>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<UsersPermissionsUserEntityResponse>;
};


export type ContactCompleted_ActionsArgs = {
  filters?: InputMaybe<ComponentCrmDataCrmActionsFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type ContactCrm_Campaign_MembersArgs = {
  filters?: InputMaybe<CrmCampaignMemberFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type ContactForm_SubmissionsArgs = {
  filters?: InputMaybe<EzformsSubmissionFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type ContactTagsArgs = {
  filters?: InputMaybe<ActiveCampaignAcTagFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ContactEntity = {
  __typename?: 'ContactEntity';
  attributes?: Maybe<Contact>;
  id?: Maybe<Scalars['ID']>;
};

export type ContactEntityResponse = {
  __typename?: 'ContactEntityResponse';
  data?: Maybe<ContactEntity>;
};

export type ContactEntityResponseCollection = {
  __typename?: 'ContactEntityResponseCollection';
  data: Array<ContactEntity>;
  meta: ResponseCollectionMeta;
};

export type ContactFiltersInput = {
  acId?: InputMaybe<StringFilterInput>;
  age?: InputMaybe<IntFilterInput>;
  and?: InputMaybe<Array<InputMaybe<ContactFiltersInput>>>;
  completed_actions?: InputMaybe<ComponentCrmDataCrmActionsFiltersInput>;
  contact_source?: InputMaybe<CrmContactSourceFiltersInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  crm_campaign_members?: InputMaybe<CrmCampaignMemberFiltersInput>;
  crm_contact_possible_duplicate_by?: InputMaybe<ContactFiltersInput>;
  crm_contact_possible_duplicate_of?: InputMaybe<ContactFiltersInput>;
  date?: InputMaybe<DateTimeFilterInput>;
  email?: InputMaybe<StringFilterInput>;
  firstName?: InputMaybe<StringFilterInput>;
  form_submissions?: InputMaybe<EzformsSubmissionFiltersInput>;
  id?: InputMaybe<IdFilterInput>;
  info?: InputMaybe<StringFilterInput>;
  lastName?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ContactFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ContactFiltersInput>>>;
  phoneNumber?: InputMaybe<StringFilterInput>;
  tags?: InputMaybe<ActiveCampaignAcTagFiltersInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  user?: InputMaybe<UsersPermissionsUserFiltersInput>;
};

export type ContactInput = {
  acId?: InputMaybe<Scalars['String']>;
  age?: InputMaybe<Scalars['Int']>;
  completed_actions?: InputMaybe<Array<InputMaybe<ComponentCrmDataCrmActionsInput>>>;
  contact_source?: InputMaybe<Scalars['ID']>;
  crm_campaign_members?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  crm_contact_possible_duplicate_by?: InputMaybe<Scalars['ID']>;
  crm_contact_possible_duplicate_of?: InputMaybe<Scalars['ID']>;
  date?: InputMaybe<Scalars['DateTime']>;
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  form_submissions?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  info?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  user?: InputMaybe<Scalars['ID']>;
};

export type ContactRelationResponseCollection = {
  __typename?: 'ContactRelationResponseCollection';
  data: Array<ContactEntity>;
};

export type CreditChange = {
  __typename?: 'CreditChange';
  access_card?: Maybe<AccessCardEntityResponse>;
  createdAt?: Maybe<Scalars['DateTime']>;
  credits?: Maybe<Scalars['Int']>;
  info?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<UsersPermissionsUserEntityResponse>;
};

export type CreditChangeEntity = {
  __typename?: 'CreditChangeEntity';
  attributes?: Maybe<CreditChange>;
  id?: Maybe<Scalars['ID']>;
};

export type CreditChangeEntityResponse = {
  __typename?: 'CreditChangeEntityResponse';
  data?: Maybe<CreditChangeEntity>;
};

export type CreditChangeEntityResponseCollection = {
  __typename?: 'CreditChangeEntityResponseCollection';
  data: Array<CreditChangeEntity>;
  meta: ResponseCollectionMeta;
};

export type CreditChangeFiltersInput = {
  access_card?: InputMaybe<AccessCardFiltersInput>;
  and?: InputMaybe<Array<InputMaybe<CreditChangeFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  credits?: InputMaybe<IntFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  info?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<CreditChangeFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<CreditChangeFiltersInput>>>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  user?: InputMaybe<UsersPermissionsUserFiltersInput>;
};

export type CreditChangeInput = {
  access_card?: InputMaybe<Scalars['ID']>;
  credits?: InputMaybe<Scalars['Int']>;
  info?: InputMaybe<Scalars['String']>;
  user?: InputMaybe<Scalars['ID']>;
};

export type CreditChangeRelationResponseCollection = {
  __typename?: 'CreditChangeRelationResponseCollection';
  data: Array<CreditChangeEntity>;
};

export type CrmCampaignMember = {
  __typename?: 'CrmCampaignMember';
  campaign_member_avatars?: Maybe<CampaignMemberAvatarRelationResponseCollection>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crm_campaign?: Maybe<CampaignEntityResponse>;
  crm_contact?: Maybe<ContactEntityResponse>;
  crm_tasks?: Maybe<CrmTaskRelationResponseCollection>;
  info?: Maybe<Scalars['String']>;
  reservations?: Maybe<ReservationRelationResponseCollection>;
  status?: Maybe<CrmCampaignMemberStatusEntityResponse>;
  statusUpdatedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  users_with_roles?: Maybe<Array<Maybe<ComponentCrmDataCrmAccountRole>>>;
  utm_data?: Maybe<ComponentCrmDataUtmData>;
};


export type CrmCampaignMemberCampaign_Member_AvatarsArgs = {
  filters?: InputMaybe<CampaignMemberAvatarFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type CrmCampaignMemberCrm_TasksArgs = {
  filters?: InputMaybe<CrmTaskFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type CrmCampaignMemberReservationsArgs = {
  filters?: InputMaybe<ReservationFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type CrmCampaignMemberUsers_With_RolesArgs = {
  filters?: InputMaybe<ComponentCrmDataCrmAccountRoleFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type CrmCampaignMemberEntity = {
  __typename?: 'CrmCampaignMemberEntity';
  attributes?: Maybe<CrmCampaignMember>;
  id?: Maybe<Scalars['ID']>;
};

export type CrmCampaignMemberEntityResponse = {
  __typename?: 'CrmCampaignMemberEntityResponse';
  data?: Maybe<CrmCampaignMemberEntity>;
};

export type CrmCampaignMemberEntityResponseCollection = {
  __typename?: 'CrmCampaignMemberEntityResponseCollection';
  data: Array<CrmCampaignMemberEntity>;
  meta: ResponseCollectionMeta;
};

export type CrmCampaignMemberFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<CrmCampaignMemberFiltersInput>>>;
  campaign_member_avatars?: InputMaybe<CampaignMemberAvatarFiltersInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  crm_campaign?: InputMaybe<CampaignFiltersInput>;
  crm_contact?: InputMaybe<ContactFiltersInput>;
  crm_tasks?: InputMaybe<CrmTaskFiltersInput>;
  id?: InputMaybe<IdFilterInput>;
  info?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<CrmCampaignMemberFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<CrmCampaignMemberFiltersInput>>>;
  reservations?: InputMaybe<ReservationFiltersInput>;
  status?: InputMaybe<CrmCampaignMemberStatusFiltersInput>;
  statusUpdatedAt?: InputMaybe<DateTimeFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  users_with_roles?: InputMaybe<ComponentCrmDataCrmAccountRoleFiltersInput>;
  utm_data?: InputMaybe<ComponentCrmDataUtmDataFiltersInput>;
};

export type CrmCampaignMemberInput = {
  campaign_member_avatars?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  crm_campaign?: InputMaybe<Scalars['ID']>;
  crm_contact?: InputMaybe<Scalars['ID']>;
  crm_tasks?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  info?: InputMaybe<Scalars['String']>;
  reservations?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  status?: InputMaybe<Scalars['ID']>;
  statusUpdatedAt?: InputMaybe<Scalars['DateTime']>;
  users_with_roles?: InputMaybe<Array<InputMaybe<ComponentCrmDataCrmAccountRoleInput>>>;
  utm_data?: InputMaybe<ComponentCrmDataUtmDataInput>;
};

export type CrmCampaignMemberRelationResponseCollection = {
  __typename?: 'CrmCampaignMemberRelationResponseCollection';
  data: Array<CrmCampaignMemberEntity>;
};

export type CrmCampaignMemberStatus = {
  __typename?: 'CrmCampaignMemberStatus';
  auto_assign_on_action?: Maybe<Scalars['JSON']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crm_campaign_members?: Maybe<CrmCampaignMemberRelationResponseCollection>;
  description?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  products?: Maybe<ProductRelationResponseCollection>;
  tags?: Maybe<ActiveCampaignAcTagRelationResponseCollection>;
  tags_remove?: Maybe<ActiveCampaignAcTagRelationResponseCollection>;
  task_feedbacks?: Maybe<CrmTaskFeedbackRelationResponseCollection>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};


export type CrmCampaignMemberStatusCrm_Campaign_MembersArgs = {
  filters?: InputMaybe<CrmCampaignMemberFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type CrmCampaignMemberStatusProductsArgs = {
  filters?: InputMaybe<ProductFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type CrmCampaignMemberStatusTagsArgs = {
  filters?: InputMaybe<ActiveCampaignAcTagFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type CrmCampaignMemberStatusTags_RemoveArgs = {
  filters?: InputMaybe<ActiveCampaignAcTagFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type CrmCampaignMemberStatusTask_FeedbacksArgs = {
  filters?: InputMaybe<CrmTaskFeedbackFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type CrmCampaignMemberStatusEntity = {
  __typename?: 'CrmCampaignMemberStatusEntity';
  attributes?: Maybe<CrmCampaignMemberStatus>;
  id?: Maybe<Scalars['ID']>;
};

export type CrmCampaignMemberStatusEntityResponse = {
  __typename?: 'CrmCampaignMemberStatusEntityResponse';
  data?: Maybe<CrmCampaignMemberStatusEntity>;
};

export type CrmCampaignMemberStatusEntityResponseCollection = {
  __typename?: 'CrmCampaignMemberStatusEntityResponseCollection';
  data: Array<CrmCampaignMemberStatusEntity>;
  meta: ResponseCollectionMeta;
};

export type CrmCampaignMemberStatusFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<CrmCampaignMemberStatusFiltersInput>>>;
  auto_assign_on_action?: InputMaybe<JsonFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  crm_campaign_members?: InputMaybe<CrmCampaignMemberFiltersInput>;
  description?: InputMaybe<StringFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<CrmCampaignMemberStatusFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<CrmCampaignMemberStatusFiltersInput>>>;
  products?: InputMaybe<ProductFiltersInput>;
  tags?: InputMaybe<ActiveCampaignAcTagFiltersInput>;
  tags_remove?: InputMaybe<ActiveCampaignAcTagFiltersInput>;
  task_feedbacks?: InputMaybe<CrmTaskFeedbackFiltersInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type CrmCampaignMemberStatusInput = {
  auto_assign_on_action?: InputMaybe<Scalars['JSON']>;
  crm_campaign_members?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  description?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  products?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  tags_remove?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  task_feedbacks?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

export type CrmCampaignMemberStatusRelationResponseCollection = {
  __typename?: 'CrmCampaignMemberStatusRelationResponseCollection';
  data: Array<CrmCampaignMemberStatusEntity>;
};

export type CrmContactAllocation = {
  __typename?: 'CrmContactAllocation';
  campaign_member_status?: Maybe<CrmCampaignMemberStatusEntityResponse>;
  contact_sources?: Maybe<CrmContactSourceRelationResponseCollection>;
  contact_tags?: Maybe<ActiveCampaignAcTagRelationResponseCollection>;
  contacts_count: Scalars['Int'];
  createdAt?: Maybe<Scalars['DateTime']>;
  crm_campaign?: Maybe<CampaignEntityResponse>;
  crm_role?: Maybe<CrmRoleEntityResponse>;
  excluded_contact_sources?: Maybe<CrmContactSourceRelationResponseCollection>;
  excluded_contact_tags?: Maybe<ActiveCampaignAcTagRelationResponseCollection>;
  lastAllocationDate?: Maybe<Scalars['DateTime']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
  recurring?: Maybe<Enum_Crmcontactallocation_Recurring>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  users?: Maybe<UsersPermissionsUserRelationResponseCollection>;
};


export type CrmContactAllocationContact_SourcesArgs = {
  filters?: InputMaybe<CrmContactSourceFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type CrmContactAllocationContact_TagsArgs = {
  filters?: InputMaybe<ActiveCampaignAcTagFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type CrmContactAllocationExcluded_Contact_SourcesArgs = {
  filters?: InputMaybe<CrmContactSourceFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type CrmContactAllocationExcluded_Contact_TagsArgs = {
  filters?: InputMaybe<ActiveCampaignAcTagFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type CrmContactAllocationUsersArgs = {
  filters?: InputMaybe<UsersPermissionsUserFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type CrmContactAllocationEntity = {
  __typename?: 'CrmContactAllocationEntity';
  attributes?: Maybe<CrmContactAllocation>;
  id?: Maybe<Scalars['ID']>;
};

export type CrmContactAllocationEntityResponse = {
  __typename?: 'CrmContactAllocationEntityResponse';
  data?: Maybe<CrmContactAllocationEntity>;
};

export type CrmContactAllocationEntityResponseCollection = {
  __typename?: 'CrmContactAllocationEntityResponseCollection';
  data: Array<CrmContactAllocationEntity>;
  meta: ResponseCollectionMeta;
};

export type CrmContactAllocationFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<CrmContactAllocationFiltersInput>>>;
  campaign_member_status?: InputMaybe<CrmCampaignMemberStatusFiltersInput>;
  contact_sources?: InputMaybe<CrmContactSourceFiltersInput>;
  contact_tags?: InputMaybe<ActiveCampaignAcTagFiltersInput>;
  contacts_count?: InputMaybe<IntFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  crm_campaign?: InputMaybe<CampaignFiltersInput>;
  crm_role?: InputMaybe<CrmRoleFiltersInput>;
  excluded_contact_sources?: InputMaybe<CrmContactSourceFiltersInput>;
  excluded_contact_tags?: InputMaybe<ActiveCampaignAcTagFiltersInput>;
  id?: InputMaybe<IdFilterInput>;
  lastAllocationDate?: InputMaybe<DateTimeFilterInput>;
  not?: InputMaybe<CrmContactAllocationFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<CrmContactAllocationFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  recurring?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  users?: InputMaybe<UsersPermissionsUserFiltersInput>;
};

export type CrmContactAllocationInput = {
  campaign_member_status?: InputMaybe<Scalars['ID']>;
  contact_sources?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  contact_tags?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  contacts_count?: InputMaybe<Scalars['Int']>;
  crm_campaign?: InputMaybe<Scalars['ID']>;
  crm_role?: InputMaybe<Scalars['ID']>;
  excluded_contact_sources?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  excluded_contact_tags?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  lastAllocationDate?: InputMaybe<Scalars['DateTime']>;
  publishedAt?: InputMaybe<Scalars['DateTime']>;
  recurring?: InputMaybe<Enum_Crmcontactallocation_Recurring>;
  users?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

export type CrmContactSource = {
  __typename?: 'CrmContactSource';
  createdAt?: Maybe<Scalars['DateTime']>;
  crm_contacts?: Maybe<ContactRelationResponseCollection>;
  crm_roles?: Maybe<CrmRoleRelationResponseCollection>;
  name: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};


export type CrmContactSourceCrm_ContactsArgs = {
  filters?: InputMaybe<ContactFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type CrmContactSourceCrm_RolesArgs = {
  filters?: InputMaybe<CrmRoleFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type CrmContactSourceEntity = {
  __typename?: 'CrmContactSourceEntity';
  attributes?: Maybe<CrmContactSource>;
  id?: Maybe<Scalars['ID']>;
};

export type CrmContactSourceEntityResponse = {
  __typename?: 'CrmContactSourceEntityResponse';
  data?: Maybe<CrmContactSourceEntity>;
};

export type CrmContactSourceEntityResponseCollection = {
  __typename?: 'CrmContactSourceEntityResponseCollection';
  data: Array<CrmContactSourceEntity>;
  meta: ResponseCollectionMeta;
};

export type CrmContactSourceFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<CrmContactSourceFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  crm_contacts?: InputMaybe<ContactFiltersInput>;
  crm_roles?: InputMaybe<CrmRoleFiltersInput>;
  id?: InputMaybe<IdFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<CrmContactSourceFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<CrmContactSourceFiltersInput>>>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type CrmContactSourceInput = {
  crm_contacts?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  crm_roles?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  name?: InputMaybe<Scalars['String']>;
};

export type CrmContactSourceRelationResponseCollection = {
  __typename?: 'CrmContactSourceRelationResponseCollection';
  data: Array<CrmContactSourceEntity>;
};

export type CrmLink = {
  __typename?: 'CrmLink';
  createdAt?: Maybe<Scalars['DateTime']>;
  crm_campaign?: Maybe<CampaignEntityResponse>;
  crm_campaign_member?: Maybe<CrmCampaignMemberEntityResponse>;
  crm_campaign_member_account_roles?: Maybe<Array<Maybe<ComponentCrmDataCrmAccountPercentage>>>;
  crm_links?: Maybe<CrmLinkRelationResponseCollection>;
  crm_task?: Maybe<CrmTaskEntityResponse>;
  identifier: Scalars['String'];
  orders?: Maybe<OrderRelationResponseCollection>;
  products?: Maybe<ProductRelationResponseCollection>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  utm_data?: Maybe<ComponentCrmDataUtmData>;
};


export type CrmLinkCrm_Campaign_Member_Account_RolesArgs = {
  filters?: InputMaybe<ComponentCrmDataCrmAccountPercentageFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type CrmLinkCrm_LinksArgs = {
  filters?: InputMaybe<CrmLinkFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type CrmLinkOrdersArgs = {
  filters?: InputMaybe<OrderFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type CrmLinkProductsArgs = {
  filters?: InputMaybe<ProductFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type CrmLinkEntity = {
  __typename?: 'CrmLinkEntity';
  attributes?: Maybe<CrmLink>;
  id?: Maybe<Scalars['ID']>;
};

export type CrmLinkEntityResponse = {
  __typename?: 'CrmLinkEntityResponse';
  data?: Maybe<CrmLinkEntity>;
};

export type CrmLinkEntityResponseCollection = {
  __typename?: 'CrmLinkEntityResponseCollection';
  data: Array<CrmLinkEntity>;
  meta: ResponseCollectionMeta;
};

export type CrmLinkFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<CrmLinkFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  crm_campaign?: InputMaybe<CampaignFiltersInput>;
  crm_campaign_member?: InputMaybe<CrmCampaignMemberFiltersInput>;
  crm_campaign_member_account_roles?: InputMaybe<ComponentCrmDataCrmAccountPercentageFiltersInput>;
  crm_links?: InputMaybe<CrmLinkFiltersInput>;
  crm_task?: InputMaybe<CrmTaskFiltersInput>;
  id?: InputMaybe<IdFilterInput>;
  identifier?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<CrmLinkFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<CrmLinkFiltersInput>>>;
  orders?: InputMaybe<OrderFiltersInput>;
  products?: InputMaybe<ProductFiltersInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  utm_data?: InputMaybe<ComponentCrmDataUtmDataFiltersInput>;
};

export type CrmLinkInput = {
  crm_campaign?: InputMaybe<Scalars['ID']>;
  crm_campaign_member?: InputMaybe<Scalars['ID']>;
  crm_campaign_member_account_roles?: InputMaybe<Array<InputMaybe<ComponentCrmDataCrmAccountPercentageInput>>>;
  crm_links?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  crm_task?: InputMaybe<Scalars['ID']>;
  identifier?: InputMaybe<Scalars['String']>;
  orders?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  products?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  utm_data?: InputMaybe<ComponentCrmDataUtmDataInput>;
};

export type CrmLinkRelationResponseCollection = {
  __typename?: 'CrmLinkRelationResponseCollection';
  data: Array<CrmLinkEntity>;
};

export type CrmRole = {
  __typename?: 'CrmRole';
  color?: Maybe<Scalars['String']>;
  contact_sources?: Maybe<CrmContactSourceRelationResponseCollection>;
  createdAt?: Maybe<Scalars['DateTime']>;
  name: Scalars['String'];
  permissions?: Maybe<Scalars['JSON']>;
  report_permissions?: Maybe<Scalars['JSON']>;
  sales_commision?: Maybe<Scalars['Float']>;
  slug?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};


export type CrmRoleContact_SourcesArgs = {
  filters?: InputMaybe<CrmContactSourceFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type CrmRoleEntity = {
  __typename?: 'CrmRoleEntity';
  attributes?: Maybe<CrmRole>;
  id?: Maybe<Scalars['ID']>;
};

export type CrmRoleEntityResponse = {
  __typename?: 'CrmRoleEntityResponse';
  data?: Maybe<CrmRoleEntity>;
};

export type CrmRoleEntityResponseCollection = {
  __typename?: 'CrmRoleEntityResponseCollection';
  data: Array<CrmRoleEntity>;
  meta: ResponseCollectionMeta;
};

export type CrmRoleFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<CrmRoleFiltersInput>>>;
  color?: InputMaybe<StringFilterInput>;
  contact_sources?: InputMaybe<CrmContactSourceFiltersInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<CrmRoleFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<CrmRoleFiltersInput>>>;
  permissions?: InputMaybe<JsonFilterInput>;
  report_permissions?: InputMaybe<JsonFilterInput>;
  sales_commision?: InputMaybe<FloatFilterInput>;
  slug?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type CrmRoleInput = {
  color?: InputMaybe<Scalars['String']>;
  contact_sources?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  name?: InputMaybe<Scalars['String']>;
  permissions?: InputMaybe<Scalars['JSON']>;
  report_permissions?: InputMaybe<Scalars['JSON']>;
  sales_commision?: InputMaybe<Scalars['Float']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type CrmRoleRelationResponseCollection = {
  __typename?: 'CrmRoleRelationResponseCollection';
  data: Array<CrmRoleEntity>;
};

export type CrmSetting = {
  __typename?: 'CrmSetting';
  caller_closer_percentage?: Maybe<Scalars['Float']>;
  caller_role?: Maybe<CrmRoleEntityResponse>;
  closer_role?: Maybe<CrmRoleEntityResponse>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CrmSettingEntity = {
  __typename?: 'CrmSettingEntity';
  attributes?: Maybe<CrmSetting>;
  id?: Maybe<Scalars['ID']>;
};

export type CrmSettingEntityResponse = {
  __typename?: 'CrmSettingEntityResponse';
  data?: Maybe<CrmSettingEntity>;
};

export type CrmSettingInput = {
  caller_closer_percentage?: InputMaybe<Scalars['Float']>;
  caller_role?: InputMaybe<Scalars['ID']>;
  closer_role?: InputMaybe<Scalars['ID']>;
};

export type CrmTask = {
  __typename?: 'CrmTask';
  ai_prompts?: Maybe<Array<Maybe<ComponentCrmDataCrmAiPrompt>>>;
  assignee?: Maybe<UsersPermissionsUserEntityResponse>;
  calendarEventId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crm_campaign?: Maybe<CampaignEntityResponse>;
  crm_campaign_member?: Maybe<CrmCampaignMemberEntityResponse>;
  crm_link?: Maybe<CrmLinkEntityResponse>;
  crm_task_template?: Maybe<CrmTaskTemplateEntityResponse>;
  dateBeforeReschedule?: Maybe<Scalars['DateTime']>;
  dueDate: Scalars['DateTime'];
  duration?: Maybe<Scalars['Int']>;
  feedback?: Maybe<CrmTaskFeedbackEntityResponse>;
  feedbackUpdatedAt?: Maybe<Scalars['DateTime']>;
  feedback_teamleader?: Maybe<Scalars['String']>;
  info?: Maybe<Scalars['String']>;
  meeting_recording_url?: Maybe<Scalars['String']>;
  meeting_recordings?: Maybe<Array<Maybe<ComponentCrmDataCrmMeetingRecording>>>;
  meeting_url?: Maybe<Scalars['String']>;
  prev_cancelled_meeting?: Maybe<CrmTaskEntityResponse>;
  questions?: Maybe<Scalars['JSON']>;
  rescheduled_meeting?: Maybe<CrmTaskEntityResponse>;
  scheduled_by?: Maybe<UsersPermissionsUserEntityResponse>;
  sendNotification?: Maybe<Scalars['Boolean']>;
  status: Enum_Crmtask_Status;
  statusDate?: Maybe<Scalars['DateTime']>;
  title: Scalars['String'];
  type?: Maybe<Enum_Crmtask_Type>;
  updateDueDateOnMeetingReschedule?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};


export type CrmTaskAi_PromptsArgs = {
  filters?: InputMaybe<ComponentCrmDataCrmAiPromptFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type CrmTaskMeeting_RecordingsArgs = {
  filters?: InputMaybe<ComponentCrmDataCrmMeetingRecordingFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type CrmTaskEntity = {
  __typename?: 'CrmTaskEntity';
  attributes?: Maybe<CrmTask>;
  id?: Maybe<Scalars['ID']>;
};

export type CrmTaskEntityResponse = {
  __typename?: 'CrmTaskEntityResponse';
  data?: Maybe<CrmTaskEntity>;
};

export type CrmTaskEntityResponseCollection = {
  __typename?: 'CrmTaskEntityResponseCollection';
  data: Array<CrmTaskEntity>;
  meta: ResponseCollectionMeta;
};

export type CrmTaskFeedback = {
  __typename?: 'CrmTaskFeedback';
  createdAt?: Maybe<Scalars['DateTime']>;
  crm_reports?: Maybe<Scalars['JSON']>;
  crm_tasks?: Maybe<CrmTaskRelationResponseCollection>;
  name?: Maybe<Scalars['String']>;
  tags?: Maybe<ActiveCampaignAcTagRelationResponseCollection>;
  tags_remove?: Maybe<ActiveCampaignAcTagRelationResponseCollection>;
  task_type?: Maybe<Enum_Crmtaskfeedback_Task_Type>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};


export type CrmTaskFeedbackCrm_TasksArgs = {
  filters?: InputMaybe<CrmTaskFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type CrmTaskFeedbackTagsArgs = {
  filters?: InputMaybe<ActiveCampaignAcTagFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type CrmTaskFeedbackTags_RemoveArgs = {
  filters?: InputMaybe<ActiveCampaignAcTagFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type CrmTaskFeedbackEntity = {
  __typename?: 'CrmTaskFeedbackEntity';
  attributes?: Maybe<CrmTaskFeedback>;
  id?: Maybe<Scalars['ID']>;
};

export type CrmTaskFeedbackEntityResponse = {
  __typename?: 'CrmTaskFeedbackEntityResponse';
  data?: Maybe<CrmTaskFeedbackEntity>;
};

export type CrmTaskFeedbackEntityResponseCollection = {
  __typename?: 'CrmTaskFeedbackEntityResponseCollection';
  data: Array<CrmTaskFeedbackEntity>;
  meta: ResponseCollectionMeta;
};

export type CrmTaskFeedbackFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<CrmTaskFeedbackFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  crm_reports?: InputMaybe<JsonFilterInput>;
  crm_tasks?: InputMaybe<CrmTaskFiltersInput>;
  id?: InputMaybe<IdFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<CrmTaskFeedbackFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<CrmTaskFeedbackFiltersInput>>>;
  tags?: InputMaybe<ActiveCampaignAcTagFiltersInput>;
  tags_remove?: InputMaybe<ActiveCampaignAcTagFiltersInput>;
  task_type?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type CrmTaskFeedbackInput = {
  crm_reports?: InputMaybe<Scalars['JSON']>;
  crm_tasks?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  name?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  tags_remove?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  task_type?: InputMaybe<Enum_Crmtaskfeedback_Task_Type>;
};

export type CrmTaskFeedbackRelationResponseCollection = {
  __typename?: 'CrmTaskFeedbackRelationResponseCollection';
  data: Array<CrmTaskFeedbackEntity>;
};

export type CrmTaskFiltersInput = {
  ai_prompts?: InputMaybe<ComponentCrmDataCrmAiPromptFiltersInput>;
  and?: InputMaybe<Array<InputMaybe<CrmTaskFiltersInput>>>;
  assignee?: InputMaybe<UsersPermissionsUserFiltersInput>;
  calendarEventId?: InputMaybe<StringFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  crm_campaign?: InputMaybe<CampaignFiltersInput>;
  crm_campaign_member?: InputMaybe<CrmCampaignMemberFiltersInput>;
  crm_link?: InputMaybe<CrmLinkFiltersInput>;
  crm_task_template?: InputMaybe<CrmTaskTemplateFiltersInput>;
  dateBeforeReschedule?: InputMaybe<DateTimeFilterInput>;
  dueDate?: InputMaybe<DateTimeFilterInput>;
  duration?: InputMaybe<IntFilterInput>;
  feedback?: InputMaybe<CrmTaskFeedbackFiltersInput>;
  feedbackUpdatedAt?: InputMaybe<DateTimeFilterInput>;
  feedback_teamleader?: InputMaybe<StringFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  info?: InputMaybe<StringFilterInput>;
  meeting_recording_url?: InputMaybe<StringFilterInput>;
  meeting_recordings?: InputMaybe<ComponentCrmDataCrmMeetingRecordingFiltersInput>;
  meeting_url?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<CrmTaskFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<CrmTaskFiltersInput>>>;
  prev_cancelled_meeting?: InputMaybe<CrmTaskFiltersInput>;
  questions?: InputMaybe<JsonFilterInput>;
  rescheduled_meeting?: InputMaybe<CrmTaskFiltersInput>;
  scheduled_by?: InputMaybe<UsersPermissionsUserFiltersInput>;
  sendNotification?: InputMaybe<BooleanFilterInput>;
  status?: InputMaybe<StringFilterInput>;
  statusDate?: InputMaybe<DateTimeFilterInput>;
  title?: InputMaybe<StringFilterInput>;
  type?: InputMaybe<StringFilterInput>;
  updateDueDateOnMeetingReschedule?: InputMaybe<BooleanFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type CrmTaskInput = {
  ai_prompts?: InputMaybe<Array<InputMaybe<ComponentCrmDataCrmAiPromptInput>>>;
  assignee?: InputMaybe<Scalars['ID']>;
  calendarEventId?: InputMaybe<Scalars['String']>;
  crm_campaign?: InputMaybe<Scalars['ID']>;
  crm_campaign_member?: InputMaybe<Scalars['ID']>;
  crm_link?: InputMaybe<Scalars['ID']>;
  crm_task_template?: InputMaybe<Scalars['ID']>;
  dateBeforeReschedule?: InputMaybe<Scalars['DateTime']>;
  dueDate?: InputMaybe<Scalars['DateTime']>;
  duration?: InputMaybe<Scalars['Int']>;
  feedback?: InputMaybe<Scalars['ID']>;
  feedbackUpdatedAt?: InputMaybe<Scalars['DateTime']>;
  feedback_teamleader?: InputMaybe<Scalars['String']>;
  info?: InputMaybe<Scalars['String']>;
  meeting_recording_url?: InputMaybe<Scalars['String']>;
  meeting_recordings?: InputMaybe<Array<InputMaybe<ComponentCrmDataCrmMeetingRecordingInput>>>;
  meeting_url?: InputMaybe<Scalars['String']>;
  prev_cancelled_meeting?: InputMaybe<Scalars['ID']>;
  questions?: InputMaybe<Scalars['JSON']>;
  rescheduled_meeting?: InputMaybe<Scalars['ID']>;
  scheduled_by?: InputMaybe<Scalars['ID']>;
  sendNotification?: InputMaybe<Scalars['Boolean']>;
  status?: InputMaybe<Enum_Crmtask_Status>;
  statusDate?: InputMaybe<Scalars['DateTime']>;
  title?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Enum_Crmtask_Type>;
  updateDueDateOnMeetingReschedule?: InputMaybe<Scalars['Boolean']>;
};

export type CrmTaskRelationResponseCollection = {
  __typename?: 'CrmTaskRelationResponseCollection';
  data: Array<CrmTaskEntity>;
};

export type CrmTaskTemplate = {
  __typename?: 'CrmTaskTemplate';
  auto_assign_on_action?: Maybe<Scalars['JSON']>;
  campaign_member_statuses?: Maybe<CrmCampaignMemberStatusRelationResponseCollection>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crm_role?: Maybe<CrmRoleEntityResponse>;
  crm_task_feedbacks?: Maybe<CrmTaskFeedbackRelationResponseCollection>;
  dueInMinutes: Scalars['Int'];
  info?: Maybe<Scalars['String']>;
  products?: Maybe<ProductRelationResponseCollection>;
  sendNotification?: Maybe<Scalars['Boolean']>;
  status: Enum_Crmtasktemplate_Status;
  title: Scalars['String'];
  type?: Maybe<Enum_Crmtasktemplate_Type>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  useRoleForTaskFeedback?: Maybe<Scalars['Boolean']>;
};


export type CrmTaskTemplateCampaign_Member_StatusesArgs = {
  filters?: InputMaybe<CrmCampaignMemberStatusFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type CrmTaskTemplateCrm_Task_FeedbacksArgs = {
  filters?: InputMaybe<CrmTaskFeedbackFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type CrmTaskTemplateProductsArgs = {
  filters?: InputMaybe<ProductFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type CrmTaskTemplateEntity = {
  __typename?: 'CrmTaskTemplateEntity';
  attributes?: Maybe<CrmTaskTemplate>;
  id?: Maybe<Scalars['ID']>;
};

export type CrmTaskTemplateEntityResponse = {
  __typename?: 'CrmTaskTemplateEntityResponse';
  data?: Maybe<CrmTaskTemplateEntity>;
};

export type CrmTaskTemplateEntityResponseCollection = {
  __typename?: 'CrmTaskTemplateEntityResponseCollection';
  data: Array<CrmTaskTemplateEntity>;
  meta: ResponseCollectionMeta;
};

export type CrmTaskTemplateFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<CrmTaskTemplateFiltersInput>>>;
  auto_assign_on_action?: InputMaybe<JsonFilterInput>;
  campaign_member_statuses?: InputMaybe<CrmCampaignMemberStatusFiltersInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  crm_role?: InputMaybe<CrmRoleFiltersInput>;
  crm_task_feedbacks?: InputMaybe<CrmTaskFeedbackFiltersInput>;
  dueInMinutes?: InputMaybe<IntFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  info?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<CrmTaskTemplateFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<CrmTaskTemplateFiltersInput>>>;
  products?: InputMaybe<ProductFiltersInput>;
  sendNotification?: InputMaybe<BooleanFilterInput>;
  status?: InputMaybe<StringFilterInput>;
  title?: InputMaybe<StringFilterInput>;
  type?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  useRoleForTaskFeedback?: InputMaybe<BooleanFilterInput>;
};

export type CrmTaskTemplateInput = {
  auto_assign_on_action?: InputMaybe<Scalars['JSON']>;
  campaign_member_statuses?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  crm_role?: InputMaybe<Scalars['ID']>;
  crm_task_feedbacks?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  dueInMinutes?: InputMaybe<Scalars['Int']>;
  info?: InputMaybe<Scalars['String']>;
  products?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  sendNotification?: InputMaybe<Scalars['Boolean']>;
  status?: InputMaybe<Enum_Crmtasktemplate_Status>;
  title?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Enum_Crmtasktemplate_Type>;
  useRoleForTaskFeedback?: InputMaybe<Scalars['Boolean']>;
};

export type CrmUserRating = {
  id: Scalars['ID'];
  rating: Scalars['Int'];
};

export type DailyTask = {
  __typename?: 'DailyTask';
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
  response_to_collect?: Maybe<Enum_Dailytask_Response_To_Collect>;
  title: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type DailyTaskClassroomMember = {
  __typename?: 'DailyTaskClassroomMember';
  classroom_member?: Maybe<ClassroomMemberEntityResponse>;
  createdAt?: Maybe<Scalars['DateTime']>;
  date?: Maybe<Scalars['Date']>;
  items?: Maybe<Array<Maybe<ComponentClassroomDailyTaskItem>>>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};


export type DailyTaskClassroomMemberItemsArgs = {
  filters?: InputMaybe<ComponentClassroomDailyTaskItemFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type DailyTaskClassroomMemberEntity = {
  __typename?: 'DailyTaskClassroomMemberEntity';
  attributes?: Maybe<DailyTaskClassroomMember>;
  id?: Maybe<Scalars['ID']>;
};

export type DailyTaskClassroomMemberEntityResponse = {
  __typename?: 'DailyTaskClassroomMemberEntityResponse';
  data?: Maybe<DailyTaskClassroomMemberEntity>;
};

export type DailyTaskClassroomMemberEntityResponseCollection = {
  __typename?: 'DailyTaskClassroomMemberEntityResponseCollection';
  data: Array<DailyTaskClassroomMemberEntity>;
  meta: ResponseCollectionMeta;
};

export type DailyTaskClassroomMemberFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<DailyTaskClassroomMemberFiltersInput>>>;
  classroom_member?: InputMaybe<ClassroomMemberFiltersInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  date?: InputMaybe<DateFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  items?: InputMaybe<ComponentClassroomDailyTaskItemFiltersInput>;
  not?: InputMaybe<DailyTaskClassroomMemberFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<DailyTaskClassroomMemberFiltersInput>>>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type DailyTaskClassroomMemberInput = {
  classroom_member?: InputMaybe<Scalars['ID']>;
  date?: InputMaybe<Scalars['Date']>;
  items?: InputMaybe<Array<InputMaybe<ComponentClassroomDailyTaskItemInput>>>;
};

export type DailyTaskClassroomMemberRelationResponseCollection = {
  __typename?: 'DailyTaskClassroomMemberRelationResponseCollection';
  data: Array<DailyTaskClassroomMemberEntity>;
};

export type DailyTaskEntity = {
  __typename?: 'DailyTaskEntity';
  attributes?: Maybe<DailyTask>;
  id?: Maybe<Scalars['ID']>;
};

export type DailyTaskEntityResponse = {
  __typename?: 'DailyTaskEntityResponse';
  data?: Maybe<DailyTaskEntity>;
};

export type DailyTaskEntityResponseCollection = {
  __typename?: 'DailyTaskEntityResponseCollection';
  data: Array<DailyTaskEntity>;
  meta: ResponseCollectionMeta;
};

export type DailyTaskFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<DailyTaskFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  description?: InputMaybe<StringFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  not?: InputMaybe<DailyTaskFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<DailyTaskFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  response_to_collect?: InputMaybe<StringFilterInput>;
  title?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type DailyTaskInput = {
  description?: InputMaybe<Scalars['String']>;
  publishedAt?: InputMaybe<Scalars['DateTime']>;
  response_to_collect?: InputMaybe<Enum_Dailytask_Response_To_Collect>;
  title?: InputMaybe<Scalars['String']>;
};

export type DateFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  contains?: InputMaybe<Scalars['Date']>;
  containsi?: InputMaybe<Scalars['Date']>;
  endsWith?: InputMaybe<Scalars['Date']>;
  eq?: InputMaybe<Scalars['Date']>;
  eqi?: InputMaybe<Scalars['Date']>;
  gt?: InputMaybe<Scalars['Date']>;
  gte?: InputMaybe<Scalars['Date']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  lt?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
  ne?: InputMaybe<Scalars['Date']>;
  nei?: InputMaybe<Scalars['Date']>;
  not?: InputMaybe<DateFilterInput>;
  notContains?: InputMaybe<Scalars['Date']>;
  notContainsi?: InputMaybe<Scalars['Date']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  notNull?: InputMaybe<Scalars['Boolean']>;
  null?: InputMaybe<Scalars['Boolean']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  startsWith?: InputMaybe<Scalars['Date']>;
};

export type DateTimeFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  contains?: InputMaybe<Scalars['DateTime']>;
  containsi?: InputMaybe<Scalars['DateTime']>;
  endsWith?: InputMaybe<Scalars['DateTime']>;
  eq?: InputMaybe<Scalars['DateTime']>;
  eqi?: InputMaybe<Scalars['DateTime']>;
  gt?: InputMaybe<Scalars['DateTime']>;
  gte?: InputMaybe<Scalars['DateTime']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  lt?: InputMaybe<Scalars['DateTime']>;
  lte?: InputMaybe<Scalars['DateTime']>;
  ne?: InputMaybe<Scalars['DateTime']>;
  nei?: InputMaybe<Scalars['DateTime']>;
  not?: InputMaybe<DateTimeFilterInput>;
  notContains?: InputMaybe<Scalars['DateTime']>;
  notContainsi?: InputMaybe<Scalars['DateTime']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  notNull?: InputMaybe<Scalars['Boolean']>;
  null?: InputMaybe<Scalars['Boolean']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  startsWith?: InputMaybe<Scalars['DateTime']>;
};

export type DefaultNotificationSetting = {
  __typename?: 'DefaultNotificationSetting';
  createdAt?: Maybe<Scalars['DateTime']>;
  settings?: Maybe<Array<Maybe<ComponentUserDataNotificationSettings>>>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};


export type DefaultNotificationSettingSettingsArgs = {
  filters?: InputMaybe<ComponentUserDataNotificationSettingsFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type DefaultNotificationSettingEntity = {
  __typename?: 'DefaultNotificationSettingEntity';
  attributes?: Maybe<DefaultNotificationSetting>;
  id?: Maybe<Scalars['ID']>;
};

export type DefaultNotificationSettingEntityResponse = {
  __typename?: 'DefaultNotificationSettingEntityResponse';
  data?: Maybe<DefaultNotificationSettingEntity>;
};

export type DefaultNotificationSettingInput = {
  settings?: InputMaybe<Array<InputMaybe<ComponentUserDataNotificationSettingsInput>>>;
};

export type Drimon = {
  __typename?: 'Drimon';
  createdAt?: Maybe<Scalars['DateTime']>;
  dragonType: Enum_Drimon_Dragontype;
  earthDamage: Scalars['Float'];
  fireDamage: Scalars['Float'];
  health: Scalars['Float'];
  iceDamage: Scalars['Float'];
  level: Scalars['Int'];
  lightningDamage: Scalars['Float'];
  name?: Maybe<Scalars['String']>;
  owners?: Maybe<UsersPermissionsUserRelationResponseCollection>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};


export type DrimonOwnersArgs = {
  filters?: InputMaybe<UsersPermissionsUserFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type DrimonEntity = {
  __typename?: 'DrimonEntity';
  attributes?: Maybe<Drimon>;
  id?: Maybe<Scalars['ID']>;
};

export type DrimonEntityResponse = {
  __typename?: 'DrimonEntityResponse';
  data?: Maybe<DrimonEntity>;
};

export type DrimonEntityResponseCollection = {
  __typename?: 'DrimonEntityResponseCollection';
  data: Array<DrimonEntity>;
  meta: ResponseCollectionMeta;
};

export type DrimonFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<DrimonFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  dragonType?: InputMaybe<StringFilterInput>;
  earthDamage?: InputMaybe<FloatFilterInput>;
  fireDamage?: InputMaybe<FloatFilterInput>;
  health?: InputMaybe<FloatFilterInput>;
  iceDamage?: InputMaybe<FloatFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  level?: InputMaybe<IntFilterInput>;
  lightningDamage?: InputMaybe<FloatFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<DrimonFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<DrimonFiltersInput>>>;
  owners?: InputMaybe<UsersPermissionsUserFiltersInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type DrimonInput = {
  dragonType?: InputMaybe<Enum_Drimon_Dragontype>;
  earthDamage?: InputMaybe<Scalars['Float']>;
  fireDamage?: InputMaybe<Scalars['Float']>;
  health?: InputMaybe<Scalars['Float']>;
  iceDamage?: InputMaybe<Scalars['Float']>;
  level?: InputMaybe<Scalars['Int']>;
  lightningDamage?: InputMaybe<Scalars['Float']>;
  name?: InputMaybe<Scalars['String']>;
  owners?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

export type DrimonRelationResponseCollection = {
  __typename?: 'DrimonRelationResponseCollection';
  data: Array<DrimonEntity>;
};

export enum Enum_Achievement_Type {
  Diploma = 'diploma',
  Experience = 'experience',
  Items = 'items',
  Other = 'other',
  Points = 'points'
}

export enum Enum_Activecampaignactag_Auto_Assign_On_Action {
  BuyProduct = 'buy_product',
  CampaignMemberAvatar = 'campaign_member_avatar',
  CampaignMemberStatus = 'campaign_member_status',
  CreditsConsumed = 'credits_consumed',
  CrmTaskFeedback = 'crm_task_feedback',
  ProductPayment = 'product_payment',
  Register = 'register'
}

export enum Enum_Activecampaignactag_Auto_Remove_On_Action {
  BuyProduct = 'buy_product',
  CampaignMemberAvatar = 'campaign_member_avatar',
  CampaignMemberStatus = 'campaign_member_status',
  CreditsConsumed = 'credits_consumed',
  CrmTaskFeedback = 'crm_task_feedback',
  ProductPayment = 'product_payment'
}

export enum Enum_Bledevice_Model {
  KkmW51 = 'kkm_w51',
  KkmW59 = 'kkm_w59'
}

export enum Enum_Classroommember_Role {
  Child = 'child',
  Coordinator = 'coordinator',
  Manager = 'manager',
  Parent = 'parent',
  Teacher = 'teacher'
}

export enum Enum_Componentclassroomdailytaskitem_Response_To_Collect {
  Boolean = 'boolean',
  Percentage = 'percentage',
  Text = 'text'
}

export enum Enum_Componentcmsdatablogarticles_Displaytype {
  Box = 'box',
  Slider = 'slider'
}

export enum Enum_Componentcmsdatablogarticles_Size {
  Big = 'big',
  Medium = 'medium',
  Small = 'small'
}

export enum Enum_Componentcmsdataformfieldcondition_Operation {
  ResponseIsEqualWith = 'response_is_equal_with',
  ResponseIsGreaterThan = 'response_is_greater_than',
  ResponseIsLessThan = 'response_is_less_than',
  ResponseIsNotEqualWith = 'response_is_not_equal_with'
}

export enum Enum_Componentcmsdataformfield_Type {
  Checkbox = 'checkbox',
  Checkboxes = 'checkboxes',
  Date = 'date',
  Datetime = 'datetime',
  Email = 'email',
  Multiselect = 'multiselect',
  Number = 'number',
  Phone = 'phone',
  Radio = 'radio',
  Radios = 'radios',
  Select = 'select',
  Text = 'text',
  Textarea = 'textarea',
  Time = 'time'
}

export enum Enum_Componentcmsdataformgroup_Type {
  Form = 'form',
  House = 'house',
  Team = 'team'
}

export enum Enum_Componentcmsdataformqchoice_Calculate_Rules {
  HasAllTags = 'has_all_tags',
  HasOneTag = 'has_one_tag'
}

export enum Enum_Componentcmsdataformqchoice_Jump_Condition_Operation {
  ResponseIsEqualWithChoice = 'response_is_equal_with_choice',
  ResponseIsGreaterThanChoice = 'response_is_greater_than_choice',
  ResponseIsLessThanChoice = 'response_is_less_than_choice',
  ResponseIsNotEqualWithChoice = 'response_is_not_equal_with_choice'
}

export enum Enum_Componentcmsdataformquestion_Desktop_Layout {
  FullBackground = 'full_background',
  FullImageLeft = 'full_image_left',
  FullImageRight = 'full_image_right',
  LandscapeImageLeft = 'landscape_image_left',
  LandscapeImageMiddle = 'landscape_image_middle',
  LandscapeImageRight = 'landscape_image_right',
  StartScreen = 'start_screen'
}

export enum Enum_Componentcmsdataformquestion_Image_Position {
  Bottom = 'bottom',
  Left = 'left',
  Right = 'right',
  Top = 'top'
}

export enum Enum_Componentcmsdataformquestion_Mobile_Layout {
  FullBackground = 'full_background',
  FullImageTop = 'full_image_top',
  LandscapeImageMiddle = 'landscape_image_middle',
  LandscapeImageTop = 'landscape_image_top',
  StartScreen = 'start_screen'
}

export enum Enum_Componentcmsdataformquestion_Size {
  Large = 'large',
  Medium = 'medium',
  Small = 'small'
}

export enum Enum_Componentcmsdataformquestion_Type {
  Birthday = 'Birthday',
  Calculate = 'Calculate',
  Date = 'Date',
  DateAndTime = 'Date_and_Time',
  Email = 'Email',
  FirstName = 'First_Name',
  GroupCalculator = 'Group_Calculator',
  LastName = 'Last_Name',
  LongText = 'Long_Text',
  MultipleChoices = 'Multiple_Choices',
  Number = 'Number',
  PhoneNumber = 'Phone_Number',
  Rating = 'Rating',
  ShortText = 'Short_Text',
  SingleChoice = 'Single_Choice',
  Time = 'Time'
}

export enum Enum_Componentcmsdataformquestion_Vertical_Alignment {
  Bottom = 'bottom',
  Middle = 'middle',
  Top = 'top'
}

export enum Enum_Componentcmsdataproductslist_Displaytype {
  Box = 'box',
  Slider = 'slider'
}

export enum Enum_Componentcmsdataproductslist_Popuptype {
  Box = 'box',
  Slider = 'slider'
}

export enum Enum_Componentcmsdataproductslist_Size {
  Big = 'big',
  Medium = 'medium',
  Small = 'small'
}

export enum Enum_Componentcmsdatareviewssection_Size {
  Big = 'big',
  Medium = 'medium',
  Small = 'small'
}

export enum Enum_Componentcmsdatascheduletask_Status {
  Done = 'done',
  InProgress = 'in_progress',
  Todo = 'todo'
}

export enum Enum_Componentcmsdatascheduletask_Type {
  Cleanup = 'cleanup',
  Internal = 'internal',
  It = 'it',
  Maintenance = 'maintenance',
  Management = 'management',
  Marketing = 'marketing',
  Other = 'other',
  PostSell = 'post_sell',
  Preparation = 'preparation',
  Repair = 'repair',
  Sell = 'sell',
  SellCaller = 'sell_caller',
  SellMarketing = 'sell_marketing',
  Verification = 'verification'
}

export enum Enum_Componentcmsdataslider_Type {
  Circle = 'circle',
  Square = 'square',
  Wide = 'wide'
}

export enum Enum_Componentcmsdatatextandimagesection_Variation {
  BottomLeft = 'bottom_left',
  BottomRight = 'bottom_right',
  TopLeft = 'top_left',
  TopRight = 'top_right'
}

export enum Enum_Componentcmssettingsscheduledlink_Availability {
  Daily = 'daily',
  Weekdays = 'weekdays',
  Weekend = 'weekend'
}

export enum Enum_Componentcrmdatacrmactions_Action_Name {
  ClickEmail = 'click_email',
  CompletedForm = 'completed_form',
  CrmAvatarsAdded = 'crm_avatars_added',
  CrmAvatarsRemoved = 'crm_avatars_removed',
  FormSubmitted = 'form_submitted',
  HouseAllocationSubmitted = 'house_allocation_submitted',
  OpenEmail = 'open_email',
  OrderCreated = 'order_created',
  PaymentCompleted = 'payment_completed',
  ReadEmail = 'read_email',
  ReplyEmail = 'reply_email',
  TagsAssigned = 'tags_assigned',
  TagsRemoved = 'tags_removed',
  TaskCreated = 'task_created',
  TaskFeedbackChanged = 'task_feedback_changed',
  TeamAllocationSubmitted = 'team_allocation_submitted',
  UnsubscribeEmail = 'unsubscribe_email'
}

export enum Enum_Componentcrmdatautmdata_Utm_Medium {
  Ads = 'Ads',
  Banner = 'Banner',
  Newsletter = 'Newsletter',
  Organic = 'Organic',
  SocialMedia = 'SocialMedia',
  Website = 'Website'
}

export enum Enum_Componentcrmdatautmdata_Utm_Source {
  Application = 'Application',
  Blog = 'Blog',
  DirectLp = 'DirectLP',
  Facebook = 'Facebook',
  Google = 'Google',
  Inf = 'Inf',
  Influencer = 'Influencer',
  Instagram = 'Instagram',
  LandingPage = 'LandingPage',
  Linkedin = 'Linkedin',
  List = 'List',
  Mail = 'Mail',
  Presentations = 'Presentations',
  Sms = 'SMS',
  Tiktok = 'Tiktok',
  Webapp = 'Webapp',
  Webinar = 'Webinar',
  Youtube = 'Youtube'
}

export enum Enum_Componentgeneralinvitations_Role {
  Admin = 'admin',
  Invited = 'invited',
  Moderator = 'moderator'
}

export enum Enum_Componentgeneralinvitations_Status {
  Confirmed = 'confirmed',
  Pending = 'pending',
  Rejected = 'rejected'
}

export enum Enum_Componentmenuproductitem_Price_Type {
  Down = 'down',
  Left = 'left',
  Right = 'right',
  Up = 'up'
}

export enum Enum_Componentsharedmetasocial_Socialnetwork {
  Facebook = 'Facebook',
  Twitter = 'Twitter'
}

export enum Enum_Componentuserdataaddress_Address_Type {
  Billing = 'billing',
  Shipping = 'shipping'
}

export enum Enum_Crmcontactallocation_Recurring {
  Daily = 'daily',
  OneTime = 'one_time',
  WeekDays = 'week_days',
  Weekly = 'weekly'
}

export enum Enum_Crmtaskfeedback_Task_Type {
  Cleanup = 'cleanup',
  Internal = 'internal',
  It = 'it',
  Maintenance = 'maintenance',
  Management = 'management',
  Marketing = 'marketing',
  Other = 'other',
  PostSell = 'post_sell',
  Preparation = 'preparation',
  Repair = 'repair',
  Sell = 'sell',
  SellCaller = 'sell_caller',
  SellMarketing = 'sell_marketing',
  Verification = 'verification'
}

export enum Enum_Crmtasktemplate_Status {
  Done = 'done',
  InProgress = 'in_progress',
  Todo = 'todo'
}

export enum Enum_Crmtasktemplate_Type {
  Cleanup = 'cleanup',
  Internal = 'internal',
  It = 'it',
  Maintenance = 'maintenance',
  Management = 'management',
  Marketing = 'marketing',
  Other = 'other',
  PostSell = 'post_sell',
  Preparation = 'preparation',
  Repair = 'repair',
  Sell = 'sell',
  SellCaller = 'sell_caller',
  SellMarketing = 'sell_marketing',
  Verification = 'verification'
}

export enum Enum_Crmtask_Status {
  Canceled = 'canceled',
  Done = 'done',
  InProgress = 'in_progress',
  Todo = 'todo'
}

export enum Enum_Crmtask_Type {
  Cleanup = 'cleanup',
  Internal = 'internal',
  It = 'it',
  Maintenance = 'maintenance',
  Management = 'management',
  Marketing = 'marketing',
  Other = 'other',
  PostSell = 'post_sell',
  Preparation = 'preparation',
  Repair = 'repair',
  Sell = 'sell',
  SellCaller = 'sell_caller',
  SellMarketing = 'sell_marketing',
  Verification = 'verification'
}

export enum Enum_Dailytask_Response_To_Collect {
  Boolean = 'boolean',
  Percentage = 'percentage',
  Text = 'text'
}

export enum Enum_Drimon_Dragontype {
  Earth = 'earth',
  Fire = 'fire',
  Ice = 'ice',
  Lightning = 'lightning'
}

export enum Enum_Eventcategory_Type {
  Other = 'other',
  Workshop = 'workshop'
}

export enum Enum_Menupage_Alignement {
  Left = 'left',
  Right = 'right'
}

export enum Enum_Messagegroup_Type {
  Afterschool = 'afterschool',
  Birthday = 'birthday',
  Event = 'event',
  Internal = 'internal'
}

export enum Enum_Message_Privacy {
  Group = 'group',
  Public = 'public',
  Specific = 'specific'
}

export enum Enum_Notificationsnotificationrequest_Status {
  Processed = 'processed',
  Processing = 'processing',
  Unprocessed = 'unprocessed'
}

export enum Enum_Notificationsnotificationrequest_Type {
  Crm = 'CRM',
  Essential = 'Essential',
  Marketing = 'Marketing',
  Order = 'Order',
  Other = 'Other'
}

export enum Enum_Notificationsnotification_Status {
  New = 'new',
  Read = 'read'
}

export enum Enum_Notificationsnotification_Type {
  Crm = 'CRM',
  Essential = 'Essential',
  Marketing = 'Marketing',
  Order = 'Order',
  Other = 'Other'
}

export enum Enum_Notificationtemplate_Auto_Create_For_Event {
  TrialSubscriptionStarted = 'trial_subscription_started'
}

export enum Enum_Notificationtemplate_Type {
  Crm = 'CRM',
  Essential = 'Essential',
  Marketing = 'Marketing',
  Order = 'Order',
  Other = 'Other',
  Promotion = 'Promotion',
  Recommendation = 'Recommendation',
  Webinar = 'Webinar'
}

export enum Enum_Orderstatuslog_Status {
  Active = 'active',
  ActiveExpired = 'active_expired',
  ActiveFailed = 'active_failed',
  ActiveRetrying = 'active_retrying',
  Canceled = 'canceled',
  Completed = 'completed',
  Failed = 'failed',
  Inactive = 'inactive',
  Pending = 'pending',
  Processing = 'processing',
  Refunded = 'refunded'
}

export enum Enum_Order_Category {
  DownPayment = 'down_payment',
  Other = 'other',
  SubscriptionAnnual = 'subscription_annual',
  SubscriptionMonthly = 'subscription_monthly',
  SubscriptionOther = 'subscription_other'
}

export enum Enum_Order_Payment_Method {
  Cash = 'cash',
  Iban = 'iban',
  Twispay = 'twispay'
}

export enum Enum_Order_Status {
  Active = 'active',
  ActiveExpired = 'active_expired',
  ActiveFailed = 'active_failed',
  ActiveRetrying = 'active_retrying',
  Canceled = 'canceled',
  Completed = 'completed',
  Failed = 'failed',
  Inactive = 'inactive',
  Pending = 'pending',
  Processing = 'processing',
  Refunded = 'refunded'
}

export enum Enum_Page_Target {
  LandingPage = 'landing_page',
  WebApp = 'web_app'
}

export enum Enum_Payment_Method {
  Cash = 'cash',
  Iban = 'iban',
  Twispay = 'twispay'
}

export enum Enum_Payment_Status {
  Approved = 'approved',
  CancelOk = 'cancel_ok',
  ChargeBack = 'charge_back',
  ChargeBackRequest = 'charge_back_request',
  CompleteFailed = 'complete_failed',
  CompleteOk = 'complete_ok',
  InProgress = 'in_progress',
  Pending_3d = 'pending_3d',
  RefundOk = 'refund_ok',
  VoidOk = 'void_ok'
}

export enum Enum_Playeravatar_Body_Type {
  Boy = 'boy',
  Girl = 'girl',
  Man = 'man',
  Woman = 'woman'
}

export enum Enum_Product_Recurringintervaltype {
  Day = 'day',
  Month = 'month'
}

export enum Enum_Product_Type {
  Catering = 'catering',
  Credits = 'credits',
  Digital = 'digital',
  Event = 'event',
  MenuDrimoland = 'menu_drimoland',
  MenuLazzurro = 'menu_lazzurro',
  MenuRiviere = 'menu_riviere',
  Physical = 'physical',
  Plates = 'plates'
}

export enum Enum_Reservationlog_Type {
  Create = 'create',
  Delete = 'delete',
  Update = 'update'
}

export enum Enum_Reservation_Status {
  Cancelled = 'cancelled',
  Completed = 'completed',
  Confirmed = 'confirmed',
  DetailsReady = 'details_ready',
  Invoiced = 'invoiced',
  Modified = 'modified',
  Payed = 'payed',
  Pending = 'pending',
  Reserved = 'reserved',
  WaitingPayment = 'waiting_payment'
}

export enum Enum_Reservation_Type {
  AllInclusive = 'All_Inclusive',
  Altceva = 'Altceva',
  Botez = 'Botez',
  ChefFirma = 'Chef_firma',
  DrimoClasic = 'Drimo_Clasic',
  DrimoSupreme = 'Drimo_Supreme',
  EtajVr_15 = 'Etaj_VR_15',
  GrupDePrieteni = 'Grup_de_prieteni',
  IesireScolara = 'Iesire_scolara',
  Lasertag = 'Lasertag',
  MasaLaLiber = 'Masa_la_liber',
  MixSupremeVr = 'Mix_Supreme_VR',
  Nunta = 'Nunta',
  Parter_15 = 'Parter_15',
  ScoalaAltfel = 'Scoala_altfel',
  Serbare = 'Serbare',
  TeamBuilding = 'Team_building',
  VrLasertag = 'VR_Lasertag'
}

export enum Enum_Smartbillinvoice_Type {
  Estimate = 'estimate',
  Invoice = 'invoice',
  Storno = 'storno'
}

export enum Enum_Timeslot_Timesheet_Type {
  AbsenceToRecover = 'absence_to_recover',
  AbsenceUnpaid = 'absence_unpaid',
  Course = 'course',
  SickLeaveLarge = 'sick_leave_large',
  SickLeaveSmall = 'sick_leave_small',
  VacationApproved = 'vacation_approved',
  VacationRequested = 'vacation_requested',
  VacationUnpaid = 'vacation_unpaid',
  Work = 'work',
  WorkFromHome = 'work_from_home'
}

export enum Enum_Timeslot_Type {
  Game = 'game',
  Room = 'room',
  User = 'user'
}

export enum Enum_Userspermissionsuser_Account_Type {
  Child = 'child',
  User = 'user'
}

export enum Enum_Userspermissionsuser_Blockedscenario {
  Blocked_1day = 'blocked_1day',
  Blocked_7days = 'blocked_7days',
  Blocked_30days = 'blocked_30days',
  BlockedIndefinitely = 'blocked_indefinitely',
  SelfBlocked = 'self_blocked'
}

export enum Enum_Userspermissionsuser_Body_Type {
  Boy = 'boy',
  Girl = 'girl',
  Man = 'man',
  Woman = 'woman'
}

export enum Enum_Voucherlist_Type {
  External = 'external',
  InternalDiscountAmount = 'internal_discount_amount',
  InternalDiscountPercentage = 'internal_discount_percentage'
}

export type EmailDesignerEmailTemplate = {
  __typename?: 'EmailDesignerEmailTemplate';
  bodyHtml?: Maybe<Scalars['String']>;
  bodyText?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  design?: Maybe<Scalars['JSON']>;
  enabled?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  subject?: Maybe<Scalars['String']>;
  tags?: Maybe<Scalars['JSON']>;
  templateReferenceId?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type EmailDesignerEmailTemplateEntity = {
  __typename?: 'EmailDesignerEmailTemplateEntity';
  attributes?: Maybe<EmailDesignerEmailTemplate>;
  id?: Maybe<Scalars['ID']>;
};

export type EmailDesignerEmailTemplateEntityResponse = {
  __typename?: 'EmailDesignerEmailTemplateEntityResponse';
  data?: Maybe<EmailDesignerEmailTemplateEntity>;
};

export type EmailDesignerEmailTemplateEntityResponseCollection = {
  __typename?: 'EmailDesignerEmailTemplateEntityResponseCollection';
  data: Array<EmailDesignerEmailTemplateEntity>;
  meta: ResponseCollectionMeta;
};

export type EmailDesignerEmailTemplateFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<EmailDesignerEmailTemplateFiltersInput>>>;
  bodyHtml?: InputMaybe<StringFilterInput>;
  bodyText?: InputMaybe<StringFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  design?: InputMaybe<JsonFilterInput>;
  enabled?: InputMaybe<BooleanFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<EmailDesignerEmailTemplateFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<EmailDesignerEmailTemplateFiltersInput>>>;
  subject?: InputMaybe<StringFilterInput>;
  tags?: InputMaybe<JsonFilterInput>;
  templateReferenceId?: InputMaybe<IntFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type EmailDesignerEmailTemplateInput = {
  bodyHtml?: InputMaybe<Scalars['String']>;
  bodyText?: InputMaybe<Scalars['String']>;
  design?: InputMaybe<Scalars['JSON']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  subject?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Scalars['JSON']>;
  templateReferenceId?: InputMaybe<Scalars['Int']>;
};

export type Error = {
  __typename?: 'Error';
  code: Scalars['String'];
  message?: Maybe<Scalars['String']>;
};

export type Event = {
  __typename?: 'Event';
  categories?: Maybe<EventCategoryRelationResponseCollection>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  end_date?: Maybe<Scalars['DateTime']>;
  image?: Maybe<UploadFileEntityResponse>;
  mobile_image?: Maybe<UploadFileEntityResponse>;
  organisers?: Maybe<UsersPermissionsUserRelationResponseCollection>;
  participants?: Maybe<UsersPermissionsUserRelationResponseCollection>;
  publishedAt?: Maybe<Scalars['DateTime']>;
  slug?: Maybe<Scalars['String']>;
  start_date?: Maybe<Scalars['DateTime']>;
  subtitle?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};


export type EventCategoriesArgs = {
  filters?: InputMaybe<EventCategoryFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type EventOrganisersArgs = {
  filters?: InputMaybe<UsersPermissionsUserFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type EventParticipantsArgs = {
  filters?: InputMaybe<UsersPermissionsUserFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type EventCategory = {
  __typename?: 'EventCategory';
  createdAt?: Maybe<Scalars['DateTime']>;
  events?: Maybe<EventRelationResponseCollection>;
  name: Scalars['String'];
  slug?: Maybe<Scalars['String']>;
  type?: Maybe<Enum_Eventcategory_Type>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};


export type EventCategoryEventsArgs = {
  filters?: InputMaybe<EventFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type EventCategoryEntity = {
  __typename?: 'EventCategoryEntity';
  attributes?: Maybe<EventCategory>;
  id?: Maybe<Scalars['ID']>;
};

export type EventCategoryEntityResponse = {
  __typename?: 'EventCategoryEntityResponse';
  data?: Maybe<EventCategoryEntity>;
};

export type EventCategoryEntityResponseCollection = {
  __typename?: 'EventCategoryEntityResponseCollection';
  data: Array<EventCategoryEntity>;
  meta: ResponseCollectionMeta;
};

export type EventCategoryFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<EventCategoryFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  events?: InputMaybe<EventFiltersInput>;
  id?: InputMaybe<IdFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<EventCategoryFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<EventCategoryFiltersInput>>>;
  slug?: InputMaybe<StringFilterInput>;
  type?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type EventCategoryInput = {
  events?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  name?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Enum_Eventcategory_Type>;
};

export type EventCategoryRelationResponseCollection = {
  __typename?: 'EventCategoryRelationResponseCollection';
  data: Array<EventCategoryEntity>;
};

export type EventEntity = {
  __typename?: 'EventEntity';
  attributes?: Maybe<Event>;
  id?: Maybe<Scalars['ID']>;
};

export type EventEntityResponse = {
  __typename?: 'EventEntityResponse';
  data?: Maybe<EventEntity>;
};

export type EventEntityResponseCollection = {
  __typename?: 'EventEntityResponseCollection';
  data: Array<EventEntity>;
  meta: ResponseCollectionMeta;
};

export type EventFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<EventFiltersInput>>>;
  categories?: InputMaybe<EventCategoryFiltersInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  description?: InputMaybe<StringFilterInput>;
  end_date?: InputMaybe<DateTimeFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  not?: InputMaybe<EventFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<EventFiltersInput>>>;
  organisers?: InputMaybe<UsersPermissionsUserFiltersInput>;
  participants?: InputMaybe<UsersPermissionsUserFiltersInput>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  slug?: InputMaybe<StringFilterInput>;
  start_date?: InputMaybe<DateTimeFilterInput>;
  subtitle?: InputMaybe<StringFilterInput>;
  title?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type EventInput = {
  categories?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  description?: InputMaybe<Scalars['String']>;
  end_date?: InputMaybe<Scalars['DateTime']>;
  image?: InputMaybe<Scalars['ID']>;
  mobile_image?: InputMaybe<Scalars['ID']>;
  organisers?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  participants?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']>;
  slug?: InputMaybe<Scalars['String']>;
  start_date?: InputMaybe<Scalars['DateTime']>;
  subtitle?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

export type EventRelationResponseCollection = {
  __typename?: 'EventRelationResponseCollection';
  data: Array<EventEntity>;
};

export type EzformsRecipient = {
  __typename?: 'EzformsRecipient';
  createdAt?: Maybe<Scalars['DateTime']>;
  email?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  number?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type EzformsRecipientEntity = {
  __typename?: 'EzformsRecipientEntity';
  attributes?: Maybe<EzformsRecipient>;
  id?: Maybe<Scalars['ID']>;
};

export type EzformsRecipientEntityResponse = {
  __typename?: 'EzformsRecipientEntityResponse';
  data?: Maybe<EzformsRecipientEntity>;
};

export type EzformsRecipientEntityResponseCollection = {
  __typename?: 'EzformsRecipientEntityResponseCollection';
  data: Array<EzformsRecipientEntity>;
  meta: ResponseCollectionMeta;
};

export type EzformsRecipientFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<EzformsRecipientFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  email?: InputMaybe<StringFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<EzformsRecipientFiltersInput>;
  number?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<InputMaybe<EzformsRecipientFiltersInput>>>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type EzformsRecipientInput = {
  email?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  number?: InputMaybe<Scalars['String']>;
};

export type EzformsSubmission = {
  __typename?: 'EzformsSubmission';
  createdAt?: Maybe<Scalars['DateTime']>;
  crm_contact?: Maybe<ContactEntityResponse>;
  data?: Maybe<Scalars['JSON']>;
  files?: Maybe<UploadFileRelationResponseCollection>;
  formName?: Maybe<Scalars['String']>;
  reservation?: Maybe<ReservationEntityResponse>;
  score?: Maybe<Scalars['String']>;
  submitted_by?: Maybe<UsersPermissionsUserEntityResponse>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};


export type EzformsSubmissionFilesArgs = {
  filters?: InputMaybe<UploadFileFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type EzformsSubmissionEntity = {
  __typename?: 'EzformsSubmissionEntity';
  attributes?: Maybe<EzformsSubmission>;
  id?: Maybe<Scalars['ID']>;
};

export type EzformsSubmissionEntityResponse = {
  __typename?: 'EzformsSubmissionEntityResponse';
  data?: Maybe<EzformsSubmissionEntity>;
};

export type EzformsSubmissionEntityResponseCollection = {
  __typename?: 'EzformsSubmissionEntityResponseCollection';
  data: Array<EzformsSubmissionEntity>;
  meta: ResponseCollectionMeta;
};

export type EzformsSubmissionFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<EzformsSubmissionFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  crm_contact?: InputMaybe<ContactFiltersInput>;
  data?: InputMaybe<JsonFilterInput>;
  formName?: InputMaybe<StringFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  not?: InputMaybe<EzformsSubmissionFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<EzformsSubmissionFiltersInput>>>;
  reservation?: InputMaybe<ReservationFiltersInput>;
  score?: InputMaybe<StringFilterInput>;
  submitted_by?: InputMaybe<UsersPermissionsUserFiltersInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type EzformsSubmissionInput = {
  crm_contact?: InputMaybe<Scalars['ID']>;
  data?: InputMaybe<Scalars['JSON']>;
  files?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  formName?: InputMaybe<Scalars['String']>;
  reservation?: InputMaybe<Scalars['ID']>;
  score?: InputMaybe<Scalars['String']>;
  submitted_by?: InputMaybe<Scalars['ID']>;
};

export type EzformsSubmissionRelationResponseCollection = {
  __typename?: 'EzformsSubmissionRelationResponseCollection';
  data: Array<EzformsSubmissionEntity>;
};

export type FileInfoInput = {
  alternativeText?: InputMaybe<Scalars['String']>;
  caption?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

export type FloatFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  contains?: InputMaybe<Scalars['Float']>;
  containsi?: InputMaybe<Scalars['Float']>;
  endsWith?: InputMaybe<Scalars['Float']>;
  eq?: InputMaybe<Scalars['Float']>;
  eqi?: InputMaybe<Scalars['Float']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  nei?: InputMaybe<Scalars['Float']>;
  not?: InputMaybe<FloatFilterInput>;
  notContains?: InputMaybe<Scalars['Float']>;
  notContainsi?: InputMaybe<Scalars['Float']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  notNull?: InputMaybe<Scalars['Boolean']>;
  null?: InputMaybe<Scalars['Boolean']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  startsWith?: InputMaybe<Scalars['Float']>;
};

export type Game = {
  __typename?: 'Game';
  access_groups?: Maybe<AccessGroupRelationResponseCollection>;
  booking_slot_rules?: Maybe<Array<Maybe<GameBookingSlotRulesDynamicZone>>>;
  color?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  current_price?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  duration?: Maybe<Scalars['Int']>;
  list_price_rules?: Maybe<Scalars['JSON']>;
  min_age?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
  number_of_players?: Maybe<Scalars['Int']>;
  price: Scalars['Float'];
  publishedAt?: Maybe<Scalars['DateTime']>;
  scheduled_price?: Maybe<Array<Maybe<GameScheduledPriceDynamicZone>>>;
  tags?: Maybe<ActiveCampaignAcTagRelationResponseCollection>;
  terminal_rfid: Scalars['String'];
  time_slots?: Maybe<TimeSlotRelationResponseCollection>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};


export type GameAccess_GroupsArgs = {
  filters?: InputMaybe<AccessGroupFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GameCurrent_PriceArgs = {
  date?: InputMaybe<Scalars['DateTime']>;
};


export type GameList_Price_RulesArgs = {
  end_date?: InputMaybe<Scalars['DateTime']>;
  start_date?: InputMaybe<Scalars['DateTime']>;
};


export type GameTagsArgs = {
  filters?: InputMaybe<ActiveCampaignAcTagFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type GameTime_SlotsArgs = {
  filters?: InputMaybe<TimeSlotFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type GameBookingSlotRulesDynamicZone = ComponentGeneralCalendarBookingSlot | ComponentGeneralDailyBookingSlot | Error;

export type GameEntity = {
  __typename?: 'GameEntity';
  attributes?: Maybe<Game>;
  id?: Maybe<Scalars['ID']>;
};

export type GameEntityResponse = {
  __typename?: 'GameEntityResponse';
  data?: Maybe<GameEntity>;
};

export type GameEntityResponseCollection = {
  __typename?: 'GameEntityResponseCollection';
  data: Array<GameEntity>;
  meta: ResponseCollectionMeta;
};

export type GameFiltersInput = {
  access_groups?: InputMaybe<AccessGroupFiltersInput>;
  and?: InputMaybe<Array<InputMaybe<GameFiltersInput>>>;
  color?: InputMaybe<StringFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  description?: InputMaybe<StringFilterInput>;
  duration?: InputMaybe<IntFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  min_age?: InputMaybe<IntFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<GameFiltersInput>;
  number_of_players?: InputMaybe<IntFilterInput>;
  or?: InputMaybe<Array<InputMaybe<GameFiltersInput>>>;
  price?: InputMaybe<FloatFilterInput>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  tags?: InputMaybe<ActiveCampaignAcTagFiltersInput>;
  terminal_rfid?: InputMaybe<StringFilterInput>;
  time_slots?: InputMaybe<TimeSlotFiltersInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type GameInput = {
  access_groups?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  booking_slot_rules?: InputMaybe<Array<Scalars['GameBookingSlotRulesDynamicZoneInput']>>;
  color?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  duration?: InputMaybe<Scalars['Int']>;
  min_age?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  number_of_players?: InputMaybe<Scalars['Int']>;
  price?: InputMaybe<Scalars['Float']>;
  publishedAt?: InputMaybe<Scalars['DateTime']>;
  scheduled_price?: InputMaybe<Array<Scalars['GameScheduledPriceDynamicZoneInput']>>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  terminal_rfid?: InputMaybe<Scalars['String']>;
  time_slots?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

export type GameRelationResponseCollection = {
  __typename?: 'GameRelationResponseCollection';
  data: Array<GameEntity>;
};

export type GameScheduledPriceDynamicZone = ComponentGeneralCalendarScheduledPrice | ComponentGeneralDailyScheduledPrice | Error;

export type GenericMorph = AccessCard | AccessGroup | Achievement | ActiveCampaignAcContactTag | ActiveCampaignAcTag | ActiveCampaignAcUserTag | Allergen | BleDevice | BleFloor | BleGateway | BleGroup | BlogCategory | BlogPost | Campaign | CampaignMemberAvatar | Classroom | ClassroomMember | Comment | ComponentClassroomDailyTaskItem | ComponentCmsDataAnimatedCardSection | ComponentCmsDataAuthorsListSection | ComponentCmsDataBlogArticles | ComponentCmsDataBoxCard | ComponentCmsDataBoxElement | ComponentCmsDataButton | ComponentCmsDataCaptureContact | ComponentCmsDataCountDownTimer | ComponentCmsDataDarkBgImageSection | ComponentCmsDataDarkImageContent | ComponentCmsDataDarkImageItem | ComponentCmsDataDarkImageSection | ComponentCmsDataDarkTextBoxSection | ComponentCmsDataDarkVersusBox | ComponentCmsDataDarkVersusContent | ComponentCmsDataDarkVersusItem | ComponentCmsDataEventsListSection | ComponentCmsDataFaq | ComponentCmsDataFaqItem | ComponentCmsDataFooterColumn | ComponentCmsDataFooterIconLink | ComponentCmsDataFooterSection | ComponentCmsDataFormField | ComponentCmsDataFormFieldCondition | ComponentCmsDataFormGroup | ComponentCmsDataFormQchoice | ComponentCmsDataFormQuestion | ComponentCmsDataHeaderSection | ComponentCmsDataHeroSection | ComponentCmsDataHeroSectionSlider | ComponentCmsDataHeroSectionTwo | ComponentCmsDataIconCard | ComponentCmsDataIconCardsSection | ComponentCmsDataImageCard | ComponentCmsDataImageCardsSection | ComponentCmsDataImageGallery | ComponentCmsDataImageGalleryItem | ComponentCmsDataImageMapCircle | ComponentCmsDataImageMapDetail | ComponentCmsDataInteractiveImageMap | ComponentCmsDataLightTopImgSection | ComponentCmsDataMenuPages | ComponentCmsDataPriceBenefit | ComponentCmsDataPriceItem | ComponentCmsDataPriceSection | ComponentCmsDataProductsList | ComponentCmsDataReusable | ComponentCmsDataReviewItem | ComponentCmsDataReviewsSection | ComponentCmsDataRichText | ComponentCmsDataRichTextHtml | ComponentCmsDataScheduleMeeting | ComponentCmsDataScheduleTask | ComponentCmsDataScrollListSection | ComponentCmsDataScrollToSection | ComponentCmsDataSingleTitleSection | ComponentCmsDataSlider | ComponentCmsDataSliderItem | ComponentCmsDataSubscriptionItem | ComponentCmsDataSubscriptionPopup | ComponentCmsDataSubscriptionPriceItem | ComponentCmsDataTextAndImageSection | ComponentCmsDataTextWithIcon | ComponentCmsDataVideoSection | ComponentCmsSettingsPaymentSettings | ComponentCmsSettingsScheduledLink | ComponentCrmDataCrmAccountPercentage | ComponentCrmDataCrmAccountRole | ComponentCrmDataCrmActions | ComponentCrmDataCrmAiPrompt | ComponentCrmDataCrmAssignedUser | ComponentCrmDataCrmMeeting | ComponentCrmDataCrmMeetingRecording | ComponentCrmDataCrmUserProfile | ComponentCrmDataCrmUserRating | ComponentCrmDataUtmData | ComponentGeneralCalendarBookingSlot | ComponentGeneralCalendarScheduledPrice | ComponentGeneralChanges | ComponentGeneralDailyBookingSlot | ComponentGeneralDailyScheduledPrice | ComponentGeneralHouseWithVideo | ComponentGeneralInvitations | ComponentGeneralTable | ComponentMenuCategoryItem | ComponentMenuEmptySpace | ComponentMenuPhoto | ComponentMenuProductItem | ComponentMenuProductWithQuantity | ComponentSharedMetaSocial | ComponentSharedSeo | ComponentUserDataAddress | ComponentUserDataNotificationSettings | Contact | CreditChange | CrmCampaignMember | CrmCampaignMemberStatus | CrmContactAllocation | CrmContactSource | CrmLink | CrmRole | CrmSetting | CrmTask | CrmTaskFeedback | CrmTaskTemplate | DailyTask | DailyTaskClassroomMember | DefaultNotificationSetting | Drimon | EmailDesignerEmailTemplate | Event | EventCategory | EzformsRecipient | EzformsSubmission | Game | GraphicMaterial | House | I18NLocale | Ingredient | Lock | Map | Menu | MenuPage | Message | MessageGroup | NotificationTemplate | NotificationsNotification | NotificationsNotificationRequest | Order | OrderStatusLog | Page | Payment | PlayerAvatar | Product | ProductCategory | PromptType | QrCode | ReactionsReaction | ReactionsReactionType | Reservation | ReservationLog | ReusableComponent | Room | ScheduledJob | SmartbillInvoice | TimeSlot | UploadFile | UploadFolder | UserAccessGroup | UserAchievement | UserCreditManagementSignaturePad | UserTicket | UsersPermissionsPermission | UsersPermissionsRole | UsersPermissionsUser | Voucher | VoucherList;

export type GraphicMaterial = {
  __typename?: 'GraphicMaterial';
  createdAt?: Maybe<Scalars['DateTime']>;
  name: Scalars['String'];
  texts?: Maybe<Array<Maybe<ComponentCmsDataRichText>>>;
  type: Scalars['Int'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};


export type GraphicMaterialTextsArgs = {
  filters?: InputMaybe<ComponentCmsDataRichTextFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type GraphicMaterialEntity = {
  __typename?: 'GraphicMaterialEntity';
  attributes?: Maybe<GraphicMaterial>;
  id?: Maybe<Scalars['ID']>;
};

export type GraphicMaterialEntityResponse = {
  __typename?: 'GraphicMaterialEntityResponse';
  data?: Maybe<GraphicMaterialEntity>;
};

export type GraphicMaterialEntityResponseCollection = {
  __typename?: 'GraphicMaterialEntityResponseCollection';
  data: Array<GraphicMaterialEntity>;
  meta: ResponseCollectionMeta;
};

export type GraphicMaterialFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<GraphicMaterialFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<GraphicMaterialFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<GraphicMaterialFiltersInput>>>;
  texts?: InputMaybe<ComponentCmsDataRichTextFiltersInput>;
  type?: InputMaybe<IntFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type GraphicMaterialInput = {
  name?: InputMaybe<Scalars['String']>;
  texts?: InputMaybe<Array<InputMaybe<ComponentCmsDataRichTextInput>>>;
  type?: InputMaybe<Scalars['Int']>;
};

export type House = {
  __typename?: 'House';
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  media?: Maybe<UploadFileRelationResponseCollection>;
  members?: Maybe<UsersPermissionsUserRelationResponseCollection>;
  name: Scalars['String'];
  slug?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};


export type HouseMediaArgs = {
  filters?: InputMaybe<UploadFileFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type HouseMembersArgs = {
  filters?: InputMaybe<UsersPermissionsUserFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type HouseEntity = {
  __typename?: 'HouseEntity';
  attributes?: Maybe<House>;
  id?: Maybe<Scalars['ID']>;
};

export type HouseEntityResponse = {
  __typename?: 'HouseEntityResponse';
  data?: Maybe<HouseEntity>;
};

export type HouseEntityResponseCollection = {
  __typename?: 'HouseEntityResponseCollection';
  data: Array<HouseEntity>;
  meta: ResponseCollectionMeta;
};

export type HouseFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<HouseFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  description?: InputMaybe<StringFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  members?: InputMaybe<UsersPermissionsUserFiltersInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<HouseFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<HouseFiltersInput>>>;
  slug?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type HouseInput = {
  description?: InputMaybe<Scalars['String']>;
  media?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  members?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  name?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type I18NLocale = {
  __typename?: 'I18NLocale';
  code?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type I18NLocaleEntity = {
  __typename?: 'I18NLocaleEntity';
  attributes?: Maybe<I18NLocale>;
  id?: Maybe<Scalars['ID']>;
};

export type I18NLocaleEntityResponse = {
  __typename?: 'I18NLocaleEntityResponse';
  data?: Maybe<I18NLocaleEntity>;
};

export type I18NLocaleEntityResponseCollection = {
  __typename?: 'I18NLocaleEntityResponseCollection';
  data: Array<I18NLocaleEntity>;
  meta: ResponseCollectionMeta;
};

export type I18NLocaleFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<I18NLocaleFiltersInput>>>;
  code?: InputMaybe<StringFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<I18NLocaleFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<I18NLocaleFiltersInput>>>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type IdFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  contains?: InputMaybe<Scalars['ID']>;
  containsi?: InputMaybe<Scalars['ID']>;
  endsWith?: InputMaybe<Scalars['ID']>;
  eq?: InputMaybe<Scalars['ID']>;
  eqi?: InputMaybe<Scalars['ID']>;
  gt?: InputMaybe<Scalars['ID']>;
  gte?: InputMaybe<Scalars['ID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  lt?: InputMaybe<Scalars['ID']>;
  lte?: InputMaybe<Scalars['ID']>;
  ne?: InputMaybe<Scalars['ID']>;
  nei?: InputMaybe<Scalars['ID']>;
  not?: InputMaybe<IdFilterInput>;
  notContains?: InputMaybe<Scalars['ID']>;
  notContainsi?: InputMaybe<Scalars['ID']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  notNull?: InputMaybe<Scalars['Boolean']>;
  null?: InputMaybe<Scalars['Boolean']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  startsWith?: InputMaybe<Scalars['ID']>;
};

export type Ingredient = {
  __typename?: 'Ingredient';
  allergens?: Maybe<AllergenRelationResponseCollection>;
  createdAt?: Maybe<Scalars['DateTime']>;
  name: Scalars['String'];
  products?: Maybe<ProductRelationResponseCollection>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};


export type IngredientAllergensArgs = {
  filters?: InputMaybe<AllergenFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type IngredientProductsArgs = {
  filters?: InputMaybe<ProductFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type IngredientEntity = {
  __typename?: 'IngredientEntity';
  attributes?: Maybe<Ingredient>;
  id?: Maybe<Scalars['ID']>;
};

export type IngredientEntityResponse = {
  __typename?: 'IngredientEntityResponse';
  data?: Maybe<IngredientEntity>;
};

export type IngredientEntityResponseCollection = {
  __typename?: 'IngredientEntityResponseCollection';
  data: Array<IngredientEntity>;
  meta: ResponseCollectionMeta;
};

export type IngredientFiltersInput = {
  allergens?: InputMaybe<AllergenFiltersInput>;
  and?: InputMaybe<Array<InputMaybe<IngredientFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<IngredientFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<IngredientFiltersInput>>>;
  products?: InputMaybe<ProductFiltersInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type IngredientInput = {
  allergens?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  name?: InputMaybe<Scalars['String']>;
  products?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

export type IngredientRelationResponseCollection = {
  __typename?: 'IngredientRelationResponseCollection';
  data: Array<IngredientEntity>;
};

export type IntFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  contains?: InputMaybe<Scalars['Int']>;
  containsi?: InputMaybe<Scalars['Int']>;
  endsWith?: InputMaybe<Scalars['Int']>;
  eq?: InputMaybe<Scalars['Int']>;
  eqi?: InputMaybe<Scalars['Int']>;
  gt?: InputMaybe<Scalars['Int']>;
  gte?: InputMaybe<Scalars['Int']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  lt?: InputMaybe<Scalars['Int']>;
  lte?: InputMaybe<Scalars['Int']>;
  ne?: InputMaybe<Scalars['Int']>;
  nei?: InputMaybe<Scalars['Int']>;
  not?: InputMaybe<IntFilterInput>;
  notContains?: InputMaybe<Scalars['Int']>;
  notContainsi?: InputMaybe<Scalars['Int']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  notNull?: InputMaybe<Scalars['Boolean']>;
  null?: InputMaybe<Scalars['Boolean']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  startsWith?: InputMaybe<Scalars['Int']>;
};

export type JsonFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  contains?: InputMaybe<Scalars['JSON']>;
  containsi?: InputMaybe<Scalars['JSON']>;
  endsWith?: InputMaybe<Scalars['JSON']>;
  eq?: InputMaybe<Scalars['JSON']>;
  eqi?: InputMaybe<Scalars['JSON']>;
  gt?: InputMaybe<Scalars['JSON']>;
  gte?: InputMaybe<Scalars['JSON']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  lt?: InputMaybe<Scalars['JSON']>;
  lte?: InputMaybe<Scalars['JSON']>;
  ne?: InputMaybe<Scalars['JSON']>;
  nei?: InputMaybe<Scalars['JSON']>;
  not?: InputMaybe<JsonFilterInput>;
  notContains?: InputMaybe<Scalars['JSON']>;
  notContainsi?: InputMaybe<Scalars['JSON']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  notNull?: InputMaybe<Scalars['Boolean']>;
  null?: InputMaybe<Scalars['Boolean']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  startsWith?: InputMaybe<Scalars['JSON']>;
};

export type Lock = {
  __typename?: 'Lock';
  createdAt?: Maybe<Scalars['DateTime']>;
  disabled?: Maybe<Scalars['Boolean']>;
  slug: Scalars['String'];
  task?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LockEntity = {
  __typename?: 'LockEntity';
  attributes?: Maybe<Lock>;
  id?: Maybe<Scalars['ID']>;
};

export type LockEntityResponse = {
  __typename?: 'LockEntityResponse';
  data?: Maybe<LockEntity>;
};

export type LockEntityResponseCollection = {
  __typename?: 'LockEntityResponseCollection';
  data: Array<LockEntity>;
  meta: ResponseCollectionMeta;
};

export type LockFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<LockFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  disabled?: InputMaybe<BooleanFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  not?: InputMaybe<LockFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<LockFiltersInput>>>;
  slug?: InputMaybe<StringFilterInput>;
  task?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type LockInput = {
  disabled?: InputMaybe<Scalars['Boolean']>;
  slug?: InputMaybe<Scalars['String']>;
  task?: InputMaybe<Scalars['String']>;
};

export type Map = {
  __typename?: 'Map';
  createdAt?: Maybe<Scalars['DateTime']>;
  name: Scalars['String'];
  owners?: Maybe<UsersPermissionsUserRelationResponseCollection>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};


export type MapOwnersArgs = {
  filters?: InputMaybe<UsersPermissionsUserFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MapEntity = {
  __typename?: 'MapEntity';
  attributes?: Maybe<Map>;
  id?: Maybe<Scalars['ID']>;
};

export type MapEntityResponse = {
  __typename?: 'MapEntityResponse';
  data?: Maybe<MapEntity>;
};

export type MapEntityResponseCollection = {
  __typename?: 'MapEntityResponseCollection';
  data: Array<MapEntity>;
  meta: ResponseCollectionMeta;
};

export type MapFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<MapFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<MapFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<MapFiltersInput>>>;
  owners?: InputMaybe<UsersPermissionsUserFiltersInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type MapInput = {
  name?: InputMaybe<Scalars['String']>;
  owners?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

export type MapRelationResponseCollection = {
  __typename?: 'MapRelationResponseCollection';
  data: Array<MapEntity>;
};

export type Menu = {
  __typename?: 'Menu';
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  description_dimension?: Maybe<Scalars['String']>;
  description_font?: Maybe<Scalars['String']>;
  generate_nutritional_info_pages?: Maybe<Scalars['Boolean']>;
  nutritional_information?: Maybe<Scalars['String']>;
  nutritional_information_background?: Maybe<UploadFileEntityResponse>;
  nutritional_information_background_2?: Maybe<UploadFileEntityResponse>;
  nutritional_information_dimension?: Maybe<Scalars['String']>;
  nutritional_information_font?: Maybe<Scalars['String']>;
  print_catalog_pages?: Maybe<MenuPageRelationResponseCollection>;
  publishedAt?: Maybe<Scalars['DateTime']>;
  slug?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  title_dimension?: Maybe<Scalars['String']>;
  title_font?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  web_catalog_items?: Maybe<ProductRelationResponseCollection>;
};


export type MenuPrint_Catalog_PagesArgs = {
  filters?: InputMaybe<MenuPageFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type MenuWeb_Catalog_ItemsArgs = {
  filters?: InputMaybe<ProductFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MenuEntity = {
  __typename?: 'MenuEntity';
  attributes?: Maybe<Menu>;
  id?: Maybe<Scalars['ID']>;
};

export type MenuEntityResponse = {
  __typename?: 'MenuEntityResponse';
  data?: Maybe<MenuEntity>;
};

export type MenuEntityResponseCollection = {
  __typename?: 'MenuEntityResponseCollection';
  data: Array<MenuEntity>;
  meta: ResponseCollectionMeta;
};

export type MenuFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<MenuFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  description?: InputMaybe<StringFilterInput>;
  description_dimension?: InputMaybe<StringFilterInput>;
  description_font?: InputMaybe<StringFilterInput>;
  generate_nutritional_info_pages?: InputMaybe<BooleanFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  not?: InputMaybe<MenuFiltersInput>;
  nutritional_information?: InputMaybe<StringFilterInput>;
  nutritional_information_dimension?: InputMaybe<StringFilterInput>;
  nutritional_information_font?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<InputMaybe<MenuFiltersInput>>>;
  print_catalog_pages?: InputMaybe<MenuPageFiltersInput>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  slug?: InputMaybe<StringFilterInput>;
  title?: InputMaybe<StringFilterInput>;
  title_dimension?: InputMaybe<StringFilterInput>;
  title_font?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  web_catalog_items?: InputMaybe<ProductFiltersInput>;
};

export type MenuInput = {
  description?: InputMaybe<Scalars['String']>;
  description_dimension?: InputMaybe<Scalars['String']>;
  description_font?: InputMaybe<Scalars['String']>;
  generate_nutritional_info_pages?: InputMaybe<Scalars['Boolean']>;
  nutritional_information?: InputMaybe<Scalars['String']>;
  nutritional_information_background?: InputMaybe<Scalars['ID']>;
  nutritional_information_background_2?: InputMaybe<Scalars['ID']>;
  nutritional_information_dimension?: InputMaybe<Scalars['String']>;
  nutritional_information_font?: InputMaybe<Scalars['String']>;
  print_catalog_pages?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']>;
  slug?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  title_dimension?: InputMaybe<Scalars['String']>;
  title_font?: InputMaybe<Scalars['String']>;
  web_catalog_items?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

export type MenuPage = {
  __typename?: 'MenuPage';
  alignement?: Maybe<Enum_Menupage_Alignement>;
  background_color?: Maybe<Scalars['String']>;
  background_image?: Maybe<UploadFileEntityResponse>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description_dimension?: Maybe<Scalars['String']>;
  description_font?: Maybe<Scalars['String']>;
  footer_text?: Maybe<Scalars['String']>;
  left_column_content?: Maybe<Array<Maybe<MenuPageLeftColumnContentDynamicZone>>>;
  menu?: Maybe<MenuEntityResponse>;
  right_column_content?: Maybe<Array<Maybe<MenuPageRightColumnContentDynamicZone>>>;
  space_1?: Maybe<Scalars['Int']>;
  space_2?: Maybe<Scalars['Int']>;
  space_3?: Maybe<Scalars['Int']>;
  space_4?: Maybe<Scalars['Int']>;
  title: Scalars['String'];
  title_dimension?: Maybe<Scalars['String']>;
  title_font?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  website?: Maybe<Scalars['JSON']>;
};

export type MenuPageEntity = {
  __typename?: 'MenuPageEntity';
  attributes?: Maybe<MenuPage>;
  id?: Maybe<Scalars['ID']>;
};

export type MenuPageEntityResponse = {
  __typename?: 'MenuPageEntityResponse';
  data?: Maybe<MenuPageEntity>;
};

export type MenuPageEntityResponseCollection = {
  __typename?: 'MenuPageEntityResponseCollection';
  data: Array<MenuPageEntity>;
  meta: ResponseCollectionMeta;
};

export type MenuPageFiltersInput = {
  alignement?: InputMaybe<StringFilterInput>;
  and?: InputMaybe<Array<InputMaybe<MenuPageFiltersInput>>>;
  background_color?: InputMaybe<StringFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  description_dimension?: InputMaybe<StringFilterInput>;
  description_font?: InputMaybe<StringFilterInput>;
  footer_text?: InputMaybe<StringFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  menu?: InputMaybe<MenuFiltersInput>;
  not?: InputMaybe<MenuPageFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<MenuPageFiltersInput>>>;
  space_1?: InputMaybe<IntFilterInput>;
  space_2?: InputMaybe<IntFilterInput>;
  space_3?: InputMaybe<IntFilterInput>;
  space_4?: InputMaybe<IntFilterInput>;
  title?: InputMaybe<StringFilterInput>;
  title_dimension?: InputMaybe<StringFilterInput>;
  title_font?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  website?: InputMaybe<JsonFilterInput>;
};

export type MenuPageInput = {
  alignement?: InputMaybe<Enum_Menupage_Alignement>;
  background_color?: InputMaybe<Scalars['String']>;
  background_image?: InputMaybe<Scalars['ID']>;
  description_dimension?: InputMaybe<Scalars['String']>;
  description_font?: InputMaybe<Scalars['String']>;
  footer_text?: InputMaybe<Scalars['String']>;
  left_column_content?: InputMaybe<Array<Scalars['MenuPageLeftColumnContentDynamicZoneInput']>>;
  menu?: InputMaybe<Scalars['ID']>;
  right_column_content?: InputMaybe<Array<Scalars['MenuPageRightColumnContentDynamicZoneInput']>>;
  space_1?: InputMaybe<Scalars['Int']>;
  space_2?: InputMaybe<Scalars['Int']>;
  space_3?: InputMaybe<Scalars['Int']>;
  space_4?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Scalars['String']>;
  title_dimension?: InputMaybe<Scalars['String']>;
  title_font?: InputMaybe<Scalars['String']>;
  website?: InputMaybe<Scalars['JSON']>;
};

export type MenuPageLeftColumnContentDynamicZone = ComponentMenuCategoryItem | ComponentMenuEmptySpace | ComponentMenuPhoto | ComponentMenuProductItem | Error;

export type MenuPageRelationResponseCollection = {
  __typename?: 'MenuPageRelationResponseCollection';
  data: Array<MenuPageEntity>;
};

export type MenuPageRightColumnContentDynamicZone = ComponentMenuCategoryItem | ComponentMenuEmptySpace | ComponentMenuPhoto | ComponentMenuProductItem | Error;

export type Message = {
  __typename?: 'Message';
  author?: Maybe<UsersPermissionsUserEntityResponse>;
  body: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  media?: Maybe<UploadFileRelationResponseCollection>;
  privacy: Enum_Message_Privacy;
  privacy_message_group?: Maybe<MessageGroupEntityResponse>;
  privacy_users?: Maybe<UsersPermissionsUserRelationResponseCollection>;
  publishedAt?: Maybe<Scalars['DateTime']>;
  reactions?: Maybe<ReactionsReactionCountResponse>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};


export type MessageMediaArgs = {
  filters?: InputMaybe<UploadFileFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type MessagePrivacy_UsersArgs = {
  filters?: InputMaybe<UsersPermissionsUserFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MessageEntity = {
  __typename?: 'MessageEntity';
  attributes?: Maybe<Message>;
  id?: Maybe<Scalars['ID']>;
};

export type MessageEntityResponse = {
  __typename?: 'MessageEntityResponse';
  data?: Maybe<MessageEntity>;
};

export type MessageEntityResponseCollection = {
  __typename?: 'MessageEntityResponseCollection';
  data: Array<MessageEntity>;
  meta: ResponseCollectionMeta;
};

export type MessageFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<MessageFiltersInput>>>;
  author?: InputMaybe<UsersPermissionsUserFiltersInput>;
  body?: InputMaybe<StringFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  not?: InputMaybe<MessageFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<MessageFiltersInput>>>;
  privacy?: InputMaybe<StringFilterInput>;
  privacy_message_group?: InputMaybe<MessageGroupFiltersInput>;
  privacy_users?: InputMaybe<UsersPermissionsUserFiltersInput>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type MessageGroup = {
  __typename?: 'MessageGroup';
  classroom?: Maybe<ClassroomEntityResponse>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  messages?: Maybe<MessageRelationResponseCollection>;
  publishedAt?: Maybe<Scalars['DateTime']>;
  reservation?: Maybe<ReservationEntityResponse>;
  slug: Scalars['String'];
  title: Scalars['String'];
  type: Enum_Messagegroup_Type;
  updatedAt?: Maybe<Scalars['DateTime']>;
};


export type MessageGroupMessagesArgs = {
  filters?: InputMaybe<MessageFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MessageGroupEntity = {
  __typename?: 'MessageGroupEntity';
  attributes?: Maybe<MessageGroup>;
  id?: Maybe<Scalars['ID']>;
};

export type MessageGroupEntityResponse = {
  __typename?: 'MessageGroupEntityResponse';
  data?: Maybe<MessageGroupEntity>;
};

export type MessageGroupEntityResponseCollection = {
  __typename?: 'MessageGroupEntityResponseCollection';
  data: Array<MessageGroupEntity>;
  meta: ResponseCollectionMeta;
};

export type MessageGroupFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<MessageGroupFiltersInput>>>;
  classroom?: InputMaybe<ClassroomFiltersInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  description?: InputMaybe<StringFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  messages?: InputMaybe<MessageFiltersInput>;
  not?: InputMaybe<MessageGroupFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<MessageGroupFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  reservation?: InputMaybe<ReservationFiltersInput>;
  slug?: InputMaybe<StringFilterInput>;
  title?: InputMaybe<StringFilterInput>;
  type?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type MessageGroupInput = {
  classroom?: InputMaybe<Scalars['ID']>;
  description?: InputMaybe<Scalars['String']>;
  messages?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']>;
  reservation?: InputMaybe<Scalars['ID']>;
  slug?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Enum_Messagegroup_Type>;
};

export type MessageInput = {
  author?: InputMaybe<Scalars['ID']>;
  body?: InputMaybe<Scalars['String']>;
  media?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  privacy?: InputMaybe<Enum_Message_Privacy>;
  privacy_message_group?: InputMaybe<Scalars['ID']>;
  privacy_users?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']>;
};

export type MessageRelationResponseCollection = {
  __typename?: 'MessageRelationResponseCollection';
  data: Array<MessageEntity>;
};

export type Mutation = {
  __typename?: 'Mutation';
  addReaction?: Maybe<ReactionsReactionCountResponse>;
  cancelOrder?: Maybe<OrderEntityResponse>;
  changeOrderPaymentMethod?: Maybe<OrderEntityResponse>;
  /** Change user password. Confirm with the current password. */
  changePassword?: Maybe<UsersPermissionsLoginPayload>;
  claimVoucher?: Maybe<VoucherEntityResponse>;
  createAccessCard?: Maybe<AccessCardEntityResponse>;
  createAccessGroup?: Maybe<AccessGroupEntityResponse>;
  createAchievement?: Maybe<AchievementEntityResponse>;
  createAllergen?: Maybe<AllergenEntityResponse>;
  createBleDevice?: Maybe<BleDeviceEntityResponse>;
  createBleFloor?: Maybe<BleFloorEntityResponse>;
  createBleGateway?: Maybe<BleGatewayEntityResponse>;
  createBleGroup?: Maybe<BleGroupEntityResponse>;
  createBlogCategory?: Maybe<BlogCategoryEntityResponse>;
  createBlogPost?: Maybe<BlogPostEntityResponse>;
  createCampaign?: Maybe<CampaignEntityResponse>;
  createCampaignMemberAvatar?: Maybe<CampaignMemberAvatarEntityResponse>;
  createClassroom?: Maybe<ClassroomEntityResponse>;
  createClassroomMember?: Maybe<ClassroomMemberEntityResponse>;
  createComment?: Maybe<CommentEntityResponse>;
  createContact?: Maybe<ContactEntityResponse>;
  createCreditChange?: Maybe<CreditChangeEntityResponse>;
  createCrmCampaignMember?: Maybe<CrmCampaignMemberEntityResponse>;
  createCrmCampaignMemberStatus?: Maybe<CrmCampaignMemberStatusEntityResponse>;
  createCrmContactAllocation?: Maybe<CrmContactAllocationEntityResponse>;
  createCrmContactSource?: Maybe<CrmContactSourceEntityResponse>;
  createCrmLink?: Maybe<CrmLinkEntityResponse>;
  createCrmRole?: Maybe<CrmRoleEntityResponse>;
  createCrmTask?: Maybe<CrmTaskEntityResponse>;
  createCrmTaskFeedback?: Maybe<CrmTaskFeedbackEntityResponse>;
  createCrmTaskTemplate?: Maybe<CrmTaskTemplateEntityResponse>;
  createDailyTask?: Maybe<DailyTaskEntityResponse>;
  createDailyTaskClassroomMember?: Maybe<DailyTaskClassroomMemberEntityResponse>;
  createDrimon?: Maybe<DrimonEntityResponse>;
  createEmailDesignerEmailTemplate?: Maybe<EmailDesignerEmailTemplateEntityResponse>;
  createEvent?: Maybe<EventEntityResponse>;
  createEventCategory?: Maybe<EventCategoryEntityResponse>;
  createEzformsRecipient?: Maybe<EzformsRecipientEntityResponse>;
  createEzformsSubmission?: Maybe<EzformsSubmissionEntityResponse>;
  createGame?: Maybe<GameEntityResponse>;
  createGraphicMaterial?: Maybe<GraphicMaterialEntityResponse>;
  createHouse?: Maybe<HouseEntityResponse>;
  createIngredient?: Maybe<IngredientEntityResponse>;
  createLock?: Maybe<LockEntityResponse>;
  createMap?: Maybe<MapEntityResponse>;
  createMenu?: Maybe<MenuEntityResponse>;
  createMenuPage?: Maybe<MenuPageEntityResponse>;
  createMessage?: Maybe<MessageEntityResponse>;
  createMessageGroup?: Maybe<MessageGroupEntityResponse>;
  createNotificationTemplate?: Maybe<NotificationTemplateEntityResponse>;
  createOrder?: Maybe<OrderEntityResponse>;
  createOrderStatusLog?: Maybe<OrderStatusLogEntityResponse>;
  createPage?: Maybe<PageEntityResponse>;
  createPageLocalization?: Maybe<PageEntityResponse>;
  createPayment?: Maybe<PaymentEntityResponse>;
  createPlayerAvatar?: Maybe<PlayerAvatarEntityResponse>;
  createProduct?: Maybe<ProductEntityResponse>;
  createProductCategory?: Maybe<ProductCategoryEntityResponse>;
  createPromptType?: Maybe<PromptTypeEntityResponse>;
  createPromptTypeLocalization?: Maybe<PromptTypeEntityResponse>;
  createQrCode?: Maybe<QrCodeEntityResponse>;
  createReservation?: Maybe<ReservationEntityResponse>;
  createReservationLog?: Maybe<ReservationLogEntityResponse>;
  createReservationLogLocalization?: Maybe<ReservationLogEntityResponse>;
  createReusableComponent?: Maybe<ReusableComponentEntityResponse>;
  createRoom?: Maybe<RoomEntityResponse>;
  createScheduledJob?: Maybe<ScheduledJobEntityResponse>;
  createShopOrder?: Maybe<OrderEntityResponse>;
  createSmartbillInvoice?: Maybe<SmartbillInvoiceEntityResponse>;
  createTimeSlot?: Maybe<TimeSlotEntityResponse>;
  createUploadFile?: Maybe<UploadFileEntityResponse>;
  createUploadFolder?: Maybe<UploadFolderEntityResponse>;
  createUserAccessGroup?: Maybe<UserAccessGroupEntityResponse>;
  createUserAchievement?: Maybe<UserAchievementEntityResponse>;
  createUserCreditManagementSignaturePad?: Maybe<UserCreditManagementSignaturePadEntityResponse>;
  createUserTicket?: Maybe<UserTicketEntityResponse>;
  /** Create a new role */
  createUsersPermissionsRole?: Maybe<UsersPermissionsCreateRolePayload>;
  /** Create a new user */
  createUsersPermissionsUser: UsersPermissionsUserEntityResponse;
  createVoucher?: Maybe<VoucherEntityResponse>;
  createVoucherList?: Maybe<VoucherListEntityResponse>;
  createVoucherListLocalization?: Maybe<VoucherListEntityResponse>;
  createVoucherLocalization?: Maybe<VoucherEntityResponse>;
  deleteAccessCard?: Maybe<AccessCardEntityResponse>;
  deleteAccessGroup?: Maybe<AccessGroupEntityResponse>;
  deleteAchievement?: Maybe<AchievementEntityResponse>;
  deleteAllergen?: Maybe<AllergenEntityResponse>;
  deleteBleDevice?: Maybe<BleDeviceEntityResponse>;
  deleteBleFloor?: Maybe<BleFloorEntityResponse>;
  deleteBleGateway?: Maybe<BleGatewayEntityResponse>;
  deleteBleGroup?: Maybe<BleGroupEntityResponse>;
  deleteBlogCategory?: Maybe<BlogCategoryEntityResponse>;
  deleteBlogPost?: Maybe<BlogPostEntityResponse>;
  deleteCampaign?: Maybe<CampaignEntityResponse>;
  deleteCampaignMemberAvatar?: Maybe<CampaignMemberAvatarEntityResponse>;
  deleteClassroom?: Maybe<ClassroomEntityResponse>;
  deleteClassroomMember?: Maybe<ClassroomMemberEntityResponse>;
  deleteComment?: Maybe<CommentEntityResponse>;
  deleteContact?: Maybe<ContactEntityResponse>;
  deleteCreditChange?: Maybe<CreditChangeEntityResponse>;
  deleteCrmCampaignMember?: Maybe<CrmCampaignMemberEntityResponse>;
  deleteCrmCampaignMemberStatus?: Maybe<CrmCampaignMemberStatusEntityResponse>;
  deleteCrmContactAllocation?: Maybe<CrmContactAllocationEntityResponse>;
  deleteCrmContactSource?: Maybe<CrmContactSourceEntityResponse>;
  deleteCrmLink?: Maybe<CrmLinkEntityResponse>;
  deleteCrmRole?: Maybe<CrmRoleEntityResponse>;
  deleteCrmSetting?: Maybe<CrmSettingEntityResponse>;
  deleteCrmTask?: Maybe<CrmTaskEntityResponse>;
  deleteCrmTaskFeedback?: Maybe<CrmTaskFeedbackEntityResponse>;
  deleteCrmTaskTemplate?: Maybe<CrmTaskTemplateEntityResponse>;
  deleteDailyTask?: Maybe<DailyTaskEntityResponse>;
  deleteDailyTaskClassroomMember?: Maybe<DailyTaskClassroomMemberEntityResponse>;
  deleteDefaultNotificationSetting?: Maybe<DefaultNotificationSettingEntityResponse>;
  deleteDrimon?: Maybe<DrimonEntityResponse>;
  deleteEmailDesignerEmailTemplate?: Maybe<EmailDesignerEmailTemplateEntityResponse>;
  deleteEvent?: Maybe<EventEntityResponse>;
  deleteEventCategory?: Maybe<EventCategoryEntityResponse>;
  deleteEzformsRecipient?: Maybe<EzformsRecipientEntityResponse>;
  deleteEzformsSubmission?: Maybe<EzformsSubmissionEntityResponse>;
  deleteGame?: Maybe<GameEntityResponse>;
  deleteGraphicMaterial?: Maybe<GraphicMaterialEntityResponse>;
  deleteHouse?: Maybe<HouseEntityResponse>;
  deleteIngredient?: Maybe<IngredientEntityResponse>;
  deleteLock?: Maybe<LockEntityResponse>;
  deleteMap?: Maybe<MapEntityResponse>;
  deleteMenu?: Maybe<MenuEntityResponse>;
  deleteMenuPage?: Maybe<MenuPageEntityResponse>;
  deleteMessage?: Maybe<MessageEntityResponse>;
  deleteMessageGroup?: Maybe<MessageGroupEntityResponse>;
  deleteNotificationTemplate?: Maybe<NotificationTemplateEntityResponse>;
  deleteOrder?: Maybe<OrderEntityResponse>;
  deleteOrderStatusLog?: Maybe<OrderStatusLogEntityResponse>;
  deletePage?: Maybe<PageEntityResponse>;
  deletePayment?: Maybe<PaymentEntityResponse>;
  deletePlayerAvatar?: Maybe<PlayerAvatarEntityResponse>;
  deleteProduct?: Maybe<ProductEntityResponse>;
  deleteProductCategory?: Maybe<ProductCategoryEntityResponse>;
  deletePromptType?: Maybe<PromptTypeEntityResponse>;
  deleteQrCode?: Maybe<QrCodeEntityResponse>;
  deleteReservation?: Maybe<ReservationEntityResponse>;
  deleteReservationLog?: Maybe<ReservationLogEntityResponse>;
  deleteReusableComponent?: Maybe<ReusableComponentEntityResponse>;
  deleteRoom?: Maybe<RoomEntityResponse>;
  deleteScheduledJob?: Maybe<ScheduledJobEntityResponse>;
  deleteSmartbillInvoice?: Maybe<SmartbillInvoiceEntityResponse>;
  deleteTimeSlot?: Maybe<TimeSlotEntityResponse>;
  deleteUploadFile?: Maybe<UploadFileEntityResponse>;
  deleteUploadFolder?: Maybe<UploadFolderEntityResponse>;
  deleteUserAccessGroup?: Maybe<UserAccessGroupEntityResponse>;
  deleteUserAchievement?: Maybe<UserAchievementEntityResponse>;
  deleteUserCreditManagementSignaturePad?: Maybe<UserCreditManagementSignaturePadEntityResponse>;
  deleteUserTicket?: Maybe<UserTicketEntityResponse>;
  /** Delete an existing role */
  deleteUsersPermissionsRole?: Maybe<UsersPermissionsDeleteRolePayload>;
  /** Delete an existing user */
  deleteUsersPermissionsUser: UsersPermissionsUserEntityResponse;
  deleteVoucher?: Maybe<VoucherEntityResponse>;
  deleteVoucherList?: Maybe<VoucherListEntityResponse>;
  /** Confirm an email users email address */
  emailConfirmation?: Maybe<UsersPermissionsLoginPayload>;
  /** Request a reset password token */
  forgotPassword?: Maybe<UsersPermissionsPasswordPayload>;
  generateCRMTaskAIPromptCompletion?: Maybe<CrmTaskEntityResponse>;
  generateVoucher?: Maybe<VoucherEntityResponse>;
  login: UsersPermissionsLoginPayload;
  markNotificationsAsRead?: Maybe<Scalars['Boolean']>;
  multipleUpload: Array<Maybe<UploadFileEntityResponse>>;
  processFormQuestion?: Maybe<Scalars['Int']>;
  /** Register a user */
  register: UsersPermissionsLoginPayload;
  removeFile?: Maybe<UploadFileEntityResponse>;
  removeReaction?: Maybe<ReactionsReactionCountResponse>;
  /** Reset user password. Confirm with a code (resetToken from forgotPassword) */
  resetPassword?: Maybe<UsersPermissionsLoginPayload>;
  saveCapturedContact?: Maybe<Scalars['Boolean']>;
  sendEmailConfirmation?: Maybe<Scalars['Boolean']>;
  setUserMobileToken?: Maybe<Scalars['Boolean']>;
  setUserRoleOnCampaignMember?: Maybe<CrmCampaignMemberEntityResponse>;
  setUserWebToken?: Maybe<Scalars['Boolean']>;
  updateAccessCard?: Maybe<AccessCardEntityResponse>;
  updateAccessGroup?: Maybe<AccessGroupEntityResponse>;
  updateAchievement?: Maybe<AchievementEntityResponse>;
  updateAllergen?: Maybe<AllergenEntityResponse>;
  updateBleDevice?: Maybe<BleDeviceEntityResponse>;
  updateBleFloor?: Maybe<BleFloorEntityResponse>;
  updateBleGateway?: Maybe<BleGatewayEntityResponse>;
  updateBleGroup?: Maybe<BleGroupEntityResponse>;
  updateBlogCategory?: Maybe<BlogCategoryEntityResponse>;
  updateBlogPost?: Maybe<BlogPostEntityResponse>;
  updateCampaign?: Maybe<CampaignEntityResponse>;
  updateCampaignMemberAvatar?: Maybe<CampaignMemberAvatarEntityResponse>;
  updateClassroom?: Maybe<ClassroomEntityResponse>;
  updateClassroomMember?: Maybe<ClassroomMemberEntityResponse>;
  updateComment?: Maybe<CommentEntityResponse>;
  updateContact?: Maybe<ContactEntityResponse>;
  updateCreditChange?: Maybe<CreditChangeEntityResponse>;
  updateCrmCampaignMember?: Maybe<CrmCampaignMemberEntityResponse>;
  updateCrmCampaignMemberStatus?: Maybe<CrmCampaignMemberStatusEntityResponse>;
  updateCrmContactAllocation?: Maybe<CrmContactAllocationEntityResponse>;
  updateCrmContactSource?: Maybe<CrmContactSourceEntityResponse>;
  updateCrmLink?: Maybe<CrmLinkEntityResponse>;
  updateCrmRole?: Maybe<CrmRoleEntityResponse>;
  updateCrmSetting?: Maybe<CrmSettingEntityResponse>;
  updateCrmTask?: Maybe<CrmTaskEntityResponse>;
  updateCrmTaskFeedback?: Maybe<CrmTaskFeedbackEntityResponse>;
  updateCrmTaskTemplate?: Maybe<CrmTaskTemplateEntityResponse>;
  updateDailyTask?: Maybe<DailyTaskEntityResponse>;
  updateDailyTaskClassroomMember?: Maybe<DailyTaskClassroomMemberEntityResponse>;
  updateDefaultNotificationSetting?: Maybe<DefaultNotificationSettingEntityResponse>;
  updateDrimon?: Maybe<DrimonEntityResponse>;
  updateEmailDesignerEmailTemplate?: Maybe<EmailDesignerEmailTemplateEntityResponse>;
  updateEvent?: Maybe<EventEntityResponse>;
  updateEventCategory?: Maybe<EventCategoryEntityResponse>;
  updateEzformsRecipient?: Maybe<EzformsRecipientEntityResponse>;
  updateEzformsSubmission?: Maybe<EzformsSubmissionEntityResponse>;
  updateFileInfo: UploadFileEntityResponse;
  updateGame?: Maybe<GameEntityResponse>;
  updateGraphicMaterial?: Maybe<GraphicMaterialEntityResponse>;
  updateHouse?: Maybe<HouseEntityResponse>;
  updateIngredient?: Maybe<IngredientEntityResponse>;
  updateLock?: Maybe<LockEntityResponse>;
  updateMap?: Maybe<MapEntityResponse>;
  updateMenu?: Maybe<MenuEntityResponse>;
  updateMenuPage?: Maybe<MenuPageEntityResponse>;
  updateMessage?: Maybe<MessageEntityResponse>;
  updateMessageGroup?: Maybe<MessageGroupEntityResponse>;
  updateNotificationTemplate?: Maybe<NotificationTemplateEntityResponse>;
  updateOrder?: Maybe<OrderEntityResponse>;
  updateOrderStatusLog?: Maybe<OrderStatusLogEntityResponse>;
  updatePage?: Maybe<PageEntityResponse>;
  updatePayment?: Maybe<PaymentEntityResponse>;
  updatePlayerAvatar?: Maybe<PlayerAvatarEntityResponse>;
  updateProduct?: Maybe<ProductEntityResponse>;
  updateProductCategory?: Maybe<ProductCategoryEntityResponse>;
  updatePromptType?: Maybe<PromptTypeEntityResponse>;
  updateQrCode?: Maybe<QrCodeEntityResponse>;
  updateReservation?: Maybe<ReservationEntityResponse>;
  updateReservationLog?: Maybe<ReservationLogEntityResponse>;
  updateReusableComponent?: Maybe<ReusableComponentEntityResponse>;
  updateRoom?: Maybe<RoomEntityResponse>;
  updateScheduledJob?: Maybe<ScheduledJobEntityResponse>;
  updateSmartbillInvoice?: Maybe<SmartbillInvoiceEntityResponse>;
  updateTimeSlot?: Maybe<TimeSlotEntityResponse>;
  updateUploadFile?: Maybe<UploadFileEntityResponse>;
  updateUploadFolder?: Maybe<UploadFolderEntityResponse>;
  updateUserAccessGroup?: Maybe<UserAccessGroupEntityResponse>;
  updateUserAchievement?: Maybe<UserAchievementEntityResponse>;
  updateUserCreditManagementSignaturePad?: Maybe<UserCreditManagementSignaturePadEntityResponse>;
  updateUserTicket?: Maybe<UserTicketEntityResponse>;
  /** Update an existing role */
  updateUsersPermissionsRole?: Maybe<UsersPermissionsUpdateRolePayload>;
  /** Update an existing user */
  updateUsersPermissionsUser: UsersPermissionsUserEntityResponse;
  updateVoucher?: Maybe<VoucherEntityResponse>;
  updateVoucherList?: Maybe<VoucherListEntityResponse>;
  upload: UploadFileEntityResponse;
};


export type MutationAddReactionArgs = {
  collection_id: Scalars['ID'];
  collection_type: Scalars['String'];
  type?: InputMaybe<Scalars['String']>;
};


export type MutationCancelOrderArgs = {
  id: Scalars['ID'];
};


export type MutationChangeOrderPaymentMethodArgs = {
  id: Scalars['ID'];
  payment_id: Enum_Order_Payment_Method;
};


export type MutationChangePasswordArgs = {
  currentPassword: Scalars['String'];
  password: Scalars['String'];
  passwordConfirmation: Scalars['String'];
};


export type MutationClaimVoucherArgs = {
  id: Scalars['ID'];
  locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type MutationCreateAccessCardArgs = {
  data: AccessCardInput;
};


export type MutationCreateAccessGroupArgs = {
  data: AccessGroupInput;
};


export type MutationCreateAchievementArgs = {
  data: AchievementInput;
};


export type MutationCreateAllergenArgs = {
  data: AllergenInput;
};


export type MutationCreateBleDeviceArgs = {
  data: BleDeviceInput;
};


export type MutationCreateBleFloorArgs = {
  data: BleFloorInput;
};


export type MutationCreateBleGatewayArgs = {
  data: BleGatewayInput;
};


export type MutationCreateBleGroupArgs = {
  data: BleGroupInput;
};


export type MutationCreateBlogCategoryArgs = {
  data: BlogCategoryInput;
};


export type MutationCreateBlogPostArgs = {
  data: BlogPostInput;
};


export type MutationCreateCampaignArgs = {
  data: CampaignInput;
};


export type MutationCreateCampaignMemberAvatarArgs = {
  data: CampaignMemberAvatarInput;
};


export type MutationCreateClassroomArgs = {
  data: ClassroomInput;
};


export type MutationCreateClassroomMemberArgs = {
  data: ClassroomMemberInput;
};


export type MutationCreateCommentArgs = {
  data: CommentInput;
};


export type MutationCreateContactArgs = {
  data: ContactInput;
};


export type MutationCreateCreditChangeArgs = {
  data: CreditChangeInput;
};


export type MutationCreateCrmCampaignMemberArgs = {
  data: CrmCampaignMemberInput;
};


export type MutationCreateCrmCampaignMemberStatusArgs = {
  data: CrmCampaignMemberStatusInput;
};


export type MutationCreateCrmContactAllocationArgs = {
  data: CrmContactAllocationInput;
};


export type MutationCreateCrmContactSourceArgs = {
  data: CrmContactSourceInput;
};


export type MutationCreateCrmLinkArgs = {
  data: CrmLinkInput;
};


export type MutationCreateCrmRoleArgs = {
  data: CrmRoleInput;
};


export type MutationCreateCrmTaskArgs = {
  data: CrmTaskInput;
};


export type MutationCreateCrmTaskFeedbackArgs = {
  data: CrmTaskFeedbackInput;
};


export type MutationCreateCrmTaskTemplateArgs = {
  data: CrmTaskTemplateInput;
};


export type MutationCreateDailyTaskArgs = {
  data: DailyTaskInput;
};


export type MutationCreateDailyTaskClassroomMemberArgs = {
  data: DailyTaskClassroomMemberInput;
};


export type MutationCreateDrimonArgs = {
  data: DrimonInput;
};


export type MutationCreateEmailDesignerEmailTemplateArgs = {
  data: EmailDesignerEmailTemplateInput;
};


export type MutationCreateEventArgs = {
  data: EventInput;
};


export type MutationCreateEventCategoryArgs = {
  data: EventCategoryInput;
};


export type MutationCreateEzformsRecipientArgs = {
  data: EzformsRecipientInput;
};


export type MutationCreateEzformsSubmissionArgs = {
  data: EzformsSubmissionInput;
};


export type MutationCreateGameArgs = {
  data: GameInput;
};


export type MutationCreateGraphicMaterialArgs = {
  data: GraphicMaterialInput;
};


export type MutationCreateHouseArgs = {
  data: HouseInput;
};


export type MutationCreateIngredientArgs = {
  data: IngredientInput;
};


export type MutationCreateLockArgs = {
  data: LockInput;
};


export type MutationCreateMapArgs = {
  data: MapInput;
};


export type MutationCreateMenuArgs = {
  data: MenuInput;
};


export type MutationCreateMenuPageArgs = {
  data: MenuPageInput;
};


export type MutationCreateMessageArgs = {
  data: MessageInput;
};


export type MutationCreateMessageGroupArgs = {
  data: MessageGroupInput;
};


export type MutationCreateNotificationTemplateArgs = {
  data: NotificationTemplateInput;
};


export type MutationCreateOrderArgs = {
  data: OrderInput;
};


export type MutationCreateOrderStatusLogArgs = {
  data: OrderStatusLogInput;
};


export type MutationCreatePageArgs = {
  data: PageInput;
  locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type MutationCreatePageLocalizationArgs = {
  data?: InputMaybe<PageInput>;
  id?: InputMaybe<Scalars['ID']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type MutationCreatePaymentArgs = {
  data: PaymentInput;
};


export type MutationCreatePlayerAvatarArgs = {
  data: PlayerAvatarInput;
};


export type MutationCreateProductArgs = {
  data: ProductInput;
};


export type MutationCreateProductCategoryArgs = {
  data: ProductCategoryInput;
};


export type MutationCreatePromptTypeArgs = {
  data: PromptTypeInput;
  locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type MutationCreatePromptTypeLocalizationArgs = {
  data?: InputMaybe<PromptTypeInput>;
  id?: InputMaybe<Scalars['ID']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type MutationCreateQrCodeArgs = {
  data: QrCodeInput;
};


export type MutationCreateReservationArgs = {
  data: ReservationInput;
};


export type MutationCreateReservationLogArgs = {
  data: ReservationLogInput;
  locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type MutationCreateReservationLogLocalizationArgs = {
  data?: InputMaybe<ReservationLogInput>;
  id?: InputMaybe<Scalars['ID']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type MutationCreateReusableComponentArgs = {
  data: ReusableComponentInput;
};


export type MutationCreateRoomArgs = {
  data: RoomInput;
};


export type MutationCreateScheduledJobArgs = {
  data: ScheduledJobInput;
};


export type MutationCreateShopOrderArgs = {
  additional_info?: InputMaybe<Scalars['String']>;
  billing_id?: InputMaybe<Scalars['ID']>;
  discounts?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  items?: InputMaybe<Array<InputMaybe<OrderItem>>>;
  payment_id?: InputMaybe<Enum_Order_Payment_Method>;
  shipping_id?: InputMaybe<Scalars['ID']>;
};


export type MutationCreateSmartbillInvoiceArgs = {
  data: SmartbillInvoiceInput;
};


export type MutationCreateTimeSlotArgs = {
  data: TimeSlotInput;
};


export type MutationCreateUploadFileArgs = {
  data: UploadFileInput;
};


export type MutationCreateUploadFolderArgs = {
  data: UploadFolderInput;
};


export type MutationCreateUserAccessGroupArgs = {
  data: UserAccessGroupInput;
};


export type MutationCreateUserAchievementArgs = {
  data: UserAchievementInput;
};


export type MutationCreateUserCreditManagementSignaturePadArgs = {
  data: UserCreditManagementSignaturePadInput;
};


export type MutationCreateUserTicketArgs = {
  data: UserTicketInput;
};


export type MutationCreateUsersPermissionsRoleArgs = {
  data: UsersPermissionsRoleInput;
};


export type MutationCreateUsersPermissionsUserArgs = {
  data: UsersPermissionsUserInput;
};


export type MutationCreateVoucherArgs = {
  data: VoucherInput;
  locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type MutationCreateVoucherListArgs = {
  data: VoucherListInput;
  locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type MutationCreateVoucherListLocalizationArgs = {
  data?: InputMaybe<VoucherListInput>;
  id?: InputMaybe<Scalars['ID']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type MutationCreateVoucherLocalizationArgs = {
  data?: InputMaybe<VoucherInput>;
  id?: InputMaybe<Scalars['ID']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type MutationDeleteAccessCardArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteAccessGroupArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteAchievementArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteAllergenArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteBleDeviceArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteBleFloorArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteBleGatewayArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteBleGroupArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteBlogCategoryArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteBlogPostArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteCampaignArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteCampaignMemberAvatarArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteClassroomArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteClassroomMemberArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteCommentArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteContactArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteCreditChangeArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteCrmCampaignMemberArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteCrmCampaignMemberStatusArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteCrmContactAllocationArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteCrmContactSourceArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteCrmLinkArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteCrmRoleArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteCrmTaskArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteCrmTaskFeedbackArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteCrmTaskTemplateArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteDailyTaskArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteDailyTaskClassroomMemberArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteDrimonArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteEmailDesignerEmailTemplateArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteEventArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteEventCategoryArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteEzformsRecipientArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteEzformsSubmissionArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteGameArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteGraphicMaterialArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteHouseArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteIngredientArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteLockArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteMapArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteMenuArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteMenuPageArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteMessageArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteMessageGroupArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteNotificationTemplateArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteOrderArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteOrderStatusLogArgs = {
  id: Scalars['ID'];
};


export type MutationDeletePageArgs = {
  id: Scalars['ID'];
  locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type MutationDeletePaymentArgs = {
  id: Scalars['ID'];
};


export type MutationDeletePlayerAvatarArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteProductArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteProductCategoryArgs = {
  id: Scalars['ID'];
};


export type MutationDeletePromptTypeArgs = {
  id: Scalars['ID'];
  locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type MutationDeleteQrCodeArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteReservationArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteReservationLogArgs = {
  id: Scalars['ID'];
  locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type MutationDeleteReusableComponentArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteRoomArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteScheduledJobArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteSmartbillInvoiceArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteTimeSlotArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteUploadFileArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteUploadFolderArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteUserAccessGroupArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteUserAchievementArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteUserCreditManagementSignaturePadArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteUserTicketArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteUsersPermissionsRoleArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteUsersPermissionsUserArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteVoucherArgs = {
  id: Scalars['ID'];
  locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type MutationDeleteVoucherListArgs = {
  id: Scalars['ID'];
  locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type MutationEmailConfirmationArgs = {
  confirmation: Scalars['String'];
};


export type MutationForgotPasswordArgs = {
  email: Scalars['String'];
};


export type MutationGenerateCrmTaskAiPromptCompletionArgs = {
  ai_prompt_id: Scalars['ID'];
  id: Scalars['ID'];
};


export type MutationGenerateVoucherArgs = {
  id: Scalars['ID'];
  locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type MutationLoginArgs = {
  input: UsersPermissionsLoginInput;
};


export type MutationMarkNotificationsAsReadArgs = {
  notificationIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};


export type MutationMultipleUploadArgs = {
  field?: InputMaybe<Scalars['String']>;
  files: Array<InputMaybe<Scalars['Upload']>>;
  ref?: InputMaybe<Scalars['String']>;
  refId?: InputMaybe<Scalars['ID']>;
};


export type MutationProcessFormQuestionArgs = {
  questionId: Scalars['ID'];
  rfid: Scalars['String'];
};


export type MutationRegisterArgs = {
  input: UsersPermissionsRegisterInput;
};


export type MutationRemoveFileArgs = {
  id: Scalars['ID'];
};


export type MutationRemoveReactionArgs = {
  collection_id: Scalars['ID'];
  collection_type: Scalars['String'];
};


export type MutationResetPasswordArgs = {
  code: Scalars['String'];
  password: Scalars['String'];
  passwordConfirmation: Scalars['String'];
};


export type MutationSaveCapturedContactArgs = {
  input: CapturedContactInput;
  recaptcha: Scalars['String'];
};


export type MutationSendEmailConfirmationArgs = {
  email: Scalars['String'];
};


export type MutationSetUserMobileTokenArgs = {
  token?: InputMaybe<Scalars['String']>;
};


export type MutationSetUserRoleOnCampaignMemberArgs = {
  id: Scalars['ID'];
  roles?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  user: Scalars['ID'];
};


export type MutationSetUserWebTokenArgs = {
  token?: InputMaybe<Scalars['String']>;
};


export type MutationUpdateAccessCardArgs = {
  data: AccessCardInput;
  id: Scalars['ID'];
};


export type MutationUpdateAccessGroupArgs = {
  data: AccessGroupInput;
  id: Scalars['ID'];
};


export type MutationUpdateAchievementArgs = {
  data: AchievementInput;
  id: Scalars['ID'];
};


export type MutationUpdateAllergenArgs = {
  data: AllergenInput;
  id: Scalars['ID'];
};


export type MutationUpdateBleDeviceArgs = {
  data: BleDeviceInput;
  id: Scalars['ID'];
};


export type MutationUpdateBleFloorArgs = {
  data: BleFloorInput;
  id: Scalars['ID'];
};


export type MutationUpdateBleGatewayArgs = {
  data: BleGatewayInput;
  id: Scalars['ID'];
};


export type MutationUpdateBleGroupArgs = {
  data: BleGroupInput;
  id: Scalars['ID'];
};


export type MutationUpdateBlogCategoryArgs = {
  data: BlogCategoryInput;
  id: Scalars['ID'];
};


export type MutationUpdateBlogPostArgs = {
  data: BlogPostInput;
  id: Scalars['ID'];
};


export type MutationUpdateCampaignArgs = {
  data: CampaignInput;
  id: Scalars['ID'];
};


export type MutationUpdateCampaignMemberAvatarArgs = {
  data: CampaignMemberAvatarInput;
  id: Scalars['ID'];
};


export type MutationUpdateClassroomArgs = {
  data: ClassroomInput;
  id: Scalars['ID'];
};


export type MutationUpdateClassroomMemberArgs = {
  data: ClassroomMemberInput;
  id: Scalars['ID'];
};


export type MutationUpdateCommentArgs = {
  data: CommentInput;
  id: Scalars['ID'];
};


export type MutationUpdateContactArgs = {
  data: ContactInput;
  id: Scalars['ID'];
};


export type MutationUpdateCreditChangeArgs = {
  data: CreditChangeInput;
  id: Scalars['ID'];
};


export type MutationUpdateCrmCampaignMemberArgs = {
  data: CrmCampaignMemberInput;
  id: Scalars['ID'];
};


export type MutationUpdateCrmCampaignMemberStatusArgs = {
  data: CrmCampaignMemberStatusInput;
  id: Scalars['ID'];
};


export type MutationUpdateCrmContactAllocationArgs = {
  data: CrmContactAllocationInput;
  id: Scalars['ID'];
};


export type MutationUpdateCrmContactSourceArgs = {
  data: CrmContactSourceInput;
  id: Scalars['ID'];
};


export type MutationUpdateCrmLinkArgs = {
  data: CrmLinkInput;
  id: Scalars['ID'];
};


export type MutationUpdateCrmRoleArgs = {
  data: CrmRoleInput;
  id: Scalars['ID'];
};


export type MutationUpdateCrmSettingArgs = {
  data: CrmSettingInput;
};


export type MutationUpdateCrmTaskArgs = {
  data: CrmTaskInput;
  id: Scalars['ID'];
};


export type MutationUpdateCrmTaskFeedbackArgs = {
  data: CrmTaskFeedbackInput;
  id: Scalars['ID'];
};


export type MutationUpdateCrmTaskTemplateArgs = {
  data: CrmTaskTemplateInput;
  id: Scalars['ID'];
};


export type MutationUpdateDailyTaskArgs = {
  data: DailyTaskInput;
  id: Scalars['ID'];
};


export type MutationUpdateDailyTaskClassroomMemberArgs = {
  data: DailyTaskClassroomMemberInput;
  id: Scalars['ID'];
};


export type MutationUpdateDefaultNotificationSettingArgs = {
  data: DefaultNotificationSettingInput;
};


export type MutationUpdateDrimonArgs = {
  data: DrimonInput;
  id: Scalars['ID'];
};


export type MutationUpdateEmailDesignerEmailTemplateArgs = {
  data: EmailDesignerEmailTemplateInput;
  id: Scalars['ID'];
};


export type MutationUpdateEventArgs = {
  data: EventInput;
  id: Scalars['ID'];
};


export type MutationUpdateEventCategoryArgs = {
  data: EventCategoryInput;
  id: Scalars['ID'];
};


export type MutationUpdateEzformsRecipientArgs = {
  data: EzformsRecipientInput;
  id: Scalars['ID'];
};


export type MutationUpdateEzformsSubmissionArgs = {
  data: EzformsSubmissionInput;
  id: Scalars['ID'];
};


export type MutationUpdateFileInfoArgs = {
  id: Scalars['ID'];
  info?: InputMaybe<FileInfoInput>;
};


export type MutationUpdateGameArgs = {
  data: GameInput;
  id: Scalars['ID'];
};


export type MutationUpdateGraphicMaterialArgs = {
  data: GraphicMaterialInput;
  id: Scalars['ID'];
};


export type MutationUpdateHouseArgs = {
  data: HouseInput;
  id: Scalars['ID'];
};


export type MutationUpdateIngredientArgs = {
  data: IngredientInput;
  id: Scalars['ID'];
};


export type MutationUpdateLockArgs = {
  data: LockInput;
  id: Scalars['ID'];
};


export type MutationUpdateMapArgs = {
  data: MapInput;
  id: Scalars['ID'];
};


export type MutationUpdateMenuArgs = {
  data: MenuInput;
  id: Scalars['ID'];
};


export type MutationUpdateMenuPageArgs = {
  data: MenuPageInput;
  id: Scalars['ID'];
};


export type MutationUpdateMessageArgs = {
  data: MessageInput;
  id: Scalars['ID'];
};


export type MutationUpdateMessageGroupArgs = {
  data: MessageGroupInput;
  id: Scalars['ID'];
};


export type MutationUpdateNotificationTemplateArgs = {
  data: NotificationTemplateInput;
  id: Scalars['ID'];
};


export type MutationUpdateOrderArgs = {
  data: OrderInput;
  id: Scalars['ID'];
};


export type MutationUpdateOrderStatusLogArgs = {
  data: OrderStatusLogInput;
  id: Scalars['ID'];
};


export type MutationUpdatePageArgs = {
  data: PageInput;
  id: Scalars['ID'];
  locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type MutationUpdatePaymentArgs = {
  data: PaymentInput;
  id: Scalars['ID'];
};


export type MutationUpdatePlayerAvatarArgs = {
  data: PlayerAvatarInput;
  id: Scalars['ID'];
};


export type MutationUpdateProductArgs = {
  data: ProductInput;
  id: Scalars['ID'];
};


export type MutationUpdateProductCategoryArgs = {
  data: ProductCategoryInput;
  id: Scalars['ID'];
};


export type MutationUpdatePromptTypeArgs = {
  data: PromptTypeInput;
  id: Scalars['ID'];
  locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type MutationUpdateQrCodeArgs = {
  data: QrCodeInput;
  id: Scalars['ID'];
};


export type MutationUpdateReservationArgs = {
  data: ReservationInput;
  id: Scalars['ID'];
};


export type MutationUpdateReservationLogArgs = {
  data: ReservationLogInput;
  id: Scalars['ID'];
  locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type MutationUpdateReusableComponentArgs = {
  data: ReusableComponentInput;
  id: Scalars['ID'];
};


export type MutationUpdateRoomArgs = {
  data: RoomInput;
  id: Scalars['ID'];
};


export type MutationUpdateScheduledJobArgs = {
  data: ScheduledJobInput;
  id: Scalars['ID'];
};


export type MutationUpdateSmartbillInvoiceArgs = {
  data: SmartbillInvoiceInput;
  id: Scalars['ID'];
};


export type MutationUpdateTimeSlotArgs = {
  data: TimeSlotInput;
  id: Scalars['ID'];
};


export type MutationUpdateUploadFileArgs = {
  data: UploadFileInput;
  id: Scalars['ID'];
};


export type MutationUpdateUploadFolderArgs = {
  data: UploadFolderInput;
  id: Scalars['ID'];
};


export type MutationUpdateUserAccessGroupArgs = {
  data: UserAccessGroupInput;
  id: Scalars['ID'];
};


export type MutationUpdateUserAchievementArgs = {
  data: UserAchievementInput;
  id: Scalars['ID'];
};


export type MutationUpdateUserCreditManagementSignaturePadArgs = {
  data: UserCreditManagementSignaturePadInput;
  id: Scalars['ID'];
};


export type MutationUpdateUserTicketArgs = {
  data: UserTicketInput;
  id: Scalars['ID'];
};


export type MutationUpdateUsersPermissionsRoleArgs = {
  data: UsersPermissionsRoleInput;
  id: Scalars['ID'];
};


export type MutationUpdateUsersPermissionsUserArgs = {
  data: UsersPermissionsUserInput;
  id: Scalars['ID'];
};


export type MutationUpdateVoucherArgs = {
  data: VoucherInput;
  id: Scalars['ID'];
  locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type MutationUpdateVoucherListArgs = {
  data: VoucherListInput;
  id: Scalars['ID'];
  locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type MutationUploadArgs = {
  field?: InputMaybe<Scalars['String']>;
  file: Scalars['Upload'];
  info?: InputMaybe<FileInfoInput>;
  ref?: InputMaybe<Scalars['String']>;
  refId?: InputMaybe<Scalars['ID']>;
};

export type NotificationTemplate = {
  __typename?: 'NotificationTemplate';
  actionButtonText?: Maybe<Scalars['String']>;
  actionButtonUrl?: Maybe<Scalars['String']>;
  actionId?: Maybe<Scalars['Int']>;
  auto_create_for_event: Enum_Notificationtemplate_Auto_Create_For_Event;
  channel?: Maybe<Scalars['JSON']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  days_after_event: Scalars['Int'];
  message: Scalars['String'];
  messagePlain: Scalars['String'];
  notification_hour: Scalars['Int'];
  publishedAt?: Maybe<Scalars['DateTime']>;
  templateName: Scalars['String'];
  title: Scalars['String'];
  type: Enum_Notificationtemplate_Type;
  updatedAt?: Maybe<Scalars['DateTime']>;
  url?: Maybe<Scalars['String']>;
  userRoles?: Maybe<Scalars['JSON']>;
};

export type NotificationTemplateEntity = {
  __typename?: 'NotificationTemplateEntity';
  attributes?: Maybe<NotificationTemplate>;
  id?: Maybe<Scalars['ID']>;
};

export type NotificationTemplateEntityResponse = {
  __typename?: 'NotificationTemplateEntityResponse';
  data?: Maybe<NotificationTemplateEntity>;
};

export type NotificationTemplateEntityResponseCollection = {
  __typename?: 'NotificationTemplateEntityResponseCollection';
  data: Array<NotificationTemplateEntity>;
  meta: ResponseCollectionMeta;
};

export type NotificationTemplateFiltersInput = {
  actionButtonText?: InputMaybe<StringFilterInput>;
  actionButtonUrl?: InputMaybe<StringFilterInput>;
  actionId?: InputMaybe<IntFilterInput>;
  and?: InputMaybe<Array<InputMaybe<NotificationTemplateFiltersInput>>>;
  auto_create_for_event?: InputMaybe<StringFilterInput>;
  channel?: InputMaybe<JsonFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  days_after_event?: InputMaybe<IntFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  message?: InputMaybe<StringFilterInput>;
  messagePlain?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<NotificationTemplateFiltersInput>;
  notification_hour?: InputMaybe<IntFilterInput>;
  or?: InputMaybe<Array<InputMaybe<NotificationTemplateFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  templateName?: InputMaybe<StringFilterInput>;
  title?: InputMaybe<StringFilterInput>;
  type?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  url?: InputMaybe<StringFilterInput>;
  userRoles?: InputMaybe<JsonFilterInput>;
};

export type NotificationTemplateInput = {
  actionButtonText?: InputMaybe<Scalars['String']>;
  actionButtonUrl?: InputMaybe<Scalars['String']>;
  actionId?: InputMaybe<Scalars['Int']>;
  auto_create_for_event?: InputMaybe<Enum_Notificationtemplate_Auto_Create_For_Event>;
  channel?: InputMaybe<Scalars['JSON']>;
  days_after_event?: InputMaybe<Scalars['Int']>;
  message?: InputMaybe<Scalars['String']>;
  messagePlain?: InputMaybe<Scalars['String']>;
  notification_hour?: InputMaybe<Scalars['Int']>;
  publishedAt?: InputMaybe<Scalars['DateTime']>;
  templateName?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Enum_Notificationtemplate_Type>;
  url?: InputMaybe<Scalars['String']>;
  userRoles?: InputMaybe<Scalars['JSON']>;
};

export type NotificationsNotification = {
  __typename?: 'NotificationsNotification';
  actionButtonText?: Maybe<Scalars['String']>;
  actionButtonUrl?: Maybe<Scalars['String']>;
  actionId?: Maybe<Scalars['Int']>;
  channel?: Maybe<Scalars['JSON']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  groupContentId?: Maybe<Scalars['String']>;
  hidden?: Maybe<Scalars['Boolean']>;
  message?: Maybe<Scalars['String']>;
  messagePlain?: Maybe<Scalars['String']>;
  receiver?: Maybe<UsersPermissionsUserEntityResponse>;
  status: Enum_Notificationsnotification_Status;
  title?: Maybe<Scalars['String']>;
  type?: Maybe<Enum_Notificationsnotification_Type>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  url?: Maybe<Scalars['String']>;
};

export type NotificationsNotificationEntity = {
  __typename?: 'NotificationsNotificationEntity';
  attributes?: Maybe<NotificationsNotification>;
  id?: Maybe<Scalars['ID']>;
};

export type NotificationsNotificationEntityResponse = {
  __typename?: 'NotificationsNotificationEntityResponse';
  data?: Maybe<NotificationsNotificationEntity>;
};

export type NotificationsNotificationEntityResponseCollection = {
  __typename?: 'NotificationsNotificationEntityResponseCollection';
  data: Array<NotificationsNotificationEntity>;
  meta: ResponseCollectionMeta;
};

export type NotificationsNotificationFiltersInput = {
  actionButtonText?: InputMaybe<StringFilterInput>;
  actionButtonUrl?: InputMaybe<StringFilterInput>;
  actionId?: InputMaybe<IntFilterInput>;
  and?: InputMaybe<Array<InputMaybe<NotificationsNotificationFiltersInput>>>;
  channel?: InputMaybe<JsonFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  groupContentId?: InputMaybe<StringFilterInput>;
  hidden?: InputMaybe<BooleanFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  message?: InputMaybe<StringFilterInput>;
  messagePlain?: InputMaybe<StringFilterInput>;
  mobileReceiptError?: InputMaybe<StringFilterInput>;
  mobileReceiptId?: InputMaybe<StringFilterInput>;
  mobileReceiptStatus?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<NotificationsNotificationFiltersInput>;
  notification_request?: InputMaybe<NotificationsNotificationRequestFiltersInput>;
  notification_template?: InputMaybe<NotificationTemplateFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<NotificationsNotificationFiltersInput>>>;
  receiver?: InputMaybe<UsersPermissionsUserFiltersInput>;
  status?: InputMaybe<StringFilterInput>;
  title?: InputMaybe<StringFilterInput>;
  type?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  url?: InputMaybe<StringFilterInput>;
};

export type NotificationsNotificationRelationResponseCollection = {
  __typename?: 'NotificationsNotificationRelationResponseCollection';
  data: Array<NotificationsNotificationEntity>;
};

export type NotificationsNotificationRequest = {
  __typename?: 'NotificationsNotificationRequest';
  actionButtonText?: Maybe<Scalars['String']>;
  actionButtonUrl?: Maybe<Scalars['String']>;
  actionId?: Maybe<Scalars['Int']>;
  channel?: Maybe<Scalars['JSON']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  message?: Maybe<Scalars['String']>;
  messagePlain?: Maybe<Scalars['String']>;
  notifications?: Maybe<NotificationsNotificationRelationResponseCollection>;
  receivers?: Maybe<UsersPermissionsUserRelationResponseCollection>;
  sendToAllUsers?: Maybe<Scalars['Boolean']>;
  status: Enum_Notificationsnotificationrequest_Status;
  tags?: Maybe<ActiveCampaignAcTagRelationResponseCollection>;
  title?: Maybe<Scalars['String']>;
  type?: Maybe<Enum_Notificationsnotificationrequest_Type>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  url?: Maybe<Scalars['String']>;
};


export type NotificationsNotificationRequestNotificationsArgs = {
  filters?: InputMaybe<NotificationsNotificationFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type NotificationsNotificationRequestReceiversArgs = {
  filters?: InputMaybe<UsersPermissionsUserFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type NotificationsNotificationRequestTagsArgs = {
  filters?: InputMaybe<ActiveCampaignAcTagFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type NotificationsNotificationRequestEntity = {
  __typename?: 'NotificationsNotificationRequestEntity';
  attributes?: Maybe<NotificationsNotificationRequest>;
  id?: Maybe<Scalars['ID']>;
};

export type NotificationsNotificationRequestFiltersInput = {
  actionButtonText?: InputMaybe<StringFilterInput>;
  actionButtonUrl?: InputMaybe<StringFilterInput>;
  actionId?: InputMaybe<IntFilterInput>;
  and?: InputMaybe<Array<InputMaybe<NotificationsNotificationRequestFiltersInput>>>;
  channel?: InputMaybe<JsonFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  message?: InputMaybe<StringFilterInput>;
  messagePlain?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<NotificationsNotificationRequestFiltersInput>;
  notifications?: InputMaybe<NotificationsNotificationFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<NotificationsNotificationRequestFiltersInput>>>;
  receivers?: InputMaybe<UsersPermissionsUserFiltersInput>;
  sendToAllUsers?: InputMaybe<BooleanFilterInput>;
  status?: InputMaybe<StringFilterInput>;
  tags?: InputMaybe<ActiveCampaignAcTagFiltersInput>;
  title?: InputMaybe<StringFilterInput>;
  type?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  url?: InputMaybe<StringFilterInput>;
};

export type NotificationsNotificationRequestRelationResponseCollection = {
  __typename?: 'NotificationsNotificationRequestRelationResponseCollection';
  data: Array<NotificationsNotificationRequestEntity>;
};

export type Order = {
  __typename?: 'Order';
  additional_info?: Maybe<Scalars['String']>;
  author?: Maybe<UsersPermissionsUserEntityResponse>;
  billing_address?: Maybe<ComponentUserDataAddress>;
  category: Enum_Order_Category;
  createdAt?: Maybe<Scalars['DateTime']>;
  crm_link?: Maybe<CrmLinkRelationResponseCollection>;
  next_payment_date?: Maybe<Scalars['DateTime']>;
  order_items: Scalars['JSON'];
  paymentLink?: Maybe<Scalars['JSON']>;
  payment_method: Enum_Order_Payment_Method;
  payments?: Maybe<PaymentRelationResponseCollection>;
  reservation?: Maybe<ReservationEntityResponse>;
  shipping_address?: Maybe<ComponentUserDataAddress>;
  status: Enum_Order_Status;
  statusDate?: Maybe<Scalars['DateTime']>;
  status_logs?: Maybe<OrderStatusLogRelationResponseCollection>;
  total_price: Scalars['Float'];
  total_vat: Scalars['Float'];
  twispay_id?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  user_credits_allocated?: Maybe<Scalars['Int']>;
  user_tickets?: Maybe<UserTicketRelationResponseCollection>;
  vat_percentage?: Maybe<Scalars['Float']>;
  vouchers_generated?: Maybe<VoucherRelationResponseCollection>;
};


export type OrderCrm_LinkArgs = {
  filters?: InputMaybe<CrmLinkFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type OrderPaymentsArgs = {
  filters?: InputMaybe<PaymentFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type OrderStatus_LogsArgs = {
  filters?: InputMaybe<OrderStatusLogFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type OrderUser_TicketsArgs = {
  filters?: InputMaybe<UserTicketFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type OrderVouchers_GeneratedArgs = {
  filters?: InputMaybe<VoucherFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type OrderEntity = {
  __typename?: 'OrderEntity';
  attributes?: Maybe<Order>;
  id?: Maybe<Scalars['ID']>;
};

export type OrderEntityResponse = {
  __typename?: 'OrderEntityResponse';
  data?: Maybe<OrderEntity>;
};

export type OrderEntityResponseCollection = {
  __typename?: 'OrderEntityResponseCollection';
  data: Array<OrderEntity>;
  meta: ResponseCollectionMeta;
};

export type OrderFiltersInput = {
  additional_info?: InputMaybe<StringFilterInput>;
  and?: InputMaybe<Array<InputMaybe<OrderFiltersInput>>>;
  author?: InputMaybe<UsersPermissionsUserFiltersInput>;
  billing_address?: InputMaybe<ComponentUserDataAddressFiltersInput>;
  category?: InputMaybe<StringFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  crm_link?: InputMaybe<CrmLinkFiltersInput>;
  id?: InputMaybe<IdFilterInput>;
  next_payment_date?: InputMaybe<DateTimeFilterInput>;
  not?: InputMaybe<OrderFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<OrderFiltersInput>>>;
  order_items?: InputMaybe<JsonFilterInput>;
  payment_method?: InputMaybe<StringFilterInput>;
  payments?: InputMaybe<PaymentFiltersInput>;
  reservation?: InputMaybe<ReservationFiltersInput>;
  shipping_address?: InputMaybe<ComponentUserDataAddressFiltersInput>;
  status?: InputMaybe<StringFilterInput>;
  statusDate?: InputMaybe<DateTimeFilterInput>;
  status_logs?: InputMaybe<OrderStatusLogFiltersInput>;
  total_price?: InputMaybe<FloatFilterInput>;
  total_vat?: InputMaybe<FloatFilterInput>;
  twispay_id?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  user_credits_allocated?: InputMaybe<IntFilterInput>;
  user_tickets?: InputMaybe<UserTicketFiltersInput>;
  vat_percentage?: InputMaybe<FloatFilterInput>;
  vouchers_generated?: InputMaybe<VoucherFiltersInput>;
};

export type OrderInput = {
  additional_info?: InputMaybe<Scalars['String']>;
  author?: InputMaybe<Scalars['ID']>;
  billing_address?: InputMaybe<ComponentUserDataAddressInput>;
  category?: InputMaybe<Enum_Order_Category>;
  crm_link?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  next_payment_date?: InputMaybe<Scalars['DateTime']>;
  order_items?: InputMaybe<Scalars['JSON']>;
  payment_method?: InputMaybe<Enum_Order_Payment_Method>;
  payments?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  reservation?: InputMaybe<Scalars['ID']>;
  shipping_address?: InputMaybe<ComponentUserDataAddressInput>;
  status?: InputMaybe<Enum_Order_Status>;
  statusDate?: InputMaybe<Scalars['DateTime']>;
  status_logs?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  total_price?: InputMaybe<Scalars['Float']>;
  total_vat?: InputMaybe<Scalars['Float']>;
  twispay_id?: InputMaybe<Scalars['String']>;
  user_credits_allocated?: InputMaybe<Scalars['Int']>;
  user_tickets?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  vat_percentage?: InputMaybe<Scalars['Float']>;
  vouchers_generated?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

export type OrderItem = {
  date?: InputMaybe<Scalars['DateTime']>;
  product_id: Scalars['ID'];
  quantity?: InputMaybe<Scalars['Int']>;
};

export type OrderRelationResponseCollection = {
  __typename?: 'OrderRelationResponseCollection';
  data: Array<OrderEntity>;
};

export type OrderStatusLog = {
  __typename?: 'OrderStatusLog';
  createdAt?: Maybe<Scalars['DateTime']>;
  endDate?: Maybe<Scalars['DateTime']>;
  order?: Maybe<OrderEntityResponse>;
  startDate: Scalars['DateTime'];
  status: Enum_Orderstatuslog_Status;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type OrderStatusLogEntity = {
  __typename?: 'OrderStatusLogEntity';
  attributes?: Maybe<OrderStatusLog>;
  id?: Maybe<Scalars['ID']>;
};

export type OrderStatusLogEntityResponse = {
  __typename?: 'OrderStatusLogEntityResponse';
  data?: Maybe<OrderStatusLogEntity>;
};

export type OrderStatusLogEntityResponseCollection = {
  __typename?: 'OrderStatusLogEntityResponseCollection';
  data: Array<OrderStatusLogEntity>;
  meta: ResponseCollectionMeta;
};

export type OrderStatusLogFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<OrderStatusLogFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  endDate?: InputMaybe<DateTimeFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  not?: InputMaybe<OrderStatusLogFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<OrderStatusLogFiltersInput>>>;
  order?: InputMaybe<OrderFiltersInput>;
  startDate?: InputMaybe<DateTimeFilterInput>;
  status?: InputMaybe<StringFilterInput>;
  title?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type OrderStatusLogInput = {
  endDate?: InputMaybe<Scalars['DateTime']>;
  order?: InputMaybe<Scalars['ID']>;
  startDate?: InputMaybe<Scalars['DateTime']>;
  status?: InputMaybe<Enum_Orderstatuslog_Status>;
  title?: InputMaybe<Scalars['String']>;
};

export type OrderStatusLogRelationResponseCollection = {
  __typename?: 'OrderStatusLogRelationResponseCollection';
  data: Array<OrderStatusLogEntity>;
};

export type Page = {
  __typename?: 'Page';
  components?: Maybe<Array<Maybe<PageComponentsDynamicZone>>>;
  createdAt?: Maybe<Scalars['DateTime']>;
  hideMenu?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
  localizations?: Maybe<PageRelationResponseCollection>;
  publishedAt?: Maybe<Scalars['DateTime']>;
  seo?: Maybe<ComponentSharedSeo>;
  slug?: Maybe<Scalars['String']>;
  target: Enum_Page_Target;
  title: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};


export type PageLocalizationsArgs = {
  filters?: InputMaybe<PageFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PageComponentsDynamicZone = ComponentCmsDataAnimatedCardSection | ComponentCmsDataAuthorsListSection | ComponentCmsDataBlogArticles | ComponentCmsDataCaptureContact | ComponentCmsDataDarkBgImageSection | ComponentCmsDataDarkImageContent | ComponentCmsDataDarkTextBoxSection | ComponentCmsDataDarkVersusContent | ComponentCmsDataEventsListSection | ComponentCmsDataFaq | ComponentCmsDataFooterSection | ComponentCmsDataFormGroup | ComponentCmsDataHeaderSection | ComponentCmsDataHeroSection | ComponentCmsDataHeroSectionSlider | ComponentCmsDataHeroSectionTwo | ComponentCmsDataIconCardsSection | ComponentCmsDataImageCardsSection | ComponentCmsDataImageGallery | ComponentCmsDataInteractiveImageMap | ComponentCmsDataLightTopImgSection | ComponentCmsDataPriceSection | ComponentCmsDataProductsList | ComponentCmsDataReusable | ComponentCmsDataReviewsSection | ComponentCmsDataRichText | ComponentCmsDataRichTextHtml | ComponentCmsDataScheduleMeeting | ComponentCmsDataScrollListSection | ComponentCmsDataScrollToSection | ComponentCmsDataSingleTitleSection | ComponentCmsDataSlider | ComponentCmsDataSubscriptionPopup | ComponentCmsDataTextAndImageSection | ComponentCmsDataVideoSection | Error;

export type PageEntity = {
  __typename?: 'PageEntity';
  attributes?: Maybe<Page>;
  id?: Maybe<Scalars['ID']>;
};

export type PageEntityResponse = {
  __typename?: 'PageEntityResponse';
  data?: Maybe<PageEntity>;
};

export type PageEntityResponseCollection = {
  __typename?: 'PageEntityResponseCollection';
  data: Array<PageEntity>;
  meta: ResponseCollectionMeta;
};

export type PageFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<PageFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  hideMenu?: InputMaybe<BooleanFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  locale?: InputMaybe<StringFilterInput>;
  localizations?: InputMaybe<PageFiltersInput>;
  not?: InputMaybe<PageFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<PageFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  seo?: InputMaybe<ComponentSharedSeoFiltersInput>;
  slug?: InputMaybe<StringFilterInput>;
  target?: InputMaybe<StringFilterInput>;
  title?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type PageInput = {
  components?: InputMaybe<Array<Scalars['PageComponentsDynamicZoneInput']>>;
  hideMenu?: InputMaybe<Scalars['Boolean']>;
  publishedAt?: InputMaybe<Scalars['DateTime']>;
  seo?: InputMaybe<ComponentSharedSeoInput>;
  slug?: InputMaybe<Scalars['String']>;
  target?: InputMaybe<Enum_Page_Target>;
  title?: InputMaybe<Scalars['String']>;
};

export type PageRelationResponseCollection = {
  __typename?: 'PageRelationResponseCollection';
  data: Array<PageEntity>;
};

export type Pagination = {
  __typename?: 'Pagination';
  page: Scalars['Int'];
  pageCount: Scalars['Int'];
  pageSize: Scalars['Int'];
  total: Scalars['Int'];
};

export type PaginationArg = {
  limit?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['Int']>;
};

export type Payment = {
  __typename?: 'Payment';
  amount: Scalars['Float'];
  createdAt?: Maybe<Scalars['DateTime']>;
  ipn_response?: Maybe<Scalars['JSON']>;
  method: Enum_Payment_Method;
  order?: Maybe<OrderEntityResponse>;
  parent_payment?: Maybe<PaymentEntityResponse>;
  smartbill_invoice_and_estimate?: Maybe<SmartbillInvoiceRelationResponseCollection>;
  status: Enum_Payment_Status;
  statusDate?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};


export type PaymentSmartbill_Invoice_And_EstimateArgs = {
  filters?: InputMaybe<SmartbillInvoiceFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PaymentEntity = {
  __typename?: 'PaymentEntity';
  attributes?: Maybe<Payment>;
  id?: Maybe<Scalars['ID']>;
};

export type PaymentEntityResponse = {
  __typename?: 'PaymentEntityResponse';
  data?: Maybe<PaymentEntity>;
};

export type PaymentEntityResponseCollection = {
  __typename?: 'PaymentEntityResponseCollection';
  data: Array<PaymentEntity>;
  meta: ResponseCollectionMeta;
};

export type PaymentFiltersInput = {
  amount?: InputMaybe<FloatFilterInput>;
  and?: InputMaybe<Array<InputMaybe<PaymentFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  ipn_response?: InputMaybe<JsonFilterInput>;
  method?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<PaymentFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<PaymentFiltersInput>>>;
  order?: InputMaybe<OrderFiltersInput>;
  parent_payment?: InputMaybe<PaymentFiltersInput>;
  smartbill_invoice_and_estimate?: InputMaybe<SmartbillInvoiceFiltersInput>;
  status?: InputMaybe<StringFilterInput>;
  statusDate?: InputMaybe<DateTimeFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type PaymentInput = {
  amount?: InputMaybe<Scalars['Float']>;
  ipn_response?: InputMaybe<Scalars['JSON']>;
  method?: InputMaybe<Enum_Payment_Method>;
  order?: InputMaybe<Scalars['ID']>;
  parent_payment?: InputMaybe<Scalars['ID']>;
  smartbill_invoice_and_estimate?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  status?: InputMaybe<Enum_Payment_Status>;
  statusDate?: InputMaybe<Scalars['DateTime']>;
};

export type PaymentRelationResponseCollection = {
  __typename?: 'PaymentRelationResponseCollection';
  data: Array<PaymentEntity>;
};

export type PlayerAvatar = {
  __typename?: 'PlayerAvatar';
  body_type: Enum_Playeravatar_Body_Type;
  createdAt?: Maybe<Scalars['DateTime']>;
  mesh_variation?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  users?: Maybe<UsersPermissionsUserRelationResponseCollection>;
};


export type PlayerAvatarUsersArgs = {
  filters?: InputMaybe<UsersPermissionsUserFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PlayerAvatarEntity = {
  __typename?: 'PlayerAvatarEntity';
  attributes?: Maybe<PlayerAvatar>;
  id?: Maybe<Scalars['ID']>;
};

export type PlayerAvatarEntityResponse = {
  __typename?: 'PlayerAvatarEntityResponse';
  data?: Maybe<PlayerAvatarEntity>;
};

export type PlayerAvatarEntityResponseCollection = {
  __typename?: 'PlayerAvatarEntityResponseCollection';
  data: Array<PlayerAvatarEntity>;
  meta: ResponseCollectionMeta;
};

export type PlayerAvatarFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<PlayerAvatarFiltersInput>>>;
  body_type?: InputMaybe<StringFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  mesh_variation?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<PlayerAvatarFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<PlayerAvatarFiltersInput>>>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  users?: InputMaybe<UsersPermissionsUserFiltersInput>;
};

export type PlayerAvatarInput = {
  body_type?: InputMaybe<Enum_Playeravatar_Body_Type>;
  mesh_variation?: InputMaybe<Scalars['String']>;
  users?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

export type Product = {
  __typename?: 'Product';
  allocates_credits?: Maybe<Scalars['Int']>;
  allocates_tickets?: Maybe<Scalars['Int']>;
  allocates_voucher_from_collection?: Maybe<VoucherListEntityResponse>;
  can_buy_only_with?: Maybe<ProductRelationResponseCollection>;
  category?: Maybe<ProductCategoryEntityResponse>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crm_campaigns?: Maybe<CampaignRelationResponseCollection>;
  crm_links?: Maybe<CrmLinkRelationResponseCollection>;
  current_price?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  ingredients?: Maybe<IngredientRelationResponseCollection>;
  isDownPayment?: Maybe<Scalars['Boolean']>;
  isRecurring?: Maybe<Scalars['Boolean']>;
  limitPurchaseOncePerUser?: Maybe<Scalars['Boolean']>;
  list_price_rules?: Maybe<Scalars['JSON']>;
  media?: Maybe<UploadFileRelationResponseCollection>;
  min_age?: Maybe<Scalars['Int']>;
  no_use_voucher?: Maybe<Scalars['Boolean']>;
  number_of_vouchers?: Maybe<Scalars['Int']>;
  nutritional_information?: Maybe<Scalars['String']>;
  paymentMethods?: Maybe<Scalars['JSON']>;
  price: Scalars['Float'];
  publishedAt?: Maybe<Scalars['DateTime']>;
  recurringIntervalMax?: Maybe<Scalars['Int']>;
  recurringIntervalType?: Maybe<Enum_Product_Recurringintervaltype>;
  recurringIntervalValue?: Maybe<Scalars['Int']>;
  recurringTrialAmount?: Maybe<Scalars['Float']>;
  recurringTrialEndDate?: Maybe<Scalars['DateTime']>;
  recurringTrialPeriod?: Maybe<Scalars['Float']>;
  scheduled_price?: Maybe<Array<Maybe<ProductScheduledPriceDynamicZone>>>;
  skipTrialPayment?: Maybe<Scalars['Boolean']>;
  tags?: Maybe<ActiveCampaignAcTagRelationResponseCollection>;
  title: Scalars['String'];
  total_calories?: Maybe<Scalars['Float']>;
  type: Enum_Product_Type;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vat: Scalars['Float'];
  vat_included?: Maybe<Scalars['Boolean']>;
  weight?: Maybe<Scalars['Float']>;
};


export type ProductCan_Buy_Only_WithArgs = {
  filters?: InputMaybe<ProductFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type ProductCrm_CampaignsArgs = {
  filters?: InputMaybe<CampaignFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type ProductCrm_LinksArgs = {
  filters?: InputMaybe<CrmLinkFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type ProductCurrent_PriceArgs = {
  date?: InputMaybe<Scalars['DateTime']>;
};


export type ProductIngredientsArgs = {
  filters?: InputMaybe<IngredientFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type ProductList_Price_RulesArgs = {
  end_date?: InputMaybe<Scalars['DateTime']>;
  start_date?: InputMaybe<Scalars['DateTime']>;
};


export type ProductMediaArgs = {
  filters?: InputMaybe<UploadFileFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type ProductTagsArgs = {
  filters?: InputMaybe<ActiveCampaignAcTagFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ProductCategory = {
  __typename?: 'ProductCategory';
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  products?: Maybe<ProductRelationResponseCollection>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};


export type ProductCategoryProductsArgs = {
  filters?: InputMaybe<ProductFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ProductCategoryEntity = {
  __typename?: 'ProductCategoryEntity';
  attributes?: Maybe<ProductCategory>;
  id?: Maybe<Scalars['ID']>;
};

export type ProductCategoryEntityResponse = {
  __typename?: 'ProductCategoryEntityResponse';
  data?: Maybe<ProductCategoryEntity>;
};

export type ProductCategoryEntityResponseCollection = {
  __typename?: 'ProductCategoryEntityResponseCollection';
  data: Array<ProductCategoryEntity>;
  meta: ResponseCollectionMeta;
};

export type ProductCategoryFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ProductCategoryFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  description?: InputMaybe<StringFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ProductCategoryFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ProductCategoryFiltersInput>>>;
  products?: InputMaybe<ProductFiltersInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type ProductCategoryInput = {
  description?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  products?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

export type ProductEntity = {
  __typename?: 'ProductEntity';
  attributes?: Maybe<Product>;
  id?: Maybe<Scalars['ID']>;
};

export type ProductEntityResponse = {
  __typename?: 'ProductEntityResponse';
  data?: Maybe<ProductEntity>;
};

export type ProductEntityResponseCollection = {
  __typename?: 'ProductEntityResponseCollection';
  data: Array<ProductEntity>;
  meta: ResponseCollectionMeta;
};

export type ProductFiltersInput = {
  allocates_credits?: InputMaybe<IntFilterInput>;
  allocates_tickets?: InputMaybe<IntFilterInput>;
  allocates_voucher_from_collection?: InputMaybe<VoucherListFiltersInput>;
  and?: InputMaybe<Array<InputMaybe<ProductFiltersInput>>>;
  can_buy_only_with?: InputMaybe<ProductFiltersInput>;
  category?: InputMaybe<ProductCategoryFiltersInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  crm_campaigns?: InputMaybe<CampaignFiltersInput>;
  crm_links?: InputMaybe<CrmLinkFiltersInput>;
  description?: InputMaybe<StringFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  ingredients?: InputMaybe<IngredientFiltersInput>;
  isDownPayment?: InputMaybe<BooleanFilterInput>;
  isRecurring?: InputMaybe<BooleanFilterInput>;
  limitPurchaseOncePerUser?: InputMaybe<BooleanFilterInput>;
  min_age?: InputMaybe<IntFilterInput>;
  no_use_voucher?: InputMaybe<BooleanFilterInput>;
  not?: InputMaybe<ProductFiltersInput>;
  number_of_vouchers?: InputMaybe<IntFilterInput>;
  nutritional_information?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ProductFiltersInput>>>;
  paymentMethods?: InputMaybe<JsonFilterInput>;
  price?: InputMaybe<FloatFilterInput>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  recurringIntervalMax?: InputMaybe<IntFilterInput>;
  recurringIntervalType?: InputMaybe<StringFilterInput>;
  recurringIntervalValue?: InputMaybe<IntFilterInput>;
  recurringTrialAmount?: InputMaybe<FloatFilterInput>;
  recurringTrialEndDate?: InputMaybe<DateTimeFilterInput>;
  recurringTrialPeriod?: InputMaybe<FloatFilterInput>;
  skipTrialPayment?: InputMaybe<BooleanFilterInput>;
  tags?: InputMaybe<ActiveCampaignAcTagFiltersInput>;
  title?: InputMaybe<StringFilterInput>;
  total_calories?: InputMaybe<FloatFilterInput>;
  type?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  vat?: InputMaybe<FloatFilterInput>;
  vat_included?: InputMaybe<BooleanFilterInput>;
  weight?: InputMaybe<FloatFilterInput>;
};

export type ProductInput = {
  allocates_credits?: InputMaybe<Scalars['Int']>;
  allocates_tickets?: InputMaybe<Scalars['Int']>;
  allocates_voucher_from_collection?: InputMaybe<Scalars['ID']>;
  can_buy_only_with?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  category?: InputMaybe<Scalars['ID']>;
  crm_campaigns?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  crm_links?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  description?: InputMaybe<Scalars['String']>;
  ingredients?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  isDownPayment?: InputMaybe<Scalars['Boolean']>;
  isRecurring?: InputMaybe<Scalars['Boolean']>;
  limitPurchaseOncePerUser?: InputMaybe<Scalars['Boolean']>;
  media?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  min_age?: InputMaybe<Scalars['Int']>;
  no_use_voucher?: InputMaybe<Scalars['Boolean']>;
  number_of_vouchers?: InputMaybe<Scalars['Int']>;
  nutritional_information?: InputMaybe<Scalars['String']>;
  paymentMethods?: InputMaybe<Scalars['JSON']>;
  price?: InputMaybe<Scalars['Float']>;
  publishedAt?: InputMaybe<Scalars['DateTime']>;
  recurringIntervalMax?: InputMaybe<Scalars['Int']>;
  recurringIntervalType?: InputMaybe<Enum_Product_Recurringintervaltype>;
  recurringIntervalValue?: InputMaybe<Scalars['Int']>;
  recurringTrialAmount?: InputMaybe<Scalars['Float']>;
  recurringTrialEndDate?: InputMaybe<Scalars['DateTime']>;
  recurringTrialPeriod?: InputMaybe<Scalars['Float']>;
  scheduled_price?: InputMaybe<Array<Scalars['ProductScheduledPriceDynamicZoneInput']>>;
  skipTrialPayment?: InputMaybe<Scalars['Boolean']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  title?: InputMaybe<Scalars['String']>;
  total_calories?: InputMaybe<Scalars['Float']>;
  type?: InputMaybe<Enum_Product_Type>;
  vat?: InputMaybe<Scalars['Float']>;
  vat_included?: InputMaybe<Scalars['Boolean']>;
  weight?: InputMaybe<Scalars['Float']>;
};

export type ProductRelationResponseCollection = {
  __typename?: 'ProductRelationResponseCollection';
  data: Array<ProductEntity>;
};

export type ProductScheduledPriceDynamicZone = ComponentGeneralCalendarScheduledPrice | ComponentGeneralDailyScheduledPrice | Error;

export type PromptType = {
  __typename?: 'PromptType';
  createdAt?: Maybe<Scalars['DateTime']>;
  locale?: Maybe<Scalars['String']>;
  localizations?: Maybe<PromptTypeRelationResponseCollection>;
  prompt: Scalars['String'];
  publishedAt?: Maybe<Scalars['DateTime']>;
  type: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};


export type PromptTypeLocalizationsArgs = {
  filters?: InputMaybe<PromptTypeFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PromptTypeEntity = {
  __typename?: 'PromptTypeEntity';
  attributes?: Maybe<PromptType>;
  id?: Maybe<Scalars['ID']>;
};

export type PromptTypeEntityResponse = {
  __typename?: 'PromptTypeEntityResponse';
  data?: Maybe<PromptTypeEntity>;
};

export type PromptTypeEntityResponseCollection = {
  __typename?: 'PromptTypeEntityResponseCollection';
  data: Array<PromptTypeEntity>;
  meta: ResponseCollectionMeta;
};

export type PromptTypeFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<PromptTypeFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  locale?: InputMaybe<StringFilterInput>;
  localizations?: InputMaybe<PromptTypeFiltersInput>;
  not?: InputMaybe<PromptTypeFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<PromptTypeFiltersInput>>>;
  prompt?: InputMaybe<StringFilterInput>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  type?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type PromptTypeInput = {
  prompt?: InputMaybe<Scalars['String']>;
  publishedAt?: InputMaybe<Scalars['DateTime']>;
  type?: InputMaybe<Scalars['String']>;
};

export type PromptTypeRelationResponseCollection = {
  __typename?: 'PromptTypeRelationResponseCollection';
  data: Array<PromptTypeEntity>;
};

export enum PublicationState {
  Live = 'LIVE',
  Preview = 'PREVIEW'
}

export type QrCode = {
  __typename?: 'QrCode';
  active: Scalars['Boolean'];
  createdAt?: Maybe<Scalars['DateTime']>;
  slug?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
  url?: Maybe<Scalars['String']>;
};

export type QrCodeEntity = {
  __typename?: 'QrCodeEntity';
  attributes?: Maybe<QrCode>;
  id?: Maybe<Scalars['ID']>;
};

export type QrCodeEntityResponse = {
  __typename?: 'QrCodeEntityResponse';
  data?: Maybe<QrCodeEntity>;
};

export type QrCodeEntityResponseCollection = {
  __typename?: 'QrCodeEntityResponseCollection';
  data: Array<QrCodeEntity>;
  meta: ResponseCollectionMeta;
};

export type QrCodeFiltersInput = {
  active?: InputMaybe<BooleanFilterInput>;
  and?: InputMaybe<Array<InputMaybe<QrCodeFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  not?: InputMaybe<QrCodeFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<QrCodeFiltersInput>>>;
  slug?: InputMaybe<StringFilterInput>;
  title?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  url?: InputMaybe<StringFilterInput>;
};

export type QrCodeInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  slug?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
};

export type Query = {
  __typename?: 'Query';
  accessCard?: Maybe<AccessCardEntityResponse>;
  accessCards?: Maybe<AccessCardEntityResponseCollection>;
  accessGroup?: Maybe<AccessGroupEntityResponse>;
  accessGroups?: Maybe<AccessGroupEntityResponseCollection>;
  achievement?: Maybe<AchievementEntityResponse>;
  achievements?: Maybe<AchievementEntityResponseCollection>;
  activeCampaignAcTag?: Maybe<ActiveCampaignAcTagEntityResponse>;
  activeCampaignAcTags?: Maybe<ActiveCampaignAcTagEntityResponseCollection>;
  allergen?: Maybe<AllergenEntityResponse>;
  allergens?: Maybe<AllergenEntityResponseCollection>;
  bleDevice?: Maybe<BleDeviceEntityResponse>;
  bleDevices?: Maybe<BleDeviceEntityResponseCollection>;
  bleFloor?: Maybe<BleFloorEntityResponse>;
  bleFloors?: Maybe<BleFloorEntityResponseCollection>;
  bleGateway?: Maybe<BleGatewayEntityResponse>;
  bleGateways?: Maybe<BleGatewayEntityResponseCollection>;
  bleGroup?: Maybe<BleGroupEntityResponse>;
  bleGroups?: Maybe<BleGroupEntityResponseCollection>;
  blogCategories?: Maybe<BlogCategoryEntityResponseCollection>;
  blogCategory?: Maybe<BlogCategoryEntityResponse>;
  blogPost?: Maybe<BlogPostEntityResponse>;
  blogPosts?: Maybe<BlogPostEntityResponseCollection>;
  campaign?: Maybe<CampaignEntityResponse>;
  campaignMemberAvatar?: Maybe<CampaignMemberAvatarEntityResponse>;
  campaignMemberAvatars?: Maybe<CampaignMemberAvatarEntityResponseCollection>;
  campaigns?: Maybe<CampaignEntityResponseCollection>;
  classroom?: Maybe<ClassroomEntityResponse>;
  classroomMember?: Maybe<ClassroomMemberEntityResponse>;
  classroomMembers?: Maybe<ClassroomMemberEntityResponseCollection>;
  classrooms?: Maybe<ClassroomEntityResponseCollection>;
  comment?: Maybe<CommentEntityResponse>;
  comments?: Maybe<CommentEntityResponseCollection>;
  contact?: Maybe<ContactEntityResponse>;
  contacts?: Maybe<ContactEntityResponseCollection>;
  creditChange?: Maybe<CreditChangeEntityResponse>;
  creditChanges?: Maybe<CreditChangeEntityResponseCollection>;
  crmCampaignMember?: Maybe<CrmCampaignMemberEntityResponse>;
  crmCampaignMemberStatus?: Maybe<CrmCampaignMemberStatusEntityResponse>;
  crmCampaignMemberStatuses?: Maybe<CrmCampaignMemberStatusEntityResponseCollection>;
  crmCampaignMembers?: Maybe<CrmCampaignMemberEntityResponseCollection>;
  crmContactAllocation?: Maybe<CrmContactAllocationEntityResponse>;
  crmContactAllocations?: Maybe<CrmContactAllocationEntityResponseCollection>;
  crmContactSource?: Maybe<CrmContactSourceEntityResponse>;
  crmContactSources?: Maybe<CrmContactSourceEntityResponseCollection>;
  crmLink?: Maybe<CrmLinkEntityResponse>;
  crmLinks?: Maybe<CrmLinkEntityResponseCollection>;
  crmRole?: Maybe<CrmRoleEntityResponse>;
  crmRoles?: Maybe<CrmRoleEntityResponseCollection>;
  crmSetting?: Maybe<CrmSettingEntityResponse>;
  crmTask?: Maybe<CrmTaskEntityResponse>;
  crmTaskFeedback?: Maybe<CrmTaskFeedbackEntityResponse>;
  crmTaskFeedbacks?: Maybe<CrmTaskFeedbackEntityResponseCollection>;
  crmTaskTemplate?: Maybe<CrmTaskTemplateEntityResponse>;
  crmTaskTemplates?: Maybe<CrmTaskTemplateEntityResponseCollection>;
  crmTasks?: Maybe<CrmTaskEntityResponseCollection>;
  dailyTask?: Maybe<DailyTaskEntityResponse>;
  dailyTaskClassroomMember?: Maybe<DailyTaskClassroomMemberEntityResponse>;
  dailyTaskClassroomMembers?: Maybe<DailyTaskClassroomMemberEntityResponseCollection>;
  dailyTasks?: Maybe<DailyTaskEntityResponseCollection>;
  defaultNotificationSetting?: Maybe<DefaultNotificationSettingEntityResponse>;
  drimon?: Maybe<DrimonEntityResponse>;
  drimons?: Maybe<DrimonEntityResponseCollection>;
  emailDesignerEmailTemplate?: Maybe<EmailDesignerEmailTemplateEntityResponse>;
  emailDesignerEmailTemplates?: Maybe<EmailDesignerEmailTemplateEntityResponseCollection>;
  event?: Maybe<EventEntityResponse>;
  eventCategories?: Maybe<EventCategoryEntityResponseCollection>;
  eventCategory?: Maybe<EventCategoryEntityResponse>;
  events?: Maybe<EventEntityResponseCollection>;
  ezformsRecipient?: Maybe<EzformsRecipientEntityResponse>;
  ezformsRecipients?: Maybe<EzformsRecipientEntityResponseCollection>;
  ezformsSubmission?: Maybe<EzformsSubmissionEntityResponse>;
  ezformsSubmissions?: Maybe<EzformsSubmissionEntityResponseCollection>;
  game?: Maybe<GameEntityResponse>;
  games?: Maybe<GameEntityResponseCollection>;
  graphicMaterial?: Maybe<GraphicMaterialEntityResponse>;
  graphicMaterials?: Maybe<GraphicMaterialEntityResponseCollection>;
  house?: Maybe<HouseEntityResponse>;
  houses?: Maybe<HouseEntityResponseCollection>;
  i18NLocale?: Maybe<I18NLocaleEntityResponse>;
  i18NLocales?: Maybe<I18NLocaleEntityResponseCollection>;
  ingredient?: Maybe<IngredientEntityResponse>;
  ingredients?: Maybe<IngredientEntityResponseCollection>;
  lock?: Maybe<LockEntityResponse>;
  locks?: Maybe<LockEntityResponseCollection>;
  map?: Maybe<MapEntityResponse>;
  maps?: Maybe<MapEntityResponseCollection>;
  me?: Maybe<UsersPermissionsMe>;
  menu?: Maybe<MenuEntityResponse>;
  menuPage?: Maybe<MenuPageEntityResponse>;
  menuPages?: Maybe<MenuPageEntityResponseCollection>;
  menus?: Maybe<MenuEntityResponseCollection>;
  message?: Maybe<MessageEntityResponse>;
  messageGroup?: Maybe<MessageGroupEntityResponse>;
  messageGroups?: Maybe<MessageGroupEntityResponseCollection>;
  messages?: Maybe<MessageEntityResponseCollection>;
  notificationTemplate?: Maybe<NotificationTemplateEntityResponse>;
  notificationTemplates?: Maybe<NotificationTemplateEntityResponseCollection>;
  notificationsNotification?: Maybe<NotificationsNotificationEntityResponse>;
  notificationsNotifications?: Maybe<NotificationsNotificationEntityResponseCollection>;
  order?: Maybe<OrderEntityResponse>;
  orderStatusLog?: Maybe<OrderStatusLogEntityResponse>;
  orderStatusLogs?: Maybe<OrderStatusLogEntityResponseCollection>;
  orders?: Maybe<OrderEntityResponseCollection>;
  page?: Maybe<PageEntityResponse>;
  pages?: Maybe<PageEntityResponseCollection>;
  payment?: Maybe<PaymentEntityResponse>;
  payments?: Maybe<PaymentEntityResponseCollection>;
  playerAvatar?: Maybe<PlayerAvatarEntityResponse>;
  playerAvatars?: Maybe<PlayerAvatarEntityResponseCollection>;
  product?: Maybe<ProductEntityResponse>;
  productCategories?: Maybe<ProductCategoryEntityResponseCollection>;
  productCategory?: Maybe<ProductCategoryEntityResponse>;
  products?: Maybe<ProductEntityResponseCollection>;
  promptType?: Maybe<PromptTypeEntityResponse>;
  promptTypes?: Maybe<PromptTypeEntityResponseCollection>;
  qrCode?: Maybe<QrCodeEntityResponse>;
  qrCodes?: Maybe<QrCodeEntityResponseCollection>;
  reservation?: Maybe<ReservationEntityResponse>;
  reservationLog?: Maybe<ReservationLogEntityResponse>;
  reservationLogs?: Maybe<ReservationLogEntityResponseCollection>;
  reservations?: Maybe<ReservationEntityResponseCollection>;
  reusableComponent?: Maybe<ReusableComponentEntityResponse>;
  reusableComponents?: Maybe<ReusableComponentEntityResponseCollection>;
  room?: Maybe<RoomEntityResponse>;
  rooms?: Maybe<RoomEntityResponseCollection>;
  scheduledJob?: Maybe<ScheduledJobEntityResponse>;
  scheduledJobs?: Maybe<ScheduledJobEntityResponseCollection>;
  smartbillInvoice?: Maybe<SmartbillInvoiceEntityResponse>;
  smartbillInvoices?: Maybe<SmartbillInvoiceEntityResponseCollection>;
  timeSlot?: Maybe<TimeSlotEntityResponse>;
  timeSlots?: Maybe<TimeSlotEntityResponseCollection>;
  uploadFile?: Maybe<UploadFileEntityResponse>;
  uploadFiles?: Maybe<UploadFileEntityResponseCollection>;
  uploadFolder?: Maybe<UploadFolderEntityResponse>;
  uploadFolders?: Maybe<UploadFolderEntityResponseCollection>;
  userAccessGroup?: Maybe<UserAccessGroupEntityResponse>;
  userAccessGroups?: Maybe<UserAccessGroupEntityResponseCollection>;
  userAchievement?: Maybe<UserAchievementEntityResponse>;
  userAchievements?: Maybe<UserAchievementEntityResponseCollection>;
  userCreditManagementSignaturePad?: Maybe<UserCreditManagementSignaturePadEntityResponse>;
  userCreditManagementSignaturePads?: Maybe<UserCreditManagementSignaturePadEntityResponseCollection>;
  userTicket?: Maybe<UserTicketEntityResponse>;
  userTickets?: Maybe<UserTicketEntityResponseCollection>;
  usersPermissionsRole?: Maybe<UsersPermissionsRoleEntityResponse>;
  usersPermissionsRoles?: Maybe<UsersPermissionsRoleEntityResponseCollection>;
  usersPermissionsUser?: Maybe<UsersPermissionsUserEntityResponse>;
  usersPermissionsUsers?: Maybe<UsersPermissionsUserEntityResponseCollection>;
  voucher?: Maybe<VoucherEntityResponse>;
  voucherList?: Maybe<VoucherListEntityResponse>;
  voucherLists?: Maybe<VoucherListEntityResponseCollection>;
  vouchers?: Maybe<VoucherEntityResponseCollection>;
};


export type QueryAccessCardArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type QueryAccessCardsArgs = {
  filters?: InputMaybe<AccessCardFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryAccessGroupArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type QueryAccessGroupsArgs = {
  filters?: InputMaybe<AccessGroupFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryAchievementArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type QueryAchievementsArgs = {
  filters?: InputMaybe<AchievementFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryActiveCampaignAcTagArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type QueryActiveCampaignAcTagsArgs = {
  filters?: InputMaybe<ActiveCampaignAcTagFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryAllergenArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type QueryAllergensArgs = {
  filters?: InputMaybe<AllergenFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryBleDeviceArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type QueryBleDevicesArgs = {
  filters?: InputMaybe<BleDeviceFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryBleFloorArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type QueryBleFloorsArgs = {
  filters?: InputMaybe<BleFloorFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryBleGatewayArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type QueryBleGatewaysArgs = {
  filters?: InputMaybe<BleGatewayFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryBleGroupArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type QueryBleGroupsArgs = {
  filters?: InputMaybe<BleGroupFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryBlogCategoriesArgs = {
  filters?: InputMaybe<BlogCategoryFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryBlogCategoryArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type QueryBlogPostArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type QueryBlogPostsArgs = {
  filters?: InputMaybe<BlogPostFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryCampaignArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type QueryCampaignMemberAvatarArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type QueryCampaignMemberAvatarsArgs = {
  filters?: InputMaybe<CampaignMemberAvatarFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryCampaignsArgs = {
  filters?: InputMaybe<CampaignFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryClassroomArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type QueryClassroomMemberArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type QueryClassroomMembersArgs = {
  filters?: InputMaybe<ClassroomMemberFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryClassroomsArgs = {
  filters?: InputMaybe<ClassroomFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryCommentArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type QueryCommentsArgs = {
  filters?: InputMaybe<CommentFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryContactArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type QueryContactsArgs = {
  filters?: InputMaybe<ContactFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryCreditChangeArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type QueryCreditChangesArgs = {
  filters?: InputMaybe<CreditChangeFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryCrmCampaignMemberArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type QueryCrmCampaignMemberStatusArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type QueryCrmCampaignMemberStatusesArgs = {
  filters?: InputMaybe<CrmCampaignMemberStatusFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryCrmCampaignMembersArgs = {
  filters?: InputMaybe<CrmCampaignMemberFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryCrmContactAllocationArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type QueryCrmContactAllocationsArgs = {
  filters?: InputMaybe<CrmContactAllocationFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryCrmContactSourceArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type QueryCrmContactSourcesArgs = {
  filters?: InputMaybe<CrmContactSourceFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryCrmLinkArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type QueryCrmLinksArgs = {
  filters?: InputMaybe<CrmLinkFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryCrmRoleArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type QueryCrmRolesArgs = {
  filters?: InputMaybe<CrmRoleFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryCrmTaskArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type QueryCrmTaskFeedbackArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type QueryCrmTaskFeedbacksArgs = {
  filters?: InputMaybe<CrmTaskFeedbackFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryCrmTaskTemplateArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type QueryCrmTaskTemplatesArgs = {
  filters?: InputMaybe<CrmTaskTemplateFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryCrmTasksArgs = {
  filters?: InputMaybe<CrmTaskFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryDailyTaskArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type QueryDailyTaskClassroomMemberArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type QueryDailyTaskClassroomMembersArgs = {
  filters?: InputMaybe<DailyTaskClassroomMemberFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryDailyTasksArgs = {
  filters?: InputMaybe<DailyTaskFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryDrimonArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type QueryDrimonsArgs = {
  filters?: InputMaybe<DrimonFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryEmailDesignerEmailTemplateArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type QueryEmailDesignerEmailTemplatesArgs = {
  filters?: InputMaybe<EmailDesignerEmailTemplateFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryEventArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type QueryEventCategoriesArgs = {
  filters?: InputMaybe<EventCategoryFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryEventCategoryArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type QueryEventsArgs = {
  filters?: InputMaybe<EventFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryEzformsRecipientArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type QueryEzformsRecipientsArgs = {
  filters?: InputMaybe<EzformsRecipientFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryEzformsSubmissionArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type QueryEzformsSubmissionsArgs = {
  filters?: InputMaybe<EzformsSubmissionFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryGameArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type QueryGamesArgs = {
  filters?: InputMaybe<GameFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryGraphicMaterialArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type QueryGraphicMaterialsArgs = {
  filters?: InputMaybe<GraphicMaterialFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryHouseArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type QueryHousesArgs = {
  filters?: InputMaybe<HouseFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryI18NLocaleArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type QueryI18NLocalesArgs = {
  filters?: InputMaybe<I18NLocaleFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryIngredientArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type QueryIngredientsArgs = {
  filters?: InputMaybe<IngredientFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryLockArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type QueryLocksArgs = {
  filters?: InputMaybe<LockFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryMapArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type QueryMapsArgs = {
  filters?: InputMaybe<MapFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryMenuArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type QueryMenuPageArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type QueryMenuPagesArgs = {
  filters?: InputMaybe<MenuPageFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryMenusArgs = {
  filters?: InputMaybe<MenuFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryMessageArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type QueryMessageGroupArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type QueryMessageGroupsArgs = {
  filters?: InputMaybe<MessageGroupFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryMessagesArgs = {
  filters?: InputMaybe<MessageFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryNotificationTemplateArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type QueryNotificationTemplatesArgs = {
  filters?: InputMaybe<NotificationTemplateFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryNotificationsNotificationArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type QueryNotificationsNotificationsArgs = {
  filters?: InputMaybe<NotificationsNotificationFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryOrderArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type QueryOrderStatusLogArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type QueryOrderStatusLogsArgs = {
  filters?: InputMaybe<OrderStatusLogFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryOrdersArgs = {
  filters?: InputMaybe<OrderFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryPageArgs = {
  id?: InputMaybe<Scalars['ID']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type QueryPagesArgs = {
  filters?: InputMaybe<PageFiltersInput>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryPaymentArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type QueryPaymentsArgs = {
  filters?: InputMaybe<PaymentFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryPlayerAvatarArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type QueryPlayerAvatarsArgs = {
  filters?: InputMaybe<PlayerAvatarFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryProductArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type QueryProductCategoriesArgs = {
  filters?: InputMaybe<ProductCategoryFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryProductCategoryArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type QueryProductsArgs = {
  filters?: InputMaybe<ProductFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryPromptTypeArgs = {
  id?: InputMaybe<Scalars['ID']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type QueryPromptTypesArgs = {
  filters?: InputMaybe<PromptTypeFiltersInput>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryQrCodeArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type QueryQrCodesArgs = {
  filters?: InputMaybe<QrCodeFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryReservationArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type QueryReservationLogArgs = {
  id?: InputMaybe<Scalars['ID']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type QueryReservationLogsArgs = {
  filters?: InputMaybe<ReservationLogFiltersInput>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryReservationsArgs = {
  filters?: InputMaybe<ReservationFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryReusableComponentArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type QueryReusableComponentsArgs = {
  filters?: InputMaybe<ReusableComponentFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryRoomArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type QueryRoomsArgs = {
  filters?: InputMaybe<RoomFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryScheduledJobArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type QueryScheduledJobsArgs = {
  filters?: InputMaybe<ScheduledJobFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QuerySmartbillInvoiceArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type QuerySmartbillInvoicesArgs = {
  filters?: InputMaybe<SmartbillInvoiceFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryTimeSlotArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type QueryTimeSlotsArgs = {
  filters?: InputMaybe<TimeSlotFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryUploadFileArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type QueryUploadFilesArgs = {
  filters?: InputMaybe<UploadFileFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryUploadFolderArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type QueryUploadFoldersArgs = {
  filters?: InputMaybe<UploadFolderFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryUserAccessGroupArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type QueryUserAccessGroupsArgs = {
  filters?: InputMaybe<UserAccessGroupFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryUserAchievementArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type QueryUserAchievementsArgs = {
  filters?: InputMaybe<UserAchievementFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryUserCreditManagementSignaturePadArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type QueryUserCreditManagementSignaturePadsArgs = {
  filters?: InputMaybe<UserCreditManagementSignaturePadFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryUserTicketArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type QueryUserTicketsArgs = {
  filters?: InputMaybe<UserTicketFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryUsersPermissionsRoleArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type QueryUsersPermissionsRolesArgs = {
  filters?: InputMaybe<UsersPermissionsRoleFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryUsersPermissionsUserArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type QueryUsersPermissionsUsersArgs = {
  filters?: InputMaybe<UsersPermissionsUserFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryVoucherArgs = {
  id?: InputMaybe<Scalars['ID']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type QueryVoucherListArgs = {
  id?: InputMaybe<Scalars['ID']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type QueryVoucherListsArgs = {
  filters?: InputMaybe<VoucherListFiltersInput>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryVouchersArgs = {
  filters?: InputMaybe<VoucherFiltersInput>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ReactionsReaction = {
  __typename?: 'ReactionsReaction';
  collection_id: Scalars['String'];
  collection_type: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  type?: Maybe<ReactionsReactionTypeEntityResponse>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<UsersPermissionsUserEntityResponse>;
};

export type ReactionsReactionCountResponse = {
  __typename?: 'ReactionsReactionCountResponse';
  reactions_count?: Maybe<Scalars['ReactionsReactionCountEntity']>;
  reactions_done?: Maybe<Scalars['ReactionsReactionStateEntity']>;
};

export type ReactionsReactionEntity = {
  __typename?: 'ReactionsReactionEntity';
  attributes?: Maybe<ReactionsReaction>;
  id?: Maybe<Scalars['ID']>;
};

export type ReactionsReactionFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ReactionsReactionFiltersInput>>>;
  collection_id?: InputMaybe<StringFilterInput>;
  collection_type?: InputMaybe<StringFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  not?: InputMaybe<ReactionsReactionFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ReactionsReactionFiltersInput>>>;
  type?: InputMaybe<ReactionsReactionTypeFiltersInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  user?: InputMaybe<UsersPermissionsUserFiltersInput>;
};

export type ReactionsReactionRelationResponseCollection = {
  __typename?: 'ReactionsReactionRelationResponseCollection';
  data: Array<ReactionsReactionEntity>;
};

export type ReactionsReactionType = {
  __typename?: 'ReactionsReactionType';
  createdAt?: Maybe<Scalars['DateTime']>;
  name: Scalars['String'];
  reactions?: Maybe<ReactionsReactionRelationResponseCollection>;
  slug?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};


export type ReactionsReactionTypeReactionsArgs = {
  filters?: InputMaybe<ReactionsReactionFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ReactionsReactionTypeEntity = {
  __typename?: 'ReactionsReactionTypeEntity';
  attributes?: Maybe<ReactionsReactionType>;
  id?: Maybe<Scalars['ID']>;
};

export type ReactionsReactionTypeEntityResponse = {
  __typename?: 'ReactionsReactionTypeEntityResponse';
  data?: Maybe<ReactionsReactionTypeEntity>;
};

export type ReactionsReactionTypeFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ReactionsReactionTypeFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ReactionsReactionTypeFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ReactionsReactionTypeFiltersInput>>>;
  reactions?: InputMaybe<ReactionsReactionFiltersInput>;
  slug?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type Reservation = {
  __typename?: 'Reservation';
  changes?: Maybe<Array<Maybe<ComponentGeneralChanges>>>;
  createdAt?: Maybe<Scalars['DateTime']>;
  crm_campaign_member?: Maybe<CrmCampaignMemberEntityResponse>;
  email?: Maybe<Scalars['String']>;
  end_date?: Maybe<Scalars['DateTime']>;
  first_name?: Maybe<Scalars['String']>;
  invited_people?: Maybe<Array<Maybe<ComponentGeneralInvitations>>>;
  last_name?: Maybe<Scalars['String']>;
  message_group?: Maybe<MessageGroupEntityResponse>;
  order?: Maybe<OrderEntityResponse>;
  phone?: Maybe<Scalars['String']>;
  products?: Maybe<Array<Maybe<ComponentMenuProductWithQuantity>>>;
  reservation_logs?: Maybe<ReservationLogRelationResponseCollection>;
  start_date?: Maybe<Scalars['DateTime']>;
  status?: Maybe<Enum_Reservation_Status>;
  time_slots?: Maybe<TimeSlotRelationResponseCollection>;
  title: Scalars['String'];
  type?: Maybe<Enum_Reservation_Type>;
  type_other?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};


export type ReservationChangesArgs = {
  filters?: InputMaybe<ComponentGeneralChangesFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type ReservationInvited_PeopleArgs = {
  filters?: InputMaybe<ComponentGeneralInvitationsFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type ReservationProductsArgs = {
  filters?: InputMaybe<ComponentMenuProductWithQuantityFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type ReservationReservation_LogsArgs = {
  filters?: InputMaybe<ReservationLogFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type ReservationTime_SlotsArgs = {
  filters?: InputMaybe<TimeSlotFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ReservationEntity = {
  __typename?: 'ReservationEntity';
  attributes?: Maybe<Reservation>;
  id?: Maybe<Scalars['ID']>;
};

export type ReservationEntityResponse = {
  __typename?: 'ReservationEntityResponse';
  data?: Maybe<ReservationEntity>;
};

export type ReservationEntityResponseCollection = {
  __typename?: 'ReservationEntityResponseCollection';
  data: Array<ReservationEntity>;
  meta: ResponseCollectionMeta;
};

export type ReservationFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ReservationFiltersInput>>>;
  changes?: InputMaybe<ComponentGeneralChangesFiltersInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  crm_campaign_member?: InputMaybe<CrmCampaignMemberFiltersInput>;
  email?: InputMaybe<StringFilterInput>;
  end_date?: InputMaybe<DateTimeFilterInput>;
  first_name?: InputMaybe<StringFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  invited_people?: InputMaybe<ComponentGeneralInvitationsFiltersInput>;
  last_name?: InputMaybe<StringFilterInput>;
  message_group?: InputMaybe<MessageGroupFiltersInput>;
  not?: InputMaybe<ReservationFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ReservationFiltersInput>>>;
  order?: InputMaybe<OrderFiltersInput>;
  phone?: InputMaybe<StringFilterInput>;
  products?: InputMaybe<ComponentMenuProductWithQuantityFiltersInput>;
  reservation_logs?: InputMaybe<ReservationLogFiltersInput>;
  start_date?: InputMaybe<DateTimeFilterInput>;
  status?: InputMaybe<StringFilterInput>;
  time_slots?: InputMaybe<TimeSlotFiltersInput>;
  title?: InputMaybe<StringFilterInput>;
  type?: InputMaybe<StringFilterInput>;
  type_other?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type ReservationInput = {
  changes?: InputMaybe<Array<InputMaybe<ComponentGeneralChangesInput>>>;
  crm_campaign_member?: InputMaybe<Scalars['ID']>;
  email?: InputMaybe<Scalars['String']>;
  end_date?: InputMaybe<Scalars['DateTime']>;
  first_name?: InputMaybe<Scalars['String']>;
  invited_people?: InputMaybe<Array<InputMaybe<ComponentGeneralInvitationsInput>>>;
  last_name?: InputMaybe<Scalars['String']>;
  message_group?: InputMaybe<Scalars['ID']>;
  order?: InputMaybe<Scalars['ID']>;
  phone?: InputMaybe<Scalars['String']>;
  products?: InputMaybe<Array<InputMaybe<ComponentMenuProductWithQuantityInput>>>;
  reservation_logs?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  start_date?: InputMaybe<Scalars['DateTime']>;
  status?: InputMaybe<Enum_Reservation_Status>;
  time_slots?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  title?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Enum_Reservation_Type>;
  type_other?: InputMaybe<Scalars['String']>;
};

export type ReservationLog = {
  __typename?: 'ReservationLog';
  createdAt?: Maybe<Scalars['DateTime']>;
  date?: Maybe<Scalars['DateTime']>;
  diff?: Maybe<Scalars['String']>;
  info?: Maybe<Scalars['String']>;
  locale?: Maybe<Scalars['String']>;
  localizations?: Maybe<ReservationLogRelationResponseCollection>;
  new_data?: Maybe<Scalars['JSON']>;
  old_data?: Maybe<Scalars['JSON']>;
  reservation?: Maybe<ReservationEntityResponse>;
  title: Scalars['String'];
  type?: Maybe<Enum_Reservationlog_Type>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<UsersPermissionsUserEntityResponse>;
};


export type ReservationLogLocalizationsArgs = {
  filters?: InputMaybe<ReservationLogFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ReservationLogEntity = {
  __typename?: 'ReservationLogEntity';
  attributes?: Maybe<ReservationLog>;
  id?: Maybe<Scalars['ID']>;
};

export type ReservationLogEntityResponse = {
  __typename?: 'ReservationLogEntityResponse';
  data?: Maybe<ReservationLogEntity>;
};

export type ReservationLogEntityResponseCollection = {
  __typename?: 'ReservationLogEntityResponseCollection';
  data: Array<ReservationLogEntity>;
  meta: ResponseCollectionMeta;
};

export type ReservationLogFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ReservationLogFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  date?: InputMaybe<DateTimeFilterInput>;
  diff?: InputMaybe<StringFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  info?: InputMaybe<StringFilterInput>;
  locale?: InputMaybe<StringFilterInput>;
  localizations?: InputMaybe<ReservationLogFiltersInput>;
  new_data?: InputMaybe<JsonFilterInput>;
  not?: InputMaybe<ReservationLogFiltersInput>;
  old_data?: InputMaybe<JsonFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ReservationLogFiltersInput>>>;
  reservation?: InputMaybe<ReservationFiltersInput>;
  title?: InputMaybe<StringFilterInput>;
  type?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  user?: InputMaybe<UsersPermissionsUserFiltersInput>;
};

export type ReservationLogInput = {
  date?: InputMaybe<Scalars['DateTime']>;
  diff?: InputMaybe<Scalars['String']>;
  info?: InputMaybe<Scalars['String']>;
  new_data?: InputMaybe<Scalars['JSON']>;
  old_data?: InputMaybe<Scalars['JSON']>;
  reservation?: InputMaybe<Scalars['ID']>;
  title?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Enum_Reservationlog_Type>;
  user?: InputMaybe<Scalars['ID']>;
};

export type ReservationLogRelationResponseCollection = {
  __typename?: 'ReservationLogRelationResponseCollection';
  data: Array<ReservationLogEntity>;
};

export type ReservationRelationResponseCollection = {
  __typename?: 'ReservationRelationResponseCollection';
  data: Array<ReservationEntity>;
};

export type ResponseCollectionMeta = {
  __typename?: 'ResponseCollectionMeta';
  pagination: Pagination;
};

export type ReusableComponent = {
  __typename?: 'ReusableComponent';
  components: Array<Maybe<ReusableComponentComponentsDynamicZone>>;
  createdAt?: Maybe<Scalars['DateTime']>;
  title: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ReusableComponentComponentsDynamicZone = ComponentCmsDataAnimatedCardSection | ComponentCmsDataAuthorsListSection | ComponentCmsDataBlogArticles | ComponentCmsDataCaptureContact | ComponentCmsDataDarkBgImageSection | ComponentCmsDataDarkImageContent | ComponentCmsDataDarkTextBoxSection | ComponentCmsDataDarkVersusContent | ComponentCmsDataEventsListSection | ComponentCmsDataFaq | ComponentCmsDataFooterSection | ComponentCmsDataFormGroup | ComponentCmsDataHeaderSection | ComponentCmsDataHeroSection | ComponentCmsDataHeroSectionSlider | ComponentCmsDataHeroSectionTwo | ComponentCmsDataIconCardsSection | ComponentCmsDataImageCardsSection | ComponentCmsDataImageGallery | ComponentCmsDataInteractiveImageMap | ComponentCmsDataLightTopImgSection | ComponentCmsDataPriceSection | ComponentCmsDataProductsList | ComponentCmsDataReviewsSection | ComponentCmsDataRichText | ComponentCmsDataRichTextHtml | ComponentCmsDataScheduleMeeting | ComponentCmsDataScrollListSection | ComponentCmsDataScrollToSection | ComponentCmsDataSingleTitleSection | ComponentCmsDataSlider | ComponentCmsDataSubscriptionPopup | ComponentCmsDataTextAndImageSection | ComponentCmsDataVideoSection | Error;

export type ReusableComponentEntity = {
  __typename?: 'ReusableComponentEntity';
  attributes?: Maybe<ReusableComponent>;
  id?: Maybe<Scalars['ID']>;
};

export type ReusableComponentEntityResponse = {
  __typename?: 'ReusableComponentEntityResponse';
  data?: Maybe<ReusableComponentEntity>;
};

export type ReusableComponentEntityResponseCollection = {
  __typename?: 'ReusableComponentEntityResponseCollection';
  data: Array<ReusableComponentEntity>;
  meta: ResponseCollectionMeta;
};

export type ReusableComponentFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ReusableComponentFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  not?: InputMaybe<ReusableComponentFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ReusableComponentFiltersInput>>>;
  title?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type ReusableComponentInput = {
  components?: InputMaybe<Array<Scalars['ReusableComponentComponentsDynamicZoneInput']>>;
  title?: InputMaybe<Scalars['String']>;
};

export type Room = {
  __typename?: 'Room';
  ble_floor?: Maybe<BleFloorEntityResponse>;
  booking_slot_rules?: Maybe<Array<Maybe<RoomBookingSlotRulesDynamicZone>>>;
  boundaries?: Maybe<Scalars['String']>;
  color?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  publishedAt?: Maybe<Scalars['DateTime']>;
  tables?: Maybe<Array<Maybe<ComponentGeneralTable>>>;
  time_slots?: Maybe<TimeSlotRelationResponseCollection>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};


export type RoomTablesArgs = {
  filters?: InputMaybe<ComponentGeneralTableFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type RoomTime_SlotsArgs = {
  filters?: InputMaybe<TimeSlotFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type RoomBookingSlotRulesDynamicZone = ComponentGeneralCalendarBookingSlot | ComponentGeneralDailyBookingSlot | Error;

export type RoomEntity = {
  __typename?: 'RoomEntity';
  attributes?: Maybe<Room>;
  id?: Maybe<Scalars['ID']>;
};

export type RoomEntityResponse = {
  __typename?: 'RoomEntityResponse';
  data?: Maybe<RoomEntity>;
};

export type RoomEntityResponseCollection = {
  __typename?: 'RoomEntityResponseCollection';
  data: Array<RoomEntity>;
  meta: ResponseCollectionMeta;
};

export type RoomFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<RoomFiltersInput>>>;
  ble_floor?: InputMaybe<BleFloorFiltersInput>;
  boundaries?: InputMaybe<StringFilterInput>;
  color?: InputMaybe<StringFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  description?: InputMaybe<StringFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<RoomFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<RoomFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  tables?: InputMaybe<ComponentGeneralTableFiltersInput>;
  time_slots?: InputMaybe<TimeSlotFiltersInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type RoomInput = {
  ble_floor?: InputMaybe<Scalars['ID']>;
  booking_slot_rules?: InputMaybe<Array<Scalars['RoomBookingSlotRulesDynamicZoneInput']>>;
  boundaries?: InputMaybe<Scalars['String']>;
  color?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  publishedAt?: InputMaybe<Scalars['DateTime']>;
  tables?: InputMaybe<Array<InputMaybe<ComponentGeneralTableInput>>>;
  time_slots?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

export type RoomRelationResponseCollection = {
  __typename?: 'RoomRelationResponseCollection';
  data: Array<RoomEntity>;
};

export type ScheduledJob = {
  __typename?: 'ScheduledJob';
  createdAt?: Maybe<Scalars['DateTime']>;
  data?: Maybe<Scalars['JSON']>;
  error?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ScheduledJobEntity = {
  __typename?: 'ScheduledJobEntity';
  attributes?: Maybe<ScheduledJob>;
  id?: Maybe<Scalars['ID']>;
};

export type ScheduledJobEntityResponse = {
  __typename?: 'ScheduledJobEntityResponse';
  data?: Maybe<ScheduledJobEntity>;
};

export type ScheduledJobEntityResponseCollection = {
  __typename?: 'ScheduledJobEntityResponseCollection';
  data: Array<ScheduledJobEntity>;
  meta: ResponseCollectionMeta;
};

export type ScheduledJobFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ScheduledJobFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  data?: InputMaybe<JsonFilterInput>;
  error?: InputMaybe<StringFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ScheduledJobFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ScheduledJobFiltersInput>>>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type ScheduledJobInput = {
  data?: InputMaybe<Scalars['JSON']>;
  error?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

export type SmartbillInvoice = {
  __typename?: 'SmartbillInvoice';
  createdAt?: Maybe<Scalars['DateTime']>;
  error_text?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  number?: Maybe<Scalars['String']>;
  payment?: Maybe<PaymentEntityResponse>;
  series?: Maybe<Scalars['String']>;
  type?: Maybe<Enum_Smartbillinvoice_Type>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  url?: Maybe<Scalars['String']>;
  view_url?: Maybe<Scalars['String']>;
};

export type SmartbillInvoiceEntity = {
  __typename?: 'SmartbillInvoiceEntity';
  attributes?: Maybe<SmartbillInvoice>;
  id?: Maybe<Scalars['ID']>;
};

export type SmartbillInvoiceEntityResponse = {
  __typename?: 'SmartbillInvoiceEntityResponse';
  data?: Maybe<SmartbillInvoiceEntity>;
};

export type SmartbillInvoiceEntityResponseCollection = {
  __typename?: 'SmartbillInvoiceEntityResponseCollection';
  data: Array<SmartbillInvoiceEntity>;
  meta: ResponseCollectionMeta;
};

export type SmartbillInvoiceFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<SmartbillInvoiceFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  error_text?: InputMaybe<StringFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  message?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<SmartbillInvoiceFiltersInput>;
  number?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<InputMaybe<SmartbillInvoiceFiltersInput>>>;
  payment?: InputMaybe<PaymentFiltersInput>;
  series?: InputMaybe<StringFilterInput>;
  type?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  url?: InputMaybe<StringFilterInput>;
  view_url?: InputMaybe<StringFilterInput>;
};

export type SmartbillInvoiceInput = {
  error_text?: InputMaybe<Scalars['String']>;
  message?: InputMaybe<Scalars['String']>;
  number?: InputMaybe<Scalars['String']>;
  payment?: InputMaybe<Scalars['ID']>;
  series?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Enum_Smartbillinvoice_Type>;
  url?: InputMaybe<Scalars['String']>;
  view_url?: InputMaybe<Scalars['String']>;
};

export type SmartbillInvoiceRelationResponseCollection = {
  __typename?: 'SmartbillInvoiceRelationResponseCollection';
  data: Array<SmartbillInvoiceEntity>;
};

export type StringFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  containsi?: InputMaybe<Scalars['String']>;
  endsWith?: InputMaybe<Scalars['String']>;
  eq?: InputMaybe<Scalars['String']>;
  eqi?: InputMaybe<Scalars['String']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nei?: InputMaybe<Scalars['String']>;
  not?: InputMaybe<StringFilterInput>;
  notContains?: InputMaybe<Scalars['String']>;
  notContainsi?: InputMaybe<Scalars['String']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  notNull?: InputMaybe<Scalars['Boolean']>;
  null?: InputMaybe<Scalars['Boolean']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  startsWith?: InputMaybe<Scalars['String']>;
};

export type TimeSlot = {
  __typename?: 'TimeSlot';
  active: Scalars['Boolean'];
  additional_info?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  end_date: Scalars['DateTime'];
  game?: Maybe<GameEntityResponse>;
  info?: Maybe<Scalars['String']>;
  marked_as_full?: Maybe<Scalars['Boolean']>;
  number_of_persons?: Maybe<Scalars['Int']>;
  number_of_tables?: Maybe<Scalars['Int']>;
  reservations?: Maybe<ReservationRelationResponseCollection>;
  room?: Maybe<RoomEntityResponse>;
  start_date: Scalars['DateTime'];
  timesheet_type?: Maybe<Enum_Timeslot_Timesheet_Type>;
  type?: Maybe<Enum_Timeslot_Type>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<UsersPermissionsUserEntityResponse>;
};


export type TimeSlotReservationsArgs = {
  filters?: InputMaybe<ReservationFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type TimeSlotEntity = {
  __typename?: 'TimeSlotEntity';
  attributes?: Maybe<TimeSlot>;
  id?: Maybe<Scalars['ID']>;
};

export type TimeSlotEntityResponse = {
  __typename?: 'TimeSlotEntityResponse';
  data?: Maybe<TimeSlotEntity>;
};

export type TimeSlotEntityResponseCollection = {
  __typename?: 'TimeSlotEntityResponseCollection';
  data: Array<TimeSlotEntity>;
  meta: ResponseCollectionMeta;
};

export type TimeSlotFiltersInput = {
  active?: InputMaybe<BooleanFilterInput>;
  additional_info?: InputMaybe<StringFilterInput>;
  and?: InputMaybe<Array<InputMaybe<TimeSlotFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  end_date?: InputMaybe<DateTimeFilterInput>;
  game?: InputMaybe<GameFiltersInput>;
  id?: InputMaybe<IdFilterInput>;
  info?: InputMaybe<StringFilterInput>;
  marked_as_full?: InputMaybe<BooleanFilterInput>;
  not?: InputMaybe<TimeSlotFiltersInput>;
  number_of_persons?: InputMaybe<IntFilterInput>;
  number_of_tables?: InputMaybe<IntFilterInput>;
  or?: InputMaybe<Array<InputMaybe<TimeSlotFiltersInput>>>;
  reservations?: InputMaybe<ReservationFiltersInput>;
  room?: InputMaybe<RoomFiltersInput>;
  start_date?: InputMaybe<DateTimeFilterInput>;
  timesheet_type?: InputMaybe<StringFilterInput>;
  type?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  user?: InputMaybe<UsersPermissionsUserFiltersInput>;
};

export type TimeSlotInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  additional_info?: InputMaybe<Scalars['String']>;
  end_date?: InputMaybe<Scalars['DateTime']>;
  game?: InputMaybe<Scalars['ID']>;
  info?: InputMaybe<Scalars['String']>;
  marked_as_full?: InputMaybe<Scalars['Boolean']>;
  number_of_persons?: InputMaybe<Scalars['Int']>;
  number_of_tables?: InputMaybe<Scalars['Int']>;
  reservations?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  room?: InputMaybe<Scalars['ID']>;
  start_date?: InputMaybe<Scalars['DateTime']>;
  timesheet_type?: InputMaybe<Enum_Timeslot_Timesheet_Type>;
  type?: InputMaybe<Enum_Timeslot_Type>;
  user?: InputMaybe<Scalars['ID']>;
};

export type TimeSlotRelationResponseCollection = {
  __typename?: 'TimeSlotRelationResponseCollection';
  data: Array<TimeSlotEntity>;
};

export type UploadFile = {
  __typename?: 'UploadFile';
  alternativeText?: Maybe<Scalars['String']>;
  caption?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  ext?: Maybe<Scalars['String']>;
  formats?: Maybe<Scalars['JSON']>;
  hash: Scalars['String'];
  height?: Maybe<Scalars['Int']>;
  mime: Scalars['String'];
  name: Scalars['String'];
  previewUrl?: Maybe<Scalars['String']>;
  provider: Scalars['String'];
  provider_metadata?: Maybe<Scalars['JSON']>;
  related?: Maybe<Array<Maybe<GenericMorph>>>;
  size: Scalars['Float'];
  updatedAt?: Maybe<Scalars['DateTime']>;
  url: Scalars['String'];
  width?: Maybe<Scalars['Int']>;
};

export type UploadFileEntity = {
  __typename?: 'UploadFileEntity';
  attributes?: Maybe<UploadFile>;
  id?: Maybe<Scalars['ID']>;
};

export type UploadFileEntityResponse = {
  __typename?: 'UploadFileEntityResponse';
  data?: Maybe<UploadFileEntity>;
};

export type UploadFileEntityResponseCollection = {
  __typename?: 'UploadFileEntityResponseCollection';
  data: Array<UploadFileEntity>;
  meta: ResponseCollectionMeta;
};

export type UploadFileFiltersInput = {
  alternativeText?: InputMaybe<StringFilterInput>;
  and?: InputMaybe<Array<InputMaybe<UploadFileFiltersInput>>>;
  caption?: InputMaybe<StringFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  ext?: InputMaybe<StringFilterInput>;
  folder?: InputMaybe<UploadFolderFiltersInput>;
  folderPath?: InputMaybe<StringFilterInput>;
  formats?: InputMaybe<JsonFilterInput>;
  hash?: InputMaybe<StringFilterInput>;
  height?: InputMaybe<IntFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  mime?: InputMaybe<StringFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<UploadFileFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<UploadFileFiltersInput>>>;
  previewUrl?: InputMaybe<StringFilterInput>;
  provider?: InputMaybe<StringFilterInput>;
  provider_metadata?: InputMaybe<JsonFilterInput>;
  size?: InputMaybe<FloatFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  url?: InputMaybe<StringFilterInput>;
  width?: InputMaybe<IntFilterInput>;
};

export type UploadFileInput = {
  alternativeText?: InputMaybe<Scalars['String']>;
  caption?: InputMaybe<Scalars['String']>;
  ext?: InputMaybe<Scalars['String']>;
  folder?: InputMaybe<Scalars['ID']>;
  folderPath?: InputMaybe<Scalars['String']>;
  formats?: InputMaybe<Scalars['JSON']>;
  hash?: InputMaybe<Scalars['String']>;
  height?: InputMaybe<Scalars['Int']>;
  mime?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  previewUrl?: InputMaybe<Scalars['String']>;
  provider?: InputMaybe<Scalars['String']>;
  provider_metadata?: InputMaybe<Scalars['JSON']>;
  size?: InputMaybe<Scalars['Float']>;
  url?: InputMaybe<Scalars['String']>;
  width?: InputMaybe<Scalars['Int']>;
};

export type UploadFileRelationResponseCollection = {
  __typename?: 'UploadFileRelationResponseCollection';
  data: Array<UploadFileEntity>;
};

export type UploadFolder = {
  __typename?: 'UploadFolder';
  children?: Maybe<UploadFolderRelationResponseCollection>;
  createdAt?: Maybe<Scalars['DateTime']>;
  files?: Maybe<UploadFileRelationResponseCollection>;
  name: Scalars['String'];
  parent?: Maybe<UploadFolderEntityResponse>;
  path: Scalars['String'];
  pathId: Scalars['Int'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};


export type UploadFolderChildrenArgs = {
  filters?: InputMaybe<UploadFolderFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type UploadFolderFilesArgs = {
  filters?: InputMaybe<UploadFileFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type UploadFolderEntity = {
  __typename?: 'UploadFolderEntity';
  attributes?: Maybe<UploadFolder>;
  id?: Maybe<Scalars['ID']>;
};

export type UploadFolderEntityResponse = {
  __typename?: 'UploadFolderEntityResponse';
  data?: Maybe<UploadFolderEntity>;
};

export type UploadFolderEntityResponseCollection = {
  __typename?: 'UploadFolderEntityResponseCollection';
  data: Array<UploadFolderEntity>;
  meta: ResponseCollectionMeta;
};

export type UploadFolderFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<UploadFolderFiltersInput>>>;
  children?: InputMaybe<UploadFolderFiltersInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  files?: InputMaybe<UploadFileFiltersInput>;
  id?: InputMaybe<IdFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<UploadFolderFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<UploadFolderFiltersInput>>>;
  parent?: InputMaybe<UploadFolderFiltersInput>;
  path?: InputMaybe<StringFilterInput>;
  pathId?: InputMaybe<IntFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type UploadFolderInput = {
  children?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  files?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  name?: InputMaybe<Scalars['String']>;
  parent?: InputMaybe<Scalars['ID']>;
  path?: InputMaybe<Scalars['String']>;
  pathId?: InputMaybe<Scalars['Int']>;
};

export type UploadFolderRelationResponseCollection = {
  __typename?: 'UploadFolderRelationResponseCollection';
  data: Array<UploadFolderEntity>;
};

export type UserAccessGroup = {
  __typename?: 'UserAccessGroup';
  access_group?: Maybe<AccessGroupEntityResponse>;
  active?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  end_date?: Maybe<Scalars['DateTime']>;
  start_date?: Maybe<Scalars['DateTime']>;
  title: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<UsersPermissionsUserEntityResponse>;
};

export type UserAccessGroupEntity = {
  __typename?: 'UserAccessGroupEntity';
  attributes?: Maybe<UserAccessGroup>;
  id?: Maybe<Scalars['ID']>;
};

export type UserAccessGroupEntityResponse = {
  __typename?: 'UserAccessGroupEntityResponse';
  data?: Maybe<UserAccessGroupEntity>;
};

export type UserAccessGroupEntityResponseCollection = {
  __typename?: 'UserAccessGroupEntityResponseCollection';
  data: Array<UserAccessGroupEntity>;
  meta: ResponseCollectionMeta;
};

export type UserAccessGroupFiltersInput = {
  access_group?: InputMaybe<AccessGroupFiltersInput>;
  active?: InputMaybe<BooleanFilterInput>;
  and?: InputMaybe<Array<InputMaybe<UserAccessGroupFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  end_date?: InputMaybe<DateTimeFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  not?: InputMaybe<UserAccessGroupFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<UserAccessGroupFiltersInput>>>;
  start_date?: InputMaybe<DateTimeFilterInput>;
  title?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  user?: InputMaybe<UsersPermissionsUserFiltersInput>;
};

export type UserAccessGroupInput = {
  access_group?: InputMaybe<Scalars['ID']>;
  active?: InputMaybe<Scalars['Boolean']>;
  end_date?: InputMaybe<Scalars['DateTime']>;
  start_date?: InputMaybe<Scalars['DateTime']>;
  title?: InputMaybe<Scalars['String']>;
  user?: InputMaybe<Scalars['ID']>;
};

export type UserAccessGroupRelationResponseCollection = {
  __typename?: 'UserAccessGroupRelationResponseCollection';
  data: Array<UserAccessGroupEntity>;
};

export type UserAchievement = {
  __typename?: 'UserAchievement';
  achievement?: Maybe<AchievementEntityResponse>;
  createdAt?: Maybe<Scalars['DateTime']>;
  points?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<UsersPermissionsUserEntityResponse>;
};

export type UserAchievementEntity = {
  __typename?: 'UserAchievementEntity';
  attributes?: Maybe<UserAchievement>;
  id?: Maybe<Scalars['ID']>;
};

export type UserAchievementEntityResponse = {
  __typename?: 'UserAchievementEntityResponse';
  data?: Maybe<UserAchievementEntity>;
};

export type UserAchievementEntityResponseCollection = {
  __typename?: 'UserAchievementEntityResponseCollection';
  data: Array<UserAchievementEntity>;
  meta: ResponseCollectionMeta;
};

export type UserAchievementFiltersInput = {
  achievement?: InputMaybe<AchievementFiltersInput>;
  and?: InputMaybe<Array<InputMaybe<UserAchievementFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  not?: InputMaybe<UserAchievementFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<UserAchievementFiltersInput>>>;
  points?: InputMaybe<FloatFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  user?: InputMaybe<UsersPermissionsUserFiltersInput>;
};

export type UserAchievementInput = {
  achievement?: InputMaybe<Scalars['ID']>;
  points?: InputMaybe<Scalars['Float']>;
  user?: InputMaybe<Scalars['ID']>;
};

export type UserAchievementRelationResponseCollection = {
  __typename?: 'UserAchievementRelationResponseCollection';
  data: Array<UserAchievementEntity>;
};

export type UserCreditManagementSignaturePad = {
  __typename?: 'UserCreditManagementSignaturePad';
  client_id: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  default_screen: Scalars['String'];
  name: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type UserCreditManagementSignaturePadEntity = {
  __typename?: 'UserCreditManagementSignaturePadEntity';
  attributes?: Maybe<UserCreditManagementSignaturePad>;
  id?: Maybe<Scalars['ID']>;
};

export type UserCreditManagementSignaturePadEntityResponse = {
  __typename?: 'UserCreditManagementSignaturePadEntityResponse';
  data?: Maybe<UserCreditManagementSignaturePadEntity>;
};

export type UserCreditManagementSignaturePadEntityResponseCollection = {
  __typename?: 'UserCreditManagementSignaturePadEntityResponseCollection';
  data: Array<UserCreditManagementSignaturePadEntity>;
  meta: ResponseCollectionMeta;
};

export type UserCreditManagementSignaturePadFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<UserCreditManagementSignaturePadFiltersInput>>>;
  client_id?: InputMaybe<StringFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  default_screen?: InputMaybe<StringFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<UserCreditManagementSignaturePadFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<UserCreditManagementSignaturePadFiltersInput>>>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type UserCreditManagementSignaturePadInput = {
  client_id?: InputMaybe<Scalars['String']>;
  default_screen?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

export type UserTicket = {
  __typename?: 'UserTicket';
  createdAt?: Maybe<Scalars['DateTime']>;
  created_from_order?: Maybe<OrderEntityResponse>;
  name: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
  used: Scalars['Boolean'];
  valid_from?: Maybe<Scalars['DateTime']>;
  valid_to?: Maybe<Scalars['DateTime']>;
};

export type UserTicketEntity = {
  __typename?: 'UserTicketEntity';
  attributes?: Maybe<UserTicket>;
  id?: Maybe<Scalars['ID']>;
};

export type UserTicketEntityResponse = {
  __typename?: 'UserTicketEntityResponse';
  data?: Maybe<UserTicketEntity>;
};

export type UserTicketEntityResponseCollection = {
  __typename?: 'UserTicketEntityResponseCollection';
  data: Array<UserTicketEntity>;
  meta: ResponseCollectionMeta;
};

export type UserTicketFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<UserTicketFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  created_from_order?: InputMaybe<OrderFiltersInput>;
  id?: InputMaybe<IdFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<UserTicketFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<UserTicketFiltersInput>>>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  used?: InputMaybe<BooleanFilterInput>;
  valid_from?: InputMaybe<DateTimeFilterInput>;
  valid_to?: InputMaybe<DateTimeFilterInput>;
};

export type UserTicketInput = {
  created_from_order?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  used?: InputMaybe<Scalars['Boolean']>;
  valid_from?: InputMaybe<Scalars['DateTime']>;
  valid_to?: InputMaybe<Scalars['DateTime']>;
};

export type UserTicketRelationResponseCollection = {
  __typename?: 'UserTicketRelationResponseCollection';
  data: Array<UserTicketEntity>;
};

export type UsersPermissionsCreateRolePayload = {
  __typename?: 'UsersPermissionsCreateRolePayload';
  ok: Scalars['Boolean'];
};

export type UsersPermissionsDeleteRolePayload = {
  __typename?: 'UsersPermissionsDeleteRolePayload';
  ok: Scalars['Boolean'];
};

export type UsersPermissionsLoginInput = {
  identifier: Scalars['String'];
  password: Scalars['String'];
  provider?: Scalars['String'];
};

export type UsersPermissionsLoginPayload = {
  __typename?: 'UsersPermissionsLoginPayload';
  jwt?: Maybe<Scalars['String']>;
  user: UsersPermissionsMe;
};

export type UsersPermissionsMe = {
  __typename?: 'UsersPermissionsMe';
  blocked?: Maybe<Scalars['Boolean']>;
  confirmed?: Maybe<Scalars['Boolean']>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  lastName?: Maybe<Scalars['String']>;
  notifications_count?: Maybe<Scalars['Int']>;
  role?: Maybe<UsersPermissionsMeRole>;
  username: Scalars['String'];
};

export type UsersPermissionsMeRole = {
  __typename?: 'UsersPermissionsMeRole';
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  type?: Maybe<Scalars['String']>;
};

export type UsersPermissionsPasswordPayload = {
  __typename?: 'UsersPermissionsPasswordPayload';
  ok: Scalars['Boolean'];
};

export type UsersPermissionsPermission = {
  __typename?: 'UsersPermissionsPermission';
  action: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  role?: Maybe<UsersPermissionsRoleEntityResponse>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type UsersPermissionsPermissionEntity = {
  __typename?: 'UsersPermissionsPermissionEntity';
  attributes?: Maybe<UsersPermissionsPermission>;
  id?: Maybe<Scalars['ID']>;
};

export type UsersPermissionsPermissionFiltersInput = {
  action?: InputMaybe<StringFilterInput>;
  and?: InputMaybe<Array<InputMaybe<UsersPermissionsPermissionFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  not?: InputMaybe<UsersPermissionsPermissionFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<UsersPermissionsPermissionFiltersInput>>>;
  role?: InputMaybe<UsersPermissionsRoleFiltersInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type UsersPermissionsPermissionRelationResponseCollection = {
  __typename?: 'UsersPermissionsPermissionRelationResponseCollection';
  data: Array<UsersPermissionsPermissionEntity>;
};

export type UsersPermissionsRegisterInput = {
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  password: Scalars['String'];
  username: Scalars['String'];
};

export type UsersPermissionsRole = {
  __typename?: 'UsersPermissionsRole';
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  permissions?: Maybe<UsersPermissionsPermissionRelationResponseCollection>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  users?: Maybe<UsersPermissionsUserRelationResponseCollection>;
};


export type UsersPermissionsRolePermissionsArgs = {
  filters?: InputMaybe<UsersPermissionsPermissionFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type UsersPermissionsRoleUsersArgs = {
  filters?: InputMaybe<UsersPermissionsUserFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type UsersPermissionsRoleEntity = {
  __typename?: 'UsersPermissionsRoleEntity';
  attributes?: Maybe<UsersPermissionsRole>;
  id?: Maybe<Scalars['ID']>;
};

export type UsersPermissionsRoleEntityResponse = {
  __typename?: 'UsersPermissionsRoleEntityResponse';
  data?: Maybe<UsersPermissionsRoleEntity>;
};

export type UsersPermissionsRoleEntityResponseCollection = {
  __typename?: 'UsersPermissionsRoleEntityResponseCollection';
  data: Array<UsersPermissionsRoleEntity>;
  meta: ResponseCollectionMeta;
};

export type UsersPermissionsRoleFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<UsersPermissionsRoleFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  description?: InputMaybe<StringFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<UsersPermissionsRoleFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<UsersPermissionsRoleFiltersInput>>>;
  permissions?: InputMaybe<UsersPermissionsPermissionFiltersInput>;
  type?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  users?: InputMaybe<UsersPermissionsUserFiltersInput>;
};

export type UsersPermissionsRoleInput = {
  description?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  permissions?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  type?: InputMaybe<Scalars['String']>;
  users?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

export type UsersPermissionsUpdateRolePayload = {
  __typename?: 'UsersPermissionsUpdateRolePayload';
  ok: Scalars['Boolean'];
};

export type UsersPermissionsUser = {
  __typename?: 'UsersPermissionsUser';
  about?: Maybe<Scalars['String']>;
  acId?: Maybe<Scalars['String']>;
  access_cards?: Maybe<AccessCardRelationResponseCollection>;
  account_childrens?: Maybe<UsersPermissionsUserRelationResponseCollection>;
  account_parents?: Maybe<UsersPermissionsUserRelationResponseCollection>;
  account_type?: Maybe<Enum_Userspermissionsuser_Account_Type>;
  achievements?: Maybe<UserAchievementRelationResponseCollection>;
  addresses?: Maybe<Array<Maybe<ComponentUserDataAddress>>>;
  authored_messages?: Maybe<MessageRelationResponseCollection>;
  birthday?: Maybe<Scalars['Date']>;
  ble_device?: Maybe<BleDeviceEntityResponse>;
  ble_groups?: Maybe<BleGroupRelationResponseCollection>;
  blocked?: Maybe<Scalars['Boolean']>;
  blockedDate?: Maybe<Scalars['DateTime']>;
  blockedScenario?: Maybe<Enum_Userspermissionsuser_Blockedscenario>;
  blog_posts?: Maybe<BlogPostRelationResponseCollection>;
  body_type?: Maybe<Enum_Userspermissionsuser_Body_Type>;
  booking_slot_rules?: Maybe<Array<Maybe<UsersPermissionsUserBookingSlotRulesDynamicZone>>>;
  claimed_vouchers?: Maybe<VoucherRelationResponseCollection>;
  classroom_member?: Maybe<ClassroomMemberEntityResponse>;
  color?: Maybe<Scalars['String']>;
  confirmed?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  credit_changes?: Maybe<CreditChangeRelationResponseCollection>;
  credit_changes_info?: Maybe<Scalars['String']>;
  crm_profile?: Maybe<ComponentCrmDataCrmUserProfile>;
  crm_tasks?: Maybe<CrmTaskRelationResponseCollection>;
  email: Scalars['String'];
  events_joined?: Maybe<EventRelationResponseCollection>;
  events_organised?: Maybe<EventRelationResponseCollection>;
  firstName?: Maybe<Scalars['String']>;
  house?: Maybe<HouseEntityResponse>;
  info_from_unreal?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  level?: Maybe<Scalars['Int']>;
  messages?: Maybe<MessageRelationResponseCollection>;
  mobileToken?: Maybe<Scalars['String']>;
  notificationSettings?: Maybe<Array<Maybe<ComponentUserDataNotificationSettings>>>;
  notification_requests?: Maybe<NotificationsNotificationRequestRelationResponseCollection>;
  notifications?: Maybe<NotificationsNotificationRelationResponseCollection>;
  one_time_products?: Maybe<ProductRelationResponseCollection>;
  orders?: Maybe<OrderRelationResponseCollection>;
  owned_drimons?: Maybe<DrimonRelationResponseCollection>;
  owned_maps?: Maybe<MapRelationResponseCollection>;
  phone?: Maybe<Scalars['String']>;
  picture?: Maybe<UploadFileEntityResponse>;
  player_avatar?: Maybe<PlayerAvatarEntityResponse>;
  provider?: Maybe<Scalars['String']>;
  reactions?: Maybe<ReactionsReactionRelationResponseCollection>;
  role?: Maybe<UsersPermissionsRoleEntityResponse>;
  roles?: Maybe<Scalars['JSON']>;
  signature?: Maybe<UploadFileEntityResponse>;
  tags?: Maybe<ActiveCampaignAcTagRelationResponseCollection>;
  time_slots?: Maybe<TimeSlotRelationResponseCollection>;
  total_credit?: Maybe<Scalars['Float']>;
  total_experience?: Maybe<Scalars['Int']>;
  total_points?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  user_access_groups?: Maybe<UserAccessGroupRelationResponseCollection>;
  user_height?: Maybe<Scalars['Float']>;
  username: Scalars['String'];
};


export type UsersPermissionsUserAccess_CardsArgs = {
  filters?: InputMaybe<AccessCardFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type UsersPermissionsUserAccount_ChildrensArgs = {
  filters?: InputMaybe<UsersPermissionsUserFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type UsersPermissionsUserAccount_ParentsArgs = {
  filters?: InputMaybe<UsersPermissionsUserFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type UsersPermissionsUserAchievementsArgs = {
  filters?: InputMaybe<UserAchievementFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type UsersPermissionsUserAddressesArgs = {
  filters?: InputMaybe<ComponentUserDataAddressFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type UsersPermissionsUserAuthored_MessagesArgs = {
  filters?: InputMaybe<MessageFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type UsersPermissionsUserBle_GroupsArgs = {
  filters?: InputMaybe<BleGroupFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type UsersPermissionsUserBlog_PostsArgs = {
  filters?: InputMaybe<BlogPostFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type UsersPermissionsUserClaimed_VouchersArgs = {
  filters?: InputMaybe<VoucherFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type UsersPermissionsUserCredit_ChangesArgs = {
  filters?: InputMaybe<CreditChangeFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type UsersPermissionsUserCrm_TasksArgs = {
  filters?: InputMaybe<CrmTaskFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type UsersPermissionsUserEvents_JoinedArgs = {
  filters?: InputMaybe<EventFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type UsersPermissionsUserEvents_OrganisedArgs = {
  filters?: InputMaybe<EventFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type UsersPermissionsUserMessagesArgs = {
  filters?: InputMaybe<MessageFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type UsersPermissionsUserNotificationSettingsArgs = {
  filters?: InputMaybe<ComponentUserDataNotificationSettingsFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type UsersPermissionsUserNotification_RequestsArgs = {
  filters?: InputMaybe<NotificationsNotificationRequestFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type UsersPermissionsUserNotificationsArgs = {
  filters?: InputMaybe<NotificationsNotificationFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type UsersPermissionsUserOne_Time_ProductsArgs = {
  filters?: InputMaybe<ProductFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type UsersPermissionsUserOwned_DrimonsArgs = {
  filters?: InputMaybe<DrimonFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type UsersPermissionsUserOwned_MapsArgs = {
  filters?: InputMaybe<MapFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type UsersPermissionsUserReactionsArgs = {
  filters?: InputMaybe<ReactionsReactionFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type UsersPermissionsUserTagsArgs = {
  filters?: InputMaybe<ActiveCampaignAcTagFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type UsersPermissionsUserTime_SlotsArgs = {
  filters?: InputMaybe<TimeSlotFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type UsersPermissionsUserUser_Access_GroupsArgs = {
  filters?: InputMaybe<UserAccessGroupFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type UsersPermissionsUserBookingSlotRulesDynamicZone = ComponentGeneralCalendarBookingSlot | ComponentGeneralDailyBookingSlot | Error;

export type UsersPermissionsUserEntity = {
  __typename?: 'UsersPermissionsUserEntity';
  attributes?: Maybe<UsersPermissionsUser>;
  id?: Maybe<Scalars['ID']>;
};

export type UsersPermissionsUserEntityResponse = {
  __typename?: 'UsersPermissionsUserEntityResponse';
  data?: Maybe<UsersPermissionsUserEntity>;
};

export type UsersPermissionsUserEntityResponseCollection = {
  __typename?: 'UsersPermissionsUserEntityResponseCollection';
  data: Array<UsersPermissionsUserEntity>;
  meta: ResponseCollectionMeta;
};

export type UsersPermissionsUserFiltersInput = {
  about?: InputMaybe<StringFilterInput>;
  acId?: InputMaybe<StringFilterInput>;
  access_cards?: InputMaybe<AccessCardFiltersInput>;
  account_childrens?: InputMaybe<UsersPermissionsUserFiltersInput>;
  account_parents?: InputMaybe<UsersPermissionsUserFiltersInput>;
  account_type?: InputMaybe<StringFilterInput>;
  achievements?: InputMaybe<UserAchievementFiltersInput>;
  addresses?: InputMaybe<ComponentUserDataAddressFiltersInput>;
  and?: InputMaybe<Array<InputMaybe<UsersPermissionsUserFiltersInput>>>;
  authored_messages?: InputMaybe<MessageFiltersInput>;
  birthday?: InputMaybe<DateFilterInput>;
  ble_device?: InputMaybe<BleDeviceFiltersInput>;
  ble_groups?: InputMaybe<BleGroupFiltersInput>;
  blocked?: InputMaybe<BooleanFilterInput>;
  blockedDate?: InputMaybe<DateTimeFilterInput>;
  blockedScenario?: InputMaybe<StringFilterInput>;
  blog_posts?: InputMaybe<BlogPostFiltersInput>;
  body_type?: InputMaybe<StringFilterInput>;
  claimed_vouchers?: InputMaybe<VoucherFiltersInput>;
  classroom_member?: InputMaybe<ClassroomMemberFiltersInput>;
  color?: InputMaybe<StringFilterInput>;
  confirmationToken?: InputMaybe<StringFilterInput>;
  confirmationTokenExpiration?: InputMaybe<DateTimeFilterInput>;
  confirmed?: InputMaybe<BooleanFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  credit_changes?: InputMaybe<CreditChangeFiltersInput>;
  credit_changes_info?: InputMaybe<StringFilterInput>;
  crm_profile?: InputMaybe<ComponentCrmDataCrmUserProfileFiltersInput>;
  crm_tasks?: InputMaybe<CrmTaskFiltersInput>;
  email?: InputMaybe<StringFilterInput>;
  events_joined?: InputMaybe<EventFiltersInput>;
  events_organised?: InputMaybe<EventFiltersInput>;
  firstName?: InputMaybe<StringFilterInput>;
  house?: InputMaybe<HouseFiltersInput>;
  id?: InputMaybe<IdFilterInput>;
  info_from_unreal?: InputMaybe<StringFilterInput>;
  lastName?: InputMaybe<StringFilterInput>;
  level?: InputMaybe<IntFilterInput>;
  messages?: InputMaybe<MessageFiltersInput>;
  mobileToken?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<UsersPermissionsUserFiltersInput>;
  notificationSettings?: InputMaybe<ComponentUserDataNotificationSettingsFiltersInput>;
  notification_requests?: InputMaybe<NotificationsNotificationRequestFiltersInput>;
  notifications?: InputMaybe<NotificationsNotificationFiltersInput>;
  one_time_products?: InputMaybe<ProductFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<UsersPermissionsUserFiltersInput>>>;
  orders?: InputMaybe<OrderFiltersInput>;
  owned_drimons?: InputMaybe<DrimonFiltersInput>;
  owned_maps?: InputMaybe<MapFiltersInput>;
  password?: InputMaybe<StringFilterInput>;
  phone?: InputMaybe<StringFilterInput>;
  player_avatar?: InputMaybe<PlayerAvatarFiltersInput>;
  provider?: InputMaybe<StringFilterInput>;
  reactions?: InputMaybe<ReactionsReactionFiltersInput>;
  resetPasswordToken?: InputMaybe<StringFilterInput>;
  role?: InputMaybe<UsersPermissionsRoleFiltersInput>;
  roles?: InputMaybe<JsonFilterInput>;
  tags?: InputMaybe<ActiveCampaignAcTagFiltersInput>;
  time_slots?: InputMaybe<TimeSlotFiltersInput>;
  total_credit?: InputMaybe<FloatFilterInput>;
  total_experience?: InputMaybe<IntFilterInput>;
  total_points?: InputMaybe<IntFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  user_access_groups?: InputMaybe<UserAccessGroupFiltersInput>;
  user_height?: InputMaybe<FloatFilterInput>;
  username?: InputMaybe<StringFilterInput>;
  webToken?: InputMaybe<StringFilterInput>;
};

export type UsersPermissionsUserInput = {
  about?: InputMaybe<Scalars['String']>;
  acId?: InputMaybe<Scalars['String']>;
  access_cards?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  account_childrens?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  account_parents?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  account_type?: InputMaybe<Enum_Userspermissionsuser_Account_Type>;
  achievements?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  addresses?: InputMaybe<Array<InputMaybe<ComponentUserDataAddressInput>>>;
  authored_messages?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  birthday?: InputMaybe<Scalars['Date']>;
  ble_device?: InputMaybe<Scalars['ID']>;
  ble_groups?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  blocked?: InputMaybe<Scalars['Boolean']>;
  blockedDate?: InputMaybe<Scalars['DateTime']>;
  blockedScenario?: InputMaybe<Enum_Userspermissionsuser_Blockedscenario>;
  blog_posts?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  body_type?: InputMaybe<Enum_Userspermissionsuser_Body_Type>;
  booking_slot_rules?: InputMaybe<Array<Scalars['UsersPermissionsUserBookingSlotRulesDynamicZoneInput']>>;
  claimed_vouchers?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  classroom_member?: InputMaybe<Scalars['ID']>;
  color?: InputMaybe<Scalars['String']>;
  confirmationToken?: InputMaybe<Scalars['String']>;
  confirmationTokenExpiration?: InputMaybe<Scalars['DateTime']>;
  confirmed?: InputMaybe<Scalars['Boolean']>;
  credit_changes?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  credit_changes_info?: InputMaybe<Scalars['String']>;
  crm_profile?: InputMaybe<ComponentCrmDataCrmUserProfileInput>;
  crm_tasks?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  email?: InputMaybe<Scalars['String']>;
  events_joined?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  events_organised?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  firstName?: InputMaybe<Scalars['String']>;
  house?: InputMaybe<Scalars['ID']>;
  info_from_unreal?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  level?: InputMaybe<Scalars['Int']>;
  messages?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  mobileToken?: InputMaybe<Scalars['String']>;
  notificationSettings?: InputMaybe<Array<InputMaybe<ComponentUserDataNotificationSettingsInput>>>;
  notification_requests?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  notifications?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  one_time_products?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  orders?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  owned_drimons?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  owned_maps?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  password?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  picture?: InputMaybe<Scalars['ID']>;
  player_avatar?: InputMaybe<Scalars['ID']>;
  provider?: InputMaybe<Scalars['String']>;
  reactions?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  resetPasswordToken?: InputMaybe<Scalars['String']>;
  role?: InputMaybe<Scalars['ID']>;
  roles?: InputMaybe<Scalars['JSON']>;
  signature?: InputMaybe<Scalars['ID']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  time_slots?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  total_credit?: InputMaybe<Scalars['Float']>;
  total_experience?: InputMaybe<Scalars['Int']>;
  total_points?: InputMaybe<Scalars['Int']>;
  user_access_groups?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  user_height?: InputMaybe<Scalars['Float']>;
  username?: InputMaybe<Scalars['String']>;
  webToken?: InputMaybe<Scalars['String']>;
};

export type UsersPermissionsUserRelationResponseCollection = {
  __typename?: 'UsersPermissionsUserRelationResponseCollection';
  data: Array<UsersPermissionsUserEntity>;
};

export type Voucher = {
  __typename?: 'Voucher';
  claimed?: Maybe<Scalars['Boolean']>;
  claimed_by?: Maybe<UsersPermissionsUserEntityResponse>;
  createdAt?: Maybe<Scalars['DateTime']>;
  created_from_order?: Maybe<OrderEntityResponse>;
  email?: Maybe<Scalars['String']>;
  locale?: Maybe<Scalars['String']>;
  localizations?: Maybe<VoucherRelationResponseCollection>;
  title: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
  voucher_list?: Maybe<VoucherListEntityResponse>;
};


export type VoucherLocalizationsArgs = {
  filters?: InputMaybe<VoucherFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type VoucherEntity = {
  __typename?: 'VoucherEntity';
  attributes?: Maybe<Voucher>;
  id?: Maybe<Scalars['ID']>;
};

export type VoucherEntityResponse = {
  __typename?: 'VoucherEntityResponse';
  data?: Maybe<VoucherEntity>;
};

export type VoucherEntityResponseCollection = {
  __typename?: 'VoucherEntityResponseCollection';
  data: Array<VoucherEntity>;
  meta: ResponseCollectionMeta;
};

export type VoucherFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<VoucherFiltersInput>>>;
  claimed?: InputMaybe<BooleanFilterInput>;
  claimed_by?: InputMaybe<UsersPermissionsUserFiltersInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  created_from_order?: InputMaybe<OrderFiltersInput>;
  email?: InputMaybe<StringFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  locale?: InputMaybe<StringFilterInput>;
  localizations?: InputMaybe<VoucherFiltersInput>;
  not?: InputMaybe<VoucherFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<VoucherFiltersInput>>>;
  title?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  voucher_list?: InputMaybe<VoucherListFiltersInput>;
};

export type VoucherInput = {
  claimed?: InputMaybe<Scalars['Boolean']>;
  claimed_by?: InputMaybe<Scalars['ID']>;
  created_from_order?: InputMaybe<Scalars['ID']>;
  email?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  voucher_list?: InputMaybe<Scalars['ID']>;
};

export type VoucherList = {
  __typename?: 'VoucherList';
  active?: Maybe<Scalars['Boolean']>;
  active_from?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  locale?: Maybe<Scalars['String']>;
  localizations?: Maybe<VoucherListRelationResponseCollection>;
  products?: Maybe<ProductRelationResponseCollection>;
  slug: Scalars['String'];
  title: Scalars['String'];
  type?: Maybe<Enum_Voucherlist_Type>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  user_can_generate_voucher?: Maybe<Scalars['Boolean']>;
  validity?: Maybe<Scalars['Int']>;
  value?: Maybe<Scalars['Float']>;
  vouchers?: Maybe<VoucherRelationResponseCollection>;
};


export type VoucherListLocalizationsArgs = {
  filters?: InputMaybe<VoucherListFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type VoucherListProductsArgs = {
  filters?: InputMaybe<ProductFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type VoucherListVouchersArgs = {
  filters?: InputMaybe<VoucherFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type VoucherListEntity = {
  __typename?: 'VoucherListEntity';
  attributes?: Maybe<VoucherList>;
  id?: Maybe<Scalars['ID']>;
};

export type VoucherListEntityResponse = {
  __typename?: 'VoucherListEntityResponse';
  data?: Maybe<VoucherListEntity>;
};

export type VoucherListEntityResponseCollection = {
  __typename?: 'VoucherListEntityResponseCollection';
  data: Array<VoucherListEntity>;
  meta: ResponseCollectionMeta;
};

export type VoucherListFiltersInput = {
  active?: InputMaybe<BooleanFilterInput>;
  active_from?: InputMaybe<DateTimeFilterInput>;
  and?: InputMaybe<Array<InputMaybe<VoucherListFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  locale?: InputMaybe<StringFilterInput>;
  localizations?: InputMaybe<VoucherListFiltersInput>;
  not?: InputMaybe<VoucherListFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<VoucherListFiltersInput>>>;
  products?: InputMaybe<ProductFiltersInput>;
  slug?: InputMaybe<StringFilterInput>;
  title?: InputMaybe<StringFilterInput>;
  type?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  user_can_generate_voucher?: InputMaybe<BooleanFilterInput>;
  validity?: InputMaybe<IntFilterInput>;
  value?: InputMaybe<FloatFilterInput>;
  vouchers?: InputMaybe<VoucherFiltersInput>;
};

export type VoucherListInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  active_from?: InputMaybe<Scalars['DateTime']>;
  products?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  slug?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Enum_Voucherlist_Type>;
  user_can_generate_voucher?: InputMaybe<Scalars['Boolean']>;
  validity?: InputMaybe<Scalars['Int']>;
  value?: InputMaybe<Scalars['Float']>;
  vouchers?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

export type VoucherListRelationResponseCollection = {
  __typename?: 'VoucherListRelationResponseCollection';
  data: Array<VoucherListEntity>;
};

export type VoucherRelationResponseCollection = {
  __typename?: 'VoucherRelationResponseCollection';
  data: Array<VoucherEntity>;
};

export type BlogPostsQueryVariables = Exact<{
  filters?: InputMaybe<BlogPostFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
}>;


export type BlogPostsQuery = { __typename?: 'Query', blogPosts?: { __typename?: 'BlogPostEntityResponseCollection', meta: { __typename?: 'ResponseCollectionMeta', pagination: { __typename?: 'Pagination', page: number, pageCount: number, total: number } }, data: Array<{ __typename?: 'BlogPostEntity', id?: string | null, attributes?: { __typename?: 'BlogPost', title: string, slug: string, info_text?: string | null, publishedAt?: any | null, author_image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', url: string } | null } | null } | null, author?: { __typename?: 'UsersPermissionsUserEntityResponse', data?: { __typename?: 'UsersPermissionsUserEntity', id?: string | null, attributes?: { __typename?: 'UsersPermissionsUser', firstName?: string | null, lastName?: string | null } | null } | null } | null, blog_categories?: { __typename?: 'BlogCategoryRelationResponseCollection', data: Array<{ __typename?: 'BlogCategoryEntity', id?: string | null, attributes?: { __typename?: 'BlogCategory', title: string, slug: string } | null }> } | null, media?: { __typename?: 'UploadFileRelationResponseCollection', data: Array<{ __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', url: string } | null }> } | null } | null }> } | null };

export type BlogCategoriesQueryVariables = Exact<{
  pagination?: InputMaybe<PaginationArg>;
}>;


export type BlogCategoriesQuery = { __typename?: 'Query', blogCategories?: { __typename?: 'BlogCategoryEntityResponseCollection', data: Array<{ __typename?: 'BlogCategoryEntity', id?: string | null, attributes?: { __typename?: 'BlogCategory', title: string, slug: string } | null }> } | null };

export type BlogPostItemQueryVariables = Exact<{
  filters?: InputMaybe<BlogPostFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  iconCardsFilters?: InputMaybe<ComponentCmsDataIconCardFiltersInput>;
  iconCardsPagination?: InputMaybe<PaginationArg>;
  boxesPagination?: InputMaybe<PaginationArg>;
  boxCardsPagination?: InputMaybe<PaginationArg>;
  sliderFilters?: InputMaybe<ComponentCmsDataSliderItemFiltersInput>;
  sliderPagination?: InputMaybe<PaginationArg>;
  faqItemsPagination?: InputMaybe<PaginationArg>;
  imageCardsItemsFilters?: InputMaybe<ComponentCmsDataImageCardFiltersInput>;
  imageCardsItemsPagination?: InputMaybe<PaginationArg>;
  authorsPagination?: InputMaybe<PaginationArg>;
  authorsFilters?: InputMaybe<UsersPermissionsUserFiltersInput>;
  reviewItemsPagination?: InputMaybe<PaginationArg>;
  reviewItemsFilters?: InputMaybe<ComponentCmsDataReviewItemFiltersInput>;
  priceItemsFilters?: InputMaybe<ComponentCmsDataPriceItemFiltersInput>;
  priceItemsPagination?: InputMaybe<PaginationArg>;
  priceBenefitsFilters?: InputMaybe<ComponentCmsDataPriceBenefitFiltersInput>;
  priceBenefitsPagination?: InputMaybe<PaginationArg>;
  imageGalleryFilters?: InputMaybe<ComponentCmsDataImageGalleryItemFiltersInput>;
  imageGalleryPagination?: InputMaybe<PaginationArg>;
  productsFilters?: InputMaybe<ProductFiltersInput>;
  productsPagination?: InputMaybe<PaginationArg>;
  menuFilters?: InputMaybe<ProductFiltersInput>;
  menuPagination?: InputMaybe<PaginationArg>;
}>;


export type BlogPostItemQuery = { __typename?: 'Query', blogPosts?: { __typename?: 'BlogPostEntityResponseCollection', meta: { __typename?: 'ResponseCollectionMeta', pagination: { __typename?: 'Pagination', page: number, pageCount: number, total: number } }, data: Array<{ __typename?: 'BlogPostEntity', id?: string | null, attributes?: { __typename?: 'BlogPost', title: string, slug: string, info_text?: string | null, publishedAt?: any | null, author_image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', url: string } | null } | null } | null, author?: { __typename?: 'UsersPermissionsUserEntityResponse', data?: { __typename?: 'UsersPermissionsUserEntity', id?: string | null, attributes?: { __typename?: 'UsersPermissionsUser', firstName?: string | null, lastName?: string | null } | null } | null } | null, blog_categories?: { __typename?: 'BlogCategoryRelationResponseCollection', data: Array<{ __typename?: 'BlogCategoryEntity', id?: string | null, attributes?: { __typename?: 'BlogCategory', title: string, slug: string } | null }> } | null, media?: { __typename?: 'UploadFileRelationResponseCollection', data: Array<{ __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', url: string } | null }> } | null, components?: Array<{ __typename?: 'ComponentCmsDataAnimatedCardSection', id: string, topTitle?: string | null, AnimatedCardSectionMainTitle: string, DataAnimatedCardSectionSecondaryTitle?: string | null, button?: { __typename?: 'ComponentCmsDataButton', id: string, text: string, url: string } | null, secondSectionImages?: { __typename?: 'UploadFileRelationResponseCollection', data: Array<{ __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, url: string, caption?: string | null } | null }> } | null, firstSectionImages: { __typename?: 'UploadFileRelationResponseCollection', data: Array<{ __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, url: string, caption?: string | null } | null }> } } | { __typename?: 'ComponentCmsDataAuthorsListSection', topTitle?: string | null, showSearch?: boolean | null, showCategories?: boolean | null, numberOfAuthorsToDisplay?: number | null, id: string, description?: string | null, displayAsSlider?: boolean | null, AuthorListMainTitle?: string | null, authors?: { __typename?: 'UsersPermissionsUserRelationResponseCollection', data: Array<{ __typename?: 'UsersPermissionsUserEntity', id?: string | null, attributes?: { __typename?: 'UsersPermissionsUser', username: string, email: string } | null }> } | null } | { __typename?: 'ComponentCmsDataBlogArticles' } | { __typename?: 'ComponentCmsDataCaptureContact' } | { __typename?: 'ComponentCmsDataDarkBgImageSection', id: string, centerText?: boolean | null, mainTitle: string, DarkBgImageSectionSecondaryTitle: string, backgroundImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, url: string } | null } | null } | null, button?: { __typename?: 'ComponentCmsDataButton', id: string, text: string, url: string, color?: string | null, textColor?: string | null } | null, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, url: string } | null } | null } | null, countDownTimer?: { __typename?: 'ComponentCmsDataCountDownTimer', id: string, endDate?: any | null, description?: string | null } | null } | { __typename?: 'ComponentCmsDataDarkImageContent', id: string, buttonText?: string | null, buttonUrl?: string | null, darkImageContentMainTitle?: string | null, backgroundImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', url: string } | null } | null } | null, left?: { __typename?: 'ComponentCmsDataDarkImageSection', id: string, title?: string | null, items?: Array<{ __typename?: 'ComponentCmsDataDarkImageItem', id: string, title?: string | null, description?: string | null } | null> | null } | null, right?: { __typename?: 'ComponentCmsDataDarkImageSection', id: string, title?: string | null, items?: Array<{ __typename?: 'ComponentCmsDataDarkImageItem', id: string, title?: string | null, description?: string | null } | null> | null } | null, countDownTimer?: { __typename?: 'ComponentCmsDataCountDownTimer', id: string, endDate?: any | null, description?: string | null } | null } | { __typename?: 'ComponentCmsDataDarkTextBoxSection', id: string, topTitle?: string | null, topTitleColor?: string | null, mainTitle: string, mainTitleColor?: string | null, box?: boolean | null, boxColor?: string | null, boxTitle?: string | null, boxTitleColor?: string | null, boxText?: string | null, boxTextColor?: string | null, bottomTitle?: string | null, buttonTitleColor?: string | null, centerText?: boolean | null, DarkTextBoxSectionButton?: { __typename?: 'ComponentCmsDataButton', id: string, text: string, textColor?: string | null, url: string, color?: string | null } | null, backgroundImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, url: string, formats?: any | null } | null } | null } | null, mobileBackgroundImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, url: string, formats?: any | null } | null } | null } | null } | { __typename?: 'ComponentCmsDataDarkVersusContent', id: string, subtitle?: string | null, buttonText?: string | null, buttonUrl?: string | null, scarcityTitle?: string | null, darkVersusContentMainTitle?: string | null, darkVersusContentTitle?: string | null, countDownTimer?: { __typename?: 'ComponentCmsDataCountDownTimer', id: string, endDate?: any | null, description?: string | null } | null, bottomImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', url: string } | null } | null } | null, darkVersusContentItems?: Array<{ __typename?: 'ComponentCmsDataDarkVersusBox', id: string, title?: string | null, leftItem?: { __typename?: 'ComponentCmsDataDarkVersusItem', id: string, title?: string | null, iconName?: string | null, content?: string | null } | null, rightItem?: { __typename?: 'ComponentCmsDataDarkVersusItem', id: string, title?: string | null, content?: string | null, iconName?: string | null } | null } | null> | null } | { __typename?: 'ComponentCmsDataEventsListSection' } | { __typename?: 'ComponentCmsDataFaq', title?: string | null, id: string, items?: Array<{ __typename?: 'ComponentCmsDataFaqItem', id: string, answer: string, question: string } | null> | null } | { __typename?: 'ComponentCmsDataFooterSection', id: string, rightText?: string | null, leftText: string, bottomContent?: string | null, iconColumnTitle?: string | null, iconLinks?: Array<{ __typename?: 'ComponentCmsDataFooterIconLink', iconName?: string | null, id: string, link?: string | null, text?: string | null } | null> | null, columns?: Array<{ __typename?: 'ComponentCmsDataFooterColumn', id: string, title?: string | null, content?: string | null } | null> | null } | { __typename?: 'ComponentCmsDataFormGroup', id: string, ask_for_rfid?: boolean | null, redirectUrl?: string | null, random_questions?: boolean | null, number_of_random_questions?: number | null, show_start_screen?: boolean | null, thank_you_message?: string | null, thank_you_message_color?: string | null, thank_you_message_background?: string | null, formGroupTitle: string, formGroupType?: Enum_Componentcmsdataformgroup_Type | null, house_videos?: Array<{ __typename?: 'ComponentGeneralHouseWithVideo', id: string, house?: { __typename?: 'HouseEntityResponse', data?: { __typename?: 'HouseEntity', id?: string | null, attributes?: { __typename?: 'House', name: string } | null } | null } | null, video: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, mime: string } | null } | null } } | null> | null, questions?: Array<{ __typename?: 'ComponentCmsDataFormQuestion', id: string, is_required?: boolean | null, use_recaptcha?: boolean | null, center_text?: boolean | null, title: string, title_color?: string | null, description?: string | null, description_color?: string | null, index: number, size?: Enum_Componentcmsdataformquestion_Size | null, type?: Enum_Componentcmsdataformquestion_Type | null, desktop_layout?: Enum_Componentcmsdataformquestion_Desktop_Layout | null, mobile_layout?: Enum_Componentcmsdataformquestion_Mobile_Layout | null, vertical_alignment?: Enum_Componentcmsdataformquestion_Vertical_Alignment | null, restart_form_timer: number, send_review_to_google?: boolean | null, input_color?: string | null, input_placeholder?: string | null, submit_button_text: string, submit_button_color?: string | null, submit_button_text_color?: string | null, submit_button_sticky?: boolean | null, is_transparent_button?: boolean | null, next_question_index?: number | null, image_position?: Enum_Componentcmsdataformquestion_Image_Position | null, background_color?: string | null, allow_other_choice?: boolean | null, nr_columns: number, space_from_top?: number | null, feedback_media_text?: string | null, rate_user?: { __typename?: 'UsersPermissionsUserRelationResponseCollection', data: Array<{ __typename?: 'UsersPermissionsUserEntity', id?: string | null }> } | null, rate_user_role?: { __typename?: 'CrmRoleRelationResponseCollection', data: Array<{ __typename?: 'CrmRoleEntity', id?: string | null }> } | null, allocate_tags?: { __typename?: 'ActiveCampaignAcTagRelationResponseCollection', data: Array<{ __typename?: 'ActiveCampaignAcTagEntity', id?: string | null }> } | null, allocate_house?: { __typename?: 'HouseEntityResponse', data?: { __typename?: 'HouseEntity', id?: string | null, attributes?: { __typename?: 'House', name: string } | null } | null } | null, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, mime: string, url: string } | null } | null } | null, video?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, mime: string, url: string } | null } | null } | null, feedback_media?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, mime: string, url: string } | null } | null } | null, choices?: Array<{ __typename?: 'ComponentCmsDataFormQchoice', id: string, choice_text?: string | null, choice_shortcut?: string | null, choice_color?: string | null, choice_color_transparent?: boolean | null, choice_big_button?: boolean | null, display_delay: number, jump_to_question_index: number, jump_condition_operation: Enum_Componentcmsdataformqchoice_Jump_Condition_Operation, feedback_media_text?: string | null, choice_media?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, mime: string, url: string } | null } | null } | null, allocate_house?: { __typename?: 'HouseEntityResponse', data?: { __typename?: 'HouseEntity', id?: string | null, attributes?: { __typename?: 'House', name: string } | null } | null } | null, feedback_media?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, mime: string, url: string } | null } | null } | null, allocate_tags?: { __typename?: 'ActiveCampaignAcTagRelationResponseCollection', data: Array<{ __typename?: 'ActiveCampaignAcTagEntity', id?: string | null }> } | null } | null> | null } | null> | null } | { __typename?: 'ComponentCmsDataHeaderSection', id: string, helloBarContent?: string | null, HeaderSectionButton?: { __typename?: 'ComponentCmsDataButton', id: string, text: string, url: string } | null, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, url: string } | null } | null } | null } | { __typename?: 'ComponentCmsDataHeroSection', id: string, mainTitle: string, bgColor?: string | null, box?: boolean | null, boxColor?: string | null, textColor?: string | null, textShadow?: boolean | null, DataHeroSectionSecondaryTitle?: string | null, HeroSectionTopTitle?: string | null, HeroSectionButton?: { __typename?: 'ComponentCmsDataButton', id: string, text: string, url: string } | null, countDownTimer?: { __typename?: 'ComponentCmsDataCountDownTimer', id: string, description?: string | null, endDate?: any | null } | null, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null } | null } | null } | null, mobileImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null } | null } | null } | null } | { __typename?: 'ComponentCmsDataHeroSectionSlider', id: string, name: string, autoPlay?: boolean | null, heroSectionSliderItems?: Array<{ __typename?: 'ComponentCmsDataHeroSection', id: string, mainTitle: string, secondaryTitle?: string | null, topTitle?: string | null, bgColor?: string | null, box?: boolean | null, boxColor?: string | null, textColor?: string | null, textShadow?: boolean | null, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, mime: string } | null } | null } | null, mobileImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, mime: string } | null } | null } | null, countDownTimer?: { __typename?: 'ComponentCmsDataCountDownTimer', id: string, description?: string | null, endDate?: any | null } | null, button?: { __typename?: 'ComponentCmsDataButton', id: string, text: string, url: string, color?: string | null, textColor?: string | null } | null } | null> | null } | { __typename?: 'ComponentCmsDataHeroSectionTwo', bottomText?: string | null, id: string, textAfterButton?: boolean | null, topText?: string | null, belowTitle?: string | null, HeroSectionTwoMainTitle: string, button?: { __typename?: 'ComponentCmsDataButton', id: string, text: string, url: string, color?: string | null, textColor?: string | null } | null, HeroSectionTwoImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, url: string } | null } | null } | null } | { __typename?: 'ComponentCmsDataIconCardsSection', mainTitle: string, subTitle: string, id: string, centerText?: boolean | null, showAppButton?: boolean | null, hasExclamationMark?: boolean | null, backgroundColor?: string | null, IconCardsSectionTopTitle: string, iconCards: Array<{ __typename?: 'ComponentCmsDataIconCard', iconName: string, id: string, large?: boolean | null, subTitle?: string | null, title: string } | null>, IconCardsSectionButtons?: Array<{ __typename?: 'ComponentCmsDataButton', id: string, text: string, url: string } | null> | null } | { __typename?: 'ComponentCmsDataImageCardsSection', id: string, backgroundColor?: string | null, ImageCardsSectiontitle?: string | null, items?: Array<{ __typename?: 'ComponentCmsDataImageCard', buttonText?: string | null, buttonUrl?: string | null, id: string, large?: boolean | null, text?: string | null, title: string, textColor?: string | null, backgroundColor?: string | null, logo?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, url: string, formats?: any | null } | null } | null } | null, picture?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, url: string, mime: string, formats?: any | null } | null } | null } | null } | null> | null } | { __typename?: 'ComponentCmsDataImageGallery', id: string, backgroundColor?: string | null, items?: Array<{ __typename?: 'ComponentCmsDataImageGalleryItem', id: string, category?: string | null, ComponentCmsDataImageGalleryTitle?: string | null, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, formats?: any | null } | null } | null } | null } | null> | null } | { __typename?: 'ComponentCmsDataInteractiveImageMap', id: string, interactiveImageMapTitle: string, interactiveImageMapImage: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', url: string, formats?: any | null, alternativeText?: string | null } | null } | null }, circles?: Array<{ __typename?: 'ComponentCmsDataImageMapCircle', id: string, position_x: number, position_y: number, radius: number, details?: { __typename?: 'ComponentCmsDataImageMapDetail', id: string, title: string, description?: string | null, hover_icon?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', url: string, formats?: any | null, alternativeText?: string | null } | null } | null } | null, non_hover_icon?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', url: string, formats?: any | null, alternativeText?: string | null } | null } | null } | null, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', url: string, formats?: any | null, alternativeText?: string | null } | null } | null } | null } | null } | null> | null } | { __typename?: 'ComponentCmsDataLightTopImgSection', id: string, topTitle?: string | null, centerText?: boolean | null, LightTopImgSectionMainTitle?: string | null, DataLightTopImgSectionTextContent?: string | null, topImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, url: string } | null } | null } | null, countDownTimer?: { __typename?: 'ComponentCmsDataCountDownTimer', id: string, endDate?: any | null, description?: string | null } | null } | { __typename?: 'ComponentCmsDataPriceSection', id: string, description?: string | null, descriptionColor?: string | null, mainTitleColor?: string | null, topTitle?: string | null, topTitleColor?: string | null, priceItemsPerSlideWeb?: number | null, sectionId?: string | null, showAsSlider?: boolean | null, showAsSliderWeb?: boolean | null, centerTitle?: boolean | null, shortDescription?: string | null, PriceSectionMainTitle?: string | null, priceItems?: Array<{ __typename?: 'ComponentCmsDataPriceItem', buttonText?: string | null, buttonUrl?: string | null, highlightTag?: string | null, id: string, itemDescription?: string | null, itemMainTitle?: string | null, itemMainTitleColor?: string | null, itemTopTitle?: string | null, itemTopTitleColor?: string | null, monthlyDiscountedPrice?: string | null, monthlyRegularPrice?: string | null, monthlyUnderPriceText?: string | null, yearlyDiscountedPrice?: string | null, yearlyRegularPrice?: string | null, yearlyUnderPriceText?: string | null, centerItemMainTitleHoriz?: boolean | null, centerPriceHoriz?: boolean | null, centerpriceBenefitsHoriz?: boolean | null, priceBenefits?: Array<{ __typename?: 'ComponentCmsDataPriceBenefit', icon?: string | null, id: string, isGrayedOut?: boolean | null, isBold?: boolean | null, text?: string | null, isIndented?: boolean | null } | null> | null } | null> | null, countDownTimer?: { __typename?: 'ComponentCmsDataCountDownTimer', id: string, endDate?: any | null, description?: string | null } | null } | { __typename?: 'ComponentCmsDataProductsList' } | { __typename?: 'ComponentCmsDataReusable', id: string, reusable_component?: { __typename?: 'ReusableComponentEntityResponse', data?: { __typename?: 'ReusableComponentEntity', id?: string | null, attributes?: { __typename?: 'ReusableComponent', title: string, components: Array<{ __typename?: 'ComponentCmsDataAnimatedCardSection', id: string, topTitle?: string | null, AnimatedCardSectionMainTitle: string, DataAnimatedCardSectionSecondaryTitle?: string | null, button?: { __typename?: 'ComponentCmsDataButton', id: string, text: string, url: string } | null, secondSectionImages?: { __typename?: 'UploadFileRelationResponseCollection', data: Array<{ __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, url: string, caption?: string | null } | null }> } | null, firstSectionImages: { __typename?: 'UploadFileRelationResponseCollection', data: Array<{ __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, url: string, caption?: string | null } | null }> } } | { __typename?: 'ComponentCmsDataAuthorsListSection', topTitle?: string | null, showSearch?: boolean | null, showCategories?: boolean | null, numberOfAuthorsToDisplay?: number | null, id: string, description?: string | null, displayAsSlider?: boolean | null, AuthorListMainTitle?: string | null, authors?: { __typename?: 'UsersPermissionsUserRelationResponseCollection', data: Array<{ __typename?: 'UsersPermissionsUserEntity', id?: string | null, attributes?: { __typename?: 'UsersPermissionsUser', username: string, email: string } | null }> } | null } | { __typename?: 'ComponentCmsDataBlogArticles' } | { __typename?: 'ComponentCmsDataCaptureContact' } | { __typename?: 'ComponentCmsDataDarkBgImageSection', id: string, centerText?: boolean | null, mainTitle: string, DarkBgImageSectionSecondaryTitle: string, backgroundImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, url: string } | null } | null } | null, button?: { __typename?: 'ComponentCmsDataButton', id: string, text: string, url: string, color?: string | null, textColor?: string | null } | null, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, url: string } | null } | null } | null, countDownTimer?: { __typename?: 'ComponentCmsDataCountDownTimer', id: string, endDate?: any | null, description?: string | null } | null } | { __typename?: 'ComponentCmsDataDarkImageContent', id: string, buttonText?: string | null, buttonUrl?: string | null, darkImageContentMainTitle?: string | null, backgroundImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', url: string } | null } | null } | null, left?: { __typename?: 'ComponentCmsDataDarkImageSection', id: string, title?: string | null, items?: Array<{ __typename?: 'ComponentCmsDataDarkImageItem', id: string, title?: string | null, description?: string | null } | null> | null } | null, right?: { __typename?: 'ComponentCmsDataDarkImageSection', id: string, title?: string | null, items?: Array<{ __typename?: 'ComponentCmsDataDarkImageItem', id: string, title?: string | null, description?: string | null } | null> | null } | null, countDownTimer?: { __typename?: 'ComponentCmsDataCountDownTimer', id: string, endDate?: any | null, description?: string | null } | null } | { __typename?: 'ComponentCmsDataDarkTextBoxSection', id: string, topTitle?: string | null, topTitleColor?: string | null, mainTitle: string, mainTitleColor?: string | null, box?: boolean | null, boxColor?: string | null, boxTitle?: string | null, boxTitleColor?: string | null, boxText?: string | null, boxTextColor?: string | null, bottomTitle?: string | null, buttonTitleColor?: string | null, centerText?: boolean | null, DarkTextBoxSectionButton?: { __typename?: 'ComponentCmsDataButton', id: string, text: string, textColor?: string | null, url: string, color?: string | null } | null, backgroundImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, url: string, formats?: any | null } | null } | null } | null, mobileBackgroundImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, url: string, formats?: any | null } | null } | null } | null } | { __typename?: 'ComponentCmsDataDarkVersusContent', id: string, subtitle?: string | null, buttonText?: string | null, buttonUrl?: string | null, scarcityTitle?: string | null, darkVersusContentMainTitle?: string | null, darkVersusContentTitle?: string | null, countDownTimer?: { __typename?: 'ComponentCmsDataCountDownTimer', id: string, endDate?: any | null, description?: string | null } | null, bottomImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', url: string } | null } | null } | null, darkVersusContentItems?: Array<{ __typename?: 'ComponentCmsDataDarkVersusBox', id: string, title?: string | null, leftItem?: { __typename?: 'ComponentCmsDataDarkVersusItem', id: string, title?: string | null, iconName?: string | null, content?: string | null } | null, rightItem?: { __typename?: 'ComponentCmsDataDarkVersusItem', id: string, title?: string | null, content?: string | null, iconName?: string | null } | null } | null> | null } | { __typename?: 'ComponentCmsDataEventsListSection' } | { __typename?: 'ComponentCmsDataFaq', title?: string | null, id: string, items?: Array<{ __typename?: 'ComponentCmsDataFaqItem', id: string, answer: string, question: string } | null> | null } | { __typename?: 'ComponentCmsDataFooterSection', id: string, rightText?: string | null, leftText: string, bottomContent?: string | null, iconColumnTitle?: string | null, iconLinks?: Array<{ __typename?: 'ComponentCmsDataFooterIconLink', iconName?: string | null, id: string, link?: string | null, text?: string | null } | null> | null, columns?: Array<{ __typename?: 'ComponentCmsDataFooterColumn', id: string, title?: string | null, content?: string | null } | null> | null } | { __typename?: 'ComponentCmsDataFormGroup', id: string, ask_for_rfid?: boolean | null, redirectUrl?: string | null, random_questions?: boolean | null, number_of_random_questions?: number | null, show_start_screen?: boolean | null, thank_you_message?: string | null, thank_you_message_color?: string | null, thank_you_message_background?: string | null, formGroupTitle: string, formGroupType?: Enum_Componentcmsdataformgroup_Type | null, house_videos?: Array<{ __typename?: 'ComponentGeneralHouseWithVideo', id: string, house?: { __typename?: 'HouseEntityResponse', data?: { __typename?: 'HouseEntity', id?: string | null, attributes?: { __typename?: 'House', name: string } | null } | null } | null, video: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, mime: string } | null } | null } } | null> | null, questions?: Array<{ __typename?: 'ComponentCmsDataFormQuestion', id: string, is_required?: boolean | null, use_recaptcha?: boolean | null, center_text?: boolean | null, title: string, title_color?: string | null, description?: string | null, description_color?: string | null, index: number, size?: Enum_Componentcmsdataformquestion_Size | null, type?: Enum_Componentcmsdataformquestion_Type | null, desktop_layout?: Enum_Componentcmsdataformquestion_Desktop_Layout | null, mobile_layout?: Enum_Componentcmsdataformquestion_Mobile_Layout | null, vertical_alignment?: Enum_Componentcmsdataformquestion_Vertical_Alignment | null, restart_form_timer: number, send_review_to_google?: boolean | null, input_color?: string | null, input_placeholder?: string | null, submit_button_text: string, submit_button_color?: string | null, submit_button_text_color?: string | null, submit_button_sticky?: boolean | null, is_transparent_button?: boolean | null, next_question_index?: number | null, image_position?: Enum_Componentcmsdataformquestion_Image_Position | null, background_color?: string | null, allow_other_choice?: boolean | null, nr_columns: number, space_from_top?: number | null, feedback_media_text?: string | null, rate_user?: { __typename?: 'UsersPermissionsUserRelationResponseCollection', data: Array<{ __typename?: 'UsersPermissionsUserEntity', id?: string | null }> } | null, rate_user_role?: { __typename?: 'CrmRoleRelationResponseCollection', data: Array<{ __typename?: 'CrmRoleEntity', id?: string | null }> } | null, allocate_tags?: { __typename?: 'ActiveCampaignAcTagRelationResponseCollection', data: Array<{ __typename?: 'ActiveCampaignAcTagEntity', id?: string | null }> } | null, allocate_house?: { __typename?: 'HouseEntityResponse', data?: { __typename?: 'HouseEntity', id?: string | null, attributes?: { __typename?: 'House', name: string } | null } | null } | null, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, mime: string, url: string } | null } | null } | null, video?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, mime: string, url: string } | null } | null } | null, feedback_media?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, mime: string, url: string } | null } | null } | null, choices?: Array<{ __typename?: 'ComponentCmsDataFormQchoice', id: string, choice_text?: string | null, choice_shortcut?: string | null, choice_color?: string | null, choice_color_transparent?: boolean | null, choice_big_button?: boolean | null, display_delay: number, jump_to_question_index: number, jump_condition_operation: Enum_Componentcmsdataformqchoice_Jump_Condition_Operation, feedback_media_text?: string | null, choice_media?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, mime: string, url: string } | null } | null } | null, allocate_house?: { __typename?: 'HouseEntityResponse', data?: { __typename?: 'HouseEntity', id?: string | null, attributes?: { __typename?: 'House', name: string } | null } | null } | null, feedback_media?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, mime: string, url: string } | null } | null } | null, allocate_tags?: { __typename?: 'ActiveCampaignAcTagRelationResponseCollection', data: Array<{ __typename?: 'ActiveCampaignAcTagEntity', id?: string | null }> } | null } | null> | null } | null> | null } | { __typename?: 'ComponentCmsDataHeaderSection', id: string, helloBarContent?: string | null, HeaderSectionButton?: { __typename?: 'ComponentCmsDataButton', id: string, text: string, url: string } | null, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, url: string } | null } | null } | null } | { __typename?: 'ComponentCmsDataHeroSection', id: string, mainTitle: string, bgColor?: string | null, box?: boolean | null, boxColor?: string | null, textColor?: string | null, textShadow?: boolean | null, DataHeroSectionSecondaryTitle?: string | null, HeroSectionTopTitle?: string | null, HeroSectionButton?: { __typename?: 'ComponentCmsDataButton', id: string, text: string, url: string } | null, countDownTimer?: { __typename?: 'ComponentCmsDataCountDownTimer', id: string, description?: string | null, endDate?: any | null } | null, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null } | null } | null } | null, mobileImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null } | null } | null } | null } | { __typename?: 'ComponentCmsDataHeroSectionSlider', id: string, name: string, autoPlay?: boolean | null, heroSectionSliderItems?: Array<{ __typename?: 'ComponentCmsDataHeroSection', id: string, mainTitle: string, secondaryTitle?: string | null, topTitle?: string | null, bgColor?: string | null, box?: boolean | null, boxColor?: string | null, textColor?: string | null, textShadow?: boolean | null, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, mime: string } | null } | null } | null, mobileImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, mime: string } | null } | null } | null, countDownTimer?: { __typename?: 'ComponentCmsDataCountDownTimer', id: string, description?: string | null, endDate?: any | null } | null, button?: { __typename?: 'ComponentCmsDataButton', id: string, text: string, url: string, color?: string | null, textColor?: string | null } | null } | null> | null } | { __typename?: 'ComponentCmsDataHeroSectionTwo', bottomText?: string | null, id: string, textAfterButton?: boolean | null, topText?: string | null, belowTitle?: string | null, HeroSectionTwoMainTitle: string, button?: { __typename?: 'ComponentCmsDataButton', id: string, text: string, url: string, color?: string | null, textColor?: string | null } | null, HeroSectionTwoImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, url: string } | null } | null } | null } | { __typename?: 'ComponentCmsDataIconCardsSection', mainTitle: string, subTitle: string, id: string, centerText?: boolean | null, showAppButton?: boolean | null, hasExclamationMark?: boolean | null, backgroundColor?: string | null, IconCardsSectionTopTitle: string, iconCards: Array<{ __typename?: 'ComponentCmsDataIconCard', iconName: string, id: string, large?: boolean | null, subTitle?: string | null, title: string } | null>, IconCardsSectionButtons?: Array<{ __typename?: 'ComponentCmsDataButton', id: string, text: string, url: string } | null> | null } | { __typename?: 'ComponentCmsDataImageCardsSection', id: string, backgroundColor?: string | null, ImageCardsSectiontitle?: string | null, items?: Array<{ __typename?: 'ComponentCmsDataImageCard', buttonText?: string | null, buttonUrl?: string | null, id: string, large?: boolean | null, text?: string | null, title: string, textColor?: string | null, backgroundColor?: string | null, logo?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, url: string, formats?: any | null } | null } | null } | null, picture?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, url: string, mime: string, formats?: any | null } | null } | null } | null } | null> | null } | { __typename?: 'ComponentCmsDataImageGallery', id: string, backgroundColor?: string | null, items?: Array<{ __typename?: 'ComponentCmsDataImageGalleryItem', id: string, category?: string | null, ComponentCmsDataImageGalleryTitle?: string | null, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, formats?: any | null } | null } | null } | null } | null> | null } | { __typename?: 'ComponentCmsDataInteractiveImageMap' } | { __typename?: 'ComponentCmsDataLightTopImgSection', id: string, topTitle?: string | null, centerText?: boolean | null, LightTopImgSectionMainTitle?: string | null, DataLightTopImgSectionTextContent?: string | null, topImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, url: string } | null } | null } | null, countDownTimer?: { __typename?: 'ComponentCmsDataCountDownTimer', id: string, endDate?: any | null, description?: string | null } | null } | { __typename?: 'ComponentCmsDataPriceSection', id: string, description?: string | null, descriptionColor?: string | null, mainTitleColor?: string | null, topTitle?: string | null, topTitleColor?: string | null, priceItemsPerSlideWeb?: number | null, sectionId?: string | null, showAsSlider?: boolean | null, showAsSliderWeb?: boolean | null, centerTitle?: boolean | null, shortDescription?: string | null, PriceSectionMainTitle?: string | null, priceItems?: Array<{ __typename?: 'ComponentCmsDataPriceItem', buttonText?: string | null, buttonUrl?: string | null, highlightTag?: string | null, id: string, itemDescription?: string | null, itemMainTitle?: string | null, itemMainTitleColor?: string | null, itemTopTitle?: string | null, itemTopTitleColor?: string | null, monthlyDiscountedPrice?: string | null, monthlyRegularPrice?: string | null, monthlyUnderPriceText?: string | null, yearlyDiscountedPrice?: string | null, yearlyRegularPrice?: string | null, yearlyUnderPriceText?: string | null, centerItemMainTitleHoriz?: boolean | null, centerPriceHoriz?: boolean | null, centerpriceBenefitsHoriz?: boolean | null, priceBenefits?: Array<{ __typename?: 'ComponentCmsDataPriceBenefit', icon?: string | null, id: string, isGrayedOut?: boolean | null, isBold?: boolean | null, text?: string | null, isIndented?: boolean | null } | null> | null } | null> | null, countDownTimer?: { __typename?: 'ComponentCmsDataCountDownTimer', id: string, endDate?: any | null, description?: string | null } | null } | { __typename?: 'ComponentCmsDataProductsList', id: string, displayType: Enum_Componentcmsdataproductslist_Displaytype, groupByCategory?: boolean | null, show?: any | null, showInPopup?: any | null, popupType?: Enum_Componentcmsdataproductslist_Popuptype | null, productSize: Enum_Componentcmsdataproductslist_Size, menu?: { __typename?: 'MenuEntityResponse', data?: { __typename?: 'MenuEntity', id?: string | null, attributes?: { __typename?: 'Menu', title: string, slug?: string | null, title_dimension?: string | null, description_dimension?: string | null, nutritional_information_dimension?: string | null, web_catalog_items?: { __typename?: 'ProductRelationResponseCollection', data: Array<{ __typename?: 'ProductEntity', id?: string | null, attributes?: { __typename?: 'Product', title: string, description?: string | null, price: number, nutritional_information?: string | null, weight?: number | null, ingredients?: { __typename?: 'IngredientRelationResponseCollection', data: Array<{ __typename?: 'IngredientEntity', id?: string | null, attributes?: { __typename?: 'Ingredient', name: string, allergens?: { __typename?: 'AllergenRelationResponseCollection', data: Array<{ __typename?: 'AllergenEntity', id?: string | null, attributes?: { __typename?: 'Allergen', name: string } | null }> } | null } | null }> } | null, media?: { __typename?: 'UploadFileRelationResponseCollection', data: Array<{ __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', url: string } | null }> } | null, category?: { __typename?: 'ProductCategoryEntityResponse', data?: { __typename?: 'ProductCategoryEntity', id?: string | null, attributes?: { __typename?: 'ProductCategory', name: string } | null } | null } | null } | null }> } | null, nutritional_information_background?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', url: string } | null } | null } | null, nutritional_information_background_2?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', url: string } | null } | null } | null } | null } | null } | null, products?: { __typename?: 'ProductRelationResponseCollection', data: Array<{ __typename?: 'ProductEntity', id?: string | null, attributes?: { __typename?: 'Product', title: string, description?: string | null, price: number, total_calories?: number | null, weight?: number | null, nutritional_information?: string | null, category?: { __typename?: 'ProductCategoryEntityResponse', data?: { __typename?: 'ProductCategoryEntity', id?: string | null, attributes?: { __typename?: 'ProductCategory', name: string } | null } | null } | null, media?: { __typename?: 'UploadFileRelationResponseCollection', data: Array<{ __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, formats?: any | null } | null }> } | null, ingredients?: { __typename?: 'IngredientRelationResponseCollection', data: Array<{ __typename?: 'IngredientEntity', id?: string | null, attributes?: { __typename?: 'Ingredient', name: string, allergens?: { __typename?: 'AllergenRelationResponseCollection', data: Array<{ __typename?: 'AllergenEntity', id?: string | null, attributes?: { __typename?: 'Allergen', name: string } | null }> } | null } | null }> } | null } | null }> } | null } | { __typename?: 'ComponentCmsDataReviewsSection', description?: string | null, id: string, topTitle?: string | null, hideImage?: boolean | null, size?: Enum_Componentcmsdatareviewssection_Size | null, box?: boolean | null, boxColor?: string | null, textColor?: string | null, itemBoxColor?: string | null, itemBoxTextColor?: string | null, ReviewSectionMainTitle?: string | null, reviewItems?: Array<{ __typename?: 'ComponentCmsDataReviewItem', authorLocation?: string | null, authorName?: string | null, authorOccupations?: string | null, contentNrOfChars?: number | null, content?: string | null, id: string, showPictureAsCircle?: boolean | null, title?: string | null, authorPicture?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, url: string, formats?: any | null } | null } | null } | null } | null> | null } | { __typename?: 'ComponentCmsDataRichText', id: string, text?: string | null, center?: boolean | null, fullWidth?: boolean | null, verticalWider?: boolean | null, backgroundImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, url: string } | null } | null } | null } | { __typename?: 'ComponentCmsDataRichTextHtml', id: string, text?: string | null, center?: boolean | null, fullWidth?: boolean | null, verticalWider?: boolean | null, backgroundImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, url: string } | null } | null } | null } | { __typename?: 'ComponentCmsDataScheduleMeeting' } | { __typename?: 'ComponentCmsDataScrollListSection', bottomSectionTitle?: string | null, id: string, mainTitle: string, topTitle?: string | null, shortDescription?: string | null, ScrollListSectionSecondaryTitle?: string | null, backgroundImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, url: string } | null } | null } | null, bottomSectionImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, url: string } | null } | null } | null, boxes: Array<{ __typename?: 'ComponentCmsDataBoxElement', id: string, boxTitle: string, boxText: string, listTitle?: string | null, bottomText?: string | null, boxCards?: Array<{ __typename?: 'ComponentCmsDataBoxCard', id: string, text: string, title: string, showMoreText?: string | null, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, url: string } | null } | null } | null } | null> | null } | null>, ScrollListSectionButton?: { __typename?: 'ComponentCmsDataButton', url: string, text: string, id: string } | null, countDownTimer?: { __typename?: 'ComponentCmsDataCountDownTimer', description?: string | null, endDate?: any | null, id: string } | null } | { __typename?: 'ComponentCmsDataScrollToSection', id: string, sectionId?: string | null } | { __typename?: 'ComponentCmsDataSingleTitleSection', id: string, center?: boolean | null, topTitle?: string | null, backgroundColor?: string | null, textColor?: string | null, SingleTitleMainTitle?: string | null, SingleTitleSubTitle?: string | null } | { __typename?: 'ComponentCmsDataSlider', id: string, type?: Enum_Componentcmsdataslider_Type | null, title?: string | null, centerText?: boolean | null, popup?: boolean | null, popupRichText?: string | null, DataSliderSubTitle?: string | null, items?: Array<{ __typename?: 'ComponentCmsDataSliderItem', body?: string | null, id: string, link?: string | null, title: string, subtitleOverImage?: boolean | null, underText?: string | null, titleNrOfChars?: number | null, underTextNrOfChars?: number | null, bodyNrOfChars?: number | null, frameColor?: string | null, titleColor?: string | null, bodyColor?: string | null, underTexColor?: string | null, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, url: string, formats?: any | null } | null } | null } | null } | null> | null } | { __typename?: 'ComponentCmsDataSubscriptionPopup' } | { __typename?: 'ComponentCmsDataTextAndImageSection', id: string, mainTitle: string, mainTitleColor?: string | null, reverse?: boolean | null, topTitle?: string | null, topTitleColor?: string | null, hideImageOnMobile?: boolean | null, maskImage?: boolean | null, bigImageOnMobile?: boolean | null, variation?: Enum_Componentcmsdatatextandimagesection_Variation | null, rounded?: boolean | null, shadow?: boolean | null, backgroundColor?: string | null, DataTextAndImageSectionTextContent: string, DataTextAndImageSectionTextContentColor?: string | null, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, url: string, formats?: any | null } | null } | null } | null, TextAndImageSectionButton?: Array<{ __typename?: 'ComponentCmsDataButton', id: string, text: string, url: string, color?: string | null, textColor?: string | null } | null> | null, countDownTimer?: { __typename?: 'ComponentCmsDataCountDownTimer', id: string, description?: string | null, endDate?: any | null } | null, underTextImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, url: string, formats?: any | null } | null } | null } | null, imageMask?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, formats?: any | null } | null } | null } | null, imageBackgroundMask?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, formats?: any | null } | null } | null } | null } | { __typename?: 'ComponentCmsDataVideoSection', id: string, belowTitleText?: string | null, centerVideo?: boolean | null, bottomText?: string | null, textAfterButton?: boolean | null, topText?: string | null, VideoSectionMainTitle?: string | null, video?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', url: string } | null } | null } | null, videoMobile?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', url: string } | null } | null } | null, button?: { __typename?: 'ComponentCmsDataButton', id: string, text: string, url: string, color?: string | null, textColor?: string | null } | null, countdownTimer?: { __typename?: 'ComponentCmsDataCountDownTimer', id: string, endDate?: any | null, description?: string | null } | null } | { __typename?: 'Error' } | null> } | null } | null } | null } | { __typename?: 'ComponentCmsDataReviewsSection', description?: string | null, id: string, topTitle?: string | null, hideImage?: boolean | null, size?: Enum_Componentcmsdatareviewssection_Size | null, box?: boolean | null, boxColor?: string | null, textColor?: string | null, itemBoxColor?: string | null, itemBoxTextColor?: string | null, ReviewSectionMainTitle?: string | null, reviewItems?: Array<{ __typename?: 'ComponentCmsDataReviewItem', authorLocation?: string | null, authorName?: string | null, authorOccupations?: string | null, contentNrOfChars?: number | null, content?: string | null, id: string, showPictureAsCircle?: boolean | null, title?: string | null, authorPicture?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, url: string, formats?: any | null } | null } | null } | null } | null> | null } | { __typename?: 'ComponentCmsDataRichText', id: string, text?: string | null, center?: boolean | null, fullWidth?: boolean | null, verticalWider?: boolean | null, backgroundImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, url: string } | null } | null } | null } | { __typename?: 'ComponentCmsDataRichTextHtml', id: string, text?: string | null, center?: boolean | null, fullWidth?: boolean | null, verticalWider?: boolean | null, backgroundImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, url: string } | null } | null } | null } | { __typename?: 'ComponentCmsDataScheduleMeeting' } | { __typename?: 'ComponentCmsDataScrollListSection', bottomSectionTitle?: string | null, id: string, mainTitle: string, topTitle?: string | null, shortDescription?: string | null, ScrollListSectionSecondaryTitle?: string | null, backgroundImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, url: string } | null } | null } | null, bottomSectionImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, url: string } | null } | null } | null, boxes: Array<{ __typename?: 'ComponentCmsDataBoxElement', id: string, boxTitle: string, boxText: string, listTitle?: string | null, bottomText?: string | null, boxCards?: Array<{ __typename?: 'ComponentCmsDataBoxCard', id: string, text: string, title: string, showMoreText?: string | null, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, url: string } | null } | null } | null } | null> | null } | null>, ScrollListSectionButton?: { __typename?: 'ComponentCmsDataButton', url: string, text: string, id: string } | null, countDownTimer?: { __typename?: 'ComponentCmsDataCountDownTimer', description?: string | null, endDate?: any | null, id: string } | null } | { __typename?: 'ComponentCmsDataScrollToSection', id: string, sectionId?: string | null } | { __typename?: 'ComponentCmsDataSingleTitleSection', id: string, center?: boolean | null, topTitle?: string | null, backgroundColor?: string | null, textColor?: string | null, SingleTitleMainTitle?: string | null, SingleTitleSubTitle?: string | null } | { __typename?: 'ComponentCmsDataSlider', id: string, type?: Enum_Componentcmsdataslider_Type | null, title?: string | null, centerText?: boolean | null, popup?: boolean | null, popupRichText?: string | null, DataSliderSubTitle?: string | null, items?: Array<{ __typename?: 'ComponentCmsDataSliderItem', body?: string | null, id: string, link?: string | null, title: string, subtitleOverImage?: boolean | null, underText?: string | null, titleNrOfChars?: number | null, underTextNrOfChars?: number | null, bodyNrOfChars?: number | null, frameColor?: string | null, titleColor?: string | null, bodyColor?: string | null, underTexColor?: string | null, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, url: string, formats?: any | null } | null } | null } | null } | null> | null } | { __typename?: 'ComponentCmsDataSubscriptionPopup' } | { __typename?: 'ComponentCmsDataTextAndImageSection', id: string, mainTitle: string, mainTitleColor?: string | null, reverse?: boolean | null, topTitle?: string | null, topTitleColor?: string | null, hideImageOnMobile?: boolean | null, maskImage?: boolean | null, bigImageOnMobile?: boolean | null, variation?: Enum_Componentcmsdatatextandimagesection_Variation | null, rounded?: boolean | null, shadow?: boolean | null, backgroundColor?: string | null, DataTextAndImageSectionTextContent: string, DataTextAndImageSectionTextContentColor?: string | null, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, url: string, formats?: any | null } | null } | null } | null, TextAndImageSectionButton?: Array<{ __typename?: 'ComponentCmsDataButton', id: string, text: string, url: string, color?: string | null, textColor?: string | null } | null> | null, countDownTimer?: { __typename?: 'ComponentCmsDataCountDownTimer', id: string, description?: string | null, endDate?: any | null } | null, underTextImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, url: string, formats?: any | null } | null } | null } | null, imageMask?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, formats?: any | null } | null } | null } | null, imageBackgroundMask?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, formats?: any | null } | null } | null } | null } | { __typename?: 'ComponentCmsDataVideoSection', id: string, belowTitleText?: string | null, centerVideo?: boolean | null, bottomText?: string | null, textAfterButton?: boolean | null, topText?: string | null, VideoSectionMainTitle?: string | null, video?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', url: string } | null } | null } | null, videoMobile?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', url: string } | null } | null } | null, button?: { __typename?: 'ComponentCmsDataButton', id: string, text: string, url: string, color?: string | null, textColor?: string | null } | null, countdownTimer?: { __typename?: 'ComponentCmsDataCountDownTimer', id: string, endDate?: any | null, description?: string | null } | null } | { __typename?: 'Error' } | null> | null } | null }> } | null };

export type BlogPostSeoQueryVariables = Exact<{
  filters?: InputMaybe<BlogPostFiltersInput>;
}>;


export type BlogPostSeoQuery = { __typename?: 'Query', blogPosts?: { __typename?: 'BlogPostEntityResponseCollection', data: Array<{ __typename?: 'BlogPostEntity', id?: string | null, attributes?: { __typename?: 'BlogPost', title: string, slug: string, seo?: { __typename?: 'ComponentSharedSeo', canonicalURL?: string | null, id: string, keywords?: string | null, metaDescription: string, metaRobots?: string | null, metaTitle: string, metaViewport?: string | null, metaImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, formats?: any | null, url: string } | null } | null } | null, metaSocial?: Array<{ __typename?: 'ComponentSharedMetaSocial', id: string, description: string, socialNetwork: Enum_Componentsharedmetasocial_Socialnetwork, title: string, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, formats?: any | null, url: string } | null } | null } | null } | null> | null } | null } | null }> } | null };

export type GetBlogPostSlugsQueryVariables = Exact<{
  filters?: InputMaybe<BlogPostFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
}>;


export type GetBlogPostSlugsQuery = { __typename?: 'Query', blogPosts?: { __typename?: 'BlogPostEntityResponseCollection', data: Array<{ __typename?: 'BlogPostEntity', id?: string | null, attributes?: { __typename?: 'BlogPost', slug: string, updatedAt?: any | null } | null }> } | null };

export type CampaignsUserWithRolesQueryVariables = Exact<{
  filters?: InputMaybe<CampaignFiltersInput>;
  usersWithRolesFilters?: InputMaybe<ComponentCrmDataCrmAccountRoleFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
}>;


export type CampaignsUserWithRolesQuery = { __typename?: 'Query', campaigns?: { __typename?: 'CampaignEntityResponseCollection', data: Array<{ __typename?: 'CampaignEntity', id?: string | null, attributes?: { __typename?: 'Campaign', users_with_roles?: Array<{ __typename?: 'ComponentCrmDataCrmAccountRole', id: string, user?: { __typename?: 'UsersPermissionsUserEntityResponse', data?: { __typename?: 'UsersPermissionsUserEntity', id?: string | null, attributes?: { __typename?: 'UsersPermissionsUser', firstName?: string | null, lastName?: string | null } | null } | null } | null, roles?: { __typename?: 'CrmRoleRelationResponseCollection', data: Array<{ __typename?: 'CrmRoleEntity', id?: string | null, attributes?: { __typename?: 'CrmRole', name: string } | null }> } | null } | null> | null } | null }> } | null };

export type GetAllFeedbacksQueryVariables = Exact<{
  filters?: InputMaybe<CrmTaskFeedbackFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
}>;


export type GetAllFeedbacksQuery = { __typename?: 'Query', crmTaskFeedbacks?: { __typename?: 'CrmTaskFeedbackEntityResponseCollection', meta: { __typename?: 'ResponseCollectionMeta', pagination: { __typename?: 'Pagination', total: number, pageCount: number, page: number } }, data: Array<{ __typename?: 'CrmTaskFeedbackEntity', id?: string | null, attributes?: { __typename?: 'CrmTaskFeedback', name?: string | null, task_type?: Enum_Crmtaskfeedback_Task_Type | null } | null }> } | null };

export type GetAllCrmUserRolesQueryVariables = Exact<{
  filters?: InputMaybe<CampaignFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  usersWithRolesFilters2?: InputMaybe<ComponentCrmDataCrmAccountRoleFiltersInput>;
  usersWithRolesPagination2?: InputMaybe<PaginationArg>;
  usersWithRolesSort2?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
}>;


export type GetAllCrmUserRolesQuery = { __typename?: 'Query', campaigns?: { __typename?: 'CampaignEntityResponseCollection', data: Array<{ __typename?: 'CampaignEntity', id?: string | null, attributes?: { __typename?: 'Campaign', users_with_roles?: Array<{ __typename?: 'ComponentCrmDataCrmAccountRole', id: string, user?: { __typename?: 'UsersPermissionsUserEntityResponse', data?: { __typename?: 'UsersPermissionsUserEntity', id?: string | null, attributes?: { __typename?: 'UsersPermissionsUser', firstName?: string | null, lastName?: string | null } | null } | null } | null } | null> | null } | null }> } | null };

export type CrmTasksQueryVariables = Exact<{
  pagination?: InputMaybe<PaginationArg>;
  filters?: InputMaybe<CrmTaskFiltersInput>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  ordersPagination?: InputMaybe<PaginationArg>;
  ordersFilters?: InputMaybe<OrderFiltersInput>;
  paymentsPagination?: InputMaybe<PaginationArg>;
  paymentsFilters?: InputMaybe<PaymentFiltersInput>;
  productsPagination?: InputMaybe<PaginationArg>;
  productsFilters?: InputMaybe<ProductFiltersInput>;
  crmLinksPagination?: InputMaybe<PaginationArg>;
  crmLinksFilters?: InputMaybe<CrmLinkFiltersInput>;
  accountRolesPagination?: InputMaybe<PaginationArg>;
}>;


export type CrmTasksQuery = { __typename?: 'Query', crmTasks?: { __typename?: 'CrmTaskEntityResponseCollection', data: Array<{ __typename?: 'CrmTaskEntity', id?: string | null, attributes?: { __typename?: 'CrmTask', title: string, status: Enum_Crmtask_Status, type?: Enum_Crmtask_Type | null, updatedAt?: any | null, meeting_url?: string | null, info?: string | null, calendarEventId?: string | null, dueDate: any, createdAt?: any | null, crm_link?: { __typename?: 'CrmLinkEntityResponse', data?: { __typename?: 'CrmLinkEntity', id?: string | null, attributes?: { __typename?: 'CrmLink', crm_campaign?: { __typename?: 'CampaignEntityResponse', data?: { __typename?: 'CampaignEntity', id?: string | null, attributes?: { __typename?: 'Campaign', name: string, slug?: string | null, updatedAt?: any | null } | null } | null } | null, orders?: { __typename?: 'OrderRelationResponseCollection', data: Array<{ __typename?: 'OrderEntity', id?: string | null, attributes?: { __typename?: 'Order', total_price: number, total_vat: number, payments?: { __typename?: 'PaymentRelationResponseCollection', data: Array<{ __typename?: 'PaymentEntity', id?: string | null, attributes?: { __typename?: 'Payment', status: Enum_Payment_Status, amount: number } | null }> } | null } | null }> } | null, products?: { __typename?: 'ProductRelationResponseCollection', data: Array<{ __typename?: 'ProductEntity', id?: string | null, attributes?: { __typename?: 'Product', title: string } | null }> } | null, crm_links?: { __typename?: 'CrmLinkRelationResponseCollection', data: Array<{ __typename?: 'CrmLinkEntity', id?: string | null, attributes?: { __typename?: 'CrmLink', orders?: { __typename?: 'OrderRelationResponseCollection', data: Array<{ __typename?: 'OrderEntity', id?: string | null, attributes?: { __typename?: 'Order', total_price: number } | null }> } | null, crm_links?: { __typename?: 'CrmLinkRelationResponseCollection', data: Array<{ __typename?: 'CrmLinkEntity', id?: string | null, attributes?: { __typename?: 'CrmLink', orders?: { __typename?: 'OrderRelationResponseCollection', data: Array<{ __typename?: 'OrderEntity', id?: string | null, attributes?: { __typename?: 'Order', total_price: number } | null }> } | null } | null }> } | null, products?: { __typename?: 'ProductRelationResponseCollection', data: Array<{ __typename?: 'ProductEntity', id?: string | null, attributes?: { __typename?: 'Product', title: string } | null }> } | null } | null }> } | null } | null } | null } | null, crm_campaign_member?: { __typename?: 'CrmCampaignMemberEntityResponse', data?: { __typename?: 'CrmCampaignMemberEntity', id?: string | null, attributes?: { __typename?: 'CrmCampaignMember', updatedAt?: any | null, users_with_roles?: Array<{ __typename?: 'ComponentCrmDataCrmAccountRole', id: string, user?: { __typename?: 'UsersPermissionsUserEntityResponse', data?: { __typename?: 'UsersPermissionsUserEntity', id?: string | null } | null } | null, roles?: { __typename?: 'CrmRoleRelationResponseCollection', data: Array<{ __typename?: 'CrmRoleEntity', id?: string | null, attributes?: { __typename?: 'CrmRole', name: string } | null }> } | null } | null> | null, utm_data?: { __typename?: 'ComponentCrmDataUtmData', utm_campaign?: string | null, utm_id?: string | null, id: string, utm_medium?: Enum_Componentcrmdatautmdata_Utm_Medium | null, utm_source?: Enum_Componentcrmdatautmdata_Utm_Source | null } | null, crm_campaign?: { __typename?: 'CampaignEntityResponse', data?: { __typename?: 'CampaignEntity', id?: string | null, attributes?: { __typename?: 'Campaign', slug?: string | null } | null } | null } | null } | null } | null } | null, assignee?: { __typename?: 'UsersPermissionsUserEntityResponse', data?: { __typename?: 'UsersPermissionsUserEntity', id?: string | null, attributes?: { __typename?: 'UsersPermissionsUser', firstName?: string | null, lastName?: string | null, crm_profile?: { __typename?: 'ComponentCrmDataCrmUserProfile', crm_roles?: { __typename?: 'CrmRoleRelationResponseCollection', data: Array<{ __typename?: 'CrmRoleEntity', id?: string | null, attributes?: { __typename?: 'CrmRole', sales_commision?: number | null } | null }> } | null } | null } | null } | null } | null, feedback?: { __typename?: 'CrmTaskFeedbackEntityResponse', data?: { __typename?: 'CrmTaskFeedbackEntity', id?: string | null, attributes?: { __typename?: 'CrmTaskFeedback', name?: string | null, crm_reports?: any | null, task_type?: Enum_Crmtaskfeedback_Task_Type | null } | null } | null } | null } | null }> } | null };

export type CrmFiltersTasksQueryVariables = Exact<{
  pagination?: InputMaybe<PaginationArg>;
  filters?: InputMaybe<CrmTaskFiltersInput>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  accountRolesPagination?: InputMaybe<PaginationArg>;
}>;


export type CrmFiltersTasksQuery = { __typename?: 'Query', crmTasks?: { __typename?: 'CrmTaskEntityResponseCollection', data: Array<{ __typename?: 'CrmTaskEntity', id?: string | null, attributes?: { __typename?: 'CrmTask', assignee?: { __typename?: 'UsersPermissionsUserEntityResponse', data?: { __typename?: 'UsersPermissionsUserEntity', id?: string | null, attributes?: { __typename?: 'UsersPermissionsUser', firstName?: string | null, lastName?: string | null } | null } | null } | null, crm_campaign_member?: { __typename?: 'CrmCampaignMemberEntityResponse', data?: { __typename?: 'CrmCampaignMemberEntity', id?: string | null, attributes?: { __typename?: 'CrmCampaignMember', users_with_roles?: Array<{ __typename?: 'ComponentCrmDataCrmAccountRole', id: string, user?: { __typename?: 'UsersPermissionsUserEntityResponse', data?: { __typename?: 'UsersPermissionsUserEntity', id?: string | null } | null } | null, roles?: { __typename?: 'CrmRoleRelationResponseCollection', data: Array<{ __typename?: 'CrmRoleEntity', id?: string | null, attributes?: { __typename?: 'CrmRole', name: string } | null }> } | null } | null> | null } | null } | null } | null } | null }> } | null };

export type CrmLinkFragmentFragment = { __typename?: 'CrmLinkRelationResponseCollection', data: Array<{ __typename?: 'CrmLinkEntity', id?: string | null, attributes?: { __typename?: 'CrmLink', orders?: { __typename?: 'OrderRelationResponseCollection', data: Array<{ __typename?: 'OrderEntity', id?: string | null, attributes?: { __typename?: 'Order', total_price: number } | null }> } | null, crm_links?: { __typename?: 'CrmLinkRelationResponseCollection', data: Array<{ __typename?: 'CrmLinkEntity', id?: string | null, attributes?: { __typename?: 'CrmLink', orders?: { __typename?: 'OrderRelationResponseCollection', data: Array<{ __typename?: 'OrderEntity', id?: string | null, attributes?: { __typename?: 'Order', total_price: number } | null }> } | null } | null }> } | null, products?: { __typename?: 'ProductRelationResponseCollection', data: Array<{ __typename?: 'ProductEntity', id?: string | null, attributes?: { __typename?: 'Product', title: string } | null }> } | null } | null }> };

export type UpdateCrmTaskMutationVariables = Exact<{
  updateCrmTaskId: Scalars['ID'];
  data: CrmTaskInput;
}>;


export type UpdateCrmTaskMutation = { __typename?: 'Mutation', updateCrmTask?: { __typename?: 'CrmTaskEntityResponse', data?: { __typename?: 'CrmTaskEntity', id?: string | null, attributes?: { __typename?: 'CrmTask', ai_prompts?: Array<{ __typename?: 'ComponentCrmDataCrmAiPrompt', id: string, prompt_text?: string | null, ai_answer?: string | null, prompt_type?: { __typename?: 'PromptTypeEntityResponse', data?: { __typename?: 'PromptTypeEntity', id?: string | null } | null } | null } | null> | null } | null } | null } | null };

export type CreateCrmLinkMutationVariables = Exact<{
  data: CrmLinkInput;
}>;


export type CreateCrmLinkMutation = { __typename?: 'Mutation', createCrmLink?: { __typename?: 'CrmLinkEntityResponse', data?: { __typename?: 'CrmLinkEntity', id?: string | null } | null } | null };

export type CreateCrmTaskMutationVariables = Exact<{
  data: CrmTaskInput;
}>;


export type CreateCrmTaskMutation = { __typename?: 'Mutation', createCrmTask?: { __typename?: 'CrmTaskEntityResponse', data?: { __typename?: 'CrmTaskEntity', id?: string | null } | null } | null };

export type AddRoleOnContactMutationVariables = Exact<{
  setUserRoleOnCampaignMemberId: Scalars['ID'];
  user: Scalars['ID'];
  roles?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
}>;


export type AddRoleOnContactMutation = { __typename?: 'Mutation', setUserRoleOnCampaignMember?: { __typename?: 'CrmCampaignMemberEntityResponse', data?: { __typename?: 'CrmCampaignMemberEntity', id?: string | null, attributes?: { __typename?: 'CrmCampaignMember', crm_campaign?: { __typename?: 'CampaignEntityResponse', data?: { __typename?: 'CampaignEntity', id?: string | null } | null } | null } | null } | null } | null };

export type UpdateContactMutationVariables = Exact<{
  updateContactId: Scalars['ID'];
  data: ContactInput;
}>;


export type UpdateContactMutation = { __typename?: 'Mutation', updateContact?: { __typename?: 'ContactEntityResponse', data?: { __typename?: 'ContactEntity', id?: string | null, attributes?: { __typename?: 'Contact', firstName?: string | null, lastName?: string | null, info?: string | null, phoneNumber?: string | null, email: string, contact_source?: { __typename?: 'CrmContactSourceEntityResponse', data?: { __typename?: 'CrmContactSourceEntity', id?: string | null, attributes?: { __typename?: 'CrmContactSource', name: string } | null } | null } | null } | null } | null } | null };

export type GenerateCrmTaskAiPromptCompletionMutationVariables = Exact<{
  generateCrmTaskAiPromptCompletionId: Scalars['ID'];
  aiPromptId: Scalars['ID'];
}>;


export type GenerateCrmTaskAiPromptCompletionMutation = { __typename?: 'Mutation', generateCRMTaskAIPromptCompletion?: { __typename?: 'CrmTaskEntityResponse', data?: { __typename?: 'CrmTaskEntity', id?: string | null } | null } | null };

export type CreateContactMutationVariables = Exact<{
  data: ContactInput;
}>;


export type CreateContactMutation = { __typename?: 'Mutation', createContact?: { __typename?: 'ContactEntityResponse', data?: { __typename?: 'ContactEntity', id?: string | null, attributes?: { __typename?: 'Contact', email: string } | null } | null } | null };

export type UploadFileMutationVariables = Exact<{
  file: Scalars['Upload'];
}>;


export type UploadFileMutation = { __typename?: 'Mutation', upload: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null } | null } };

export type GetCampaignsQueryVariables = Exact<{
  filters?: InputMaybe<CampaignFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  crmCampaignMembersFilters?: InputMaybe<CrmCampaignMemberFiltersInput>;
  crmCampaignMembersPagination?: InputMaybe<PaginationArg>;
  crmCampaignMembersSort?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  usersWithRolesPagination?: InputMaybe<PaginationArg>;
  usersWithRolesFilters?: InputMaybe<ComponentCrmDataCrmAccountRoleFiltersInput>;
}>;


export type GetCampaignsQuery = { __typename?: 'Query', campaigns?: { __typename?: 'CampaignEntityResponseCollection', data: Array<{ __typename?: 'CampaignEntity', id?: string | null, attributes?: { __typename?: 'Campaign', createdAt?: any | null, name: string, slug?: string | null, crm_campaign_members?: { __typename?: 'CrmCampaignMemberRelationResponseCollection', data: Array<{ __typename?: 'CrmCampaignMemberEntity', id?: string | null }> } | null, users_with_roles?: Array<{ __typename?: 'ComponentCrmDataCrmAccountRole', id: string, user?: { __typename?: 'UsersPermissionsUserEntityResponse', data?: { __typename?: 'UsersPermissionsUserEntity', id?: string | null, attributes?: { __typename?: 'UsersPermissionsUser', firstName?: string | null, lastName?: string | null } | null } | null } | null } | null> | null } | null }> } | null };

export type GetCampaignsListQueryVariables = Exact<{
  filters?: InputMaybe<CampaignFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  crmCampaignMembersFilters?: InputMaybe<CrmCampaignMemberFiltersInput>;
  crmCampaignMembersPagination?: InputMaybe<PaginationArg>;
  crmCampaignMembersSort?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  usersWithRolesFilters2?: InputMaybe<ComponentCrmDataCrmAccountRoleFiltersInput>;
  usersWithRolesPagination2?: InputMaybe<PaginationArg>;
  usersWithRolesSort2?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  assignedFilters2?: InputMaybe<UsersPermissionsUserFiltersInput>;
  assignedUsersFilters2?: InputMaybe<ComponentCrmDataCrmAssignedUserFiltersInput>;
  assignedUsersPagination2?: InputMaybe<PaginationArg>;
  usersWithRatingFilters2?: InputMaybe<ComponentCrmDataCrmUserRatingFiltersInput>;
  usersWithRatingPagination2?: InputMaybe<PaginationArg>;
}>;


export type GetCampaignsListQuery = { __typename?: 'Query', campaigns?: { __typename?: 'CampaignEntityResponseCollection', data: Array<{ __typename?: 'CampaignEntity', id?: string | null, attributes?: { __typename?: 'Campaign', createdAt?: any | null, name: string, slug?: string | null, crm_campaign_members?: { __typename?: 'CrmCampaignMemberRelationResponseCollection', data: Array<{ __typename?: 'CrmCampaignMemberEntity', id?: string | null }> } | null, users_with_roles?: Array<{ __typename?: 'ComponentCrmDataCrmAccountRole', id: string, user?: { __typename?: 'UsersPermissionsUserEntityResponse', data?: { __typename?: 'UsersPermissionsUserEntity', id?: string | null, attributes?: { __typename?: 'UsersPermissionsUser', email: string } | null } | null } | null, roles?: { __typename?: 'CrmRoleRelationResponseCollection', data: Array<{ __typename?: 'CrmRoleEntity', id?: string | null, attributes?: { __typename?: 'CrmRole', name: string } | null }> } | null } | null> | null, schedule_meeting?: { __typename?: 'ComponentCrmDataCrmMeeting', id: string, meetingDescription?: string | null, meetingDuration: number, scheduleBuffer?: number | null, title: string, tags?: { __typename?: 'ActiveCampaignAcTagRelationResponseCollection', data: Array<{ __typename?: 'ActiveCampaignAcTagEntity', id?: string | null }> } | null, tasks?: Array<{ __typename?: 'ComponentCmsDataScheduleTask', id: string, info?: string | null, isDueInAfterCreationDate?: boolean | null, sendNotification?: boolean | null, status?: Enum_Componentcmsdatascheduletask_Status | null, title?: string | null, type?: Enum_Componentcmsdatascheduletask_Type | null, due_in?: number | null } | null> | null, assigned_users?: Array<{ __typename?: 'ComponentCrmDataCrmAssignedUser', id: string, user?: { __typename?: 'UsersPermissionsUserEntityResponse', data?: { __typename?: 'UsersPermissionsUserEntity', id?: string | null, attributes?: { __typename?: 'UsersPermissionsUser', email: string } | null } | null } | null, assigned?: { __typename?: 'UsersPermissionsUserRelationResponseCollection', data: Array<{ __typename?: 'UsersPermissionsUserEntity', id?: string | null, attributes?: { __typename?: 'UsersPermissionsUser', email: string } | null }> } | null } | null> | null, users_with_rating?: Array<{ __typename?: 'ComponentCrmDataCrmUserRating', id: string, rating: number, user?: { __typename?: 'UsersPermissionsUserEntityResponse', data?: { __typename?: 'UsersPermissionsUserEntity', id?: string | null, attributes?: { __typename?: 'UsersPermissionsUser', email: string } | null } | null } | null } | null> | null, crm_role?: { __typename?: 'CrmRoleEntityResponse', data?: { __typename?: 'CrmRoleEntity', id?: string | null, attributes?: { __typename?: 'CrmRole', name: string } | null } | null } | null, crm_cm_status?: { __typename?: 'CrmCampaignMemberStatusEntityResponse', data?: { __typename?: 'CrmCampaignMemberStatusEntity', id?: string | null, attributes?: { __typename?: 'CrmCampaignMemberStatus', name: string } | null } | null } | null } | null } | null }> } | null };

export type GetCrmTasksFromCampaignsQueryVariables = Exact<{
  filters?: InputMaybe<CampaignFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  crmCampaignMembersFilters?: InputMaybe<CrmCampaignMemberFiltersInput>;
  crmCampaignMembersPagination?: InputMaybe<PaginationArg>;
  crmCampaignMembersSort?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  crmTasksFilters?: InputMaybe<CrmTaskFiltersInput>;
  crmTasksPagination?: InputMaybe<PaginationArg>;
  crmTasksSort?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
}>;


export type GetCrmTasksFromCampaignsQuery = { __typename?: 'Query', campaigns?: { __typename?: 'CampaignEntityResponseCollection', data: Array<{ __typename?: 'CampaignEntity', id?: string | null, attributes?: { __typename?: 'Campaign', slug?: string | null, crm_campaign_members?: { __typename?: 'CrmCampaignMemberRelationResponseCollection', data: Array<{ __typename?: 'CrmCampaignMemberEntity', id?: string | null, attributes?: { __typename?: 'CrmCampaignMember', crm_tasks?: { __typename?: 'CrmTaskRelationResponseCollection', data: Array<{ __typename?: 'CrmTaskEntity', id?: string | null, attributes?: { __typename?: 'CrmTask', createdAt?: any | null, status: Enum_Crmtask_Status, type?: Enum_Crmtask_Type | null, dueDate: any, title: string, meeting_url?: string | null, assignee?: { __typename?: 'UsersPermissionsUserEntityResponse', data?: { __typename?: 'UsersPermissionsUserEntity', id?: string | null, attributes?: { __typename?: 'UsersPermissionsUser', firstName?: string | null, lastName?: string | null } | null } | null } | null, crm_campaign_member?: { __typename?: 'CrmCampaignMemberEntityResponse', data?: { __typename?: 'CrmCampaignMemberEntity', id?: string | null, attributes?: { __typename?: 'CrmCampaignMember', crm_contact?: { __typename?: 'ContactEntityResponse', data?: { __typename?: 'ContactEntity', id?: string | null, attributes?: { __typename?: 'Contact', firstName?: string | null, lastName?: string | null } | null } | null } | null } | null } | null } | null, crm_link?: { __typename?: 'CrmLinkEntityResponse', data?: { __typename?: 'CrmLinkEntity', id?: string | null } | null } | null, feedback?: { __typename?: 'CrmTaskFeedbackEntityResponse', data?: { __typename?: 'CrmTaskFeedbackEntity', id?: string | null, attributes?: { __typename?: 'CrmTaskFeedback', crm_reports?: any | null, name?: string | null, task_type?: Enum_Crmtaskfeedback_Task_Type | null } | null } | null } | null } | null }> } | null } | null }> } | null } | null }> } | null };

export type GetCrmSingleTaskQueryVariables = Exact<{
  crmTaskId: Scalars['ID'];
  filters?: InputMaybe<ComponentCrmDataCrmAccountRoleFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  rolesFilters?: InputMaybe<CrmRoleFiltersInput>;
  rolesPagination?: InputMaybe<PaginationArg>;
  rolesSort?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  aiPromptsPagination?: InputMaybe<PaginationArg>;
}>;


export type GetCrmSingleTaskQuery = { __typename?: 'Query', crmTask?: { __typename?: 'CrmTaskEntityResponse', data?: { __typename?: 'CrmTaskEntity', id?: string | null, attributes?: { __typename?: 'CrmTask', calendarEventId?: string | null, duration?: number | null, createdAt?: any | null, dueDate: any, info?: string | null, meeting_url?: string | null, meeting_recording_url?: string | null, status: Enum_Crmtask_Status, title: string, type?: Enum_Crmtask_Type | null, updatedAt?: any | null, feedback_teamleader?: string | null, feedbackUpdatedAt?: any | null, questions?: any | null, assignee?: { __typename?: 'UsersPermissionsUserEntityResponse', data?: { __typename?: 'UsersPermissionsUserEntity', id?: string | null, attributes?: { __typename?: 'UsersPermissionsUser', firstName?: string | null, lastName?: string | null, email: string } | null } | null } | null, crm_campaign_member?: { __typename?: 'CrmCampaignMemberEntityResponse', data?: { __typename?: 'CrmCampaignMemberEntity', id?: string | null, attributes?: { __typename?: 'CrmCampaignMember', info?: string | null, crm_contact?: { __typename?: 'ContactEntityResponse', data?: { __typename?: 'ContactEntity', id?: string | null, attributes?: { __typename?: 'Contact', email: string, firstName?: string | null, lastName?: string | null, phoneNumber?: string | null } | null } | null } | null, users_with_roles?: Array<{ __typename?: 'ComponentCrmDataCrmAccountRole', id: string, user?: { __typename?: 'UsersPermissionsUserEntityResponse', data?: { __typename?: 'UsersPermissionsUserEntity', id?: string | null, attributes?: { __typename?: 'UsersPermissionsUser', email: string } | null } | null } | null, roles?: { __typename?: 'CrmRoleRelationResponseCollection', data: Array<{ __typename?: 'CrmRoleEntity', id?: string | null, attributes?: { __typename?: 'CrmRole', name: string, slug?: string | null } | null }> } | null } | null> | null } | null } | null } | null, crm_link?: { __typename?: 'CrmLinkEntityResponse', data?: { __typename?: 'CrmLinkEntity', id?: string | null, attributes?: { __typename?: 'CrmLink', identifier: string, products?: { __typename?: 'ProductRelationResponseCollection', data: Array<{ __typename?: 'ProductEntity', id?: string | null }> } | null } | null } | null } | null, feedback?: { __typename?: 'CrmTaskFeedbackEntityResponse', data?: { __typename?: 'CrmTaskFeedbackEntity', id?: string | null, attributes?: { __typename?: 'CrmTaskFeedback', name?: string | null, task_type?: Enum_Crmtaskfeedback_Task_Type | null, createdAt?: any | null } | null } | null } | null, ai_prompts?: Array<{ __typename?: 'ComponentCrmDataCrmAiPrompt', id: string, prompt_text?: string | null, ai_answer?: string | null, prompt_type?: { __typename?: 'PromptTypeEntityResponse', data?: { __typename?: 'PromptTypeEntity', id?: string | null, attributes?: { __typename?: 'PromptType', type: string, prompt: string } | null } | null } | null } | null> | null, crm_campaign?: { __typename?: 'CampaignEntityResponse', data?: { __typename?: 'CampaignEntity', id?: string | null, attributes?: { __typename?: 'Campaign', name: string } | null } | null } | null } | null } | null } | null };

export type GetCrmTasksQueryVariables = Exact<{
  filters?: InputMaybe<CrmTaskFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
}>;


export type GetCrmTasksQuery = { __typename?: 'Query', crmTasks?: { __typename?: 'CrmTaskEntityResponseCollection', data: Array<{ __typename?: 'CrmTaskEntity', id?: string | null, attributes?: { __typename?: 'CrmTask', createdAt?: any | null, status: Enum_Crmtask_Status, type?: Enum_Crmtask_Type | null, dueDate: any, title: string, meeting_url?: string | null, assignee?: { __typename?: 'UsersPermissionsUserEntityResponse', data?: { __typename?: 'UsersPermissionsUserEntity', id?: string | null, attributes?: { __typename?: 'UsersPermissionsUser', firstName?: string | null, lastName?: string | null } | null } | null } | null, crm_campaign_member?: { __typename?: 'CrmCampaignMemberEntityResponse', data?: { __typename?: 'CrmCampaignMemberEntity', id?: string | null, attributes?: { __typename?: 'CrmCampaignMember', crm_contact?: { __typename?: 'ContactEntityResponse', data?: { __typename?: 'ContactEntity', id?: string | null, attributes?: { __typename?: 'Contact', firstName?: string | null, lastName?: string | null } | null } | null } | null } | null } | null } | null, crm_link?: { __typename?: 'CrmLinkEntityResponse', data?: { __typename?: 'CrmLinkEntity', id?: string | null } | null } | null, feedback?: { __typename?: 'CrmTaskFeedbackEntityResponse', data?: { __typename?: 'CrmTaskFeedbackEntity', id?: string | null, attributes?: { __typename?: 'CrmTaskFeedback', crm_reports?: any | null, name?: string | null, task_type?: Enum_Crmtaskfeedback_Task_Type | null } | null } | null } | null } | null }> } | null };

export type GetAllCampaignMembersEmailsQueryVariables = Exact<{
  filters?: InputMaybe<CrmCampaignMemberFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
}>;


export type GetAllCampaignMembersEmailsQuery = { __typename?: 'Query', crmCampaignMembers?: { __typename?: 'CrmCampaignMemberEntityResponseCollection', data: Array<{ __typename?: 'CrmCampaignMemberEntity', id?: string | null, attributes?: { __typename?: 'CrmCampaignMember', crm_contact?: { __typename?: 'ContactEntityResponse', data?: { __typename?: 'ContactEntity', id?: string | null, attributes?: { __typename?: 'Contact', email: string, firstName?: string | null, lastName?: string | null, phoneNumber?: string | null } | null } | null } | null } | null }> } | null };

export type GetCrmCampaignMembersListQueryVariables = Exact<{
  filters?: InputMaybe<CrmCampaignMemberFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  reservationsSort?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  accountRolesFilters?: InputMaybe<ComponentCrmDataCrmAccountRoleFiltersInput>;
  accountRolesPagination?: InputMaybe<PaginationArg>;
  accountRolesSort?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  rolesFilters?: InputMaybe<CrmRoleFiltersInput>;
  rolesPagination?: InputMaybe<PaginationArg>;
  rolesSort?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  timeSlotsFilters?: InputMaybe<TimeSlotFiltersInput>;
  productsFilters?: InputMaybe<ComponentMenuProductWithQuantityFiltersInput>;
  reservationsPagination?: InputMaybe<PaginationArg>;
  timeSlotsPagination?: InputMaybe<PaginationArg>;
  productsPagination?: InputMaybe<PaginationArg>;
}>;


export type GetCrmCampaignMembersListQuery = { __typename?: 'Query', crmCampaignMembers?: { __typename?: 'CrmCampaignMemberEntityResponseCollection', meta: { __typename?: 'ResponseCollectionMeta', pagination: { __typename?: 'Pagination', page: number, pageCount: number, total: number } }, data: Array<{ __typename?: 'CrmCampaignMemberEntity', id?: string | null, attributes?: { __typename?: 'CrmCampaignMember', statusUpdatedAt?: any | null, info?: string | null, users_with_roles?: Array<{ __typename?: 'ComponentCrmDataCrmAccountRole', id: string, user?: { __typename?: 'UsersPermissionsUserEntityResponse', data?: { __typename?: 'UsersPermissionsUserEntity', id?: string | null, attributes?: { __typename?: 'UsersPermissionsUser', email: string } | null } | null } | null, roles?: { __typename?: 'CrmRoleRelationResponseCollection', data: Array<{ __typename?: 'CrmRoleEntity', id?: string | null, attributes?: { __typename?: 'CrmRole', name: string } | null }> } | null } | null> | null, crm_contact?: { __typename?: 'ContactEntityResponse', data?: { __typename?: 'ContactEntity', id?: string | null, attributes?: { __typename?: 'Contact', firstName?: string | null, lastName?: string | null, phoneNumber?: string | null, email: string } | null } | null } | null, status?: { __typename?: 'CrmCampaignMemberStatusEntityResponse', data?: { __typename?: 'CrmCampaignMemberStatusEntity', id?: string | null, attributes?: { __typename?: 'CrmCampaignMemberStatus', createdAt?: any | null, description?: string | null, name: string } | null } | null } | null, reservations?: { __typename?: 'ReservationRelationResponseCollection', data: Array<{ __typename?: 'ReservationEntity', id?: string | null, attributes?: { __typename?: 'Reservation', title: string, type?: Enum_Reservation_Type | null, status?: Enum_Reservation_Status | null, start_date?: any | null, time_slots?: { __typename?: 'TimeSlotRelationResponseCollection', data: Array<{ __typename?: 'TimeSlotEntity', id?: string | null, attributes?: { __typename?: 'TimeSlot', info?: string | null, additional_info?: string | null, number_of_persons?: number | null, room?: { __typename?: 'RoomEntityResponse', data?: { __typename?: 'RoomEntity', id?: string | null, attributes?: { __typename?: 'Room', name: string } | null } | null } | null, game?: { __typename?: 'GameEntityResponse', data?: { __typename?: 'GameEntity', id?: string | null, attributes?: { __typename?: 'Game', name: string } | null } | null } | null } | null }> } | null, products?: Array<{ __typename?: 'ComponentMenuProductWithQuantity', id: string, info?: string | null, quantity: number, discount_percentage?: number | null, discount_amount?: number | null, product?: { __typename?: 'ProductEntityResponse', data?: { __typename?: 'ProductEntity', id?: string | null, attributes?: { __typename?: 'Product', title: string, price: number } | null } | null } | null } | null> | null } | null }> } | null } | null }> } | null };

export type GetCrmLinksIdentifiersQueryVariables = Exact<{
  filters?: InputMaybe<CrmLinkFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
}>;


export type GetCrmLinksIdentifiersQuery = { __typename?: 'Query', crmLinks?: { __typename?: 'CrmLinkEntityResponseCollection', data: Array<{ __typename?: 'CrmLinkEntity', id?: string | null, attributes?: { __typename?: 'CrmLink', identifier: string } | null }> } | null };

export type GetCrmCampaignUserTasksQueryVariables = Exact<{
  filters?: InputMaybe<CampaignFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  crmTasksFilters?: InputMaybe<CrmTaskFiltersInput>;
  crmTasksPagination?: InputMaybe<PaginationArg>;
  crmTasksSort?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  usersWithRolesFilters?: InputMaybe<ComponentCrmDataCrmAccountRoleFiltersInput>;
  usersWithRolesPagination?: InputMaybe<PaginationArg>;
  usersWithRolesSort?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
}>;


export type GetCrmCampaignUserTasksQuery = { __typename?: 'Query', campaigns?: { __typename?: 'CampaignEntityResponseCollection', data: Array<{ __typename?: 'CampaignEntity', id?: string | null, attributes?: { __typename?: 'Campaign', slug?: string | null, users_with_roles?: Array<{ __typename?: 'ComponentCrmDataCrmAccountRole', id: string, user?: { __typename?: 'UsersPermissionsUserEntityResponse', data?: { __typename?: 'UsersPermissionsUserEntity', id?: string | null, attributes?: { __typename?: 'UsersPermissionsUser', crm_tasks?: { __typename?: 'CrmTaskRelationResponseCollection', data: Array<{ __typename?: 'CrmTaskEntity', id?: string | null, attributes?: { __typename?: 'CrmTask', createdAt?: any | null, status: Enum_Crmtask_Status, type?: Enum_Crmtask_Type | null, dueDate: any, title: string, meeting_url?: string | null, assignee?: { __typename?: 'UsersPermissionsUserEntityResponse', data?: { __typename?: 'UsersPermissionsUserEntity', id?: string | null, attributes?: { __typename?: 'UsersPermissionsUser', firstName?: string | null, lastName?: string | null } | null } | null } | null, crm_campaign_member?: { __typename?: 'CrmCampaignMemberEntityResponse', data?: { __typename?: 'CrmCampaignMemberEntity', id?: string | null, attributes?: { __typename?: 'CrmCampaignMember', crm_contact?: { __typename?: 'ContactEntityResponse', data?: { __typename?: 'ContactEntity', id?: string | null, attributes?: { __typename?: 'Contact', firstName?: string | null, lastName?: string | null, email: string } | null } | null } | null } | null } | null } | null, crm_link?: { __typename?: 'CrmLinkEntityResponse', data?: { __typename?: 'CrmLinkEntity', id?: string | null } | null } | null, feedback?: { __typename?: 'CrmTaskFeedbackEntityResponse', data?: { __typename?: 'CrmTaskFeedbackEntity', id?: string | null, attributes?: { __typename?: 'CrmTaskFeedback', createdAt?: any | null, crm_reports?: any | null, name?: string | null, task_type?: Enum_Crmtaskfeedback_Task_Type | null } | null } | null } | null } | null }> } | null } | null } | null } | null } | null> | null } | null }>, meta: { __typename?: 'ResponseCollectionMeta', pagination: { __typename?: 'Pagination', page: number, pageCount: number, pageSize: number, total: number } } } | null };

export type GetCrmUsersQueryVariables = Exact<{
  filters?: InputMaybe<CampaignFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  usersWithRolesFilters?: InputMaybe<ComponentCrmDataCrmAccountRoleFiltersInput>;
  usersWithRolesPagination?: InputMaybe<PaginationArg>;
}>;


export type GetCrmUsersQuery = { __typename?: 'Query', campaigns?: { __typename?: 'CampaignEntityResponseCollection', data: Array<{ __typename?: 'CampaignEntity', id?: string | null, attributes?: { __typename?: 'Campaign', name: string, users_with_roles?: Array<{ __typename?: 'ComponentCrmDataCrmAccountRole', id: string, user?: { __typename?: 'UsersPermissionsUserEntityResponse', data?: { __typename?: 'UsersPermissionsUserEntity', id?: string | null, attributes?: { __typename?: 'UsersPermissionsUser', email: string, firstName?: string | null, lastName?: string | null } | null } | null } | null, roles?: { __typename?: 'CrmRoleRelationResponseCollection', data: Array<{ __typename?: 'CrmRoleEntity', id?: string | null, attributes?: { __typename?: 'CrmRole', name: string, permissions?: any | null, contact_sources?: { __typename?: 'CrmContactSourceRelationResponseCollection', data: Array<{ __typename?: 'CrmContactSourceEntity', id?: string | null, attributes?: { __typename?: 'CrmContactSource', name: string } | null }> } | null } | null }> } | null } | null> | null } | null }> } | null };

export type GetCrmSingleLinkQueryVariables = Exact<{
  crmLinkId: Scalars['ID'];
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  ordersFilters?: InputMaybe<OrderFiltersInput>;
  ordersPagination?: InputMaybe<PaginationArg>;
  ordersSort?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  productsFilters?: InputMaybe<ProductFiltersInput>;
  productsPagination?: InputMaybe<PaginationArg>;
  productsSort?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
}>;


export type GetCrmSingleLinkQuery = { __typename?: 'Query', crmLink?: { __typename?: 'CrmLinkEntityResponse', data?: { __typename?: 'CrmLinkEntity', id?: string | null, attributes?: { __typename?: 'CrmLink', createdAt?: any | null, identifier: string, updatedAt?: any | null, crm_campaign?: { __typename?: 'CampaignEntityResponse', data?: { __typename?: 'CampaignEntity', id?: string | null } | null } | null, crm_campaign_member?: { __typename?: 'CrmCampaignMemberEntityResponse', data?: { __typename?: 'CrmCampaignMemberEntity', id?: string | null } | null } | null, crm_campaign_member_account_roles?: Array<{ __typename?: 'ComponentCrmDataCrmAccountPercentage', id: string, roles?: { __typename?: 'CrmRoleRelationResponseCollection', data: Array<{ __typename?: 'CrmRoleEntity', id?: string | null, attributes?: { __typename?: 'CrmRole', name: string, slug?: string | null, sales_commision?: number | null } | null }> } | null, user?: { __typename?: 'UsersPermissionsUserEntityResponse', data?: { __typename?: 'UsersPermissionsUserEntity', id?: string | null } | null } | null } | null> | null, crm_task?: { __typename?: 'CrmTaskEntityResponse', data?: { __typename?: 'CrmTaskEntity', id?: string | null } | null } | null, orders?: { __typename?: 'OrderRelationResponseCollection', data: Array<{ __typename?: 'OrderEntity', id?: string | null, attributes?: { __typename?: 'Order', total_price: number } | null }> } | null, utm_data?: { __typename?: 'ComponentCrmDataUtmData', id: string, utm_campaign?: string | null, utm_id?: string | null, utm_medium?: Enum_Componentcrmdatautmdata_Utm_Medium | null, utm_source?: Enum_Componentcrmdatautmdata_Utm_Source | null } | null, products?: { __typename?: 'ProductRelationResponseCollection', data: Array<{ __typename?: 'ProductEntity', id?: string | null }> } | null } | null } | null } | null };

export type GetCrmCampaignMembersQueryVariables = Exact<{
  filters?: InputMaybe<CampaignFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  crmCampaignMembersFilters?: InputMaybe<CrmCampaignMemberFiltersInput>;
  crmCampaignMembersPagination?: InputMaybe<PaginationArg>;
  crmCampaignMembersSort?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  accountRolesFilters?: InputMaybe<ComponentCrmDataCrmAccountRoleFiltersInput>;
  accountRolesPagination?: InputMaybe<PaginationArg>;
  accountRolesSort?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  rolesFilters?: InputMaybe<CrmRoleFiltersInput>;
  rolesPagination?: InputMaybe<PaginationArg>;
  rolesSort?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
}>;


export type GetCrmCampaignMembersQuery = { __typename?: 'Query', campaigns?: { __typename?: 'CampaignEntityResponseCollection', data: Array<{ __typename?: 'CampaignEntity', id?: string | null, attributes?: { __typename?: 'Campaign', crm_campaign_members?: { __typename?: 'CrmCampaignMemberRelationResponseCollection', data: Array<{ __typename?: 'CrmCampaignMemberEntity', id?: string | null, attributes?: { __typename?: 'CrmCampaignMember', statusUpdatedAt?: any | null, users_with_roles?: Array<{ __typename?: 'ComponentCrmDataCrmAccountRole', id: string, user?: { __typename?: 'UsersPermissionsUserEntityResponse', data?: { __typename?: 'UsersPermissionsUserEntity', id?: string | null, attributes?: { __typename?: 'UsersPermissionsUser', email: string } | null } | null } | null, roles?: { __typename?: 'CrmRoleRelationResponseCollection', data: Array<{ __typename?: 'CrmRoleEntity', id?: string | null, attributes?: { __typename?: 'CrmRole', name: string } | null }> } | null } | null> | null, crm_contact?: { __typename?: 'ContactEntityResponse', data?: { __typename?: 'ContactEntity', id?: string | null, attributes?: { __typename?: 'Contact', firstName?: string | null, lastName?: string | null, phoneNumber?: string | null, email: string } | null } | null } | null, status?: { __typename?: 'CrmCampaignMemberStatusEntityResponse', data?: { __typename?: 'CrmCampaignMemberStatusEntity', id?: string | null, attributes?: { __typename?: 'CrmCampaignMemberStatus', createdAt?: any | null, description?: string | null, name: string } | null } | null } | null } | null }> } | null } | null }> } | null };

export type CrmSingleMemberQueryVariables = Exact<{
  crmCampaignMemberId: Scalars['ID'];
  filters?: InputMaybe<CrmTaskFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  accountRolesFilters?: InputMaybe<ComponentCrmDataCrmAccountRoleFiltersInput>;
  accountRolesPagination?: InputMaybe<PaginationArg>;
  accountRolesSort?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  rolesFilters2?: InputMaybe<CrmRoleFiltersInput>;
  rolesPagination2?: InputMaybe<PaginationArg>;
  rolesSort2?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  completedActionsFilters?: InputMaybe<ComponentCrmDataCrmActionsFiltersInput>;
  completedActionsPagination?: InputMaybe<PaginationArg>;
  completedActionsSort?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
}>;


export type CrmSingleMemberQuery = { __typename?: 'Query', crmCampaignMember?: { __typename?: 'CrmCampaignMemberEntityResponse', data?: { __typename?: 'CrmCampaignMemberEntity', id?: string | null, attributes?: { __typename?: 'CrmCampaignMember', info?: string | null, crm_contact?: { __typename?: 'ContactEntityResponse', data?: { __typename?: 'ContactEntity', id?: string | null, attributes?: { __typename?: 'Contact', email: string, firstName?: string | null, lastName?: string | null, phoneNumber?: string | null, completed_actions?: Array<{ __typename?: 'ComponentCrmDataCrmActions', action_date?: any | null, action_name: Enum_Componentcrmdatacrmactions_Action_Name, action_info?: string | null, id: string } | null> | null } | null } | null } | null, crm_tasks?: { __typename?: 'CrmTaskRelationResponseCollection', data: Array<{ __typename?: 'CrmTaskEntity', id?: string | null, attributes?: { __typename?: 'CrmTask', title: string, status: Enum_Crmtask_Status, feedback?: { __typename?: 'CrmTaskFeedbackEntityResponse', data?: { __typename?: 'CrmTaskFeedbackEntity', id?: string | null, attributes?: { __typename?: 'CrmTaskFeedback', name?: string | null, task_type?: Enum_Crmtaskfeedback_Task_Type | null } | null } | null } | null } | null }> } | null, users_with_roles?: Array<{ __typename?: 'ComponentCrmDataCrmAccountRole', id: string, user?: { __typename?: 'UsersPermissionsUserEntityResponse', data?: { __typename?: 'UsersPermissionsUserEntity', id?: string | null, attributes?: { __typename?: 'UsersPermissionsUser', email: string } | null } | null } | null, roles?: { __typename?: 'CrmRoleRelationResponseCollection', data: Array<{ __typename?: 'CrmRoleEntity', id?: string | null, attributes?: { __typename?: 'CrmRole', name: string, slug?: string | null } | null }> } | null } | null> | null, crm_campaign?: { __typename?: 'CampaignEntityResponse', data?: { __typename?: 'CampaignEntity', id?: string | null } | null } | null, status?: { __typename?: 'CrmCampaignMemberStatusEntityResponse', data?: { __typename?: 'CrmCampaignMemberStatusEntity', id?: string | null, attributes?: { __typename?: 'CrmCampaignMemberStatus', createdAt?: any | null, description?: string | null, name: string } | null } | null } | null, reservations?: { __typename?: 'ReservationRelationResponseCollection', data: Array<{ __typename?: 'ReservationEntity', id?: string | null, attributes?: { __typename?: 'Reservation', title: string, status?: Enum_Reservation_Status | null } | null }> } | null } | null } | null } | null };

export type GetCrmRolesQueryVariables = Exact<{
  filters?: InputMaybe<CrmRoleFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
}>;


export type GetCrmRolesQuery = { __typename?: 'Query', crmRoles?: { __typename?: 'CrmRoleEntityResponseCollection', data: Array<{ __typename?: 'CrmRoleEntity', id?: string | null, attributes?: { __typename?: 'CrmRole', name: string, permissions?: any | null, sales_commision?: number | null, slug?: string | null } | null }> } | null };

export type GetCrmSingleContactQueryVariables = Exact<{
  contactId: Scalars['ID'];
  completedActionsfilters?: InputMaybe<ComponentCrmDataCrmActionsFiltersInput>;
  completedActionspagination?: InputMaybe<PaginationArg>;
  completedActionssort?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  campaignMembersFilters?: InputMaybe<CrmCampaignMemberFiltersInput>;
  campaignMembersPagination?: InputMaybe<PaginationArg>;
}>;


export type GetCrmSingleContactQuery = { __typename?: 'Query', contact?: { __typename?: 'ContactEntityResponse', data?: { __typename?: 'ContactEntity', id?: string | null, attributes?: { __typename?: 'Contact', acId?: string | null, age?: number | null, createdAt?: any | null, date?: any | null, email: string, firstName?: string | null, info?: string | null, lastName?: string | null, phoneNumber?: string | null, updatedAt?: any | null, completed_actions?: Array<{ __typename?: 'ComponentCrmDataCrmActions', action_info?: string | null, action_date?: any | null, action_name: Enum_Componentcrmdatacrmactions_Action_Name, id: string } | null> | null, contact_source?: { __typename?: 'CrmContactSourceEntityResponse', data?: { __typename?: 'CrmContactSourceEntity', id?: string | null, attributes?: { __typename?: 'CrmContactSource', name: string } | null } | null } | null, user?: { __typename?: 'UsersPermissionsUserEntityResponse', data?: { __typename?: 'UsersPermissionsUserEntity', id?: string | null, attributes?: { __typename?: 'UsersPermissionsUser', email: string } | null } | null } | null, crm_campaign_members?: { __typename?: 'CrmCampaignMemberRelationResponseCollection', data: Array<{ __typename?: 'CrmCampaignMemberEntity', id?: string | null }> } | null } | null } | null } | null };

export type GetCampaignsIdsQueryVariables = Exact<{
  filters?: InputMaybe<CampaignFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
}>;


export type GetCampaignsIdsQuery = { __typename?: 'Query', campaigns?: { __typename?: 'CampaignEntityResponseCollection', data: Array<{ __typename?: 'CampaignEntity', id?: string | null, attributes?: { __typename?: 'Campaign', name: string, slug?: string | null } | null }> } | null };

export type GetProductsIdsQueryVariables = Exact<{
  filters?: InputMaybe<ProductFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
}>;


export type GetProductsIdsQuery = { __typename?: 'Query', products?: { __typename?: 'ProductEntityResponseCollection', data: Array<{ __typename?: 'ProductEntity', id?: string | null, attributes?: { __typename?: 'Product', title: string, price: number } | null }> } | null };

export type GetProductsFromCampaignQueryVariables = Exact<{
  campaignId: Scalars['ID'];
  filters?: InputMaybe<ProductFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
}>;


export type GetProductsFromCampaignQuery = { __typename?: 'Query', campaign?: { __typename?: 'CampaignEntityResponse', data?: { __typename?: 'CampaignEntity', id?: string | null, attributes?: { __typename?: 'Campaign', products?: { __typename?: 'ProductRelationResponseCollection', data: Array<{ __typename?: 'ProductEntity', id?: string | null, attributes?: { __typename?: 'Product', title: string, price: number } | null }> } | null } | null } | null } | null };

export type GetCrmTaskFeedbacksQueryVariables = Exact<{
  filters?: InputMaybe<CrmTaskFeedbackFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
}>;


export type GetCrmTaskFeedbacksQuery = { __typename?: 'Query', crmTaskFeedbacks?: { __typename?: 'CrmTaskFeedbackEntityResponseCollection', data: Array<{ __typename?: 'CrmTaskFeedbackEntity', id?: string | null, attributes?: { __typename?: 'CrmTaskFeedback', createdAt?: any | null, crm_reports?: any | null, name?: string | null, task_type?: Enum_Crmtaskfeedback_Task_Type | null, updatedAt?: any | null } | null }> } | null };

export type GetAllCampaignMemberStatusesQueryVariables = Exact<{
  filters?: InputMaybe<CrmCampaignMemberStatusFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
}>;


export type GetAllCampaignMemberStatusesQuery = { __typename?: 'Query', crmCampaignMemberStatuses?: { __typename?: 'CrmCampaignMemberStatusEntityResponseCollection', data: Array<{ __typename?: 'CrmCampaignMemberStatusEntity', id?: string | null, attributes?: { __typename?: 'CrmCampaignMemberStatus', auto_assign_on_action?: any | null, createdAt?: any | null, description?: string | null, name: string } | null }> } | null };

export type GetCrmContactsQueryVariables = Exact<{
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  filters?: InputMaybe<ContactFiltersInput>;
  crmCampaignMembersPagination?: InputMaybe<PaginationArg>;
  crmCampaignMembersFilters?: InputMaybe<CrmCampaignMemberFiltersInput>;
  crmCampaignMembersSort?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
}>;


export type GetCrmContactsQuery = { __typename?: 'Query', contacts?: { __typename?: 'ContactEntityResponseCollection', meta: { __typename?: 'ResponseCollectionMeta', pagination: { __typename?: 'Pagination', total: number, page: number, pageCount: number, pageSize: number } }, data: Array<{ __typename?: 'ContactEntity', id?: string | null, attributes?: { __typename?: 'Contact', firstName?: string | null, lastName?: string | null, info?: string | null, phoneNumber?: string | null, email: string, age?: number | null, contact_source?: { __typename?: 'CrmContactSourceEntityResponse', data?: { __typename?: 'CrmContactSourceEntity', id?: string | null, attributes?: { __typename?: 'CrmContactSource', name: string } | null } | null } | null, crm_campaign_members?: { __typename?: 'CrmCampaignMemberRelationResponseCollection', data: Array<{ __typename?: 'CrmCampaignMemberEntity', id?: string | null, attributes?: { __typename?: 'CrmCampaignMember', statusUpdatedAt?: any | null, crm_campaign?: { __typename?: 'CampaignEntityResponse', data?: { __typename?: 'CampaignEntity', id?: string | null, attributes?: { __typename?: 'Campaign', name: string } | null } | null } | null, users_with_roles?: Array<{ __typename?: 'ComponentCrmDataCrmAccountRole', id: string, user?: { __typename?: 'UsersPermissionsUserEntityResponse', data?: { __typename?: 'UsersPermissionsUserEntity', id?: string | null, attributes?: { __typename?: 'UsersPermissionsUser', firstName?: string | null, lastName?: string | null } | null } | null } | null, roles?: { __typename?: 'CrmRoleRelationResponseCollection', data: Array<{ __typename?: 'CrmRoleEntity', id?: string | null, attributes?: { __typename?: 'CrmRole', name: string } | null }> } | null } | null> | null } | null }> } | null } | null }> } | null };

export type GetCrmFiltersContactsQueryVariables = Exact<{
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  filters?: InputMaybe<ContactFiltersInput>;
  completedActionsPagination?: InputMaybe<PaginationArg>;
  completedActionsFilters?: InputMaybe<ComponentCrmDataCrmActionsFiltersInput>;
}>;


export type GetCrmFiltersContactsQuery = { __typename?: 'Query', contacts?: { __typename?: 'ContactEntityResponseCollection', meta: { __typename?: 'ResponseCollectionMeta', pagination: { __typename?: 'Pagination', page: number, pageCount: number, total: number } }, data: Array<{ __typename?: 'ContactEntity', id?: string | null, attributes?: { __typename?: 'Contact', firstName?: string | null, lastName?: string | null, info?: string | null, phoneNumber?: string | null, email: string, contact_source?: { __typename?: 'CrmContactSourceEntityResponse', data?: { __typename?: 'CrmContactSourceEntity', id?: string | null, attributes?: { __typename?: 'CrmContactSource', name: string } | null } | null } | null, completed_actions?: Array<{ __typename?: 'ComponentCrmDataCrmActions', id: string, action_name: Enum_Componentcrmdatacrmactions_Action_Name, action_info?: string | null, action_date?: any | null } | null> | null } | null }> } | null };

export type GetCrmAllTasksQueryVariables = Exact<{
  filters?: InputMaybe<CrmTaskFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
}>;


export type GetCrmAllTasksQuery = { __typename?: 'Query', crmTasks?: { __typename?: 'CrmTaskEntityResponseCollection', data: Array<{ __typename?: 'CrmTaskEntity', id?: string | null, attributes?: { __typename?: 'CrmTask', createdAt?: any | null, status: Enum_Crmtask_Status, type?: Enum_Crmtask_Type | null, dueDate: any, title: string, meeting_url?: string | null, meeting_recording_url?: string | null, assignee?: { __typename?: 'UsersPermissionsUserEntityResponse', data?: { __typename?: 'UsersPermissionsUserEntity', id?: string | null, attributes?: { __typename?: 'UsersPermissionsUser', firstName?: string | null, lastName?: string | null } | null } | null } | null, crm_campaign_member?: { __typename?: 'CrmCampaignMemberEntityResponse', data?: { __typename?: 'CrmCampaignMemberEntity', id?: string | null, attributes?: { __typename?: 'CrmCampaignMember', crm_contact?: { __typename?: 'ContactEntityResponse', data?: { __typename?: 'ContactEntity', id?: string | null, attributes?: { __typename?: 'Contact', firstName?: string | null, lastName?: string | null, email: string } | null } | null } | null } | null } | null } | null, crm_link?: { __typename?: 'CrmLinkEntityResponse', data?: { __typename?: 'CrmLinkEntity', id?: string | null } | null } | null, feedback?: { __typename?: 'CrmTaskFeedbackEntityResponse', data?: { __typename?: 'CrmTaskFeedbackEntity', id?: string | null, attributes?: { __typename?: 'CrmTaskFeedback', createdAt?: any | null, crm_reports?: any | null, name?: string | null, task_type?: Enum_Crmtaskfeedback_Task_Type | null } | null } | null } | null } | null }>, meta: { __typename?: 'ResponseCollectionMeta', pagination: { __typename?: 'Pagination', page: number, pageCount: number, pageSize: number, total: number } } } | null };

export type GetCrmContactSourcesQueryVariables = Exact<{
  filters?: InputMaybe<CrmContactSourceFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
}>;


export type GetCrmContactSourcesQuery = { __typename?: 'Query', crmContactSources?: { __typename?: 'CrmContactSourceEntityResponseCollection', data: Array<{ __typename?: 'CrmContactSourceEntity', id?: string | null, attributes?: { __typename?: 'CrmContactSource', name: string, crm_roles?: { __typename?: 'CrmRoleRelationResponseCollection', data: Array<{ __typename?: 'CrmRoleEntity', id?: string | null, attributes?: { __typename?: 'CrmRole', name: string } | null }> } | null } | null }> } | null };

export type GetPromptTypesQueryVariables = Exact<{
  filters?: InputMaybe<PromptTypeFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
}>;


export type GetPromptTypesQuery = { __typename?: 'Query', promptTypes?: { __typename?: 'PromptTypeEntityResponseCollection', data: Array<{ __typename?: 'PromptTypeEntity', id?: string | null, attributes?: { __typename?: 'PromptType', type: string, prompt: string } | null }> } | null };

export type GetAllCampaignMembersIdsQueryVariables = Exact<{
  filters?: InputMaybe<CrmCampaignMemberFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
}>;


export type GetAllCampaignMembersIdsQuery = { __typename?: 'Query', crmCampaignMembers?: { __typename?: 'CrmCampaignMemberEntityResponseCollection', data: Array<{ __typename?: 'CrmCampaignMemberEntity', id?: string | null }> } | null };

export type UsersFromCampaignQueryVariables = Exact<{
  campaignId?: InputMaybe<Scalars['ID']>;
  filters?: InputMaybe<ComponentCrmDataCrmAccountRoleFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
}>;


export type UsersFromCampaignQuery = { __typename?: 'Query', campaign?: { __typename?: 'CampaignEntityResponse', data?: { __typename?: 'CampaignEntity', id?: string | null, attributes?: { __typename?: 'Campaign', users_with_roles?: Array<{ __typename?: 'ComponentCrmDataCrmAccountRole', id: string, user?: { __typename?: 'UsersPermissionsUserEntityResponse', data?: { __typename?: 'UsersPermissionsUserEntity', id?: string | null, attributes?: { __typename?: 'UsersPermissionsUser', firstName?: string | null, lastName?: string | null } | null } | null } | null, roles?: { __typename?: 'CrmRoleRelationResponseCollection', data: Array<{ __typename?: 'CrmRoleEntity', id?: string | null, attributes?: { __typename?: 'CrmRole', name: string } | null }> } | null } | null> | null } | null } | null } | null };

export type CampaignUsersWithRolesQueryVariables = Exact<{
  campaignId?: InputMaybe<Scalars['ID']>;
  filters?: InputMaybe<ComponentCrmDataCrmAccountRoleFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
}>;


export type CampaignUsersWithRolesQuery = { __typename?: 'Query', campaign?: { __typename?: 'CampaignEntityResponse', data?: { __typename?: 'CampaignEntity', id?: string | null, attributes?: { __typename?: 'Campaign', users_with_roles?: Array<{ __typename?: 'ComponentCrmDataCrmAccountRole', id: string, user?: { __typename?: 'UsersPermissionsUserEntityResponse', data?: { __typename?: 'UsersPermissionsUserEntity', id?: string | null, attributes?: { __typename?: 'UsersPermissionsUser', email: string } | null } | null } | null, roles?: { __typename?: 'CrmRoleRelationResponseCollection', data: Array<{ __typename?: 'CrmRoleEntity', id?: string | null, attributes?: { __typename?: 'CrmRole', name: string } | null }> } | null } | null> | null } | null } | null } | null };

export type ReservationUsersWithRolesQueryVariables = Exact<{
  reservationId?: InputMaybe<Scalars['ID']>;
  filters?: InputMaybe<ComponentCrmDataCrmAccountRoleFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
}>;


export type ReservationUsersWithRolesQuery = { __typename?: 'Query', reservation?: { __typename?: 'ReservationEntityResponse', data?: { __typename?: 'ReservationEntity', id?: string | null, attributes?: { __typename?: 'Reservation', crm_campaign_member?: { __typename?: 'CrmCampaignMemberEntityResponse', data?: { __typename?: 'CrmCampaignMemberEntity', id?: string | null, attributes?: { __typename?: 'CrmCampaignMember', users_with_roles?: Array<{ __typename?: 'ComponentCrmDataCrmAccountRole', id: string, user?: { __typename?: 'UsersPermissionsUserEntityResponse', data?: { __typename?: 'UsersPermissionsUserEntity', id?: string | null, attributes?: { __typename?: 'UsersPermissionsUser', email: string } | null } | null } | null, roles?: { __typename?: 'CrmRoleRelationResponseCollection', data: Array<{ __typename?: 'CrmRoleEntity', id?: string | null, attributes?: { __typename?: 'CrmRole', name: string } | null }> } | null } | null> | null } | null } | null } | null } | null } | null } | null };

export type CrmCampaignMemberUsersWithRolesQueryVariables = Exact<{
  crmCampaignMemberId?: InputMaybe<Scalars['ID']>;
  filters?: InputMaybe<ComponentCrmDataCrmAccountRoleFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
}>;


export type CrmCampaignMemberUsersWithRolesQuery = { __typename?: 'Query', crmCampaignMember?: { __typename?: 'CrmCampaignMemberEntityResponse', data?: { __typename?: 'CrmCampaignMemberEntity', id?: string | null, attributes?: { __typename?: 'CrmCampaignMember', users_with_roles?: Array<{ __typename?: 'ComponentCrmDataCrmAccountRole', id: string, user?: { __typename?: 'UsersPermissionsUserEntityResponse', data?: { __typename?: 'UsersPermissionsUserEntity', id?: string | null, attributes?: { __typename?: 'UsersPermissionsUser', email: string } | null } | null } | null, roles?: { __typename?: 'CrmRoleRelationResponseCollection', data: Array<{ __typename?: 'CrmRoleEntity', id?: string | null, attributes?: { __typename?: 'CrmRole', name: string } | null }> } | null } | null> | null } | null } | null } | null };

export type UserWithRolesFieldsFragment = { __typename?: 'ComponentCrmDataCrmAccountRole', id: string, user?: { __typename?: 'UsersPermissionsUserEntityResponse', data?: { __typename?: 'UsersPermissionsUserEntity', id?: string | null, attributes?: { __typename?: 'UsersPermissionsUser', email: string } | null } | null } | null, roles?: { __typename?: 'CrmRoleRelationResponseCollection', data: Array<{ __typename?: 'CrmRoleEntity', id?: string | null, attributes?: { __typename?: 'CrmRole', name: string } | null }> } | null };

export type MeQueryVariables = Exact<{ [key: string]: never; }>;


export type MeQuery = { __typename?: 'Query', me?: { __typename?: 'UsersPermissionsMe', id: string, username: string, email?: string | null, confirmed?: boolean | null, blocked?: boolean | null, firstName?: string | null, lastName?: string | null, role?: { __typename?: 'UsersPermissionsMeRole', id: string, name: string, type?: string | null } | null } | null };

export type PermissionMatrixUsersPermissionsUserQueryVariables = Exact<{
  usersPermissionsUserId?: InputMaybe<Scalars['ID']>;
  pagination?: InputMaybe<PaginationArg>;
}>;


export type PermissionMatrixUsersPermissionsUserQuery = { __typename?: 'Query', usersPermissionsUser?: { __typename?: 'UsersPermissionsUserEntityResponse', data?: { __typename?: 'UsersPermissionsUserEntity', id?: string | null, attributes?: { __typename?: 'UsersPermissionsUser', crm_profile?: { __typename?: 'ComponentCrmDataCrmUserProfile', id: string, crm_roles?: { __typename?: 'CrmRoleRelationResponseCollection', data: Array<{ __typename?: 'CrmRoleEntity', id?: string | null, attributes?: { __typename?: 'CrmRole', name: string, permissions?: any | null } | null }> } | null } | null } | null } | null } | null };

export type UsersPermissionsUserQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type UsersPermissionsUserQuery = { __typename?: 'Query', usersPermissionsUser?: { __typename?: 'UsersPermissionsUserEntityResponse', data?: { __typename?: 'UsersPermissionsUserEntity', id?: string | null, attributes?: { __typename?: 'UsersPermissionsUser', username: string, email: string, confirmed?: boolean | null, blocked?: boolean | null, firstName?: string | null, lastName?: string | null, createdAt?: any | null, role?: { __typename?: 'UsersPermissionsRoleEntityResponse', data?: { __typename?: 'UsersPermissionsRoleEntity', attributes?: { __typename?: 'UsersPermissionsRole', name: string, type?: string | null } | null } | null } | null } | null } | null } | null };

export type CheckUsernameQueryVariables = Exact<{
  filters?: InputMaybe<UsersPermissionsUserFiltersInput>;
}>;


export type CheckUsernameQuery = { __typename?: 'Query', usersPermissionsUsers?: { __typename?: 'UsersPermissionsUserEntityResponseCollection', data: Array<{ __typename?: 'UsersPermissionsUserEntity', attributes?: { __typename?: 'UsersPermissionsUser', username: string } | null }> } | null };

export type PermissionUserQueryVariables = Exact<{
  usersPermissionsUserId?: InputMaybe<Scalars['ID']>;
}>;


export type PermissionUserQuery = { __typename?: 'Query', usersPermissionsUser?: { __typename?: 'UsersPermissionsUserEntityResponse', data?: { __typename?: 'UsersPermissionsUserEntity', id?: string | null, attributes?: { __typename?: 'UsersPermissionsUser', crm_profile?: { __typename?: 'ComponentCrmDataCrmUserProfile', id: string, crm_roles?: { __typename?: 'CrmRoleRelationResponseCollection', data: Array<{ __typename?: 'CrmRoleEntity', id?: string | null, attributes?: { __typename?: 'CrmRole', permissions?: any | null } | null }> } | null } | null } | null } | null } | null };

export type MenuQueryVariables = Exact<{
  menuId?: InputMaybe<Scalars['ID']>;
  filters?: InputMaybe<MenuPageFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
}>;


export type MenuQuery = { __typename?: 'Query', menu?: { __typename?: 'MenuEntityResponse', data?: { __typename?: 'MenuEntity', id?: string | null, attributes?: { __typename?: 'Menu', title: string, slug?: string | null, generate_nutritional_info_pages?: boolean | null, nutritional_information_dimension?: string | null, title_dimension?: string | null, description_dimension?: string | null, nutritional_information_background?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', url: string } | null } | null } | null, nutritional_information_background_2?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', url: string } | null } | null } | null, print_catalog_pages?: { __typename?: 'MenuPageRelationResponseCollection', data: Array<{ __typename?: 'MenuPageEntity', id?: string | null, attributes?: { __typename?: 'MenuPage', title_dimension?: string | null, description_dimension?: string | null, space_1?: number | null, space_2?: number | null, space_3?: number | null, space_4?: number | null, alignement?: Enum_Menupage_Alignement | null, footer_text?: string | null, background_image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null } | null } | null } | null, left_column_content?: Array<{ __typename?: 'ComponentMenuCategoryItem', id: string, color?: string | null, entire_row?: boolean | null, description_dimension?: string | null, title_dimension?: string | null, product_category?: { __typename?: 'ProductCategoryEntityResponse', data?: { __typename?: 'ProductCategoryEntity', id?: string | null, attributes?: { __typename?: 'ProductCategory', name: string } | null } | null } | null } | { __typename?: 'ComponentMenuEmptySpace', id: string, size?: number | null } | { __typename?: 'ComponentMenuPhoto', id: string, entire_row?: boolean | null, media: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', url: string } | null } | null } } | { __typename?: 'ComponentMenuProductItem', id: string, available?: boolean | null, show_picture?: boolean | null, show_weight?: boolean | null, space_1?: number | null, space_2?: number | null, space_3?: number | null, space_4?: number | null, price_type?: Enum_Componentmenuproductitem_Price_Type | null, price_per_100g?: boolean | null, entire_row?: boolean | null, title_dimension?: string | null, description_dimension?: string | null, product?: { __typename?: 'ProductEntityResponse', data?: { __typename?: 'ProductEntity', id?: string | null, attributes?: { __typename?: 'Product', title: string, weight?: number | null, price: number, description?: string | null, nutritional_information?: string | null, ingredients?: { __typename?: 'IngredientRelationResponseCollection', data: Array<{ __typename?: 'IngredientEntity', id?: string | null, attributes?: { __typename?: 'Ingredient', name: string, allergens?: { __typename?: 'AllergenRelationResponseCollection', data: Array<{ __typename?: 'AllergenEntity', id?: string | null, attributes?: { __typename?: 'Allergen', name: string } | null }> } | null } | null }> } | null, media?: { __typename?: 'UploadFileRelationResponseCollection', data: Array<{ __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, url: string } | null }> } | null } | null } | null } | null } | { __typename?: 'Error' } | null> | null, right_column_content?: Array<{ __typename?: 'ComponentMenuCategoryItem', id: string, color?: string | null, entire_row?: boolean | null, description_dimension?: string | null, title_dimension?: string | null, product_category?: { __typename?: 'ProductCategoryEntityResponse', data?: { __typename?: 'ProductCategoryEntity', id?: string | null, attributes?: { __typename?: 'ProductCategory', name: string } | null } | null } | null } | { __typename?: 'ComponentMenuEmptySpace', id: string, size?: number | null } | { __typename?: 'ComponentMenuPhoto', id: string, entire_row?: boolean | null, media: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', url: string } | null } | null } } | { __typename?: 'ComponentMenuProductItem', id: string, available?: boolean | null, show_picture?: boolean | null, show_weight?: boolean | null, space_1?: number | null, space_2?: number | null, space_3?: number | null, space_4?: number | null, price_type?: Enum_Componentmenuproductitem_Price_Type | null, price_per_100g?: boolean | null, entire_row?: boolean | null, title_dimension?: string | null, description_dimension?: string | null, product?: { __typename?: 'ProductEntityResponse', data?: { __typename?: 'ProductEntity', id?: string | null, attributes?: { __typename?: 'Product', title: string, weight?: number | null, price: number, description?: string | null, nutritional_information?: string | null, ingredients?: { __typename?: 'IngredientRelationResponseCollection', data: Array<{ __typename?: 'IngredientEntity', id?: string | null, attributes?: { __typename?: 'Ingredient', name: string, allergens?: { __typename?: 'AllergenRelationResponseCollection', data: Array<{ __typename?: 'AllergenEntity', id?: string | null, attributes?: { __typename?: 'Allergen', name: string } | null }> } | null } | null }> } | null, media?: { __typename?: 'UploadFileRelationResponseCollection', data: Array<{ __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, url: string } | null }> } | null } | null } | null } | null } | { __typename?: 'Error' } | null> | null } | null }> } | null } | null } | null } | null };

export type WebCatalogMenuQueryVariables = Exact<{
  menuId?: InputMaybe<Scalars['ID']>;
  filters?: InputMaybe<ProductFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
}>;


export type WebCatalogMenuQuery = { __typename?: 'Query', menu?: { __typename?: 'MenuEntityResponse', data?: { __typename?: 'MenuEntity', id?: string | null, attributes?: { __typename?: 'Menu', title: string, slug?: string | null, title_dimension?: string | null, description_dimension?: string | null, nutritional_information_dimension?: string | null, web_catalog_items?: { __typename?: 'ProductRelationResponseCollection', data: Array<{ __typename?: 'ProductEntity', id?: string | null, attributes?: { __typename?: 'Product', title: string, description?: string | null, price: number, media?: { __typename?: 'UploadFileRelationResponseCollection', data: Array<{ __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', url: string } | null }> } | null, category?: { __typename?: 'ProductCategoryEntityResponse', data?: { __typename?: 'ProductCategoryEntity', id?: string | null, attributes?: { __typename?: 'ProductCategory', name: string } | null } | null } | null } | null }> } | null, nutritional_information_background?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', url: string } | null } | null } | null, nutritional_information_background_2?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', url: string } | null } | null } | null } | null } | null } | null };

export type ProductItemFieldsFragment = { __typename?: 'ComponentMenuProductItem', id: string, available?: boolean | null, show_picture?: boolean | null, show_weight?: boolean | null, space_1?: number | null, space_2?: number | null, space_3?: number | null, space_4?: number | null, price_type?: Enum_Componentmenuproductitem_Price_Type | null, price_per_100g?: boolean | null, entire_row?: boolean | null, title_dimension?: string | null, description_dimension?: string | null, product?: { __typename?: 'ProductEntityResponse', data?: { __typename?: 'ProductEntity', id?: string | null, attributes?: { __typename?: 'Product', title: string, weight?: number | null, price: number, description?: string | null, nutritional_information?: string | null, ingredients?: { __typename?: 'IngredientRelationResponseCollection', data: Array<{ __typename?: 'IngredientEntity', id?: string | null, attributes?: { __typename?: 'Ingredient', name: string, allergens?: { __typename?: 'AllergenRelationResponseCollection', data: Array<{ __typename?: 'AllergenEntity', id?: string | null, attributes?: { __typename?: 'Allergen', name: string } | null }> } | null } | null }> } | null, media?: { __typename?: 'UploadFileRelationResponseCollection', data: Array<{ __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, url: string } | null }> } | null } | null } | null } | null };

export type EmptySpaceFieldsFragment = { __typename?: 'ComponentMenuEmptySpace', id: string, size?: number | null };

export type CategoryItemFieldsFragment = { __typename?: 'ComponentMenuCategoryItem', id: string, color?: string | null, entire_row?: boolean | null, description_dimension?: string | null, title_dimension?: string | null, product_category?: { __typename?: 'ProductCategoryEntityResponse', data?: { __typename?: 'ProductCategoryEntity', id?: string | null, attributes?: { __typename?: 'ProductCategory', name: string } | null } | null } | null };

export type MenuPhotoFieldsFragment = { __typename?: 'ComponentMenuPhoto', id: string, entire_row?: boolean | null, media: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', url: string } | null } | null } };

export type MenusQueryVariables = Exact<{
  filters?: InputMaybe<MenuFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
}>;


export type MenusQuery = { __typename?: 'Query', menus?: { __typename?: 'MenuEntityResponseCollection', data: Array<{ __typename?: 'MenuEntity', id?: string | null, attributes?: { __typename?: 'Menu', title: string } | null }> } | null };

export type UserBasicInfoMeFragment = { __typename?: 'UsersPermissionsMe', id: string, username: string, email?: string | null, confirmed?: boolean | null, blocked?: boolean | null, role?: { __typename?: 'UsersPermissionsMeRole', id: string, name: string, description?: string | null, type?: string | null } | null };

export type RegisterMutationVariables = Exact<{
  input: UsersPermissionsRegisterInput;
}>;


export type RegisterMutation = { __typename?: 'Mutation', register: { __typename?: 'UsersPermissionsLoginPayload', jwt?: string | null, user: { __typename?: 'UsersPermissionsMe', id: string, username: string, email?: string | null, confirmed?: boolean | null, blocked?: boolean | null, role?: { __typename?: 'UsersPermissionsMeRole', id: string, name: string, description?: string | null, type?: string | null } | null } } };

export type ResetPasswordMutationVariables = Exact<{
  password: Scalars['String'];
  passwordConfirmation: Scalars['String'];
  code: Scalars['String'];
}>;


export type ResetPasswordMutation = { __typename?: 'Mutation', resetPassword?: { __typename?: 'UsersPermissionsLoginPayload', jwt?: string | null, user: { __typename?: 'UsersPermissionsMe', id: string, username: string, email?: string | null, confirmed?: boolean | null, blocked?: boolean | null, role?: { __typename?: 'UsersPermissionsMeRole', id: string, name: string, description?: string | null, type?: string | null } | null } } | null };

export type LoginMutationVariables = Exact<{
  input: UsersPermissionsLoginInput;
}>;


export type LoginMutation = { __typename?: 'Mutation', login: { __typename?: 'UsersPermissionsLoginPayload', jwt?: string | null, user: { __typename?: 'UsersPermissionsMe', id: string, username: string, email?: string | null, confirmed?: boolean | null, blocked?: boolean | null, role?: { __typename?: 'UsersPermissionsMeRole', id: string, name: string, description?: string | null, type?: string | null } | null } } };

export type ForgotPasswordMutationVariables = Exact<{
  email: Scalars['String'];
}>;


export type ForgotPasswordMutation = { __typename?: 'Mutation', forgotPassword?: { __typename?: 'UsersPermissionsPasswordPayload', ok: boolean } | null };

export type EmailConfirmationMutationVariables = Exact<{
  confirmation: Scalars['String'];
}>;


export type EmailConfirmationMutation = { __typename?: 'Mutation', emailConfirmation?: { __typename?: 'UsersPermissionsLoginPayload', jwt?: string | null, user: { __typename?: 'UsersPermissionsMe', id: string, username: string, email?: string | null, confirmed?: boolean | null, blocked?: boolean | null, role?: { __typename?: 'UsersPermissionsMeRole', id: string, name: string, description?: string | null, type?: string | null } | null } } | null };

export type SendEmailConfirmationMutationVariables = Exact<{
  email: Scalars['String'];
}>;


export type SendEmailConfirmationMutation = { __typename?: 'Mutation', sendEmailConfirmation?: boolean | null };

export type SaveCapturedContactMutationVariables = Exact<{
  input: CapturedContactInput;
  recaptcha: Scalars['String'];
}>;


export type SaveCapturedContactMutation = { __typename?: 'Mutation', saveCapturedContact?: boolean | null };

export type ProcessFormQuestionMutationVariables = Exact<{
  rfid: Scalars['String'];
  questionId: Scalars['ID'];
}>;


export type ProcessFormQuestionMutation = { __typename?: 'Mutation', processFormQuestion?: number | null };

export type HeaderSectionComponentFragment = { __typename?: 'ComponentCmsDataHeaderSection', id: string, helloBarContent?: string | null, HeaderSectionButton?: { __typename?: 'ComponentCmsDataButton', id: string, text: string, url: string } | null, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, url: string } | null } | null } | null };

export type HeroSectionComponentFragment = { __typename?: 'ComponentCmsDataHeroSection', id: string, mainTitle: string, bgColor?: string | null, box?: boolean | null, boxColor?: string | null, textColor?: string | null, textShadow?: boolean | null, DataHeroSectionSecondaryTitle?: string | null, HeroSectionTopTitle?: string | null, HeroSectionButton?: { __typename?: 'ComponentCmsDataButton', id: string, text: string, url: string } | null, countDownTimer?: { __typename?: 'ComponentCmsDataCountDownTimer', id: string, description?: string | null, endDate?: any | null } | null, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null } | null } | null } | null, mobileImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null } | null } | null } | null };

export type IconCardsSectionComponentFragment = { __typename?: 'ComponentCmsDataIconCardsSection', mainTitle: string, subTitle: string, id: string, centerText?: boolean | null, showAppButton?: boolean | null, hasExclamationMark?: boolean | null, backgroundColor?: string | null, IconCardsSectionTopTitle: string, iconCards: Array<{ __typename?: 'ComponentCmsDataIconCard', iconName: string, id: string, large?: boolean | null, subTitle?: string | null, title: string } | null>, IconCardsSectionButtons?: Array<{ __typename?: 'ComponentCmsDataButton', id: string, text: string, url: string } | null> | null };

export type HeroSectionSliderComponentFragment = { __typename?: 'ComponentCmsDataHeroSectionSlider', id: string, name: string, autoPlay?: boolean | null, heroSectionSliderItems?: Array<{ __typename?: 'ComponentCmsDataHeroSection', id: string, mainTitle: string, secondaryTitle?: string | null, topTitle?: string | null, bgColor?: string | null, box?: boolean | null, boxColor?: string | null, textColor?: string | null, textShadow?: boolean | null, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, mime: string } | null } | null } | null, mobileImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, mime: string } | null } | null } | null, countDownTimer?: { __typename?: 'ComponentCmsDataCountDownTimer', id: string, description?: string | null, endDate?: any | null } | null, button?: { __typename?: 'ComponentCmsDataButton', id: string, text: string, url: string, color?: string | null, textColor?: string | null } | null } | null> | null };

export type VideoSectionComponentFragment = { __typename?: 'ComponentCmsDataVideoSection', id: string, belowTitleText?: string | null, centerVideo?: boolean | null, bottomText?: string | null, textAfterButton?: boolean | null, topText?: string | null, VideoSectionMainTitle?: string | null, video?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', url: string } | null } | null } | null, videoMobile?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', url: string } | null } | null } | null, button?: { __typename?: 'ComponentCmsDataButton', id: string, text: string, url: string, color?: string | null, textColor?: string | null } | null, countdownTimer?: { __typename?: 'ComponentCmsDataCountDownTimer', id: string, endDate?: any | null, description?: string | null } | null };

export type DarkImageContentSectionComponentFragment = { __typename?: 'ComponentCmsDataDarkImageContent', id: string, buttonText?: string | null, buttonUrl?: string | null, darkImageContentMainTitle?: string | null, backgroundImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', url: string } | null } | null } | null, left?: { __typename?: 'ComponentCmsDataDarkImageSection', id: string, title?: string | null, items?: Array<{ __typename?: 'ComponentCmsDataDarkImageItem', id: string, title?: string | null, description?: string | null } | null> | null } | null, right?: { __typename?: 'ComponentCmsDataDarkImageSection', id: string, title?: string | null, items?: Array<{ __typename?: 'ComponentCmsDataDarkImageItem', id: string, title?: string | null, description?: string | null } | null> | null } | null, countDownTimer?: { __typename?: 'ComponentCmsDataCountDownTimer', id: string, endDate?: any | null, description?: string | null } | null };

export type DarkVersusContentSectionComponentFragment = { __typename?: 'ComponentCmsDataDarkVersusContent', id: string, subtitle?: string | null, buttonText?: string | null, buttonUrl?: string | null, scarcityTitle?: string | null, darkVersusContentMainTitle?: string | null, darkVersusContentTitle?: string | null, countDownTimer?: { __typename?: 'ComponentCmsDataCountDownTimer', id: string, endDate?: any | null, description?: string | null } | null, bottomImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', url: string } | null } | null } | null, darkVersusContentItems?: Array<{ __typename?: 'ComponentCmsDataDarkVersusBox', id: string, title?: string | null, leftItem?: { __typename?: 'ComponentCmsDataDarkVersusItem', id: string, title?: string | null, iconName?: string | null, content?: string | null } | null, rightItem?: { __typename?: 'ComponentCmsDataDarkVersusItem', id: string, title?: string | null, content?: string | null, iconName?: string | null } | null } | null> | null };

export type ScrollToSectionComponentFragment = { __typename?: 'ComponentCmsDataScrollToSection', id: string, sectionId?: string | null };

export type ImageCardsSectionComponentFragment = { __typename?: 'ComponentCmsDataImageCardsSection', id: string, backgroundColor?: string | null, ImageCardsSectiontitle?: string | null, items?: Array<{ __typename?: 'ComponentCmsDataImageCard', buttonText?: string | null, buttonUrl?: string | null, id: string, large?: boolean | null, text?: string | null, title: string, textColor?: string | null, backgroundColor?: string | null, logo?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, url: string, formats?: any | null } | null } | null } | null, picture?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, url: string, mime: string, formats?: any | null } | null } | null } | null } | null> | null };

export type AuthorsListSectionComponentFragment = { __typename?: 'ComponentCmsDataAuthorsListSection', topTitle?: string | null, showSearch?: boolean | null, showCategories?: boolean | null, numberOfAuthorsToDisplay?: number | null, id: string, description?: string | null, displayAsSlider?: boolean | null, AuthorListMainTitle?: string | null, authors?: { __typename?: 'UsersPermissionsUserRelationResponseCollection', data: Array<{ __typename?: 'UsersPermissionsUserEntity', id?: string | null, attributes?: { __typename?: 'UsersPermissionsUser', username: string, email: string } | null }> } | null };

export type TextAndImageSectionComponentFragment = { __typename?: 'ComponentCmsDataTextAndImageSection', id: string, mainTitle: string, mainTitleColor?: string | null, reverse?: boolean | null, topTitle?: string | null, topTitleColor?: string | null, hideImageOnMobile?: boolean | null, maskImage?: boolean | null, bigImageOnMobile?: boolean | null, variation?: Enum_Componentcmsdatatextandimagesection_Variation | null, rounded?: boolean | null, shadow?: boolean | null, backgroundColor?: string | null, DataTextAndImageSectionTextContent: string, DataTextAndImageSectionTextContentColor?: string | null, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, url: string, formats?: any | null } | null } | null } | null, TextAndImageSectionButton?: Array<{ __typename?: 'ComponentCmsDataButton', id: string, text: string, url: string, color?: string | null, textColor?: string | null } | null> | null, countDownTimer?: { __typename?: 'ComponentCmsDataCountDownTimer', id: string, description?: string | null, endDate?: any | null } | null, underTextImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, url: string, formats?: any | null } | null } | null } | null, imageMask?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, formats?: any | null } | null } | null } | null, imageBackgroundMask?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, formats?: any | null } | null } | null } | null };

export type SingleTitleSectionComponentFragment = { __typename?: 'ComponentCmsDataSingleTitleSection', id: string, center?: boolean | null, topTitle?: string | null, backgroundColor?: string | null, textColor?: string | null, SingleTitleMainTitle?: string | null, SingleTitleSubTitle?: string | null };

export type ReviewsSectionComponentFragment = { __typename?: 'ComponentCmsDataReviewsSection', description?: string | null, id: string, topTitle?: string | null, hideImage?: boolean | null, size?: Enum_Componentcmsdatareviewssection_Size | null, box?: boolean | null, boxColor?: string | null, textColor?: string | null, itemBoxColor?: string | null, itemBoxTextColor?: string | null, ReviewSectionMainTitle?: string | null, reviewItems?: Array<{ __typename?: 'ComponentCmsDataReviewItem', authorLocation?: string | null, authorName?: string | null, authorOccupations?: string | null, contentNrOfChars?: number | null, content?: string | null, id: string, showPictureAsCircle?: boolean | null, title?: string | null, authorPicture?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, url: string, formats?: any | null } | null } | null } | null } | null> | null };

export type LightTopImgSectionComponentFragment = { __typename?: 'ComponentCmsDataLightTopImgSection', id: string, topTitle?: string | null, centerText?: boolean | null, LightTopImgSectionMainTitle?: string | null, DataLightTopImgSectionTextContent?: string | null, topImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, url: string } | null } | null } | null, countDownTimer?: { __typename?: 'ComponentCmsDataCountDownTimer', id: string, endDate?: any | null, description?: string | null } | null };

export type DarkBgImageSectionComponentFragment = { __typename?: 'ComponentCmsDataDarkBgImageSection', id: string, centerText?: boolean | null, mainTitle: string, DarkBgImageSectionSecondaryTitle: string, backgroundImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, url: string } | null } | null } | null, button?: { __typename?: 'ComponentCmsDataButton', id: string, text: string, url: string, color?: string | null, textColor?: string | null } | null, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, url: string } | null } | null } | null, countDownTimer?: { __typename?: 'ComponentCmsDataCountDownTimer', id: string, endDate?: any | null, description?: string | null } | null };

export type FooterSectionComponentFragment = { __typename?: 'ComponentCmsDataFooterSection', id: string, rightText?: string | null, leftText: string, bottomContent?: string | null, iconColumnTitle?: string | null, iconLinks?: Array<{ __typename?: 'ComponentCmsDataFooterIconLink', iconName?: string | null, id: string, link?: string | null, text?: string | null } | null> | null, columns?: Array<{ __typename?: 'ComponentCmsDataFooterColumn', id: string, title?: string | null, content?: string | null } | null> | null };

export type DarkTextBoxSectionComponentFragment = { __typename?: 'ComponentCmsDataDarkTextBoxSection', id: string, topTitle?: string | null, topTitleColor?: string | null, mainTitle: string, mainTitleColor?: string | null, box?: boolean | null, boxColor?: string | null, boxTitle?: string | null, boxTitleColor?: string | null, boxText?: string | null, boxTextColor?: string | null, bottomTitle?: string | null, buttonTitleColor?: string | null, centerText?: boolean | null, DarkTextBoxSectionButton?: { __typename?: 'ComponentCmsDataButton', id: string, text: string, textColor?: string | null, url: string, color?: string | null } | null, backgroundImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, url: string, formats?: any | null } | null } | null } | null, mobileBackgroundImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, url: string, formats?: any | null } | null } | null } | null };

export type ScrollListSectionComponentFragment = { __typename?: 'ComponentCmsDataScrollListSection', bottomSectionTitle?: string | null, id: string, mainTitle: string, topTitle?: string | null, shortDescription?: string | null, ScrollListSectionSecondaryTitle?: string | null, backgroundImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, url: string } | null } | null } | null, bottomSectionImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, url: string } | null } | null } | null, boxes: Array<{ __typename?: 'ComponentCmsDataBoxElement', id: string, boxTitle: string, boxText: string, listTitle?: string | null, bottomText?: string | null, boxCards?: Array<{ __typename?: 'ComponentCmsDataBoxCard', id: string, text: string, title: string, showMoreText?: string | null, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, url: string } | null } | null } | null } | null> | null } | null>, ScrollListSectionButton?: { __typename?: 'ComponentCmsDataButton', url: string, text: string, id: string } | null, countDownTimer?: { __typename?: 'ComponentCmsDataCountDownTimer', description?: string | null, endDate?: any | null, id: string } | null };

export type AnimatedCardSectionComponentFragment = { __typename?: 'ComponentCmsDataAnimatedCardSection', id: string, topTitle?: string | null, AnimatedCardSectionMainTitle: string, DataAnimatedCardSectionSecondaryTitle?: string | null, button?: { __typename?: 'ComponentCmsDataButton', id: string, text: string, url: string } | null, secondSectionImages?: { __typename?: 'UploadFileRelationResponseCollection', data: Array<{ __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, url: string, caption?: string | null } | null }> } | null, firstSectionImages: { __typename?: 'UploadFileRelationResponseCollection', data: Array<{ __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, url: string, caption?: string | null } | null }> } };

export type FormGroupSectionComponentFragment = { __typename?: 'ComponentCmsDataFormGroup', id: string, ask_for_rfid?: boolean | null, redirectUrl?: string | null, random_questions?: boolean | null, number_of_random_questions?: number | null, show_start_screen?: boolean | null, thank_you_message?: string | null, thank_you_message_color?: string | null, thank_you_message_background?: string | null, formGroupTitle: string, formGroupType?: Enum_Componentcmsdataformgroup_Type | null, house_videos?: Array<{ __typename?: 'ComponentGeneralHouseWithVideo', id: string, house?: { __typename?: 'HouseEntityResponse', data?: { __typename?: 'HouseEntity', id?: string | null, attributes?: { __typename?: 'House', name: string } | null } | null } | null, video: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, mime: string } | null } | null } } | null> | null, questions?: Array<{ __typename?: 'ComponentCmsDataFormQuestion', id: string, is_required?: boolean | null, use_recaptcha?: boolean | null, center_text?: boolean | null, title: string, title_color?: string | null, description?: string | null, description_color?: string | null, index: number, size?: Enum_Componentcmsdataformquestion_Size | null, type?: Enum_Componentcmsdataformquestion_Type | null, desktop_layout?: Enum_Componentcmsdataformquestion_Desktop_Layout | null, mobile_layout?: Enum_Componentcmsdataformquestion_Mobile_Layout | null, vertical_alignment?: Enum_Componentcmsdataformquestion_Vertical_Alignment | null, restart_form_timer: number, send_review_to_google?: boolean | null, input_color?: string | null, input_placeholder?: string | null, submit_button_text: string, submit_button_color?: string | null, submit_button_text_color?: string | null, submit_button_sticky?: boolean | null, is_transparent_button?: boolean | null, next_question_index?: number | null, image_position?: Enum_Componentcmsdataformquestion_Image_Position | null, background_color?: string | null, allow_other_choice?: boolean | null, nr_columns: number, space_from_top?: number | null, feedback_media_text?: string | null, rate_user?: { __typename?: 'UsersPermissionsUserRelationResponseCollection', data: Array<{ __typename?: 'UsersPermissionsUserEntity', id?: string | null }> } | null, rate_user_role?: { __typename?: 'CrmRoleRelationResponseCollection', data: Array<{ __typename?: 'CrmRoleEntity', id?: string | null }> } | null, allocate_tags?: { __typename?: 'ActiveCampaignAcTagRelationResponseCollection', data: Array<{ __typename?: 'ActiveCampaignAcTagEntity', id?: string | null }> } | null, allocate_house?: { __typename?: 'HouseEntityResponse', data?: { __typename?: 'HouseEntity', id?: string | null, attributes?: { __typename?: 'House', name: string } | null } | null } | null, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, mime: string, url: string } | null } | null } | null, video?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, mime: string, url: string } | null } | null } | null, feedback_media?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, mime: string, url: string } | null } | null } | null, choices?: Array<{ __typename?: 'ComponentCmsDataFormQchoice', id: string, choice_text?: string | null, choice_shortcut?: string | null, choice_color?: string | null, choice_color_transparent?: boolean | null, choice_big_button?: boolean | null, display_delay: number, jump_to_question_index: number, jump_condition_operation: Enum_Componentcmsdataformqchoice_Jump_Condition_Operation, feedback_media_text?: string | null, choice_media?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, mime: string, url: string } | null } | null } | null, allocate_house?: { __typename?: 'HouseEntityResponse', data?: { __typename?: 'HouseEntity', id?: string | null, attributes?: { __typename?: 'House', name: string } | null } | null } | null, feedback_media?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, mime: string, url: string } | null } | null } | null, allocate_tags?: { __typename?: 'ActiveCampaignAcTagRelationResponseCollection', data: Array<{ __typename?: 'ActiveCampaignAcTagEntity', id?: string | null }> } | null } | null> | null } | null> | null };

export type RichTextSectionComponentFragment = { __typename?: 'ComponentCmsDataRichText', id: string, text?: string | null, center?: boolean | null, fullWidth?: boolean | null, verticalWider?: boolean | null, backgroundImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, url: string } | null } | null } | null };

export type RichTextHtmlSectionComponentFragment = { __typename?: 'ComponentCmsDataRichTextHtml', id: string, text?: string | null, center?: boolean | null, fullWidth?: boolean | null, verticalWider?: boolean | null, backgroundImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, url: string } | null } | null } | null };

export type ImageGalleryComponentFragment = { __typename?: 'ComponentCmsDataImageGallery', id: string, backgroundColor?: string | null, items?: Array<{ __typename?: 'ComponentCmsDataImageGalleryItem', id: string, category?: string | null, ComponentCmsDataImageGalleryTitle?: string | null, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, formats?: any | null } | null } | null } | null } | null> | null };

export type PriceSectionComponentFragment = { __typename?: 'ComponentCmsDataPriceSection', id: string, description?: string | null, descriptionColor?: string | null, mainTitleColor?: string | null, topTitle?: string | null, topTitleColor?: string | null, priceItemsPerSlideWeb?: number | null, sectionId?: string | null, showAsSlider?: boolean | null, showAsSliderWeb?: boolean | null, centerTitle?: boolean | null, shortDescription?: string | null, PriceSectionMainTitle?: string | null, priceItems?: Array<{ __typename?: 'ComponentCmsDataPriceItem', buttonText?: string | null, buttonUrl?: string | null, highlightTag?: string | null, id: string, itemDescription?: string | null, itemMainTitle?: string | null, itemMainTitleColor?: string | null, itemTopTitle?: string | null, itemTopTitleColor?: string | null, monthlyDiscountedPrice?: string | null, monthlyRegularPrice?: string | null, monthlyUnderPriceText?: string | null, yearlyDiscountedPrice?: string | null, yearlyRegularPrice?: string | null, yearlyUnderPriceText?: string | null, centerItemMainTitleHoriz?: boolean | null, centerPriceHoriz?: boolean | null, centerpriceBenefitsHoriz?: boolean | null, priceBenefits?: Array<{ __typename?: 'ComponentCmsDataPriceBenefit', icon?: string | null, id: string, isGrayedOut?: boolean | null, isBold?: boolean | null, text?: string | null, isIndented?: boolean | null } | null> | null } | null> | null, countDownTimer?: { __typename?: 'ComponentCmsDataCountDownTimer', id: string, endDate?: any | null, description?: string | null } | null };

export type ProductListFragment = { __typename?: 'ComponentCmsDataProductsList', id: string, displayType: Enum_Componentcmsdataproductslist_Displaytype, groupByCategory?: boolean | null, show?: any | null, showInPopup?: any | null, popupType?: Enum_Componentcmsdataproductslist_Popuptype | null, productSize: Enum_Componentcmsdataproductslist_Size, menu?: { __typename?: 'MenuEntityResponse', data?: { __typename?: 'MenuEntity', id?: string | null, attributes?: { __typename?: 'Menu', title: string, slug?: string | null, title_dimension?: string | null, description_dimension?: string | null, nutritional_information_dimension?: string | null, web_catalog_items?: { __typename?: 'ProductRelationResponseCollection', data: Array<{ __typename?: 'ProductEntity', id?: string | null, attributes?: { __typename?: 'Product', title: string, description?: string | null, price: number, nutritional_information?: string | null, weight?: number | null, ingredients?: { __typename?: 'IngredientRelationResponseCollection', data: Array<{ __typename?: 'IngredientEntity', id?: string | null, attributes?: { __typename?: 'Ingredient', name: string, allergens?: { __typename?: 'AllergenRelationResponseCollection', data: Array<{ __typename?: 'AllergenEntity', id?: string | null, attributes?: { __typename?: 'Allergen', name: string } | null }> } | null } | null }> } | null, media?: { __typename?: 'UploadFileRelationResponseCollection', data: Array<{ __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', url: string } | null }> } | null, category?: { __typename?: 'ProductCategoryEntityResponse', data?: { __typename?: 'ProductCategoryEntity', id?: string | null, attributes?: { __typename?: 'ProductCategory', name: string } | null } | null } | null } | null }> } | null, nutritional_information_background?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', url: string } | null } | null } | null, nutritional_information_background_2?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', url: string } | null } | null } | null } | null } | null } | null, products?: { __typename?: 'ProductRelationResponseCollection', data: Array<{ __typename?: 'ProductEntity', id?: string | null, attributes?: { __typename?: 'Product', title: string, description?: string | null, price: number, total_calories?: number | null, weight?: number | null, nutritional_information?: string | null, category?: { __typename?: 'ProductCategoryEntityResponse', data?: { __typename?: 'ProductCategoryEntity', id?: string | null, attributes?: { __typename?: 'ProductCategory', name: string } | null } | null } | null, media?: { __typename?: 'UploadFileRelationResponseCollection', data: Array<{ __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, formats?: any | null } | null }> } | null, ingredients?: { __typename?: 'IngredientRelationResponseCollection', data: Array<{ __typename?: 'IngredientEntity', id?: string | null, attributes?: { __typename?: 'Ingredient', name: string, allergens?: { __typename?: 'AllergenRelationResponseCollection', data: Array<{ __typename?: 'AllergenEntity', id?: string | null, attributes?: { __typename?: 'Allergen', name: string } | null }> } | null } | null }> } | null } | null }> } | null };

export type MenuFragment = { __typename?: 'MenuEntityResponse', data?: { __typename?: 'MenuEntity', id?: string | null, attributes?: { __typename?: 'Menu', title: string, slug?: string | null, title_dimension?: string | null, description_dimension?: string | null, nutritional_information_dimension?: string | null, web_catalog_items?: { __typename?: 'ProductRelationResponseCollection', data: Array<{ __typename?: 'ProductEntity', id?: string | null, attributes?: { __typename?: 'Product', title: string, description?: string | null, price: number, nutritional_information?: string | null, weight?: number | null, ingredients?: { __typename?: 'IngredientRelationResponseCollection', data: Array<{ __typename?: 'IngredientEntity', id?: string | null, attributes?: { __typename?: 'Ingredient', name: string, allergens?: { __typename?: 'AllergenRelationResponseCollection', data: Array<{ __typename?: 'AllergenEntity', id?: string | null, attributes?: { __typename?: 'Allergen', name: string } | null }> } | null } | null }> } | null, media?: { __typename?: 'UploadFileRelationResponseCollection', data: Array<{ __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', url: string } | null }> } | null, category?: { __typename?: 'ProductCategoryEntityResponse', data?: { __typename?: 'ProductCategoryEntity', id?: string | null, attributes?: { __typename?: 'ProductCategory', name: string } | null } | null } | null } | null }> } | null, nutritional_information_background?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', url: string } | null } | null } | null, nutritional_information_background_2?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', url: string } | null } | null } | null } | null } | null };

export type ProductsFragment = { __typename?: 'ProductRelationResponseCollection', data: Array<{ __typename?: 'ProductEntity', id?: string | null, attributes?: { __typename?: 'Product', title: string, description?: string | null, price: number, total_calories?: number | null, weight?: number | null, nutritional_information?: string | null, category?: { __typename?: 'ProductCategoryEntityResponse', data?: { __typename?: 'ProductCategoryEntity', id?: string | null, attributes?: { __typename?: 'ProductCategory', name: string } | null } | null } | null, media?: { __typename?: 'UploadFileRelationResponseCollection', data: Array<{ __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, formats?: any | null } | null }> } | null, ingredients?: { __typename?: 'IngredientRelationResponseCollection', data: Array<{ __typename?: 'IngredientEntity', id?: string | null, attributes?: { __typename?: 'Ingredient', name: string, allergens?: { __typename?: 'AllergenRelationResponseCollection', data: Array<{ __typename?: 'AllergenEntity', id?: string | null, attributes?: { __typename?: 'Allergen', name: string } | null }> } | null } | null }> } | null } | null }> };

export type SliderSectionComponentFragment = { __typename?: 'ComponentCmsDataSlider', id: string, type?: Enum_Componentcmsdataslider_Type | null, title?: string | null, centerText?: boolean | null, popup?: boolean | null, popupRichText?: string | null, DataSliderSubTitle?: string | null, items?: Array<{ __typename?: 'ComponentCmsDataSliderItem', body?: string | null, id: string, link?: string | null, title: string, subtitleOverImage?: boolean | null, underText?: string | null, titleNrOfChars?: number | null, underTextNrOfChars?: number | null, bodyNrOfChars?: number | null, frameColor?: string | null, titleColor?: string | null, bodyColor?: string | null, underTexColor?: string | null, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, url: string, formats?: any | null } | null } | null } | null } | null> | null };

export type HeroSectionTwoComponentFragment = { __typename?: 'ComponentCmsDataHeroSectionTwo', bottomText?: string | null, id: string, textAfterButton?: boolean | null, topText?: string | null, belowTitle?: string | null, HeroSectionTwoMainTitle: string, button?: { __typename?: 'ComponentCmsDataButton', id: string, text: string, url: string, color?: string | null, textColor?: string | null } | null, HeroSectionTwoImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, url: string } | null } | null } | null };

export type FaqSectionComponentFragment = { __typename?: 'ComponentCmsDataFaq', title?: string | null, id: string, items?: Array<{ __typename?: 'ComponentCmsDataFaqItem', id: string, answer: string, question: string } | null> | null };

export type InteractiveImageMapFragment = { __typename?: 'ComponentCmsDataInteractiveImageMap', id: string, interactiveImageMapTitle: string, interactiveImageMapImage: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', url: string, formats?: any | null, alternativeText?: string | null } | null } | null }, circles?: Array<{ __typename?: 'ComponentCmsDataImageMapCircle', id: string, position_x: number, position_y: number, radius: number, details?: { __typename?: 'ComponentCmsDataImageMapDetail', id: string, title: string, description?: string | null, hover_icon?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', url: string, formats?: any | null, alternativeText?: string | null } | null } | null } | null, non_hover_icon?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', url: string, formats?: any | null, alternativeText?: string | null } | null } | null } | null, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', url: string, formats?: any | null, alternativeText?: string | null } | null } | null } | null } | null } | null> | null };

export type ReusableComponentFragment = { __typename?: 'ComponentCmsDataReusable', id: string, reusable_component?: { __typename?: 'ReusableComponentEntityResponse', data?: { __typename?: 'ReusableComponentEntity', id?: string | null, attributes?: { __typename?: 'ReusableComponent', title: string, components: Array<{ __typename?: 'ComponentCmsDataAnimatedCardSection', id: string, topTitle?: string | null, AnimatedCardSectionMainTitle: string, DataAnimatedCardSectionSecondaryTitle?: string | null, button?: { __typename?: 'ComponentCmsDataButton', id: string, text: string, url: string } | null, secondSectionImages?: { __typename?: 'UploadFileRelationResponseCollection', data: Array<{ __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, url: string, caption?: string | null } | null }> } | null, firstSectionImages: { __typename?: 'UploadFileRelationResponseCollection', data: Array<{ __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, url: string, caption?: string | null } | null }> } } | { __typename?: 'ComponentCmsDataAuthorsListSection', topTitle?: string | null, showSearch?: boolean | null, showCategories?: boolean | null, numberOfAuthorsToDisplay?: number | null, id: string, description?: string | null, displayAsSlider?: boolean | null, AuthorListMainTitle?: string | null, authors?: { __typename?: 'UsersPermissionsUserRelationResponseCollection', data: Array<{ __typename?: 'UsersPermissionsUserEntity', id?: string | null, attributes?: { __typename?: 'UsersPermissionsUser', username: string, email: string } | null }> } | null } | { __typename?: 'ComponentCmsDataBlogArticles' } | { __typename?: 'ComponentCmsDataCaptureContact' } | { __typename?: 'ComponentCmsDataDarkBgImageSection', id: string, centerText?: boolean | null, mainTitle: string, DarkBgImageSectionSecondaryTitle: string, backgroundImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, url: string } | null } | null } | null, button?: { __typename?: 'ComponentCmsDataButton', id: string, text: string, url: string, color?: string | null, textColor?: string | null } | null, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, url: string } | null } | null } | null, countDownTimer?: { __typename?: 'ComponentCmsDataCountDownTimer', id: string, endDate?: any | null, description?: string | null } | null } | { __typename?: 'ComponentCmsDataDarkImageContent', id: string, buttonText?: string | null, buttonUrl?: string | null, darkImageContentMainTitle?: string | null, backgroundImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', url: string } | null } | null } | null, left?: { __typename?: 'ComponentCmsDataDarkImageSection', id: string, title?: string | null, items?: Array<{ __typename?: 'ComponentCmsDataDarkImageItem', id: string, title?: string | null, description?: string | null } | null> | null } | null, right?: { __typename?: 'ComponentCmsDataDarkImageSection', id: string, title?: string | null, items?: Array<{ __typename?: 'ComponentCmsDataDarkImageItem', id: string, title?: string | null, description?: string | null } | null> | null } | null, countDownTimer?: { __typename?: 'ComponentCmsDataCountDownTimer', id: string, endDate?: any | null, description?: string | null } | null } | { __typename?: 'ComponentCmsDataDarkTextBoxSection', id: string, topTitle?: string | null, topTitleColor?: string | null, mainTitle: string, mainTitleColor?: string | null, box?: boolean | null, boxColor?: string | null, boxTitle?: string | null, boxTitleColor?: string | null, boxText?: string | null, boxTextColor?: string | null, bottomTitle?: string | null, buttonTitleColor?: string | null, centerText?: boolean | null, DarkTextBoxSectionButton?: { __typename?: 'ComponentCmsDataButton', id: string, text: string, textColor?: string | null, url: string, color?: string | null } | null, backgroundImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, url: string, formats?: any | null } | null } | null } | null, mobileBackgroundImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, url: string, formats?: any | null } | null } | null } | null } | { __typename?: 'ComponentCmsDataDarkVersusContent', id: string, subtitle?: string | null, buttonText?: string | null, buttonUrl?: string | null, scarcityTitle?: string | null, darkVersusContentMainTitle?: string | null, darkVersusContentTitle?: string | null, countDownTimer?: { __typename?: 'ComponentCmsDataCountDownTimer', id: string, endDate?: any | null, description?: string | null } | null, bottomImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', url: string } | null } | null } | null, darkVersusContentItems?: Array<{ __typename?: 'ComponentCmsDataDarkVersusBox', id: string, title?: string | null, leftItem?: { __typename?: 'ComponentCmsDataDarkVersusItem', id: string, title?: string | null, iconName?: string | null, content?: string | null } | null, rightItem?: { __typename?: 'ComponentCmsDataDarkVersusItem', id: string, title?: string | null, content?: string | null, iconName?: string | null } | null } | null> | null } | { __typename?: 'ComponentCmsDataEventsListSection' } | { __typename?: 'ComponentCmsDataFaq', title?: string | null, id: string, items?: Array<{ __typename?: 'ComponentCmsDataFaqItem', id: string, answer: string, question: string } | null> | null } | { __typename?: 'ComponentCmsDataFooterSection', id: string, rightText?: string | null, leftText: string, bottomContent?: string | null, iconColumnTitle?: string | null, iconLinks?: Array<{ __typename?: 'ComponentCmsDataFooterIconLink', iconName?: string | null, id: string, link?: string | null, text?: string | null } | null> | null, columns?: Array<{ __typename?: 'ComponentCmsDataFooterColumn', id: string, title?: string | null, content?: string | null } | null> | null } | { __typename?: 'ComponentCmsDataFormGroup', id: string, ask_for_rfid?: boolean | null, redirectUrl?: string | null, random_questions?: boolean | null, number_of_random_questions?: number | null, show_start_screen?: boolean | null, thank_you_message?: string | null, thank_you_message_color?: string | null, thank_you_message_background?: string | null, formGroupTitle: string, formGroupType?: Enum_Componentcmsdataformgroup_Type | null, house_videos?: Array<{ __typename?: 'ComponentGeneralHouseWithVideo', id: string, house?: { __typename?: 'HouseEntityResponse', data?: { __typename?: 'HouseEntity', id?: string | null, attributes?: { __typename?: 'House', name: string } | null } | null } | null, video: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, mime: string } | null } | null } } | null> | null, questions?: Array<{ __typename?: 'ComponentCmsDataFormQuestion', id: string, is_required?: boolean | null, use_recaptcha?: boolean | null, center_text?: boolean | null, title: string, title_color?: string | null, description?: string | null, description_color?: string | null, index: number, size?: Enum_Componentcmsdataformquestion_Size | null, type?: Enum_Componentcmsdataformquestion_Type | null, desktop_layout?: Enum_Componentcmsdataformquestion_Desktop_Layout | null, mobile_layout?: Enum_Componentcmsdataformquestion_Mobile_Layout | null, vertical_alignment?: Enum_Componentcmsdataformquestion_Vertical_Alignment | null, restart_form_timer: number, send_review_to_google?: boolean | null, input_color?: string | null, input_placeholder?: string | null, submit_button_text: string, submit_button_color?: string | null, submit_button_text_color?: string | null, submit_button_sticky?: boolean | null, is_transparent_button?: boolean | null, next_question_index?: number | null, image_position?: Enum_Componentcmsdataformquestion_Image_Position | null, background_color?: string | null, allow_other_choice?: boolean | null, nr_columns: number, space_from_top?: number | null, feedback_media_text?: string | null, rate_user?: { __typename?: 'UsersPermissionsUserRelationResponseCollection', data: Array<{ __typename?: 'UsersPermissionsUserEntity', id?: string | null }> } | null, rate_user_role?: { __typename?: 'CrmRoleRelationResponseCollection', data: Array<{ __typename?: 'CrmRoleEntity', id?: string | null }> } | null, allocate_tags?: { __typename?: 'ActiveCampaignAcTagRelationResponseCollection', data: Array<{ __typename?: 'ActiveCampaignAcTagEntity', id?: string | null }> } | null, allocate_house?: { __typename?: 'HouseEntityResponse', data?: { __typename?: 'HouseEntity', id?: string | null, attributes?: { __typename?: 'House', name: string } | null } | null } | null, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, mime: string, url: string } | null } | null } | null, video?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, mime: string, url: string } | null } | null } | null, feedback_media?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, mime: string, url: string } | null } | null } | null, choices?: Array<{ __typename?: 'ComponentCmsDataFormQchoice', id: string, choice_text?: string | null, choice_shortcut?: string | null, choice_color?: string | null, choice_color_transparent?: boolean | null, choice_big_button?: boolean | null, display_delay: number, jump_to_question_index: number, jump_condition_operation: Enum_Componentcmsdataformqchoice_Jump_Condition_Operation, feedback_media_text?: string | null, choice_media?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, mime: string, url: string } | null } | null } | null, allocate_house?: { __typename?: 'HouseEntityResponse', data?: { __typename?: 'HouseEntity', id?: string | null, attributes?: { __typename?: 'House', name: string } | null } | null } | null, feedback_media?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, mime: string, url: string } | null } | null } | null, allocate_tags?: { __typename?: 'ActiveCampaignAcTagRelationResponseCollection', data: Array<{ __typename?: 'ActiveCampaignAcTagEntity', id?: string | null }> } | null } | null> | null } | null> | null } | { __typename?: 'ComponentCmsDataHeaderSection', id: string, helloBarContent?: string | null, HeaderSectionButton?: { __typename?: 'ComponentCmsDataButton', id: string, text: string, url: string } | null, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, url: string } | null } | null } | null } | { __typename?: 'ComponentCmsDataHeroSection', id: string, mainTitle: string, bgColor?: string | null, box?: boolean | null, boxColor?: string | null, textColor?: string | null, textShadow?: boolean | null, DataHeroSectionSecondaryTitle?: string | null, HeroSectionTopTitle?: string | null, HeroSectionButton?: { __typename?: 'ComponentCmsDataButton', id: string, text: string, url: string } | null, countDownTimer?: { __typename?: 'ComponentCmsDataCountDownTimer', id: string, description?: string | null, endDate?: any | null } | null, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null } | null } | null } | null, mobileImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null } | null } | null } | null } | { __typename?: 'ComponentCmsDataHeroSectionSlider', id: string, name: string, autoPlay?: boolean | null, heroSectionSliderItems?: Array<{ __typename?: 'ComponentCmsDataHeroSection', id: string, mainTitle: string, secondaryTitle?: string | null, topTitle?: string | null, bgColor?: string | null, box?: boolean | null, boxColor?: string | null, textColor?: string | null, textShadow?: boolean | null, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, mime: string } | null } | null } | null, mobileImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, mime: string } | null } | null } | null, countDownTimer?: { __typename?: 'ComponentCmsDataCountDownTimer', id: string, description?: string | null, endDate?: any | null } | null, button?: { __typename?: 'ComponentCmsDataButton', id: string, text: string, url: string, color?: string | null, textColor?: string | null } | null } | null> | null } | { __typename?: 'ComponentCmsDataHeroSectionTwo', bottomText?: string | null, id: string, textAfterButton?: boolean | null, topText?: string | null, belowTitle?: string | null, HeroSectionTwoMainTitle: string, button?: { __typename?: 'ComponentCmsDataButton', id: string, text: string, url: string, color?: string | null, textColor?: string | null } | null, HeroSectionTwoImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, url: string } | null } | null } | null } | { __typename?: 'ComponentCmsDataIconCardsSection', mainTitle: string, subTitle: string, id: string, centerText?: boolean | null, showAppButton?: boolean | null, hasExclamationMark?: boolean | null, backgroundColor?: string | null, IconCardsSectionTopTitle: string, iconCards: Array<{ __typename?: 'ComponentCmsDataIconCard', iconName: string, id: string, large?: boolean | null, subTitle?: string | null, title: string } | null>, IconCardsSectionButtons?: Array<{ __typename?: 'ComponentCmsDataButton', id: string, text: string, url: string } | null> | null } | { __typename?: 'ComponentCmsDataImageCardsSection', id: string, backgroundColor?: string | null, ImageCardsSectiontitle?: string | null, items?: Array<{ __typename?: 'ComponentCmsDataImageCard', buttonText?: string | null, buttonUrl?: string | null, id: string, large?: boolean | null, text?: string | null, title: string, textColor?: string | null, backgroundColor?: string | null, logo?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, url: string, formats?: any | null } | null } | null } | null, picture?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, url: string, mime: string, formats?: any | null } | null } | null } | null } | null> | null } | { __typename?: 'ComponentCmsDataImageGallery', id: string, backgroundColor?: string | null, items?: Array<{ __typename?: 'ComponentCmsDataImageGalleryItem', id: string, category?: string | null, ComponentCmsDataImageGalleryTitle?: string | null, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, formats?: any | null } | null } | null } | null } | null> | null } | { __typename?: 'ComponentCmsDataInteractiveImageMap' } | { __typename?: 'ComponentCmsDataLightTopImgSection', id: string, topTitle?: string | null, centerText?: boolean | null, LightTopImgSectionMainTitle?: string | null, DataLightTopImgSectionTextContent?: string | null, topImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, url: string } | null } | null } | null, countDownTimer?: { __typename?: 'ComponentCmsDataCountDownTimer', id: string, endDate?: any | null, description?: string | null } | null } | { __typename?: 'ComponentCmsDataPriceSection', id: string, description?: string | null, descriptionColor?: string | null, mainTitleColor?: string | null, topTitle?: string | null, topTitleColor?: string | null, priceItemsPerSlideWeb?: number | null, sectionId?: string | null, showAsSlider?: boolean | null, showAsSliderWeb?: boolean | null, centerTitle?: boolean | null, shortDescription?: string | null, PriceSectionMainTitle?: string | null, priceItems?: Array<{ __typename?: 'ComponentCmsDataPriceItem', buttonText?: string | null, buttonUrl?: string | null, highlightTag?: string | null, id: string, itemDescription?: string | null, itemMainTitle?: string | null, itemMainTitleColor?: string | null, itemTopTitle?: string | null, itemTopTitleColor?: string | null, monthlyDiscountedPrice?: string | null, monthlyRegularPrice?: string | null, monthlyUnderPriceText?: string | null, yearlyDiscountedPrice?: string | null, yearlyRegularPrice?: string | null, yearlyUnderPriceText?: string | null, centerItemMainTitleHoriz?: boolean | null, centerPriceHoriz?: boolean | null, centerpriceBenefitsHoriz?: boolean | null, priceBenefits?: Array<{ __typename?: 'ComponentCmsDataPriceBenefit', icon?: string | null, id: string, isGrayedOut?: boolean | null, isBold?: boolean | null, text?: string | null, isIndented?: boolean | null } | null> | null } | null> | null, countDownTimer?: { __typename?: 'ComponentCmsDataCountDownTimer', id: string, endDate?: any | null, description?: string | null } | null } | { __typename?: 'ComponentCmsDataProductsList', id: string, displayType: Enum_Componentcmsdataproductslist_Displaytype, groupByCategory?: boolean | null, show?: any | null, showInPopup?: any | null, popupType?: Enum_Componentcmsdataproductslist_Popuptype | null, productSize: Enum_Componentcmsdataproductslist_Size, menu?: { __typename?: 'MenuEntityResponse', data?: { __typename?: 'MenuEntity', id?: string | null, attributes?: { __typename?: 'Menu', title: string, slug?: string | null, title_dimension?: string | null, description_dimension?: string | null, nutritional_information_dimension?: string | null, web_catalog_items?: { __typename?: 'ProductRelationResponseCollection', data: Array<{ __typename?: 'ProductEntity', id?: string | null, attributes?: { __typename?: 'Product', title: string, description?: string | null, price: number, nutritional_information?: string | null, weight?: number | null, ingredients?: { __typename?: 'IngredientRelationResponseCollection', data: Array<{ __typename?: 'IngredientEntity', id?: string | null, attributes?: { __typename?: 'Ingredient', name: string, allergens?: { __typename?: 'AllergenRelationResponseCollection', data: Array<{ __typename?: 'AllergenEntity', id?: string | null, attributes?: { __typename?: 'Allergen', name: string } | null }> } | null } | null }> } | null, media?: { __typename?: 'UploadFileRelationResponseCollection', data: Array<{ __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', url: string } | null }> } | null, category?: { __typename?: 'ProductCategoryEntityResponse', data?: { __typename?: 'ProductCategoryEntity', id?: string | null, attributes?: { __typename?: 'ProductCategory', name: string } | null } | null } | null } | null }> } | null, nutritional_information_background?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', url: string } | null } | null } | null, nutritional_information_background_2?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', url: string } | null } | null } | null } | null } | null } | null, products?: { __typename?: 'ProductRelationResponseCollection', data: Array<{ __typename?: 'ProductEntity', id?: string | null, attributes?: { __typename?: 'Product', title: string, description?: string | null, price: number, total_calories?: number | null, weight?: number | null, nutritional_information?: string | null, category?: { __typename?: 'ProductCategoryEntityResponse', data?: { __typename?: 'ProductCategoryEntity', id?: string | null, attributes?: { __typename?: 'ProductCategory', name: string } | null } | null } | null, media?: { __typename?: 'UploadFileRelationResponseCollection', data: Array<{ __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, formats?: any | null } | null }> } | null, ingredients?: { __typename?: 'IngredientRelationResponseCollection', data: Array<{ __typename?: 'IngredientEntity', id?: string | null, attributes?: { __typename?: 'Ingredient', name: string, allergens?: { __typename?: 'AllergenRelationResponseCollection', data: Array<{ __typename?: 'AllergenEntity', id?: string | null, attributes?: { __typename?: 'Allergen', name: string } | null }> } | null } | null }> } | null } | null }> } | null } | { __typename?: 'ComponentCmsDataReviewsSection', description?: string | null, id: string, topTitle?: string | null, hideImage?: boolean | null, size?: Enum_Componentcmsdatareviewssection_Size | null, box?: boolean | null, boxColor?: string | null, textColor?: string | null, itemBoxColor?: string | null, itemBoxTextColor?: string | null, ReviewSectionMainTitle?: string | null, reviewItems?: Array<{ __typename?: 'ComponentCmsDataReviewItem', authorLocation?: string | null, authorName?: string | null, authorOccupations?: string | null, contentNrOfChars?: number | null, content?: string | null, id: string, showPictureAsCircle?: boolean | null, title?: string | null, authorPicture?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, url: string, formats?: any | null } | null } | null } | null } | null> | null } | { __typename?: 'ComponentCmsDataRichText', id: string, text?: string | null, center?: boolean | null, fullWidth?: boolean | null, verticalWider?: boolean | null, backgroundImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, url: string } | null } | null } | null } | { __typename?: 'ComponentCmsDataRichTextHtml', id: string, text?: string | null, center?: boolean | null, fullWidth?: boolean | null, verticalWider?: boolean | null, backgroundImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, url: string } | null } | null } | null } | { __typename?: 'ComponentCmsDataScheduleMeeting' } | { __typename?: 'ComponentCmsDataScrollListSection', bottomSectionTitle?: string | null, id: string, mainTitle: string, topTitle?: string | null, shortDescription?: string | null, ScrollListSectionSecondaryTitle?: string | null, backgroundImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, url: string } | null } | null } | null, bottomSectionImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, url: string } | null } | null } | null, boxes: Array<{ __typename?: 'ComponentCmsDataBoxElement', id: string, boxTitle: string, boxText: string, listTitle?: string | null, bottomText?: string | null, boxCards?: Array<{ __typename?: 'ComponentCmsDataBoxCard', id: string, text: string, title: string, showMoreText?: string | null, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, url: string } | null } | null } | null } | null> | null } | null>, ScrollListSectionButton?: { __typename?: 'ComponentCmsDataButton', url: string, text: string, id: string } | null, countDownTimer?: { __typename?: 'ComponentCmsDataCountDownTimer', description?: string | null, endDate?: any | null, id: string } | null } | { __typename?: 'ComponentCmsDataScrollToSection', id: string, sectionId?: string | null } | { __typename?: 'ComponentCmsDataSingleTitleSection', id: string, center?: boolean | null, topTitle?: string | null, backgroundColor?: string | null, textColor?: string | null, SingleTitleMainTitle?: string | null, SingleTitleSubTitle?: string | null } | { __typename?: 'ComponentCmsDataSlider', id: string, type?: Enum_Componentcmsdataslider_Type | null, title?: string | null, centerText?: boolean | null, popup?: boolean | null, popupRichText?: string | null, DataSliderSubTitle?: string | null, items?: Array<{ __typename?: 'ComponentCmsDataSliderItem', body?: string | null, id: string, link?: string | null, title: string, subtitleOverImage?: boolean | null, underText?: string | null, titleNrOfChars?: number | null, underTextNrOfChars?: number | null, bodyNrOfChars?: number | null, frameColor?: string | null, titleColor?: string | null, bodyColor?: string | null, underTexColor?: string | null, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, url: string, formats?: any | null } | null } | null } | null } | null> | null } | { __typename?: 'ComponentCmsDataSubscriptionPopup' } | { __typename?: 'ComponentCmsDataTextAndImageSection', id: string, mainTitle: string, mainTitleColor?: string | null, reverse?: boolean | null, topTitle?: string | null, topTitleColor?: string | null, hideImageOnMobile?: boolean | null, maskImage?: boolean | null, bigImageOnMobile?: boolean | null, variation?: Enum_Componentcmsdatatextandimagesection_Variation | null, rounded?: boolean | null, shadow?: boolean | null, backgroundColor?: string | null, DataTextAndImageSectionTextContent: string, DataTextAndImageSectionTextContentColor?: string | null, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, url: string, formats?: any | null } | null } | null } | null, TextAndImageSectionButton?: Array<{ __typename?: 'ComponentCmsDataButton', id: string, text: string, url: string, color?: string | null, textColor?: string | null } | null> | null, countDownTimer?: { __typename?: 'ComponentCmsDataCountDownTimer', id: string, description?: string | null, endDate?: any | null } | null, underTextImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, url: string, formats?: any | null } | null } | null } | null, imageMask?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, formats?: any | null } | null } | null } | null, imageBackgroundMask?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, formats?: any | null } | null } | null } | null } | { __typename?: 'ComponentCmsDataVideoSection', id: string, belowTitleText?: string | null, centerVideo?: boolean | null, bottomText?: string | null, textAfterButton?: boolean | null, topText?: string | null, VideoSectionMainTitle?: string | null, video?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', url: string } | null } | null } | null, videoMobile?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', url: string } | null } | null } | null, button?: { __typename?: 'ComponentCmsDataButton', id: string, text: string, url: string, color?: string | null, textColor?: string | null } | null, countdownTimer?: { __typename?: 'ComponentCmsDataCountDownTimer', id: string, endDate?: any | null, description?: string | null } | null } | { __typename?: 'Error' } | null> } | null } | null } | null };

export type SeoDataFragment = { __typename?: 'ComponentSharedSeo', canonicalURL?: string | null, id: string, keywords?: string | null, metaDescription: string, metaRobots?: string | null, metaTitle: string, metaViewport?: string | null, metaImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, formats?: any | null, url: string } | null } | null } | null, metaSocial?: Array<{ __typename?: 'ComponentSharedMetaSocial', id: string, description: string, socialNetwork: Enum_Componentsharedmetasocial_Socialnetwork, title: string, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, formats?: any | null, url: string } | null } | null } | null } | null> | null };

export type LandingPagesQueryVariables = Exact<{
  filters?: InputMaybe<PageFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  iconCardsFilters?: InputMaybe<ComponentCmsDataIconCardFiltersInput>;
  iconCardsPagination?: InputMaybe<PaginationArg>;
  boxesPagination?: InputMaybe<PaginationArg>;
  boxCardsPagination?: InputMaybe<PaginationArg>;
  sliderFilters?: InputMaybe<ComponentCmsDataSliderItemFiltersInput>;
  sliderPagination?: InputMaybe<PaginationArg>;
  faqItemsPagination?: InputMaybe<PaginationArg>;
  imageCardsItemsFilters?: InputMaybe<ComponentCmsDataImageCardFiltersInput>;
  imageCardsItemsPagination?: InputMaybe<PaginationArg>;
  authorsPagination?: InputMaybe<PaginationArg>;
  authorsFilters?: InputMaybe<UsersPermissionsUserFiltersInput>;
  reviewItemsPagination?: InputMaybe<PaginationArg>;
  reviewItemsFilters?: InputMaybe<ComponentCmsDataReviewItemFiltersInput>;
  priceItemsFilters?: InputMaybe<ComponentCmsDataPriceItemFiltersInput>;
  priceItemsPagination?: InputMaybe<PaginationArg>;
  priceBenefitsFilters?: InputMaybe<ComponentCmsDataPriceBenefitFiltersInput>;
  priceBenefitsPagination?: InputMaybe<PaginationArg>;
  imageGalleryFilters?: InputMaybe<ComponentCmsDataImageGalleryItemFiltersInput>;
  imageGalleryPagination?: InputMaybe<PaginationArg>;
  productsFilters?: InputMaybe<ProductFiltersInput>;
  productsPagination?: InputMaybe<PaginationArg>;
  menuFilters?: InputMaybe<ProductFiltersInput>;
  menuPagination?: InputMaybe<PaginationArg>;
}>;


export type LandingPagesQuery = { __typename?: 'Query', pages?: { __typename?: 'PageEntityResponseCollection', data: Array<{ __typename?: 'PageEntity', id?: string | null, attributes?: { __typename?: 'Page', title: string, slug?: string | null, hideMenu?: boolean | null, seo?: { __typename?: 'ComponentSharedSeo', canonicalURL?: string | null, id: string, keywords?: string | null, metaDescription: string, metaRobots?: string | null, metaTitle: string, metaViewport?: string | null, metaImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, formats?: any | null, url: string } | null } | null } | null, metaSocial?: Array<{ __typename?: 'ComponentSharedMetaSocial', id: string, description: string, socialNetwork: Enum_Componentsharedmetasocial_Socialnetwork, title: string, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, formats?: any | null, url: string } | null } | null } | null } | null> | null } | null, components?: Array<{ __typename?: 'ComponentCmsDataAnimatedCardSection', id: string, topTitle?: string | null, AnimatedCardSectionMainTitle: string, DataAnimatedCardSectionSecondaryTitle?: string | null, button?: { __typename?: 'ComponentCmsDataButton', id: string, text: string, url: string } | null, secondSectionImages?: { __typename?: 'UploadFileRelationResponseCollection', data: Array<{ __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, url: string, caption?: string | null } | null }> } | null, firstSectionImages: { __typename?: 'UploadFileRelationResponseCollection', data: Array<{ __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, url: string, caption?: string | null } | null }> } } | { __typename?: 'ComponentCmsDataAuthorsListSection', topTitle?: string | null, showSearch?: boolean | null, showCategories?: boolean | null, numberOfAuthorsToDisplay?: number | null, id: string, description?: string | null, displayAsSlider?: boolean | null, AuthorListMainTitle?: string | null, authors?: { __typename?: 'UsersPermissionsUserRelationResponseCollection', data: Array<{ __typename?: 'UsersPermissionsUserEntity', id?: string | null, attributes?: { __typename?: 'UsersPermissionsUser', username: string, email: string } | null }> } | null } | { __typename?: 'ComponentCmsDataBlogArticles' } | { __typename?: 'ComponentCmsDataCaptureContact' } | { __typename?: 'ComponentCmsDataDarkBgImageSection', id: string, centerText?: boolean | null, mainTitle: string, DarkBgImageSectionSecondaryTitle: string, backgroundImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, url: string } | null } | null } | null, button?: { __typename?: 'ComponentCmsDataButton', id: string, text: string, url: string, color?: string | null, textColor?: string | null } | null, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, url: string } | null } | null } | null, countDownTimer?: { __typename?: 'ComponentCmsDataCountDownTimer', id: string, endDate?: any | null, description?: string | null } | null } | { __typename?: 'ComponentCmsDataDarkImageContent', id: string, buttonText?: string | null, buttonUrl?: string | null, darkImageContentMainTitle?: string | null, backgroundImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', url: string } | null } | null } | null, left?: { __typename?: 'ComponentCmsDataDarkImageSection', id: string, title?: string | null, items?: Array<{ __typename?: 'ComponentCmsDataDarkImageItem', id: string, title?: string | null, description?: string | null } | null> | null } | null, right?: { __typename?: 'ComponentCmsDataDarkImageSection', id: string, title?: string | null, items?: Array<{ __typename?: 'ComponentCmsDataDarkImageItem', id: string, title?: string | null, description?: string | null } | null> | null } | null, countDownTimer?: { __typename?: 'ComponentCmsDataCountDownTimer', id: string, endDate?: any | null, description?: string | null } | null } | { __typename?: 'ComponentCmsDataDarkTextBoxSection', id: string, topTitle?: string | null, topTitleColor?: string | null, mainTitle: string, mainTitleColor?: string | null, box?: boolean | null, boxColor?: string | null, boxTitle?: string | null, boxTitleColor?: string | null, boxText?: string | null, boxTextColor?: string | null, bottomTitle?: string | null, buttonTitleColor?: string | null, centerText?: boolean | null, DarkTextBoxSectionButton?: { __typename?: 'ComponentCmsDataButton', id: string, text: string, textColor?: string | null, url: string, color?: string | null } | null, backgroundImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, url: string, formats?: any | null } | null } | null } | null, mobileBackgroundImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, url: string, formats?: any | null } | null } | null } | null } | { __typename?: 'ComponentCmsDataDarkVersusContent', id: string, subtitle?: string | null, buttonText?: string | null, buttonUrl?: string | null, scarcityTitle?: string | null, darkVersusContentMainTitle?: string | null, darkVersusContentTitle?: string | null, countDownTimer?: { __typename?: 'ComponentCmsDataCountDownTimer', id: string, endDate?: any | null, description?: string | null } | null, bottomImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', url: string } | null } | null } | null, darkVersusContentItems?: Array<{ __typename?: 'ComponentCmsDataDarkVersusBox', id: string, title?: string | null, leftItem?: { __typename?: 'ComponentCmsDataDarkVersusItem', id: string, title?: string | null, iconName?: string | null, content?: string | null } | null, rightItem?: { __typename?: 'ComponentCmsDataDarkVersusItem', id: string, title?: string | null, content?: string | null, iconName?: string | null } | null } | null> | null } | { __typename?: 'ComponentCmsDataEventsListSection' } | { __typename?: 'ComponentCmsDataFaq', title?: string | null, id: string, items?: Array<{ __typename?: 'ComponentCmsDataFaqItem', id: string, answer: string, question: string } | null> | null } | { __typename?: 'ComponentCmsDataFooterSection', id: string, rightText?: string | null, leftText: string, bottomContent?: string | null, iconColumnTitle?: string | null, iconLinks?: Array<{ __typename?: 'ComponentCmsDataFooterIconLink', iconName?: string | null, id: string, link?: string | null, text?: string | null } | null> | null, columns?: Array<{ __typename?: 'ComponentCmsDataFooterColumn', id: string, title?: string | null, content?: string | null } | null> | null } | { __typename?: 'ComponentCmsDataFormGroup', id: string, ask_for_rfid?: boolean | null, redirectUrl?: string | null, random_questions?: boolean | null, number_of_random_questions?: number | null, show_start_screen?: boolean | null, thank_you_message?: string | null, thank_you_message_color?: string | null, thank_you_message_background?: string | null, formGroupTitle: string, formGroupType?: Enum_Componentcmsdataformgroup_Type | null, house_videos?: Array<{ __typename?: 'ComponentGeneralHouseWithVideo', id: string, house?: { __typename?: 'HouseEntityResponse', data?: { __typename?: 'HouseEntity', id?: string | null, attributes?: { __typename?: 'House', name: string } | null } | null } | null, video: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, mime: string } | null } | null } } | null> | null, questions?: Array<{ __typename?: 'ComponentCmsDataFormQuestion', id: string, is_required?: boolean | null, use_recaptcha?: boolean | null, center_text?: boolean | null, title: string, title_color?: string | null, description?: string | null, description_color?: string | null, index: number, size?: Enum_Componentcmsdataformquestion_Size | null, type?: Enum_Componentcmsdataformquestion_Type | null, desktop_layout?: Enum_Componentcmsdataformquestion_Desktop_Layout | null, mobile_layout?: Enum_Componentcmsdataformquestion_Mobile_Layout | null, vertical_alignment?: Enum_Componentcmsdataformquestion_Vertical_Alignment | null, restart_form_timer: number, send_review_to_google?: boolean | null, input_color?: string | null, input_placeholder?: string | null, submit_button_text: string, submit_button_color?: string | null, submit_button_text_color?: string | null, submit_button_sticky?: boolean | null, is_transparent_button?: boolean | null, next_question_index?: number | null, image_position?: Enum_Componentcmsdataformquestion_Image_Position | null, background_color?: string | null, allow_other_choice?: boolean | null, nr_columns: number, space_from_top?: number | null, feedback_media_text?: string | null, rate_user?: { __typename?: 'UsersPermissionsUserRelationResponseCollection', data: Array<{ __typename?: 'UsersPermissionsUserEntity', id?: string | null }> } | null, rate_user_role?: { __typename?: 'CrmRoleRelationResponseCollection', data: Array<{ __typename?: 'CrmRoleEntity', id?: string | null }> } | null, allocate_tags?: { __typename?: 'ActiveCampaignAcTagRelationResponseCollection', data: Array<{ __typename?: 'ActiveCampaignAcTagEntity', id?: string | null }> } | null, allocate_house?: { __typename?: 'HouseEntityResponse', data?: { __typename?: 'HouseEntity', id?: string | null, attributes?: { __typename?: 'House', name: string } | null } | null } | null, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, mime: string, url: string } | null } | null } | null, video?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, mime: string, url: string } | null } | null } | null, feedback_media?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, mime: string, url: string } | null } | null } | null, choices?: Array<{ __typename?: 'ComponentCmsDataFormQchoice', id: string, choice_text?: string | null, choice_shortcut?: string | null, choice_color?: string | null, choice_color_transparent?: boolean | null, choice_big_button?: boolean | null, display_delay: number, jump_to_question_index: number, jump_condition_operation: Enum_Componentcmsdataformqchoice_Jump_Condition_Operation, feedback_media_text?: string | null, choice_media?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, mime: string, url: string } | null } | null } | null, allocate_house?: { __typename?: 'HouseEntityResponse', data?: { __typename?: 'HouseEntity', id?: string | null, attributes?: { __typename?: 'House', name: string } | null } | null } | null, feedback_media?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, mime: string, url: string } | null } | null } | null, allocate_tags?: { __typename?: 'ActiveCampaignAcTagRelationResponseCollection', data: Array<{ __typename?: 'ActiveCampaignAcTagEntity', id?: string | null }> } | null } | null> | null } | null> | null } | { __typename?: 'ComponentCmsDataHeaderSection', id: string, helloBarContent?: string | null, HeaderSectionButton?: { __typename?: 'ComponentCmsDataButton', id: string, text: string, url: string } | null, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, url: string } | null } | null } | null } | { __typename?: 'ComponentCmsDataHeroSection', id: string, mainTitle: string, bgColor?: string | null, box?: boolean | null, boxColor?: string | null, textColor?: string | null, textShadow?: boolean | null, DataHeroSectionSecondaryTitle?: string | null, HeroSectionTopTitle?: string | null, HeroSectionButton?: { __typename?: 'ComponentCmsDataButton', id: string, text: string, url: string } | null, countDownTimer?: { __typename?: 'ComponentCmsDataCountDownTimer', id: string, description?: string | null, endDate?: any | null } | null, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null } | null } | null } | null, mobileImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null } | null } | null } | null } | { __typename?: 'ComponentCmsDataHeroSectionSlider', id: string, name: string, autoPlay?: boolean | null, heroSectionSliderItems?: Array<{ __typename?: 'ComponentCmsDataHeroSection', id: string, mainTitle: string, secondaryTitle?: string | null, topTitle?: string | null, bgColor?: string | null, box?: boolean | null, boxColor?: string | null, textColor?: string | null, textShadow?: boolean | null, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, mime: string } | null } | null } | null, mobileImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, mime: string } | null } | null } | null, countDownTimer?: { __typename?: 'ComponentCmsDataCountDownTimer', id: string, description?: string | null, endDate?: any | null } | null, button?: { __typename?: 'ComponentCmsDataButton', id: string, text: string, url: string, color?: string | null, textColor?: string | null } | null } | null> | null } | { __typename?: 'ComponentCmsDataHeroSectionTwo', bottomText?: string | null, id: string, textAfterButton?: boolean | null, topText?: string | null, belowTitle?: string | null, HeroSectionTwoMainTitle: string, button?: { __typename?: 'ComponentCmsDataButton', id: string, text: string, url: string, color?: string | null, textColor?: string | null } | null, HeroSectionTwoImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, url: string } | null } | null } | null } | { __typename?: 'ComponentCmsDataIconCardsSection', mainTitle: string, subTitle: string, id: string, centerText?: boolean | null, showAppButton?: boolean | null, hasExclamationMark?: boolean | null, backgroundColor?: string | null, IconCardsSectionTopTitle: string, iconCards: Array<{ __typename?: 'ComponentCmsDataIconCard', iconName: string, id: string, large?: boolean | null, subTitle?: string | null, title: string } | null>, IconCardsSectionButtons?: Array<{ __typename?: 'ComponentCmsDataButton', id: string, text: string, url: string } | null> | null } | { __typename?: 'ComponentCmsDataImageCardsSection', id: string, backgroundColor?: string | null, ImageCardsSectiontitle?: string | null, items?: Array<{ __typename?: 'ComponentCmsDataImageCard', buttonText?: string | null, buttonUrl?: string | null, id: string, large?: boolean | null, text?: string | null, title: string, textColor?: string | null, backgroundColor?: string | null, logo?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, url: string, formats?: any | null } | null } | null } | null, picture?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, url: string, mime: string, formats?: any | null } | null } | null } | null } | null> | null } | { __typename?: 'ComponentCmsDataImageGallery', id: string, backgroundColor?: string | null, items?: Array<{ __typename?: 'ComponentCmsDataImageGalleryItem', id: string, category?: string | null, ComponentCmsDataImageGalleryTitle?: string | null, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, formats?: any | null } | null } | null } | null } | null> | null } | { __typename?: 'ComponentCmsDataInteractiveImageMap', id: string, interactiveImageMapTitle: string, interactiveImageMapImage: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', url: string, formats?: any | null, alternativeText?: string | null } | null } | null }, circles?: Array<{ __typename?: 'ComponentCmsDataImageMapCircle', id: string, position_x: number, position_y: number, radius: number, details?: { __typename?: 'ComponentCmsDataImageMapDetail', id: string, title: string, description?: string | null, hover_icon?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', url: string, formats?: any | null, alternativeText?: string | null } | null } | null } | null, non_hover_icon?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', url: string, formats?: any | null, alternativeText?: string | null } | null } | null } | null, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', url: string, formats?: any | null, alternativeText?: string | null } | null } | null } | null } | null } | null> | null } | { __typename?: 'ComponentCmsDataLightTopImgSection', id: string, topTitle?: string | null, centerText?: boolean | null, LightTopImgSectionMainTitle?: string | null, DataLightTopImgSectionTextContent?: string | null, topImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, url: string } | null } | null } | null, countDownTimer?: { __typename?: 'ComponentCmsDataCountDownTimer', id: string, endDate?: any | null, description?: string | null } | null } | { __typename?: 'ComponentCmsDataPriceSection', id: string, description?: string | null, descriptionColor?: string | null, mainTitleColor?: string | null, topTitle?: string | null, topTitleColor?: string | null, priceItemsPerSlideWeb?: number | null, sectionId?: string | null, showAsSlider?: boolean | null, showAsSliderWeb?: boolean | null, centerTitle?: boolean | null, shortDescription?: string | null, PriceSectionMainTitle?: string | null, priceItems?: Array<{ __typename?: 'ComponentCmsDataPriceItem', buttonText?: string | null, buttonUrl?: string | null, highlightTag?: string | null, id: string, itemDescription?: string | null, itemMainTitle?: string | null, itemMainTitleColor?: string | null, itemTopTitle?: string | null, itemTopTitleColor?: string | null, monthlyDiscountedPrice?: string | null, monthlyRegularPrice?: string | null, monthlyUnderPriceText?: string | null, yearlyDiscountedPrice?: string | null, yearlyRegularPrice?: string | null, yearlyUnderPriceText?: string | null, centerItemMainTitleHoriz?: boolean | null, centerPriceHoriz?: boolean | null, centerpriceBenefitsHoriz?: boolean | null, priceBenefits?: Array<{ __typename?: 'ComponentCmsDataPriceBenefit', icon?: string | null, id: string, isGrayedOut?: boolean | null, isBold?: boolean | null, text?: string | null, isIndented?: boolean | null } | null> | null } | null> | null, countDownTimer?: { __typename?: 'ComponentCmsDataCountDownTimer', id: string, endDate?: any | null, description?: string | null } | null } | { __typename?: 'ComponentCmsDataProductsList', id: string, displayType: Enum_Componentcmsdataproductslist_Displaytype, groupByCategory?: boolean | null, show?: any | null, showInPopup?: any | null, popupType?: Enum_Componentcmsdataproductslist_Popuptype | null, productSize: Enum_Componentcmsdataproductslist_Size, menu?: { __typename?: 'MenuEntityResponse', data?: { __typename?: 'MenuEntity', id?: string | null, attributes?: { __typename?: 'Menu', title: string, slug?: string | null, title_dimension?: string | null, description_dimension?: string | null, nutritional_information_dimension?: string | null, web_catalog_items?: { __typename?: 'ProductRelationResponseCollection', data: Array<{ __typename?: 'ProductEntity', id?: string | null, attributes?: { __typename?: 'Product', title: string, description?: string | null, price: number, nutritional_information?: string | null, weight?: number | null, ingredients?: { __typename?: 'IngredientRelationResponseCollection', data: Array<{ __typename?: 'IngredientEntity', id?: string | null, attributes?: { __typename?: 'Ingredient', name: string, allergens?: { __typename?: 'AllergenRelationResponseCollection', data: Array<{ __typename?: 'AllergenEntity', id?: string | null, attributes?: { __typename?: 'Allergen', name: string } | null }> } | null } | null }> } | null, media?: { __typename?: 'UploadFileRelationResponseCollection', data: Array<{ __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', url: string } | null }> } | null, category?: { __typename?: 'ProductCategoryEntityResponse', data?: { __typename?: 'ProductCategoryEntity', id?: string | null, attributes?: { __typename?: 'ProductCategory', name: string } | null } | null } | null } | null }> } | null, nutritional_information_background?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', url: string } | null } | null } | null, nutritional_information_background_2?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', url: string } | null } | null } | null } | null } | null } | null, products?: { __typename?: 'ProductRelationResponseCollection', data: Array<{ __typename?: 'ProductEntity', id?: string | null, attributes?: { __typename?: 'Product', title: string, description?: string | null, price: number, total_calories?: number | null, weight?: number | null, nutritional_information?: string | null, category?: { __typename?: 'ProductCategoryEntityResponse', data?: { __typename?: 'ProductCategoryEntity', id?: string | null, attributes?: { __typename?: 'ProductCategory', name: string } | null } | null } | null, media?: { __typename?: 'UploadFileRelationResponseCollection', data: Array<{ __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, formats?: any | null } | null }> } | null, ingredients?: { __typename?: 'IngredientRelationResponseCollection', data: Array<{ __typename?: 'IngredientEntity', id?: string | null, attributes?: { __typename?: 'Ingredient', name: string, allergens?: { __typename?: 'AllergenRelationResponseCollection', data: Array<{ __typename?: 'AllergenEntity', id?: string | null, attributes?: { __typename?: 'Allergen', name: string } | null }> } | null } | null }> } | null } | null }> } | null } | { __typename?: 'ComponentCmsDataReusable', id: string, reusable_component?: { __typename?: 'ReusableComponentEntityResponse', data?: { __typename?: 'ReusableComponentEntity', id?: string | null, attributes?: { __typename?: 'ReusableComponent', title: string, components: Array<{ __typename?: 'ComponentCmsDataAnimatedCardSection', id: string, topTitle?: string | null, AnimatedCardSectionMainTitle: string, DataAnimatedCardSectionSecondaryTitle?: string | null, button?: { __typename?: 'ComponentCmsDataButton', id: string, text: string, url: string } | null, secondSectionImages?: { __typename?: 'UploadFileRelationResponseCollection', data: Array<{ __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, url: string, caption?: string | null } | null }> } | null, firstSectionImages: { __typename?: 'UploadFileRelationResponseCollection', data: Array<{ __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, url: string, caption?: string | null } | null }> } } | { __typename?: 'ComponentCmsDataAuthorsListSection', topTitle?: string | null, showSearch?: boolean | null, showCategories?: boolean | null, numberOfAuthorsToDisplay?: number | null, id: string, description?: string | null, displayAsSlider?: boolean | null, AuthorListMainTitle?: string | null, authors?: { __typename?: 'UsersPermissionsUserRelationResponseCollection', data: Array<{ __typename?: 'UsersPermissionsUserEntity', id?: string | null, attributes?: { __typename?: 'UsersPermissionsUser', username: string, email: string } | null }> } | null } | { __typename?: 'ComponentCmsDataBlogArticles' } | { __typename?: 'ComponentCmsDataCaptureContact' } | { __typename?: 'ComponentCmsDataDarkBgImageSection', id: string, centerText?: boolean | null, mainTitle: string, DarkBgImageSectionSecondaryTitle: string, backgroundImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, url: string } | null } | null } | null, button?: { __typename?: 'ComponentCmsDataButton', id: string, text: string, url: string, color?: string | null, textColor?: string | null } | null, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, url: string } | null } | null } | null, countDownTimer?: { __typename?: 'ComponentCmsDataCountDownTimer', id: string, endDate?: any | null, description?: string | null } | null } | { __typename?: 'ComponentCmsDataDarkImageContent', id: string, buttonText?: string | null, buttonUrl?: string | null, darkImageContentMainTitle?: string | null, backgroundImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', url: string } | null } | null } | null, left?: { __typename?: 'ComponentCmsDataDarkImageSection', id: string, title?: string | null, items?: Array<{ __typename?: 'ComponentCmsDataDarkImageItem', id: string, title?: string | null, description?: string | null } | null> | null } | null, right?: { __typename?: 'ComponentCmsDataDarkImageSection', id: string, title?: string | null, items?: Array<{ __typename?: 'ComponentCmsDataDarkImageItem', id: string, title?: string | null, description?: string | null } | null> | null } | null, countDownTimer?: { __typename?: 'ComponentCmsDataCountDownTimer', id: string, endDate?: any | null, description?: string | null } | null } | { __typename?: 'ComponentCmsDataDarkTextBoxSection', id: string, topTitle?: string | null, topTitleColor?: string | null, mainTitle: string, mainTitleColor?: string | null, box?: boolean | null, boxColor?: string | null, boxTitle?: string | null, boxTitleColor?: string | null, boxText?: string | null, boxTextColor?: string | null, bottomTitle?: string | null, buttonTitleColor?: string | null, centerText?: boolean | null, DarkTextBoxSectionButton?: { __typename?: 'ComponentCmsDataButton', id: string, text: string, textColor?: string | null, url: string, color?: string | null } | null, backgroundImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, url: string, formats?: any | null } | null } | null } | null, mobileBackgroundImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, url: string, formats?: any | null } | null } | null } | null } | { __typename?: 'ComponentCmsDataDarkVersusContent', id: string, subtitle?: string | null, buttonText?: string | null, buttonUrl?: string | null, scarcityTitle?: string | null, darkVersusContentMainTitle?: string | null, darkVersusContentTitle?: string | null, countDownTimer?: { __typename?: 'ComponentCmsDataCountDownTimer', id: string, endDate?: any | null, description?: string | null } | null, bottomImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', url: string } | null } | null } | null, darkVersusContentItems?: Array<{ __typename?: 'ComponentCmsDataDarkVersusBox', id: string, title?: string | null, leftItem?: { __typename?: 'ComponentCmsDataDarkVersusItem', id: string, title?: string | null, iconName?: string | null, content?: string | null } | null, rightItem?: { __typename?: 'ComponentCmsDataDarkVersusItem', id: string, title?: string | null, content?: string | null, iconName?: string | null } | null } | null> | null } | { __typename?: 'ComponentCmsDataEventsListSection' } | { __typename?: 'ComponentCmsDataFaq', title?: string | null, id: string, items?: Array<{ __typename?: 'ComponentCmsDataFaqItem', id: string, answer: string, question: string } | null> | null } | { __typename?: 'ComponentCmsDataFooterSection', id: string, rightText?: string | null, leftText: string, bottomContent?: string | null, iconColumnTitle?: string | null, iconLinks?: Array<{ __typename?: 'ComponentCmsDataFooterIconLink', iconName?: string | null, id: string, link?: string | null, text?: string | null } | null> | null, columns?: Array<{ __typename?: 'ComponentCmsDataFooterColumn', id: string, title?: string | null, content?: string | null } | null> | null } | { __typename?: 'ComponentCmsDataFormGroup', id: string, ask_for_rfid?: boolean | null, redirectUrl?: string | null, random_questions?: boolean | null, number_of_random_questions?: number | null, show_start_screen?: boolean | null, thank_you_message?: string | null, thank_you_message_color?: string | null, thank_you_message_background?: string | null, formGroupTitle: string, formGroupType?: Enum_Componentcmsdataformgroup_Type | null, house_videos?: Array<{ __typename?: 'ComponentGeneralHouseWithVideo', id: string, house?: { __typename?: 'HouseEntityResponse', data?: { __typename?: 'HouseEntity', id?: string | null, attributes?: { __typename?: 'House', name: string } | null } | null } | null, video: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, mime: string } | null } | null } } | null> | null, questions?: Array<{ __typename?: 'ComponentCmsDataFormQuestion', id: string, is_required?: boolean | null, use_recaptcha?: boolean | null, center_text?: boolean | null, title: string, title_color?: string | null, description?: string | null, description_color?: string | null, index: number, size?: Enum_Componentcmsdataformquestion_Size | null, type?: Enum_Componentcmsdataformquestion_Type | null, desktop_layout?: Enum_Componentcmsdataformquestion_Desktop_Layout | null, mobile_layout?: Enum_Componentcmsdataformquestion_Mobile_Layout | null, vertical_alignment?: Enum_Componentcmsdataformquestion_Vertical_Alignment | null, restart_form_timer: number, send_review_to_google?: boolean | null, input_color?: string | null, input_placeholder?: string | null, submit_button_text: string, submit_button_color?: string | null, submit_button_text_color?: string | null, submit_button_sticky?: boolean | null, is_transparent_button?: boolean | null, next_question_index?: number | null, image_position?: Enum_Componentcmsdataformquestion_Image_Position | null, background_color?: string | null, allow_other_choice?: boolean | null, nr_columns: number, space_from_top?: number | null, feedback_media_text?: string | null, rate_user?: { __typename?: 'UsersPermissionsUserRelationResponseCollection', data: Array<{ __typename?: 'UsersPermissionsUserEntity', id?: string | null }> } | null, rate_user_role?: { __typename?: 'CrmRoleRelationResponseCollection', data: Array<{ __typename?: 'CrmRoleEntity', id?: string | null }> } | null, allocate_tags?: { __typename?: 'ActiveCampaignAcTagRelationResponseCollection', data: Array<{ __typename?: 'ActiveCampaignAcTagEntity', id?: string | null }> } | null, allocate_house?: { __typename?: 'HouseEntityResponse', data?: { __typename?: 'HouseEntity', id?: string | null, attributes?: { __typename?: 'House', name: string } | null } | null } | null, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, mime: string, url: string } | null } | null } | null, video?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, mime: string, url: string } | null } | null } | null, feedback_media?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, mime: string, url: string } | null } | null } | null, choices?: Array<{ __typename?: 'ComponentCmsDataFormQchoice', id: string, choice_text?: string | null, choice_shortcut?: string | null, choice_color?: string | null, choice_color_transparent?: boolean | null, choice_big_button?: boolean | null, display_delay: number, jump_to_question_index: number, jump_condition_operation: Enum_Componentcmsdataformqchoice_Jump_Condition_Operation, feedback_media_text?: string | null, choice_media?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, mime: string, url: string } | null } | null } | null, allocate_house?: { __typename?: 'HouseEntityResponse', data?: { __typename?: 'HouseEntity', id?: string | null, attributes?: { __typename?: 'House', name: string } | null } | null } | null, feedback_media?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, mime: string, url: string } | null } | null } | null, allocate_tags?: { __typename?: 'ActiveCampaignAcTagRelationResponseCollection', data: Array<{ __typename?: 'ActiveCampaignAcTagEntity', id?: string | null }> } | null } | null> | null } | null> | null } | { __typename?: 'ComponentCmsDataHeaderSection', id: string, helloBarContent?: string | null, HeaderSectionButton?: { __typename?: 'ComponentCmsDataButton', id: string, text: string, url: string } | null, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, url: string } | null } | null } | null } | { __typename?: 'ComponentCmsDataHeroSection', id: string, mainTitle: string, bgColor?: string | null, box?: boolean | null, boxColor?: string | null, textColor?: string | null, textShadow?: boolean | null, DataHeroSectionSecondaryTitle?: string | null, HeroSectionTopTitle?: string | null, HeroSectionButton?: { __typename?: 'ComponentCmsDataButton', id: string, text: string, url: string } | null, countDownTimer?: { __typename?: 'ComponentCmsDataCountDownTimer', id: string, description?: string | null, endDate?: any | null } | null, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null } | null } | null } | null, mobileImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null } | null } | null } | null } | { __typename?: 'ComponentCmsDataHeroSectionSlider', id: string, name: string, autoPlay?: boolean | null, heroSectionSliderItems?: Array<{ __typename?: 'ComponentCmsDataHeroSection', id: string, mainTitle: string, secondaryTitle?: string | null, topTitle?: string | null, bgColor?: string | null, box?: boolean | null, boxColor?: string | null, textColor?: string | null, textShadow?: boolean | null, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, mime: string } | null } | null } | null, mobileImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, mime: string } | null } | null } | null, countDownTimer?: { __typename?: 'ComponentCmsDataCountDownTimer', id: string, description?: string | null, endDate?: any | null } | null, button?: { __typename?: 'ComponentCmsDataButton', id: string, text: string, url: string, color?: string | null, textColor?: string | null } | null } | null> | null } | { __typename?: 'ComponentCmsDataHeroSectionTwo', bottomText?: string | null, id: string, textAfterButton?: boolean | null, topText?: string | null, belowTitle?: string | null, HeroSectionTwoMainTitle: string, button?: { __typename?: 'ComponentCmsDataButton', id: string, text: string, url: string, color?: string | null, textColor?: string | null } | null, HeroSectionTwoImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, url: string } | null } | null } | null } | { __typename?: 'ComponentCmsDataIconCardsSection', mainTitle: string, subTitle: string, id: string, centerText?: boolean | null, showAppButton?: boolean | null, hasExclamationMark?: boolean | null, backgroundColor?: string | null, IconCardsSectionTopTitle: string, iconCards: Array<{ __typename?: 'ComponentCmsDataIconCard', iconName: string, id: string, large?: boolean | null, subTitle?: string | null, title: string } | null>, IconCardsSectionButtons?: Array<{ __typename?: 'ComponentCmsDataButton', id: string, text: string, url: string } | null> | null } | { __typename?: 'ComponentCmsDataImageCardsSection', id: string, backgroundColor?: string | null, ImageCardsSectiontitle?: string | null, items?: Array<{ __typename?: 'ComponentCmsDataImageCard', buttonText?: string | null, buttonUrl?: string | null, id: string, large?: boolean | null, text?: string | null, title: string, textColor?: string | null, backgroundColor?: string | null, logo?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, url: string, formats?: any | null } | null } | null } | null, picture?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, url: string, mime: string, formats?: any | null } | null } | null } | null } | null> | null } | { __typename?: 'ComponentCmsDataImageGallery', id: string, backgroundColor?: string | null, items?: Array<{ __typename?: 'ComponentCmsDataImageGalleryItem', id: string, category?: string | null, ComponentCmsDataImageGalleryTitle?: string | null, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, formats?: any | null } | null } | null } | null } | null> | null } | { __typename?: 'ComponentCmsDataInteractiveImageMap' } | { __typename?: 'ComponentCmsDataLightTopImgSection', id: string, topTitle?: string | null, centerText?: boolean | null, LightTopImgSectionMainTitle?: string | null, DataLightTopImgSectionTextContent?: string | null, topImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, url: string } | null } | null } | null, countDownTimer?: { __typename?: 'ComponentCmsDataCountDownTimer', id: string, endDate?: any | null, description?: string | null } | null } | { __typename?: 'ComponentCmsDataPriceSection', id: string, description?: string | null, descriptionColor?: string | null, mainTitleColor?: string | null, topTitle?: string | null, topTitleColor?: string | null, priceItemsPerSlideWeb?: number | null, sectionId?: string | null, showAsSlider?: boolean | null, showAsSliderWeb?: boolean | null, centerTitle?: boolean | null, shortDescription?: string | null, PriceSectionMainTitle?: string | null, priceItems?: Array<{ __typename?: 'ComponentCmsDataPriceItem', buttonText?: string | null, buttonUrl?: string | null, highlightTag?: string | null, id: string, itemDescription?: string | null, itemMainTitle?: string | null, itemMainTitleColor?: string | null, itemTopTitle?: string | null, itemTopTitleColor?: string | null, monthlyDiscountedPrice?: string | null, monthlyRegularPrice?: string | null, monthlyUnderPriceText?: string | null, yearlyDiscountedPrice?: string | null, yearlyRegularPrice?: string | null, yearlyUnderPriceText?: string | null, centerItemMainTitleHoriz?: boolean | null, centerPriceHoriz?: boolean | null, centerpriceBenefitsHoriz?: boolean | null, priceBenefits?: Array<{ __typename?: 'ComponentCmsDataPriceBenefit', icon?: string | null, id: string, isGrayedOut?: boolean | null, isBold?: boolean | null, text?: string | null, isIndented?: boolean | null } | null> | null } | null> | null, countDownTimer?: { __typename?: 'ComponentCmsDataCountDownTimer', id: string, endDate?: any | null, description?: string | null } | null } | { __typename?: 'ComponentCmsDataProductsList', id: string, displayType: Enum_Componentcmsdataproductslist_Displaytype, groupByCategory?: boolean | null, show?: any | null, showInPopup?: any | null, popupType?: Enum_Componentcmsdataproductslist_Popuptype | null, productSize: Enum_Componentcmsdataproductslist_Size, menu?: { __typename?: 'MenuEntityResponse', data?: { __typename?: 'MenuEntity', id?: string | null, attributes?: { __typename?: 'Menu', title: string, slug?: string | null, title_dimension?: string | null, description_dimension?: string | null, nutritional_information_dimension?: string | null, web_catalog_items?: { __typename?: 'ProductRelationResponseCollection', data: Array<{ __typename?: 'ProductEntity', id?: string | null, attributes?: { __typename?: 'Product', title: string, description?: string | null, price: number, nutritional_information?: string | null, weight?: number | null, ingredients?: { __typename?: 'IngredientRelationResponseCollection', data: Array<{ __typename?: 'IngredientEntity', id?: string | null, attributes?: { __typename?: 'Ingredient', name: string, allergens?: { __typename?: 'AllergenRelationResponseCollection', data: Array<{ __typename?: 'AllergenEntity', id?: string | null, attributes?: { __typename?: 'Allergen', name: string } | null }> } | null } | null }> } | null, media?: { __typename?: 'UploadFileRelationResponseCollection', data: Array<{ __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', url: string } | null }> } | null, category?: { __typename?: 'ProductCategoryEntityResponse', data?: { __typename?: 'ProductCategoryEntity', id?: string | null, attributes?: { __typename?: 'ProductCategory', name: string } | null } | null } | null } | null }> } | null, nutritional_information_background?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', url: string } | null } | null } | null, nutritional_information_background_2?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', url: string } | null } | null } | null } | null } | null } | null, products?: { __typename?: 'ProductRelationResponseCollection', data: Array<{ __typename?: 'ProductEntity', id?: string | null, attributes?: { __typename?: 'Product', title: string, description?: string | null, price: number, total_calories?: number | null, weight?: number | null, nutritional_information?: string | null, category?: { __typename?: 'ProductCategoryEntityResponse', data?: { __typename?: 'ProductCategoryEntity', id?: string | null, attributes?: { __typename?: 'ProductCategory', name: string } | null } | null } | null, media?: { __typename?: 'UploadFileRelationResponseCollection', data: Array<{ __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, formats?: any | null } | null }> } | null, ingredients?: { __typename?: 'IngredientRelationResponseCollection', data: Array<{ __typename?: 'IngredientEntity', id?: string | null, attributes?: { __typename?: 'Ingredient', name: string, allergens?: { __typename?: 'AllergenRelationResponseCollection', data: Array<{ __typename?: 'AllergenEntity', id?: string | null, attributes?: { __typename?: 'Allergen', name: string } | null }> } | null } | null }> } | null } | null }> } | null } | { __typename?: 'ComponentCmsDataReviewsSection', description?: string | null, id: string, topTitle?: string | null, hideImage?: boolean | null, size?: Enum_Componentcmsdatareviewssection_Size | null, box?: boolean | null, boxColor?: string | null, textColor?: string | null, itemBoxColor?: string | null, itemBoxTextColor?: string | null, ReviewSectionMainTitle?: string | null, reviewItems?: Array<{ __typename?: 'ComponentCmsDataReviewItem', authorLocation?: string | null, authorName?: string | null, authorOccupations?: string | null, contentNrOfChars?: number | null, content?: string | null, id: string, showPictureAsCircle?: boolean | null, title?: string | null, authorPicture?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, url: string, formats?: any | null } | null } | null } | null } | null> | null } | { __typename?: 'ComponentCmsDataRichText', id: string, text?: string | null, center?: boolean | null, fullWidth?: boolean | null, verticalWider?: boolean | null, backgroundImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, url: string } | null } | null } | null } | { __typename?: 'ComponentCmsDataRichTextHtml', id: string, text?: string | null, center?: boolean | null, fullWidth?: boolean | null, verticalWider?: boolean | null, backgroundImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, url: string } | null } | null } | null } | { __typename?: 'ComponentCmsDataScheduleMeeting' } | { __typename?: 'ComponentCmsDataScrollListSection', bottomSectionTitle?: string | null, id: string, mainTitle: string, topTitle?: string | null, shortDescription?: string | null, ScrollListSectionSecondaryTitle?: string | null, backgroundImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, url: string } | null } | null } | null, bottomSectionImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, url: string } | null } | null } | null, boxes: Array<{ __typename?: 'ComponentCmsDataBoxElement', id: string, boxTitle: string, boxText: string, listTitle?: string | null, bottomText?: string | null, boxCards?: Array<{ __typename?: 'ComponentCmsDataBoxCard', id: string, text: string, title: string, showMoreText?: string | null, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, url: string } | null } | null } | null } | null> | null } | null>, ScrollListSectionButton?: { __typename?: 'ComponentCmsDataButton', url: string, text: string, id: string } | null, countDownTimer?: { __typename?: 'ComponentCmsDataCountDownTimer', description?: string | null, endDate?: any | null, id: string } | null } | { __typename?: 'ComponentCmsDataScrollToSection', id: string, sectionId?: string | null } | { __typename?: 'ComponentCmsDataSingleTitleSection', id: string, center?: boolean | null, topTitle?: string | null, backgroundColor?: string | null, textColor?: string | null, SingleTitleMainTitle?: string | null, SingleTitleSubTitle?: string | null } | { __typename?: 'ComponentCmsDataSlider', id: string, type?: Enum_Componentcmsdataslider_Type | null, title?: string | null, centerText?: boolean | null, popup?: boolean | null, popupRichText?: string | null, DataSliderSubTitle?: string | null, items?: Array<{ __typename?: 'ComponentCmsDataSliderItem', body?: string | null, id: string, link?: string | null, title: string, subtitleOverImage?: boolean | null, underText?: string | null, titleNrOfChars?: number | null, underTextNrOfChars?: number | null, bodyNrOfChars?: number | null, frameColor?: string | null, titleColor?: string | null, bodyColor?: string | null, underTexColor?: string | null, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, url: string, formats?: any | null } | null } | null } | null } | null> | null } | { __typename?: 'ComponentCmsDataSubscriptionPopup' } | { __typename?: 'ComponentCmsDataTextAndImageSection', id: string, mainTitle: string, mainTitleColor?: string | null, reverse?: boolean | null, topTitle?: string | null, topTitleColor?: string | null, hideImageOnMobile?: boolean | null, maskImage?: boolean | null, bigImageOnMobile?: boolean | null, variation?: Enum_Componentcmsdatatextandimagesection_Variation | null, rounded?: boolean | null, shadow?: boolean | null, backgroundColor?: string | null, DataTextAndImageSectionTextContent: string, DataTextAndImageSectionTextContentColor?: string | null, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, url: string, formats?: any | null } | null } | null } | null, TextAndImageSectionButton?: Array<{ __typename?: 'ComponentCmsDataButton', id: string, text: string, url: string, color?: string | null, textColor?: string | null } | null> | null, countDownTimer?: { __typename?: 'ComponentCmsDataCountDownTimer', id: string, description?: string | null, endDate?: any | null } | null, underTextImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, url: string, formats?: any | null } | null } | null } | null, imageMask?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, formats?: any | null } | null } | null } | null, imageBackgroundMask?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, formats?: any | null } | null } | null } | null } | { __typename?: 'ComponentCmsDataVideoSection', id: string, belowTitleText?: string | null, centerVideo?: boolean | null, bottomText?: string | null, textAfterButton?: boolean | null, topText?: string | null, VideoSectionMainTitle?: string | null, video?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', url: string } | null } | null } | null, videoMobile?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', url: string } | null } | null } | null, button?: { __typename?: 'ComponentCmsDataButton', id: string, text: string, url: string, color?: string | null, textColor?: string | null } | null, countdownTimer?: { __typename?: 'ComponentCmsDataCountDownTimer', id: string, endDate?: any | null, description?: string | null } | null } | { __typename?: 'Error' } | null> } | null } | null } | null } | { __typename?: 'ComponentCmsDataReviewsSection', description?: string | null, id: string, topTitle?: string | null, hideImage?: boolean | null, size?: Enum_Componentcmsdatareviewssection_Size | null, box?: boolean | null, boxColor?: string | null, textColor?: string | null, itemBoxColor?: string | null, itemBoxTextColor?: string | null, ReviewSectionMainTitle?: string | null, reviewItems?: Array<{ __typename?: 'ComponentCmsDataReviewItem', authorLocation?: string | null, authorName?: string | null, authorOccupations?: string | null, contentNrOfChars?: number | null, content?: string | null, id: string, showPictureAsCircle?: boolean | null, title?: string | null, authorPicture?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, url: string, formats?: any | null } | null } | null } | null } | null> | null } | { __typename?: 'ComponentCmsDataRichText', id: string, text?: string | null, center?: boolean | null, fullWidth?: boolean | null, verticalWider?: boolean | null, backgroundImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, url: string } | null } | null } | null } | { __typename?: 'ComponentCmsDataRichTextHtml', id: string, text?: string | null, center?: boolean | null, fullWidth?: boolean | null, verticalWider?: boolean | null, backgroundImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, url: string } | null } | null } | null } | { __typename?: 'ComponentCmsDataScheduleMeeting' } | { __typename?: 'ComponentCmsDataScrollListSection', bottomSectionTitle?: string | null, id: string, mainTitle: string, topTitle?: string | null, shortDescription?: string | null, ScrollListSectionSecondaryTitle?: string | null, backgroundImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, url: string } | null } | null } | null, bottomSectionImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, url: string } | null } | null } | null, boxes: Array<{ __typename?: 'ComponentCmsDataBoxElement', id: string, boxTitle: string, boxText: string, listTitle?: string | null, bottomText?: string | null, boxCards?: Array<{ __typename?: 'ComponentCmsDataBoxCard', id: string, text: string, title: string, showMoreText?: string | null, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, url: string } | null } | null } | null } | null> | null } | null>, ScrollListSectionButton?: { __typename?: 'ComponentCmsDataButton', url: string, text: string, id: string } | null, countDownTimer?: { __typename?: 'ComponentCmsDataCountDownTimer', description?: string | null, endDate?: any | null, id: string } | null } | { __typename?: 'ComponentCmsDataScrollToSection', id: string, sectionId?: string | null } | { __typename?: 'ComponentCmsDataSingleTitleSection', id: string, center?: boolean | null, topTitle?: string | null, backgroundColor?: string | null, textColor?: string | null, SingleTitleMainTitle?: string | null, SingleTitleSubTitle?: string | null } | { __typename?: 'ComponentCmsDataSlider', id: string, type?: Enum_Componentcmsdataslider_Type | null, title?: string | null, centerText?: boolean | null, popup?: boolean | null, popupRichText?: string | null, DataSliderSubTitle?: string | null, items?: Array<{ __typename?: 'ComponentCmsDataSliderItem', body?: string | null, id: string, link?: string | null, title: string, subtitleOverImage?: boolean | null, underText?: string | null, titleNrOfChars?: number | null, underTextNrOfChars?: number | null, bodyNrOfChars?: number | null, frameColor?: string | null, titleColor?: string | null, bodyColor?: string | null, underTexColor?: string | null, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, url: string, formats?: any | null } | null } | null } | null } | null> | null } | { __typename?: 'ComponentCmsDataSubscriptionPopup' } | { __typename?: 'ComponentCmsDataTextAndImageSection', id: string, mainTitle: string, mainTitleColor?: string | null, reverse?: boolean | null, topTitle?: string | null, topTitleColor?: string | null, hideImageOnMobile?: boolean | null, maskImage?: boolean | null, bigImageOnMobile?: boolean | null, variation?: Enum_Componentcmsdatatextandimagesection_Variation | null, rounded?: boolean | null, shadow?: boolean | null, backgroundColor?: string | null, DataTextAndImageSectionTextContent: string, DataTextAndImageSectionTextContentColor?: string | null, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, url: string, formats?: any | null } | null } | null } | null, TextAndImageSectionButton?: Array<{ __typename?: 'ComponentCmsDataButton', id: string, text: string, url: string, color?: string | null, textColor?: string | null } | null> | null, countDownTimer?: { __typename?: 'ComponentCmsDataCountDownTimer', id: string, description?: string | null, endDate?: any | null } | null, underTextImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, url: string, formats?: any | null } | null } | null } | null, imageMask?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, formats?: any | null } | null } | null } | null, imageBackgroundMask?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null, formats?: any | null } | null } | null } | null } | { __typename?: 'ComponentCmsDataVideoSection', id: string, belowTitleText?: string | null, centerVideo?: boolean | null, bottomText?: string | null, textAfterButton?: boolean | null, topText?: string | null, VideoSectionMainTitle?: string | null, video?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', url: string } | null } | null } | null, videoMobile?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', url: string } | null } | null } | null, button?: { __typename?: 'ComponentCmsDataButton', id: string, text: string, url: string, color?: string | null, textColor?: string | null } | null, countdownTimer?: { __typename?: 'ComponentCmsDataCountDownTimer', id: string, endDate?: any | null, description?: string | null } | null } | { __typename?: 'Error' } | null> | null } | null }> } | null };

export type GetPagesHeaderQueryVariables = Exact<{
  filters?: InputMaybe<PageFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
}>;


export type GetPagesHeaderQuery = { __typename?: 'Query', pages?: { __typename?: 'PageEntityResponseCollection', data: Array<{ __typename?: 'PageEntity', id?: string | null, attributes?: { __typename?: 'Page', components?: Array<{ __typename?: 'ComponentCmsDataAnimatedCardSection' } | { __typename?: 'ComponentCmsDataAuthorsListSection' } | { __typename?: 'ComponentCmsDataBlogArticles' } | { __typename?: 'ComponentCmsDataCaptureContact' } | { __typename?: 'ComponentCmsDataDarkBgImageSection' } | { __typename?: 'ComponentCmsDataDarkImageContent' } | { __typename?: 'ComponentCmsDataDarkTextBoxSection' } | { __typename?: 'ComponentCmsDataDarkVersusContent' } | { __typename?: 'ComponentCmsDataEventsListSection' } | { __typename?: 'ComponentCmsDataFaq' } | { __typename?: 'ComponentCmsDataFooterSection' } | { __typename?: 'ComponentCmsDataFormGroup' } | { __typename?: 'ComponentCmsDataHeaderSection', id: string, button?: { __typename?: 'ComponentCmsDataButton', url: string, text: string, id: string } | null, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, url: string } | null } | null } | null } | { __typename?: 'ComponentCmsDataHeroSection' } | { __typename?: 'ComponentCmsDataHeroSectionSlider' } | { __typename?: 'ComponentCmsDataHeroSectionTwo' } | { __typename?: 'ComponentCmsDataIconCardsSection' } | { __typename?: 'ComponentCmsDataImageCardsSection' } | { __typename?: 'ComponentCmsDataImageGallery' } | { __typename?: 'ComponentCmsDataInteractiveImageMap' } | { __typename?: 'ComponentCmsDataLightTopImgSection' } | { __typename?: 'ComponentCmsDataPriceSection' } | { __typename?: 'ComponentCmsDataProductsList' } | { __typename?: 'ComponentCmsDataReusable' } | { __typename?: 'ComponentCmsDataReviewsSection' } | { __typename?: 'ComponentCmsDataRichText' } | { __typename?: 'ComponentCmsDataRichTextHtml' } | { __typename?: 'ComponentCmsDataScheduleMeeting' } | { __typename?: 'ComponentCmsDataScrollListSection' } | { __typename?: 'ComponentCmsDataScrollToSection' } | { __typename?: 'ComponentCmsDataSingleTitleSection' } | { __typename?: 'ComponentCmsDataSlider' } | { __typename?: 'ComponentCmsDataSubscriptionPopup' } | { __typename?: 'ComponentCmsDataTextAndImageSection' } | { __typename?: 'ComponentCmsDataVideoSection' } | { __typename?: 'Error' } | null> | null } | null }> } | null };

export type GetLandingPageAuthorsQueryVariables = Exact<{
  filters?: InputMaybe<UsersPermissionsUserFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
}>;


export type GetLandingPageAuthorsQuery = { __typename?: 'Query', usersPermissionsUsers?: { __typename?: 'UsersPermissionsUserEntityResponseCollection', data: Array<{ __typename?: 'UsersPermissionsUserEntity', id?: string | null, attributes?: { __typename?: 'UsersPermissionsUser', firstName?: string | null, lastName?: string | null, username: string, email: string } | null }> } | null };

export type PagesSeoQueryVariables = Exact<{
  filters?: InputMaybe<PageFiltersInput>;
}>;


export type PagesSeoQuery = { __typename?: 'Query', pages?: { __typename?: 'PageEntityResponseCollection', data: Array<{ __typename?: 'PageEntity', id?: string | null, attributes?: { __typename?: 'Page', title: string, slug?: string | null, seo?: { __typename?: 'ComponentSharedSeo', canonicalURL?: string | null, id: string, keywords?: string | null, metaDescription: string, metaRobots?: string | null, metaTitle: string, metaViewport?: string | null, metaImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, formats?: any | null, url: string } | null } | null } | null, metaSocial?: Array<{ __typename?: 'ComponentSharedMetaSocial', id: string, description: string, socialNetwork: Enum_Componentsharedmetasocial_Socialnetwork, title: string, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, formats?: any | null, url: string } | null } | null } | null } | null> | null } | null } | null }> } | null };

export type MainLayoutPageQueryVariables = Exact<{
  filters?: InputMaybe<PageFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
}>;


export type MainLayoutPageQuery = { __typename?: 'Query', pages?: { __typename?: 'PageEntityResponseCollection', data: Array<{ __typename?: 'PageEntity', id?: string | null, attributes?: { __typename?: 'Page', title: string, slug?: string | null, seo?: { __typename?: 'ComponentSharedSeo', canonicalURL?: string | null, id: string, keywords?: string | null, metaDescription: string, metaRobots?: string | null, metaTitle: string, metaViewport?: string | null, metaImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, formats?: any | null, url: string } | null } | null } | null, metaSocial?: Array<{ __typename?: 'ComponentSharedMetaSocial', id: string, description: string, socialNetwork: Enum_Componentsharedmetasocial_Socialnetwork, title: string, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, formats?: any | null, url: string } | null } | null } | null } | null> | null } | null, components?: Array<{ __typename?: 'ComponentCmsDataAnimatedCardSection' } | { __typename?: 'ComponentCmsDataAuthorsListSection' } | { __typename?: 'ComponentCmsDataBlogArticles' } | { __typename?: 'ComponentCmsDataCaptureContact' } | { __typename?: 'ComponentCmsDataDarkBgImageSection' } | { __typename?: 'ComponentCmsDataDarkImageContent' } | { __typename?: 'ComponentCmsDataDarkTextBoxSection' } | { __typename?: 'ComponentCmsDataDarkVersusContent' } | { __typename?: 'ComponentCmsDataEventsListSection' } | { __typename?: 'ComponentCmsDataFaq' } | { __typename?: 'ComponentCmsDataFooterSection' } | { __typename?: 'ComponentCmsDataFormGroup' } | { __typename?: 'ComponentCmsDataHeaderSection', id: string, helloBarContent?: string | null, HeaderSectionButton?: { __typename?: 'ComponentCmsDataButton', id: string, text: string, url: string } | null, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, url: string } | null } | null } | null } | { __typename?: 'ComponentCmsDataHeroSection' } | { __typename?: 'ComponentCmsDataHeroSectionSlider' } | { __typename?: 'ComponentCmsDataHeroSectionTwo' } | { __typename?: 'ComponentCmsDataIconCardsSection' } | { __typename?: 'ComponentCmsDataImageCardsSection' } | { __typename?: 'ComponentCmsDataImageGallery' } | { __typename?: 'ComponentCmsDataInteractiveImageMap' } | { __typename?: 'ComponentCmsDataLightTopImgSection' } | { __typename?: 'ComponentCmsDataPriceSection' } | { __typename?: 'ComponentCmsDataProductsList' } | { __typename?: 'ComponentCmsDataReusable' } | { __typename?: 'ComponentCmsDataReviewsSection' } | { __typename?: 'ComponentCmsDataRichText' } | { __typename?: 'ComponentCmsDataRichTextHtml' } | { __typename?: 'ComponentCmsDataScheduleMeeting' } | { __typename?: 'ComponentCmsDataScrollListSection' } | { __typename?: 'ComponentCmsDataScrollToSection' } | { __typename?: 'ComponentCmsDataSingleTitleSection' } | { __typename?: 'ComponentCmsDataSlider' } | { __typename?: 'ComponentCmsDataSubscriptionPopup' } | { __typename?: 'ComponentCmsDataTextAndImageSection' } | { __typename?: 'ComponentCmsDataVideoSection' } | { __typename?: 'Error' } | null> | null } | null }> } | null };

export type GetPageSlugsQueryVariables = Exact<{
  filters?: InputMaybe<PageFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
}>;


export type GetPageSlugsQuery = { __typename?: 'Query', pages?: { __typename?: 'PageEntityResponseCollection', data: Array<{ __typename?: 'PageEntity', id?: string | null, attributes?: { __typename?: 'Page', slug?: string | null, updatedAt?: any | null } | null }> } | null };

export type UpdateUsersPermissionsUserMutationVariables = Exact<{
  updateUsersPermissionsUserId: Scalars['ID'];
  data: UsersPermissionsUserInput;
}>;


export type UpdateUsersPermissionsUserMutation = { __typename?: 'Mutation', updateUsersPermissionsUser: { __typename?: 'UsersPermissionsUserEntityResponse', data?: { __typename?: 'UsersPermissionsUserEntity', id?: string | null, attributes?: { __typename?: 'UsersPermissionsUser', firstName?: string | null, lastName?: string | null, username: string } | null } | null } };

export type CreateCrmCampaignMemberMutationVariables = Exact<{
  data: CrmCampaignMemberInput;
}>;


export type CreateCrmCampaignMemberMutation = { __typename?: 'Mutation', createCrmCampaignMember?: { __typename?: 'CrmCampaignMemberEntityResponse', data?: { __typename?: 'CrmCampaignMemberEntity', id?: string | null, attributes?: { __typename?: 'CrmCampaignMember', info?: string | null } | null } | null } | null };

export type CampaignsQueryVariables = Exact<{
  filters?: InputMaybe<CampaignFiltersInput>;
}>;


export type CampaignsQuery = { __typename?: 'Query', campaigns?: { __typename?: 'CampaignEntityResponseCollection', data: Array<{ __typename?: 'CampaignEntity', id?: string | null, attributes?: { __typename?: 'Campaign', name: string } | null }> } | null };

export type ContactsQueryVariables = Exact<{
  filters?: InputMaybe<ContactFiltersInput>;
}>;


export type ContactsQuery = { __typename?: 'Query', contacts?: { __typename?: 'ContactEntityResponseCollection', data: Array<{ __typename?: 'ContactEntity', id?: string | null, attributes?: { __typename?: 'Contact', email: string } | null }> } | null };

export type GamesQueryVariables = Exact<{
  filters?: InputMaybe<GameFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
}>;


export type GamesQuery = { __typename?: 'Query', games?: { __typename?: 'GameEntityResponseCollection', data: Array<{ __typename?: 'GameEntity', id?: string | null, attributes?: { __typename?: 'Game', name: string } | null }> } | null };

export type RoomsQueryVariables = Exact<{
  filters?: InputMaybe<RoomFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
}>;


export type RoomsQuery = { __typename?: 'Query', rooms?: { __typename?: 'RoomEntityResponseCollection', data: Array<{ __typename?: 'RoomEntity', id?: string | null, attributes?: { __typename?: 'Room', name: string, booking_slot_rules?: Array<{ __typename?: 'ComponentGeneralCalendarBookingSlot', id: string, day: any, start_time: any, end_time: any, active: boolean, slot_length?: number | null } | { __typename?: 'ComponentGeneralDailyBookingSlot', slot_length?: number | null, start_time: any, end_time: any, day_of_week: number, active: boolean, id: string } | { __typename?: 'Error', code: string, message?: string | null } | null> | null } | null }> } | null };

export type ProductsQueryVariables = Exact<{
  filters?: InputMaybe<ProductFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
}>;


export type ProductsQuery = { __typename?: 'Query', products?: { __typename?: 'ProductEntityResponseCollection', data: Array<{ __typename?: 'ProductEntity', id?: string | null, attributes?: { __typename?: 'Product', title: string, description?: string | null, price: number } | null }> } | null };

export type CreateReservationMutationVariables = Exact<{
  data: ReservationInput;
}>;


export type CreateReservationMutation = { __typename?: 'Mutation', createReservation?: { __typename?: 'ReservationEntityResponse', data?: { __typename?: 'ReservationEntity', id?: string | null } | null } | null };

export type UpdateReservationMutationVariables = Exact<{
  updateReservationId: Scalars['ID'];
  data: ReservationInput;
}>;


export type UpdateReservationMutation = { __typename?: 'Mutation', updateReservation?: { __typename?: 'ReservationEntityResponse', data?: { __typename?: 'ReservationEntity', id?: string | null } | null } | null };

export type UpdateCrmCampaignMemberMutationVariables = Exact<{
  updateCrmCampaignMemberId: Scalars['ID'];
  data: CrmCampaignMemberInput;
}>;


export type UpdateCrmCampaignMemberMutation = { __typename?: 'Mutation', updateCrmCampaignMember?: { __typename?: 'CrmCampaignMemberEntityResponse', data?: { __typename?: 'CrmCampaignMemberEntity', id?: string | null } | null } | null };

export type ReservationQueryVariables = Exact<{
  reservationId?: InputMaybe<Scalars['ID']>;
  filters?: InputMaybe<ComponentMenuProductWithQuantityFiltersInput>;
  timeSlotsFilters?: InputMaybe<TimeSlotFiltersInput>;
  usersWithRolesFilters?: InputMaybe<ComponentCrmDataCrmAccountRoleFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
}>;


export type ReservationQuery = { __typename?: 'Query', reservation?: { __typename?: 'ReservationEntityResponse', data?: { __typename?: 'ReservationEntity', id?: string | null, attributes?: { __typename?: 'Reservation', first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null, title: string, status?: Enum_Reservation_Status | null, type?: Enum_Reservation_Type | null, start_date?: any | null, end_date?: any | null, products?: Array<{ __typename?: 'ComponentMenuProductWithQuantity', id: string, quantity: number, info?: string | null, discount_amount?: number | null, discount_percentage?: number | null, product?: { __typename?: 'ProductEntityResponse', data?: { __typename?: 'ProductEntity', id?: string | null, attributes?: { __typename?: 'Product', title: string, price: number } | null } | null } | null } | null> | null, time_slots?: { __typename?: 'TimeSlotRelationResponseCollection', data: Array<{ __typename?: 'TimeSlotEntity', id?: string | null, attributes?: { __typename?: 'TimeSlot', type?: Enum_Timeslot_Type | null, info?: string | null, number_of_persons?: number | null, number_of_tables?: number | null, additional_info?: string | null, start_date: any, end_date: any, game?: { __typename?: 'GameEntityResponse', data?: { __typename?: 'GameEntity', id?: string | null, attributes?: { __typename?: 'Game', name: string } | null } | null } | null, room?: { __typename?: 'RoomEntityResponse', data?: { __typename?: 'RoomEntity', id?: string | null, attributes?: { __typename?: 'Room', name: string } | null } | null } | null } | null }> } | null, crm_campaign_member?: { __typename?: 'CrmCampaignMemberEntityResponse', data?: { __typename?: 'CrmCampaignMemberEntity', id?: string | null, attributes?: { __typename?: 'CrmCampaignMember', info?: string | null, users_with_roles?: Array<{ __typename?: 'ComponentCrmDataCrmAccountRole', id: string, roles?: { __typename?: 'CrmRoleRelationResponseCollection', data: Array<{ __typename?: 'CrmRoleEntity', id?: string | null, attributes?: { __typename?: 'CrmRole', name: string } | null }> } | null, user?: { __typename?: 'UsersPermissionsUserEntityResponse', data?: { __typename?: 'UsersPermissionsUserEntity', id?: string | null, attributes?: { __typename?: 'UsersPermissionsUser', firstName?: string | null, lastName?: string | null } | null } | null } | null } | null> | null, crm_campaign?: { __typename?: 'CampaignEntityResponse', data?: { __typename?: 'CampaignEntity', id?: string | null, attributes?: { __typename?: 'Campaign', users_with_roles?: Array<{ __typename?: 'ComponentCrmDataCrmAccountRole', id: string, user?: { __typename?: 'UsersPermissionsUserEntityResponse', data?: { __typename?: 'UsersPermissionsUserEntity', id?: string | null, attributes?: { __typename?: 'UsersPermissionsUser', firstName?: string | null, lastName?: string | null } | null } | null } | null, roles?: { __typename?: 'CrmRoleRelationResponseCollection', data: Array<{ __typename?: 'CrmRoleEntity', id?: string | null, attributes?: { __typename?: 'CrmRole', name: string } | null }> } | null } | null> | null } | null } | null } | null } | null } | null } | null } | null } | null } | null };

export type ReservationsQueryVariables = Exact<{
  filters?: InputMaybe<ReservationFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  timeSlotsFilters?: InputMaybe<TimeSlotFiltersInput>;
}>;


export type ReservationsQuery = { __typename?: 'Query', reservations?: { __typename?: 'ReservationEntityResponseCollection', data: Array<{ __typename?: 'ReservationEntity', id?: string | null, attributes?: { __typename?: 'Reservation', title: string, start_date?: any | null, end_date?: any | null, status?: Enum_Reservation_Status | null, type?: Enum_Reservation_Type | null, time_slots?: { __typename?: 'TimeSlotRelationResponseCollection', data: Array<{ __typename?: 'TimeSlotEntity', id?: string | null, attributes?: { __typename?: 'TimeSlot', number_of_persons?: number | null, room?: { __typename?: 'RoomEntityResponse', data?: { __typename?: 'RoomEntity', id?: string | null, attributes?: { __typename?: 'Room', name: string, color?: string | null } | null } | null } | null } | null }> } | null, crm_campaign_member?: { __typename?: 'CrmCampaignMemberEntityResponse', data?: { __typename?: 'CrmCampaignMemberEntity', id?: string | null, attributes?: { __typename?: 'CrmCampaignMember', info?: string | null } | null } | null } | null } | null }>, meta: { __typename?: 'ResponseCollectionMeta', pagination: { __typename?: 'Pagination', page: number, pageCount: number, pageSize: number, total: number } } } | null };

export type UpdateTimeSlotMutationVariables = Exact<{
  updateTimeSlotId: Scalars['ID'];
  data: TimeSlotInput;
}>;


export type UpdateTimeSlotMutation = { __typename?: 'Mutation', updateTimeSlot?: { __typename?: 'TimeSlotEntityResponse', data?: { __typename?: 'TimeSlotEntity', id?: string | null } | null } | null };

export type CreateTimeSlotMutationVariables = Exact<{
  data: TimeSlotInput;
}>;


export type CreateTimeSlotMutation = { __typename?: 'Mutation', createTimeSlot?: { __typename?: 'TimeSlotEntityResponse', data?: { __typename?: 'TimeSlotEntity', id?: string | null } | null } | null };

export type TimeSlotsQueryVariables = Exact<{
  filters?: InputMaybe<TimeSlotFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  reservationsFilters?: InputMaybe<ReservationFiltersInput>;
  reservationsPagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
}>;


export type TimeSlotsQuery = { __typename?: 'Query', timeSlots?: { __typename?: 'TimeSlotEntityResponseCollection', data: Array<{ __typename?: 'TimeSlotEntity', id?: string | null, attributes?: { __typename?: 'TimeSlot', info?: string | null, number_of_persons?: number | null, number_of_tables?: number | null, additional_info?: string | null, start_date: any, end_date: any, type?: Enum_Timeslot_Type | null, timesheet_type?: Enum_Timeslot_Timesheet_Type | null, user?: { __typename?: 'UsersPermissionsUserEntityResponse', data?: { __typename?: 'UsersPermissionsUserEntity', id?: string | null, attributes?: { __typename?: 'UsersPermissionsUser', firstName?: string | null, lastName?: string | null } | null } | null } | null, game?: { __typename?: 'GameEntityResponse', data?: { __typename?: 'GameEntity', id?: string | null, attributes?: { __typename?: 'Game', name: string, color?: string | null } | null } | null } | null, room?: { __typename?: 'RoomEntityResponse', data?: { __typename?: 'RoomEntity', id?: string | null, attributes?: { __typename?: 'Room', name: string, color?: string | null } | null } | null } | null, reservations?: { __typename?: 'ReservationRelationResponseCollection', data: Array<{ __typename?: 'ReservationEntity', id?: string | null, attributes?: { __typename?: 'Reservation', title: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null } | null }> } | null } | null }>, meta: { __typename?: 'ResponseCollectionMeta', pagination: { __typename?: 'Pagination', page: number, pageCount: number, pageSize: number, total: number } } } | null };

export const CrmLinkFragmentFragmentDoc = gql`
    fragment crmLinkFragment on CrmLinkRelationResponseCollection {
  data {
    id
    attributes {
      orders {
        data {
          id
          attributes {
            total_price
          }
        }
      }
      crm_links {
        data {
          id
          attributes {
            orders {
              data {
                id
                attributes {
                  total_price
                }
              }
            }
          }
        }
      }
      products {
        data {
          id
          attributes {
            title
          }
        }
      }
    }
  }
}
    `;
export const UserWithRolesFieldsFragmentDoc = gql`
    fragment UserWithRolesFields on ComponentCrmDataCrmAccountRole {
  id
  user {
    data {
      id
      attributes {
        email
      }
    }
  }
  roles {
    data {
      id
      attributes {
        name
      }
    }
  }
}
    `;
export const ProductItemFieldsFragmentDoc = gql`
    fragment ProductItemFields on ComponentMenuProductItem {
  id
  available
  show_picture
  show_weight
  space_1
  space_2
  space_3
  space_4
  price_type
  price_per_100g
  entire_row
  product {
    data {
      id
      attributes {
        title
        weight
        price
        description
        nutritional_information
        ingredients {
          data {
            id
            attributes {
              name
              allergens {
                data {
                  id
                  attributes {
                    name
                  }
                }
              }
            }
          }
        }
        media {
          data {
            id
            attributes {
              alternativeText
              url
            }
          }
        }
      }
    }
  }
  title_dimension
  description_dimension
}
    `;
export const EmptySpaceFieldsFragmentDoc = gql`
    fragment EmptySpaceFields on ComponentMenuEmptySpace {
  id
  size
}
    `;
export const CategoryItemFieldsFragmentDoc = gql`
    fragment CategoryItemFields on ComponentMenuCategoryItem {
  id
  color
  entire_row
  product_category {
    data {
      id
      attributes {
        name
      }
    }
  }
  description_dimension
  title_dimension
}
    `;
export const MenuPhotoFieldsFragmentDoc = gql`
    fragment MenuPhotoFields on ComponentMenuPhoto {
  id
  entire_row
  media {
    data {
      id
      attributes {
        url
      }
    }
  }
}
    `;
export const UserBasicInfoMeFragmentDoc = gql`
    fragment userBasicInfoMe on UsersPermissionsMe {
  id
  username
  email
  confirmed
  blocked
  role {
    id
    name
    description
    type
  }
}
    `;
export const InteractiveImageMapFragmentDoc = gql`
    fragment InteractiveImageMap on ComponentCmsDataInteractiveImageMap {
  id
  interactiveImageMapTitle: title
  interactiveImageMapImage: image {
    data {
      id
      attributes {
        url
        formats
        alternativeText
      }
    }
  }
  circles {
    id
    position_x
    position_y
    radius
    details {
      id
      title
      description
      hover_icon {
        data {
          id
          attributes {
            url
            formats
            alternativeText
          }
        }
      }
      non_hover_icon {
        data {
          id
          attributes {
            url
            formats
            alternativeText
          }
        }
      }
      image {
        data {
          id
          attributes {
            url
            formats
            alternativeText
          }
        }
      }
    }
  }
}
    `;
export const MenuFragmentDoc = gql`
    fragment Menu on MenuEntityResponse {
  data {
    id
    attributes {
      title
      slug
      web_catalog_items(filters: $menuFilters, pagination: $menuPagination) {
        data {
          id
          attributes {
            title
            description
            price
            nutritional_information
            weight
            ingredients {
              data {
                id
                attributes {
                  name
                  allergens {
                    data {
                      id
                      attributes {
                        name
                      }
                    }
                  }
                }
              }
            }
            media {
              data {
                id
                attributes {
                  url
                }
              }
            }
            category {
              data {
                id
                attributes {
                  name
                }
              }
            }
          }
        }
      }
      title_dimension
      description_dimension
      nutritional_information_dimension
      nutritional_information_background {
        data {
          id
          attributes {
            url
          }
        }
      }
      nutritional_information_background_2 {
        data {
          id
          attributes {
            url
          }
        }
      }
    }
  }
}
    `;
export const ProductsFragmentDoc = gql`
    fragment Products on ProductRelationResponseCollection {
  data {
    id
    attributes {
      title
      description
      price
      total_calories
      weight
      nutritional_information
      category {
        data {
          id
          attributes {
            name
          }
        }
      }
      media {
        data {
          id
          attributes {
            url
            alternativeText
            formats
          }
        }
      }
      ingredients {
        data {
          id
          attributes {
            name
            allergens {
              data {
                id
                attributes {
                  name
                }
              }
            }
          }
        }
      }
    }
  }
}
    `;
export const ProductListFragmentDoc = gql`
    fragment ProductList on ComponentCmsDataProductsList {
  id
  displayType
  groupByCategory
  show
  showInPopup
  productSize: size
  popupType
  menu {
    ...Menu
  }
  products(filters: $productsFilters, pagination: $productsPagination) {
    ...Products
  }
}
    ${MenuFragmentDoc}
${ProductsFragmentDoc}`;
export const ImageGalleryComponentFragmentDoc = gql`
    fragment ImageGalleryComponent on ComponentCmsDataImageGallery {
  id
  backgroundColor
  items(filters: $imageGalleryFilters, pagination: $imageGalleryPagination) {
    id
    ComponentCmsDataImageGalleryTitle: title
    category
    image {
      data {
        id
        attributes {
          url
          alternativeText
          formats
        }
      }
    }
  }
}
    `;
export const HeaderSectionComponentFragmentDoc = gql`
    fragment HeaderSectionComponent on ComponentCmsDataHeaderSection {
  id
  HeaderSectionButton: button {
    id
    text
    url
  }
  image {
    data {
      id
      attributes {
        alternativeText
        url
      }
    }
  }
  helloBarContent
}
    `;
export const HeroSectionComponentFragmentDoc = gql`
    fragment HeroSectionComponent on ComponentCmsDataHeroSection {
  HeroSectionButton: button {
    id
    text
    url
  }
  countDownTimer {
    id
    description
    endDate
  }
  id
  image {
    data {
      id
      attributes {
        url
        alternativeText
      }
    }
  }
  mobileImage {
    data {
      id
      attributes {
        url
        alternativeText
      }
    }
  }
  mainTitle
  DataHeroSectionSecondaryTitle: secondaryTitle
  HeroSectionTopTitle: topTitle
  bgColor
  box
  boxColor
  textColor
  textShadow
}
    `;
export const IconCardsSectionComponentFragmentDoc = gql`
    fragment IconCardsSectionComponent on ComponentCmsDataIconCardsSection {
  mainTitle
  subTitle
  IconCardsSectionTopTitle: topTitle
  iconCards(filters: $iconCardsFilters, pagination: $iconCardsPagination) {
    iconName
    id
    large
    subTitle
    title
  }
  id
  centerText
  showAppButton
  IconCardsSectionButtons: button {
    id
    text
    url
  }
  hasExclamationMark
  backgroundColor
}
    `;
export const TextAndImageSectionComponentFragmentDoc = gql`
    fragment TextAndImageSectionComponent on ComponentCmsDataTextAndImageSection {
  id
  image {
    data {
      id
      attributes {
        alternativeText
        url
        formats
      }
    }
  }
  TextAndImageSectionButton: button {
    id
    text
    url
    color
    textColor
  }
  countDownTimer {
    id
    description
    endDate
  }
  mainTitle
  mainTitleColor
  reverse
  DataTextAndImageSectionTextContent: textContent
  DataTextAndImageSectionTextContentColor: textContentColor
  topTitle
  topTitleColor
  underTextImage {
    data {
      id
      attributes {
        alternativeText
        url
        formats
      }
    }
  }
  hideImageOnMobile
  maskImage
  bigImageOnMobile
  imageMask {
    data {
      id
      attributes {
        url
        alternativeText
        formats
      }
    }
  }
  variation
  rounded
  shadow
  imageBackgroundMask {
    data {
      id
      attributes {
        url
        alternativeText
        formats
      }
    }
  }
  backgroundColor
}
    `;
export const DarkTextBoxSectionComponentFragmentDoc = gql`
    fragment DarkTextBoxSectionComponent on ComponentCmsDataDarkTextBoxSection {
  id
  topTitle
  topTitleColor
  mainTitle
  mainTitleColor
  box
  boxColor
  boxTitle
  boxTitleColor
  boxText
  boxTextColor
  bottomTitle
  buttonTitleColor
  DarkTextBoxSectionButton: button {
    id
    text
    textColor
    url
    color
  }
  backgroundImage {
    data {
      id
      attributes {
        alternativeText
        url
        formats
      }
    }
  }
  mobileBackgroundImage {
    data {
      id
      attributes {
        alternativeText
        url
        formats
      }
    }
  }
  centerText
}
    `;
export const ScrollListSectionComponentFragmentDoc = gql`
    fragment ScrollListSectionComponent on ComponentCmsDataScrollListSection {
  backgroundImage {
    data {
      id
      attributes {
        alternativeText
        url
      }
    }
  }
  bottomSectionImage {
    data {
      id
      attributes {
        alternativeText
        url
      }
    }
  }
  bottomSectionTitle
  id
  mainTitle
  ScrollListSectionSecondaryTitle: secondaryTitle
  topTitle
  boxes(pagination: $boxesPagination) {
    id
    boxTitle
    boxText
    boxCards(pagination: $boxCardsPagination) {
      id
      image {
        data {
          id
          attributes {
            alternativeText
            url
          }
        }
      }
      text
      title
      showMoreText
    }
    listTitle
    bottomText
  }
  ScrollListSectionButton: button {
    url
    text
    id
  }
  countDownTimer {
    description
    endDate
    id
  }
  shortDescription
}
    `;
export const AnimatedCardSectionComponentFragmentDoc = gql`
    fragment AnimatedCardSectionComponent on ComponentCmsDataAnimatedCardSection {
  button {
    id
    text
    url
  }
  id
  AnimatedCardSectionMainTitle: mainTitle
  secondSectionImages {
    data {
      id
      attributes {
        alternativeText
        url
        caption
      }
    }
  }
  DataAnimatedCardSectionSecondaryTitle: secondaryTitle
  topTitle
  firstSectionImages {
    data {
      id
      attributes {
        alternativeText
        url
        caption
      }
    }
  }
}
    `;
export const LightTopImgSectionComponentFragmentDoc = gql`
    fragment LightTopImgSectionComponent on ComponentCmsDataLightTopImgSection {
  id
  LightTopImgSectionMainTitle: mainTitle
  DataLightTopImgSectionTextContent: textContent
  topTitle
  centerText
  topImage {
    data {
      id
      attributes {
        alternativeText
        url
      }
    }
  }
  countDownTimer {
    id
    endDate
    description
  }
}
    `;
export const DarkBgImageSectionComponentFragmentDoc = gql`
    fragment DarkBgImageSectionComponent on ComponentCmsDataDarkBgImageSection {
  backgroundImage {
    data {
      id
      attributes {
        alternativeText
        url
      }
    }
  }
  button {
    id
    text
    url
    color
    textColor
  }
  id
  centerText
  mainTitle
  DarkBgImageSectionSecondaryTitle: secondaryTitle
  image {
    data {
      id
      attributes {
        alternativeText
        url
      }
    }
  }
  countDownTimer {
    id
    endDate
    description
  }
}
    `;
export const FooterSectionComponentFragmentDoc = gql`
    fragment FooterSectionComponent on ComponentCmsDataFooterSection {
  id
  rightText
  leftText
  bottomContent
  iconColumnTitle
  iconLinks {
    iconName
    id
    link
    text
  }
  columns {
    id
    title
    content
  }
}
    `;
export const RichTextSectionComponentFragmentDoc = gql`
    fragment RichTextSectionComponent on ComponentCmsDataRichText {
  id
  text
  center
  backgroundImage {
    data {
      id
      attributes {
        alternativeText
        url
      }
    }
  }
  fullWidth
  verticalWider
}
    `;
export const RichTextHtmlSectionComponentFragmentDoc = gql`
    fragment RichTextHtmlSectionComponent on ComponentCmsDataRichTextHtml {
  id
  text
  center
  backgroundImage {
    data {
      id
      attributes {
        alternativeText
        url
      }
    }
  }
  fullWidth
  verticalWider
}
    `;
export const SliderSectionComponentFragmentDoc = gql`
    fragment SliderSectionComponent on ComponentCmsDataSlider {
  id
  type
  title
  centerText
  DataSliderSubTitle: subTitle
  items(filters: $sliderFilters, pagination: $sliderPagination) {
    body
    id
    image {
      data {
        id
        attributes {
          alternativeText
          url
          formats
        }
      }
    }
    link
    title
    subtitleOverImage
    underText
    titleNrOfChars
    underTextNrOfChars
    bodyNrOfChars
    frameColor
    titleColor
    bodyColor
    underTexColor
  }
  popup
  popupRichText
}
    `;
export const HeroSectionTwoComponentFragmentDoc = gql`
    fragment HeroSectionTwoComponent on ComponentCmsDataHeroSectionTwo {
  bottomText
  button {
    id
    text
    url
    color
    textColor
  }
  id
  HeroSectionTwoMainTitle: mainTitle
  textAfterButton
  topText
  HeroSectionTwoImage: image {
    data {
      id
      attributes {
        alternativeText
        url
      }
    }
  }
  belowTitle
}
    `;
export const FaqSectionComponentFragmentDoc = gql`
    fragment FaqSectionComponent on ComponentCmsDataFaq {
  title
  id
  items(pagination: $faqItemsPagination) {
    id
    answer
    question
  }
}
    `;
export const SingleTitleSectionComponentFragmentDoc = gql`
    fragment SingleTitleSectionComponent on ComponentCmsDataSingleTitleSection {
  id
  SingleTitleMainTitle: mainTitle
  center
  topTitle
  SingleTitleSubTitle: subTitle
  backgroundColor
  textColor
}
    `;
export const ImageCardsSectionComponentFragmentDoc = gql`
    fragment ImageCardsSectionComponent on ComponentCmsDataImageCardsSection {
  id
  backgroundColor
  ImageCardsSectiontitle: title
  items(filters: $imageCardsItemsFilters, pagination: $imageCardsItemsPagination) {
    buttonText
    buttonUrl
    id
    large
    logo {
      data {
        id
        attributes {
          alternativeText
          url
          formats
        }
      }
    }
    picture {
      data {
        id
        attributes {
          alternativeText
          url
          mime
          formats
        }
      }
    }
    text
    title
    textColor
    backgroundColor
  }
}
    `;
export const AuthorsListSectionComponentFragmentDoc = gql`
    fragment AuthorsListSectionComponent on ComponentCmsDataAuthorsListSection {
  topTitle
  showSearch
  showCategories
  numberOfAuthorsToDisplay
  AuthorListMainTitle: mainTitle
  id
  description
  authors(pagination: $authorsPagination, filters: $authorsFilters) {
    data {
      id
      attributes {
        username
        email
      }
    }
  }
  displayAsSlider
}
    `;
export const ReviewsSectionComponentFragmentDoc = gql`
    fragment ReviewsSectionComponent on ComponentCmsDataReviewsSection {
  description
  id
  ReviewSectionMainTitle: mainTitle
  topTitle
  hideImage
  size
  box
  boxColor
  textColor
  itemBoxColor
  itemBoxTextColor
  reviewItems(pagination: $reviewItemsPagination, filters: $reviewItemsFilters) {
    authorLocation
    authorName
    authorOccupations
    contentNrOfChars
    authorPicture {
      data {
        id
        attributes {
          alternativeText
          url
          formats
        }
      }
    }
    content
    id
    showPictureAsCircle
    title
  }
}
    `;
export const PriceSectionComponentFragmentDoc = gql`
    fragment PriceSectionComponent on ComponentCmsDataPriceSection {
  id
  description
  descriptionColor
  PriceSectionMainTitle: mainTitle
  mainTitleColor
  topTitle
  topTitleColor
  priceItemsPerSlideWeb
  priceItems(filters: $priceItemsFilters, pagination: $priceItemsPagination) {
    buttonText
    buttonUrl
    highlightTag
    id
    itemDescription
    itemMainTitle
    itemMainTitleColor
    itemTopTitle
    itemTopTitleColor
    monthlyDiscountedPrice
    monthlyRegularPrice
    monthlyUnderPriceText
    yearlyDiscountedPrice
    yearlyRegularPrice
    yearlyUnderPriceText
    centerItemMainTitleHoriz
    centerPriceHoriz
    centerpriceBenefitsHoriz
    priceBenefits(
      filters: $priceBenefitsFilters
      pagination: $priceBenefitsPagination
    ) {
      icon
      id
      isGrayedOut
      isBold
      text
      isIndented
    }
  }
  sectionId
  showAsSlider
  showAsSliderWeb
  priceItemsPerSlideWeb
  countDownTimer {
    id
    endDate
    description
  }
  centerTitle
  shortDescription
}
    `;
export const VideoSectionComponentFragmentDoc = gql`
    fragment VideoSectionComponent on ComponentCmsDataVideoSection {
  id
  belowTitleText
  centerVideo
  bottomText
  VideoSectionMainTitle: mainTitle
  textAfterButton
  topText
  video {
    data {
      id
      attributes {
        url
      }
    }
  }
  videoMobile {
    data {
      id
      attributes {
        url
      }
    }
  }
  button {
    id
    text
    url
    color
    textColor
  }
  countdownTimer {
    id
    endDate
    description
  }
}
    `;
export const DarkImageContentSectionComponentFragmentDoc = gql`
    fragment DarkImageContentSectionComponent on ComponentCmsDataDarkImageContent {
  id
  darkImageContentMainTitle: mainTitle
  buttonText
  backgroundImage {
    data {
      id
      attributes {
        url
      }
    }
  }
  buttonUrl
  left {
    id
    title
    items {
      id
      title
      description
    }
  }
  right {
    id
    title
    items {
      id
      title
      description
    }
  }
  countDownTimer {
    id
    endDate
    description
  }
}
    `;
export const DarkVersusContentSectionComponentFragmentDoc = gql`
    fragment DarkVersusContentSectionComponent on ComponentCmsDataDarkVersusContent {
  id
  darkVersusContentMainTitle: mainTitle
  darkVersusContentTitle: title
  subtitle
  countDownTimer {
    id
    endDate
    description
  }
  bottomImage {
    data {
      id
      attributes {
        url
      }
    }
  }
  darkVersusContentItems: items {
    id
    title
    leftItem {
      id
      title
      iconName
      content
    }
    rightItem {
      id
      title
      content
      iconName
    }
  }
  buttonText
  buttonUrl
  scarcityTitle
}
    `;
export const ScrollToSectionComponentFragmentDoc = gql`
    fragment ScrollToSectionComponent on ComponentCmsDataScrollToSection {
  id
  sectionId
}
    `;
export const HeroSectionSliderComponentFragmentDoc = gql`
    fragment HeroSectionSliderComponent on ComponentCmsDataHeroSectionSlider {
  id
  name
  autoPlay
  heroSectionSliderItems: items {
    id
    mainTitle
    secondaryTitle
    topTitle
    image {
      data {
        id
        attributes {
          url
          alternativeText
          mime
        }
      }
    }
    mobileImage {
      data {
        id
        attributes {
          url
          alternativeText
          mime
        }
      }
    }
    bgColor
    box
    boxColor
    textColor
    textShadow
    countDownTimer {
      id
      description
      endDate
    }
    button {
      id
      text
      url
      color
      textColor
    }
  }
}
    `;
export const FormGroupSectionComponentFragmentDoc = gql`
    fragment FormGroupSectionComponent on ComponentCmsDataFormGroup {
  id
  formGroupTitle: title
  formGroupType: type
  ask_for_rfid
  house_videos {
    id
    house {
      data {
        id
        attributes {
          name
        }
      }
    }
    video {
      data {
        id
        attributes {
          url
          alternativeText
          mime
        }
      }
    }
  }
  redirectUrl
  random_questions
  number_of_random_questions
  show_start_screen
  thank_you_message
  thank_you_message_color
  thank_you_message_background
  questions {
    id
    is_required
    use_recaptcha
    center_text
    title
    title_color
    description
    description_color
    index
    size
    type
    desktop_layout
    mobile_layout
    vertical_alignment
    restart_form_timer
    rate_user {
      data {
        id
      }
    }
    rate_user_role {
      data {
        id
      }
    }
    send_review_to_google
    allocate_tags {
      data {
        id
      }
    }
    allocate_house {
      data {
        id
        attributes {
          name
        }
      }
    }
    input_color
    input_placeholder
    submit_button_text
    submit_button_color
    submit_button_text_color
    submit_button_sticky
    is_transparent_button
    next_question_index
    image {
      data {
        id
        attributes {
          alternativeText
          mime
          url
        }
      }
    }
    image_position
    video {
      data {
        id
        attributes {
          alternativeText
          mime
          url
        }
      }
    }
    background_color
    allow_other_choice
    nr_columns
    space_from_top
    feedback_media_text
    feedback_media {
      data {
        id
        attributes {
          alternativeText
          mime
          url
        }
      }
    }
    choices {
      id
      choice_text
      choice_media {
        data {
          id
          attributes {
            alternativeText
            mime
            url
          }
        }
      }
      choice_shortcut
      choice_color
      choice_color_transparent
      choice_big_button
      display_delay
      jump_to_question_index
      jump_condition_operation
      allocate_house {
        data {
          id
          attributes {
            name
          }
        }
      }
      feedback_media_text
      feedback_media {
        data {
          id
          attributes {
            alternativeText
            mime
            url
          }
        }
      }
      allocate_tags {
        data {
          id
        }
      }
      allocate_house {
        data {
          id
          attributes {
            name
          }
        }
      }
    }
  }
}
    `;
export const ReusableComponentFragmentDoc = gql`
    fragment ReusableComponent on ComponentCmsDataReusable {
  id
  reusable_component {
    data {
      id
      attributes {
        title
        components {
          ...ProductList
          ...ImageGalleryComponent
          ...HeaderSectionComponent
          ...HeroSectionComponent
          ...IconCardsSectionComponent
          ...TextAndImageSectionComponent
          ...DarkTextBoxSectionComponent
          ...ScrollListSectionComponent
          ...AnimatedCardSectionComponent
          ...LightTopImgSectionComponent
          ...DarkBgImageSectionComponent
          ...FooterSectionComponent
          ...RichTextSectionComponent
          ...RichTextHtmlSectionComponent
          ...SliderSectionComponent
          ...HeroSectionTwoComponent
          ...FaqSectionComponent
          ...SingleTitleSectionComponent
          ...ImageCardsSectionComponent
          ...AuthorsListSectionComponent
          ...ReviewsSectionComponent
          ...PriceSectionComponent
          ...VideoSectionComponent
          ...DarkImageContentSectionComponent
          ...DarkVersusContentSectionComponent
          ...ScrollToSectionComponent
          ...HeroSectionSliderComponent
          ...FormGroupSectionComponent
        }
      }
    }
  }
}
    ${ProductListFragmentDoc}
${ImageGalleryComponentFragmentDoc}
${HeaderSectionComponentFragmentDoc}
${HeroSectionComponentFragmentDoc}
${IconCardsSectionComponentFragmentDoc}
${TextAndImageSectionComponentFragmentDoc}
${DarkTextBoxSectionComponentFragmentDoc}
${ScrollListSectionComponentFragmentDoc}
${AnimatedCardSectionComponentFragmentDoc}
${LightTopImgSectionComponentFragmentDoc}
${DarkBgImageSectionComponentFragmentDoc}
${FooterSectionComponentFragmentDoc}
${RichTextSectionComponentFragmentDoc}
${RichTextHtmlSectionComponentFragmentDoc}
${SliderSectionComponentFragmentDoc}
${HeroSectionTwoComponentFragmentDoc}
${FaqSectionComponentFragmentDoc}
${SingleTitleSectionComponentFragmentDoc}
${ImageCardsSectionComponentFragmentDoc}
${AuthorsListSectionComponentFragmentDoc}
${ReviewsSectionComponentFragmentDoc}
${PriceSectionComponentFragmentDoc}
${VideoSectionComponentFragmentDoc}
${DarkImageContentSectionComponentFragmentDoc}
${DarkVersusContentSectionComponentFragmentDoc}
${ScrollToSectionComponentFragmentDoc}
${HeroSectionSliderComponentFragmentDoc}
${FormGroupSectionComponentFragmentDoc}`;
export const SeoDataFragmentDoc = gql`
    fragment SeoData on ComponentSharedSeo {
  canonicalURL
  id
  keywords
  metaDescription
  metaRobots
  metaTitle
  metaViewport
  metaImage {
    data {
      id
      attributes {
        alternativeText
        formats
        url
      }
    }
  }
  metaSocial {
    id
    description
    socialNetwork
    title
    image {
      data {
        id
        attributes {
          alternativeText
          formats
          url
        }
      }
    }
  }
}
    `;
export const BlogPostsDocument = gql`
    query BlogPosts($filters: BlogPostFiltersInput, $pagination: PaginationArg, $sort: [String]) {
  blogPosts(filters: $filters, pagination: $pagination, sort: $sort) {
    meta {
      pagination {
        page
        pageCount
        total
      }
    }
    data {
      id
      attributes {
        title
        slug
        info_text
        author_image {
          data {
            id
            attributes {
              url
            }
          }
        }
        author {
          data {
            id
            attributes {
              firstName
              lastName
            }
          }
        }
        blog_categories {
          data {
            id
            attributes {
              title
              slug
            }
          }
        }
        media {
          data {
            id
            attributes {
              url
            }
          }
        }
        publishedAt
      }
    }
  }
}
    `;

/**
 * __useBlogPostsQuery__
 *
 * To run a query within a React component, call `useBlogPostsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBlogPostsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBlogPostsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useBlogPostsQuery(baseOptions?: Apollo.QueryHookOptions<BlogPostsQuery, BlogPostsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BlogPostsQuery, BlogPostsQueryVariables>(BlogPostsDocument, options);
      }
export function useBlogPostsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BlogPostsQuery, BlogPostsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BlogPostsQuery, BlogPostsQueryVariables>(BlogPostsDocument, options);
        }
export type BlogPostsQueryHookResult = ReturnType<typeof useBlogPostsQuery>;
export type BlogPostsLazyQueryHookResult = ReturnType<typeof useBlogPostsLazyQuery>;
export type BlogPostsQueryResult = Apollo.QueryResult<BlogPostsQuery, BlogPostsQueryVariables>;
export const BlogCategoriesDocument = gql`
    query BlogCategories($pagination: PaginationArg) {
  blogCategories(pagination: $pagination) {
    data {
      id
      attributes {
        title
        slug
      }
    }
  }
}
    `;

/**
 * __useBlogCategoriesQuery__
 *
 * To run a query within a React component, call `useBlogCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useBlogCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBlogCategoriesQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useBlogCategoriesQuery(baseOptions?: Apollo.QueryHookOptions<BlogCategoriesQuery, BlogCategoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BlogCategoriesQuery, BlogCategoriesQueryVariables>(BlogCategoriesDocument, options);
      }
export function useBlogCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BlogCategoriesQuery, BlogCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BlogCategoriesQuery, BlogCategoriesQueryVariables>(BlogCategoriesDocument, options);
        }
export type BlogCategoriesQueryHookResult = ReturnType<typeof useBlogCategoriesQuery>;
export type BlogCategoriesLazyQueryHookResult = ReturnType<typeof useBlogCategoriesLazyQuery>;
export type BlogCategoriesQueryResult = Apollo.QueryResult<BlogCategoriesQuery, BlogCategoriesQueryVariables>;
export const BlogPostItemDocument = gql`
    query BlogPostItem($filters: BlogPostFiltersInput, $pagination: PaginationArg, $sort: [String], $iconCardsFilters: ComponentCmsDataIconCardFiltersInput, $iconCardsPagination: PaginationArg, $boxesPagination: PaginationArg, $boxCardsPagination: PaginationArg, $sliderFilters: ComponentCmsDataSliderItemFiltersInput, $sliderPagination: PaginationArg, $faqItemsPagination: PaginationArg, $imageCardsItemsFilters: ComponentCmsDataImageCardFiltersInput, $imageCardsItemsPagination: PaginationArg, $authorsPagination: PaginationArg, $authorsFilters: UsersPermissionsUserFiltersInput, $reviewItemsPagination: PaginationArg, $reviewItemsFilters: ComponentCmsDataReviewItemFiltersInput, $priceItemsFilters: ComponentCmsDataPriceItemFiltersInput, $priceItemsPagination: PaginationArg, $priceBenefitsFilters: ComponentCmsDataPriceBenefitFiltersInput, $priceBenefitsPagination: PaginationArg, $imageGalleryFilters: ComponentCmsDataImageGalleryItemFiltersInput, $imageGalleryPagination: PaginationArg, $productsFilters: ProductFiltersInput, $productsPagination: PaginationArg, $menuFilters: ProductFiltersInput, $menuPagination: PaginationArg) {
  blogPosts(filters: $filters, pagination: $pagination, sort: $sort) {
    meta {
      pagination {
        page
        pageCount
        total
      }
    }
    data {
      id
      attributes {
        title
        slug
        info_text
        author_image {
          data {
            id
            attributes {
              url
            }
          }
        }
        author {
          data {
            id
            attributes {
              firstName
              lastName
            }
          }
        }
        blog_categories {
          data {
            id
            attributes {
              title
              slug
            }
          }
        }
        media {
          data {
            id
            attributes {
              url
            }
          }
        }
        publishedAt
        components {
          ...ImageGalleryComponent
          ...HeaderSectionComponent
          ...HeroSectionComponent
          ...IconCardsSectionComponent
          ...TextAndImageSectionComponent
          ...DarkTextBoxSectionComponent
          ...ScrollListSectionComponent
          ...AnimatedCardSectionComponent
          ...LightTopImgSectionComponent
          ...DarkBgImageSectionComponent
          ...FooterSectionComponent
          ...RichTextSectionComponent
          ...RichTextHtmlSectionComponent
          ...SliderSectionComponent
          ...HeroSectionTwoComponent
          ...FaqSectionComponent
          ...SingleTitleSectionComponent
          ...ImageCardsSectionComponent
          ...AuthorsListSectionComponent
          ...ReviewsSectionComponent
          ...PriceSectionComponent
          ...VideoSectionComponent
          ...DarkImageContentSectionComponent
          ...DarkVersusContentSectionComponent
          ...ScrollToSectionComponent
          ...HeroSectionSliderComponent
          ...FormGroupSectionComponent
          ...InteractiveImageMap
          ...ReusableComponent
        }
      }
    }
  }
}
    ${ImageGalleryComponentFragmentDoc}
${HeaderSectionComponentFragmentDoc}
${HeroSectionComponentFragmentDoc}
${IconCardsSectionComponentFragmentDoc}
${TextAndImageSectionComponentFragmentDoc}
${DarkTextBoxSectionComponentFragmentDoc}
${ScrollListSectionComponentFragmentDoc}
${AnimatedCardSectionComponentFragmentDoc}
${LightTopImgSectionComponentFragmentDoc}
${DarkBgImageSectionComponentFragmentDoc}
${FooterSectionComponentFragmentDoc}
${RichTextSectionComponentFragmentDoc}
${RichTextHtmlSectionComponentFragmentDoc}
${SliderSectionComponentFragmentDoc}
${HeroSectionTwoComponentFragmentDoc}
${FaqSectionComponentFragmentDoc}
${SingleTitleSectionComponentFragmentDoc}
${ImageCardsSectionComponentFragmentDoc}
${AuthorsListSectionComponentFragmentDoc}
${ReviewsSectionComponentFragmentDoc}
${PriceSectionComponentFragmentDoc}
${VideoSectionComponentFragmentDoc}
${DarkImageContentSectionComponentFragmentDoc}
${DarkVersusContentSectionComponentFragmentDoc}
${ScrollToSectionComponentFragmentDoc}
${HeroSectionSliderComponentFragmentDoc}
${FormGroupSectionComponentFragmentDoc}
${InteractiveImageMapFragmentDoc}
${ReusableComponentFragmentDoc}`;

/**
 * __useBlogPostItemQuery__
 *
 * To run a query within a React component, call `useBlogPostItemQuery` and pass it any options that fit your needs.
 * When your component renders, `useBlogPostItemQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBlogPostItemQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      sort: // value for 'sort'
 *      iconCardsFilters: // value for 'iconCardsFilters'
 *      iconCardsPagination: // value for 'iconCardsPagination'
 *      boxesPagination: // value for 'boxesPagination'
 *      boxCardsPagination: // value for 'boxCardsPagination'
 *      sliderFilters: // value for 'sliderFilters'
 *      sliderPagination: // value for 'sliderPagination'
 *      faqItemsPagination: // value for 'faqItemsPagination'
 *      imageCardsItemsFilters: // value for 'imageCardsItemsFilters'
 *      imageCardsItemsPagination: // value for 'imageCardsItemsPagination'
 *      authorsPagination: // value for 'authorsPagination'
 *      authorsFilters: // value for 'authorsFilters'
 *      reviewItemsPagination: // value for 'reviewItemsPagination'
 *      reviewItemsFilters: // value for 'reviewItemsFilters'
 *      priceItemsFilters: // value for 'priceItemsFilters'
 *      priceItemsPagination: // value for 'priceItemsPagination'
 *      priceBenefitsFilters: // value for 'priceBenefitsFilters'
 *      priceBenefitsPagination: // value for 'priceBenefitsPagination'
 *      imageGalleryFilters: // value for 'imageGalleryFilters'
 *      imageGalleryPagination: // value for 'imageGalleryPagination'
 *      productsFilters: // value for 'productsFilters'
 *      productsPagination: // value for 'productsPagination'
 *      menuFilters: // value for 'menuFilters'
 *      menuPagination: // value for 'menuPagination'
 *   },
 * });
 */
export function useBlogPostItemQuery(baseOptions?: Apollo.QueryHookOptions<BlogPostItemQuery, BlogPostItemQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BlogPostItemQuery, BlogPostItemQueryVariables>(BlogPostItemDocument, options);
      }
export function useBlogPostItemLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BlogPostItemQuery, BlogPostItemQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BlogPostItemQuery, BlogPostItemQueryVariables>(BlogPostItemDocument, options);
        }
export type BlogPostItemQueryHookResult = ReturnType<typeof useBlogPostItemQuery>;
export type BlogPostItemLazyQueryHookResult = ReturnType<typeof useBlogPostItemLazyQuery>;
export type BlogPostItemQueryResult = Apollo.QueryResult<BlogPostItemQuery, BlogPostItemQueryVariables>;
export const BlogPostSeoDocument = gql`
    query BlogPostSeo($filters: BlogPostFiltersInput) {
  blogPosts(filters: $filters) {
    data {
      id
      attributes {
        title
        slug
        seo {
          ...SeoData
        }
      }
    }
  }
}
    ${SeoDataFragmentDoc}`;

/**
 * __useBlogPostSeoQuery__
 *
 * To run a query within a React component, call `useBlogPostSeoQuery` and pass it any options that fit your needs.
 * When your component renders, `useBlogPostSeoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBlogPostSeoQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useBlogPostSeoQuery(baseOptions?: Apollo.QueryHookOptions<BlogPostSeoQuery, BlogPostSeoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BlogPostSeoQuery, BlogPostSeoQueryVariables>(BlogPostSeoDocument, options);
      }
export function useBlogPostSeoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BlogPostSeoQuery, BlogPostSeoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BlogPostSeoQuery, BlogPostSeoQueryVariables>(BlogPostSeoDocument, options);
        }
export type BlogPostSeoQueryHookResult = ReturnType<typeof useBlogPostSeoQuery>;
export type BlogPostSeoLazyQueryHookResult = ReturnType<typeof useBlogPostSeoLazyQuery>;
export type BlogPostSeoQueryResult = Apollo.QueryResult<BlogPostSeoQuery, BlogPostSeoQueryVariables>;
export const GetBlogPostSlugsDocument = gql`
    query GetBlogPostSlugs($filters: BlogPostFiltersInput, $pagination: PaginationArg) {
  blogPosts(filters: $filters, pagination: $pagination) {
    data {
      id
      attributes {
        slug
        updatedAt
      }
    }
  }
}
    `;

/**
 * __useGetBlogPostSlugsQuery__
 *
 * To run a query within a React component, call `useGetBlogPostSlugsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBlogPostSlugsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBlogPostSlugsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useGetBlogPostSlugsQuery(baseOptions?: Apollo.QueryHookOptions<GetBlogPostSlugsQuery, GetBlogPostSlugsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBlogPostSlugsQuery, GetBlogPostSlugsQueryVariables>(GetBlogPostSlugsDocument, options);
      }
export function useGetBlogPostSlugsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBlogPostSlugsQuery, GetBlogPostSlugsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBlogPostSlugsQuery, GetBlogPostSlugsQueryVariables>(GetBlogPostSlugsDocument, options);
        }
export type GetBlogPostSlugsQueryHookResult = ReturnType<typeof useGetBlogPostSlugsQuery>;
export type GetBlogPostSlugsLazyQueryHookResult = ReturnType<typeof useGetBlogPostSlugsLazyQuery>;
export type GetBlogPostSlugsQueryResult = Apollo.QueryResult<GetBlogPostSlugsQuery, GetBlogPostSlugsQueryVariables>;
export const CampaignsUserWithRolesDocument = gql`
    query CampaignsUserWithRoles($filters: CampaignFiltersInput, $usersWithRolesFilters: ComponentCrmDataCrmAccountRoleFiltersInput, $pagination: PaginationArg) {
  campaigns(filters: $filters) {
    data {
      id
      attributes {
        users_with_roles(filters: $usersWithRolesFilters, pagination: $pagination) {
          id
          user {
            data {
              id
              attributes {
                firstName
                lastName
              }
            }
          }
          roles {
            data {
              id
              attributes {
                name
              }
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useCampaignsUserWithRolesQuery__
 *
 * To run a query within a React component, call `useCampaignsUserWithRolesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCampaignsUserWithRolesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCampaignsUserWithRolesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      usersWithRolesFilters: // value for 'usersWithRolesFilters'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useCampaignsUserWithRolesQuery(baseOptions?: Apollo.QueryHookOptions<CampaignsUserWithRolesQuery, CampaignsUserWithRolesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CampaignsUserWithRolesQuery, CampaignsUserWithRolesQueryVariables>(CampaignsUserWithRolesDocument, options);
      }
export function useCampaignsUserWithRolesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CampaignsUserWithRolesQuery, CampaignsUserWithRolesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CampaignsUserWithRolesQuery, CampaignsUserWithRolesQueryVariables>(CampaignsUserWithRolesDocument, options);
        }
export type CampaignsUserWithRolesQueryHookResult = ReturnType<typeof useCampaignsUserWithRolesQuery>;
export type CampaignsUserWithRolesLazyQueryHookResult = ReturnType<typeof useCampaignsUserWithRolesLazyQuery>;
export type CampaignsUserWithRolesQueryResult = Apollo.QueryResult<CampaignsUserWithRolesQuery, CampaignsUserWithRolesQueryVariables>;
export const GetAllFeedbacksDocument = gql`
    query GetAllFeedbacks($filters: CrmTaskFeedbackFiltersInput, $pagination: PaginationArg, $sort: [String]) {
  crmTaskFeedbacks(filters: $filters, pagination: $pagination, sort: $sort) {
    meta {
      pagination {
        total
        pageCount
        page
      }
    }
    data {
      id
      attributes {
        name
        task_type
      }
    }
  }
}
    `;

/**
 * __useGetAllFeedbacksQuery__
 *
 * To run a query within a React component, call `useGetAllFeedbacksQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllFeedbacksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllFeedbacksQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetAllFeedbacksQuery(baseOptions?: Apollo.QueryHookOptions<GetAllFeedbacksQuery, GetAllFeedbacksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllFeedbacksQuery, GetAllFeedbacksQueryVariables>(GetAllFeedbacksDocument, options);
      }
export function useGetAllFeedbacksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllFeedbacksQuery, GetAllFeedbacksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllFeedbacksQuery, GetAllFeedbacksQueryVariables>(GetAllFeedbacksDocument, options);
        }
export type GetAllFeedbacksQueryHookResult = ReturnType<typeof useGetAllFeedbacksQuery>;
export type GetAllFeedbacksLazyQueryHookResult = ReturnType<typeof useGetAllFeedbacksLazyQuery>;
export type GetAllFeedbacksQueryResult = Apollo.QueryResult<GetAllFeedbacksQuery, GetAllFeedbacksQueryVariables>;
export const GetAllCrmUserRolesDocument = gql`
    query GetAllCrmUserRoles($filters: CampaignFiltersInput, $pagination: PaginationArg, $sort: [String], $usersWithRolesFilters2: ComponentCrmDataCrmAccountRoleFiltersInput, $usersWithRolesPagination2: PaginationArg, $usersWithRolesSort2: [String]) {
  campaigns(filters: $filters, pagination: $pagination, sort: $sort) {
    data {
      id
      attributes {
        users_with_roles(
          filters: $usersWithRolesFilters2
          pagination: $usersWithRolesPagination2
          sort: $usersWithRolesSort2
        ) {
          id
          user {
            data {
              id
              attributes {
                firstName
                lastName
              }
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetAllCrmUserRolesQuery__
 *
 * To run a query within a React component, call `useGetAllCrmUserRolesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllCrmUserRolesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllCrmUserRolesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      sort: // value for 'sort'
 *      usersWithRolesFilters2: // value for 'usersWithRolesFilters2'
 *      usersWithRolesPagination2: // value for 'usersWithRolesPagination2'
 *      usersWithRolesSort2: // value for 'usersWithRolesSort2'
 *   },
 * });
 */
export function useGetAllCrmUserRolesQuery(baseOptions?: Apollo.QueryHookOptions<GetAllCrmUserRolesQuery, GetAllCrmUserRolesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllCrmUserRolesQuery, GetAllCrmUserRolesQueryVariables>(GetAllCrmUserRolesDocument, options);
      }
export function useGetAllCrmUserRolesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllCrmUserRolesQuery, GetAllCrmUserRolesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllCrmUserRolesQuery, GetAllCrmUserRolesQueryVariables>(GetAllCrmUserRolesDocument, options);
        }
export type GetAllCrmUserRolesQueryHookResult = ReturnType<typeof useGetAllCrmUserRolesQuery>;
export type GetAllCrmUserRolesLazyQueryHookResult = ReturnType<typeof useGetAllCrmUserRolesLazyQuery>;
export type GetAllCrmUserRolesQueryResult = Apollo.QueryResult<GetAllCrmUserRolesQuery, GetAllCrmUserRolesQueryVariables>;
export const CrmTasksDocument = gql`
    query CrmTasks($pagination: PaginationArg, $filters: CrmTaskFiltersInput, $sort: [String], $ordersPagination: PaginationArg, $ordersFilters: OrderFiltersInput, $paymentsPagination: PaginationArg, $paymentsFilters: PaymentFiltersInput, $productsPagination: PaginationArg, $productsFilters: ProductFiltersInput, $crmLinksPagination: PaginationArg, $crmLinksFilters: CrmLinkFiltersInput, $accountRolesPagination: PaginationArg) {
  crmTasks(pagination: $pagination, filters: $filters, sort: $sort) {
    data {
      id
      attributes {
        title
        status
        type
        updatedAt
        meeting_url
        info
        calendarEventId
        dueDate
        crm_link {
          data {
            id
            attributes {
              crm_campaign {
                data {
                  id
                  attributes {
                    name
                    slug
                    updatedAt
                  }
                }
              }
              orders(pagination: $ordersPagination, filters: $ordersFilters) {
                data {
                  id
                  attributes {
                    payments(pagination: $paymentsPagination, filters: $paymentsFilters) {
                      data {
                        id
                        attributes {
                          status
                          amount
                        }
                      }
                    }
                    total_price
                    total_vat
                  }
                }
              }
              products(pagination: $productsPagination, filters: $productsFilters) {
                data {
                  id
                  attributes {
                    title
                  }
                }
              }
              crm_links(pagination: $crmLinksPagination, filters: $crmLinksFilters) {
                ...crmLinkFragment
              }
            }
          }
        }
        crm_campaign_member {
          data {
            id
            attributes {
              users_with_roles(pagination: $accountRolesPagination) {
                id
                user {
                  data {
                    id
                  }
                }
                roles {
                  data {
                    id
                    attributes {
                      name
                    }
                  }
                }
              }
              updatedAt
              utm_data {
                utm_campaign
                utm_id
                id
                utm_medium
                utm_source
              }
              crm_campaign {
                data {
                  id
                  attributes {
                    slug
                  }
                }
              }
            }
          }
        }
        createdAt
        assignee {
          data {
            id
            attributes {
              firstName
              lastName
              crm_profile {
                crm_roles {
                  data {
                    id
                    attributes {
                      sales_commision
                    }
                  }
                }
              }
            }
          }
        }
        feedback {
          data {
            id
            attributes {
              name
              crm_reports
              task_type
            }
          }
        }
      }
    }
  }
}
    ${CrmLinkFragmentFragmentDoc}`;

/**
 * __useCrmTasksQuery__
 *
 * To run a query within a React component, call `useCrmTasksQuery` and pass it any options that fit your needs.
 * When your component renders, `useCrmTasksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCrmTasksQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      filters: // value for 'filters'
 *      sort: // value for 'sort'
 *      ordersPagination: // value for 'ordersPagination'
 *      ordersFilters: // value for 'ordersFilters'
 *      paymentsPagination: // value for 'paymentsPagination'
 *      paymentsFilters: // value for 'paymentsFilters'
 *      productsPagination: // value for 'productsPagination'
 *      productsFilters: // value for 'productsFilters'
 *      crmLinksPagination: // value for 'crmLinksPagination'
 *      crmLinksFilters: // value for 'crmLinksFilters'
 *      accountRolesPagination: // value for 'accountRolesPagination'
 *   },
 * });
 */
export function useCrmTasksQuery(baseOptions?: Apollo.QueryHookOptions<CrmTasksQuery, CrmTasksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CrmTasksQuery, CrmTasksQueryVariables>(CrmTasksDocument, options);
      }
export function useCrmTasksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CrmTasksQuery, CrmTasksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CrmTasksQuery, CrmTasksQueryVariables>(CrmTasksDocument, options);
        }
export type CrmTasksQueryHookResult = ReturnType<typeof useCrmTasksQuery>;
export type CrmTasksLazyQueryHookResult = ReturnType<typeof useCrmTasksLazyQuery>;
export type CrmTasksQueryResult = Apollo.QueryResult<CrmTasksQuery, CrmTasksQueryVariables>;
export const CrmFiltersTasksDocument = gql`
    query CrmFiltersTasks($pagination: PaginationArg, $filters: CrmTaskFiltersInput, $sort: [String], $accountRolesPagination: PaginationArg) {
  crmTasks(pagination: $pagination, filters: $filters, sort: $sort) {
    data {
      id
      attributes {
        assignee {
          data {
            id
            attributes {
              firstName
              lastName
            }
          }
        }
        crm_campaign_member {
          data {
            id
            attributes {
              users_with_roles(pagination: $accountRolesPagination) {
                id
                user {
                  data {
                    id
                  }
                }
                roles {
                  data {
                    id
                    attributes {
                      name
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useCrmFiltersTasksQuery__
 *
 * To run a query within a React component, call `useCrmFiltersTasksQuery` and pass it any options that fit your needs.
 * When your component renders, `useCrmFiltersTasksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCrmFiltersTasksQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      filters: // value for 'filters'
 *      sort: // value for 'sort'
 *      accountRolesPagination: // value for 'accountRolesPagination'
 *   },
 * });
 */
export function useCrmFiltersTasksQuery(baseOptions?: Apollo.QueryHookOptions<CrmFiltersTasksQuery, CrmFiltersTasksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CrmFiltersTasksQuery, CrmFiltersTasksQueryVariables>(CrmFiltersTasksDocument, options);
      }
export function useCrmFiltersTasksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CrmFiltersTasksQuery, CrmFiltersTasksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CrmFiltersTasksQuery, CrmFiltersTasksQueryVariables>(CrmFiltersTasksDocument, options);
        }
export type CrmFiltersTasksQueryHookResult = ReturnType<typeof useCrmFiltersTasksQuery>;
export type CrmFiltersTasksLazyQueryHookResult = ReturnType<typeof useCrmFiltersTasksLazyQuery>;
export type CrmFiltersTasksQueryResult = Apollo.QueryResult<CrmFiltersTasksQuery, CrmFiltersTasksQueryVariables>;
export const UpdateCrmTaskDocument = gql`
    mutation updateCrmTask($updateCrmTaskId: ID!, $data: CrmTaskInput!) {
  updateCrmTask(id: $updateCrmTaskId, data: $data) {
    data {
      id
      attributes {
        ai_prompts {
          id
          prompt_text
          prompt_type {
            data {
              id
            }
          }
          ai_answer
        }
      }
    }
  }
}
    `;
export type UpdateCrmTaskMutationFn = Apollo.MutationFunction<UpdateCrmTaskMutation, UpdateCrmTaskMutationVariables>;

/**
 * __useUpdateCrmTaskMutation__
 *
 * To run a mutation, you first call `useUpdateCrmTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCrmTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCrmTaskMutation, { data, loading, error }] = useUpdateCrmTaskMutation({
 *   variables: {
 *      updateCrmTaskId: // value for 'updateCrmTaskId'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateCrmTaskMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCrmTaskMutation, UpdateCrmTaskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCrmTaskMutation, UpdateCrmTaskMutationVariables>(UpdateCrmTaskDocument, options);
      }
export type UpdateCrmTaskMutationHookResult = ReturnType<typeof useUpdateCrmTaskMutation>;
export type UpdateCrmTaskMutationResult = Apollo.MutationResult<UpdateCrmTaskMutation>;
export type UpdateCrmTaskMutationOptions = Apollo.BaseMutationOptions<UpdateCrmTaskMutation, UpdateCrmTaskMutationVariables>;
export const CreateCrmLinkDocument = gql`
    mutation createCrmLink($data: CrmLinkInput!) {
  createCrmLink(data: $data) {
    data {
      id
    }
  }
}
    `;
export type CreateCrmLinkMutationFn = Apollo.MutationFunction<CreateCrmLinkMutation, CreateCrmLinkMutationVariables>;

/**
 * __useCreateCrmLinkMutation__
 *
 * To run a mutation, you first call `useCreateCrmLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCrmLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCrmLinkMutation, { data, loading, error }] = useCreateCrmLinkMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateCrmLinkMutation(baseOptions?: Apollo.MutationHookOptions<CreateCrmLinkMutation, CreateCrmLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCrmLinkMutation, CreateCrmLinkMutationVariables>(CreateCrmLinkDocument, options);
      }
export type CreateCrmLinkMutationHookResult = ReturnType<typeof useCreateCrmLinkMutation>;
export type CreateCrmLinkMutationResult = Apollo.MutationResult<CreateCrmLinkMutation>;
export type CreateCrmLinkMutationOptions = Apollo.BaseMutationOptions<CreateCrmLinkMutation, CreateCrmLinkMutationVariables>;
export const CreateCrmTaskDocument = gql`
    mutation createCrmTask($data: CrmTaskInput!) {
  createCrmTask(data: $data) {
    data {
      id
    }
  }
}
    `;
export type CreateCrmTaskMutationFn = Apollo.MutationFunction<CreateCrmTaskMutation, CreateCrmTaskMutationVariables>;

/**
 * __useCreateCrmTaskMutation__
 *
 * To run a mutation, you first call `useCreateCrmTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCrmTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCrmTaskMutation, { data, loading, error }] = useCreateCrmTaskMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateCrmTaskMutation(baseOptions?: Apollo.MutationHookOptions<CreateCrmTaskMutation, CreateCrmTaskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCrmTaskMutation, CreateCrmTaskMutationVariables>(CreateCrmTaskDocument, options);
      }
export type CreateCrmTaskMutationHookResult = ReturnType<typeof useCreateCrmTaskMutation>;
export type CreateCrmTaskMutationResult = Apollo.MutationResult<CreateCrmTaskMutation>;
export type CreateCrmTaskMutationOptions = Apollo.BaseMutationOptions<CreateCrmTaskMutation, CreateCrmTaskMutationVariables>;
export const AddRoleOnContactDocument = gql`
    mutation addRoleOnContact($setUserRoleOnCampaignMemberId: ID!, $user: ID!, $roles: [ID]) {
  setUserRoleOnCampaignMember(
    id: $setUserRoleOnCampaignMemberId
    user: $user
    roles: $roles
  ) {
    data {
      id
      attributes {
        crm_campaign {
          data {
            id
          }
        }
      }
    }
  }
}
    `;
export type AddRoleOnContactMutationFn = Apollo.MutationFunction<AddRoleOnContactMutation, AddRoleOnContactMutationVariables>;

/**
 * __useAddRoleOnContactMutation__
 *
 * To run a mutation, you first call `useAddRoleOnContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddRoleOnContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addRoleOnContactMutation, { data, loading, error }] = useAddRoleOnContactMutation({
 *   variables: {
 *      setUserRoleOnCampaignMemberId: // value for 'setUserRoleOnCampaignMemberId'
 *      user: // value for 'user'
 *      roles: // value for 'roles'
 *   },
 * });
 */
export function useAddRoleOnContactMutation(baseOptions?: Apollo.MutationHookOptions<AddRoleOnContactMutation, AddRoleOnContactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddRoleOnContactMutation, AddRoleOnContactMutationVariables>(AddRoleOnContactDocument, options);
      }
export type AddRoleOnContactMutationHookResult = ReturnType<typeof useAddRoleOnContactMutation>;
export type AddRoleOnContactMutationResult = Apollo.MutationResult<AddRoleOnContactMutation>;
export type AddRoleOnContactMutationOptions = Apollo.BaseMutationOptions<AddRoleOnContactMutation, AddRoleOnContactMutationVariables>;
export const UpdateContactDocument = gql`
    mutation updateContact($updateContactId: ID!, $data: ContactInput!) {
  updateContact(id: $updateContactId, data: $data) {
    data {
      id
      attributes {
        firstName
        lastName
        info
        phoneNumber
        contact_source {
          data {
            id
            attributes {
              name
            }
          }
        }
        email
      }
    }
  }
}
    `;
export type UpdateContactMutationFn = Apollo.MutationFunction<UpdateContactMutation, UpdateContactMutationVariables>;

/**
 * __useUpdateContactMutation__
 *
 * To run a mutation, you first call `useUpdateContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateContactMutation, { data, loading, error }] = useUpdateContactMutation({
 *   variables: {
 *      updateContactId: // value for 'updateContactId'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateContactMutation(baseOptions?: Apollo.MutationHookOptions<UpdateContactMutation, UpdateContactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateContactMutation, UpdateContactMutationVariables>(UpdateContactDocument, options);
      }
export type UpdateContactMutationHookResult = ReturnType<typeof useUpdateContactMutation>;
export type UpdateContactMutationResult = Apollo.MutationResult<UpdateContactMutation>;
export type UpdateContactMutationOptions = Apollo.BaseMutationOptions<UpdateContactMutation, UpdateContactMutationVariables>;
export const GenerateCrmTaskAiPromptCompletionDocument = gql`
    mutation generateCRMTaskAIPromptCompletion($generateCrmTaskAiPromptCompletionId: ID!, $aiPromptId: ID!) {
  generateCRMTaskAIPromptCompletion(
    id: $generateCrmTaskAiPromptCompletionId
    ai_prompt_id: $aiPromptId
  ) {
    data {
      id
    }
  }
}
    `;
export type GenerateCrmTaskAiPromptCompletionMutationFn = Apollo.MutationFunction<GenerateCrmTaskAiPromptCompletionMutation, GenerateCrmTaskAiPromptCompletionMutationVariables>;

/**
 * __useGenerateCrmTaskAiPromptCompletionMutation__
 *
 * To run a mutation, you first call `useGenerateCrmTaskAiPromptCompletionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateCrmTaskAiPromptCompletionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateCrmTaskAiPromptCompletionMutation, { data, loading, error }] = useGenerateCrmTaskAiPromptCompletionMutation({
 *   variables: {
 *      generateCrmTaskAiPromptCompletionId: // value for 'generateCrmTaskAiPromptCompletionId'
 *      aiPromptId: // value for 'aiPromptId'
 *   },
 * });
 */
export function useGenerateCrmTaskAiPromptCompletionMutation(baseOptions?: Apollo.MutationHookOptions<GenerateCrmTaskAiPromptCompletionMutation, GenerateCrmTaskAiPromptCompletionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateCrmTaskAiPromptCompletionMutation, GenerateCrmTaskAiPromptCompletionMutationVariables>(GenerateCrmTaskAiPromptCompletionDocument, options);
      }
export type GenerateCrmTaskAiPromptCompletionMutationHookResult = ReturnType<typeof useGenerateCrmTaskAiPromptCompletionMutation>;
export type GenerateCrmTaskAiPromptCompletionMutationResult = Apollo.MutationResult<GenerateCrmTaskAiPromptCompletionMutation>;
export type GenerateCrmTaskAiPromptCompletionMutationOptions = Apollo.BaseMutationOptions<GenerateCrmTaskAiPromptCompletionMutation, GenerateCrmTaskAiPromptCompletionMutationVariables>;
export const CreateContactDocument = gql`
    mutation createContact($data: ContactInput!) {
  createContact(data: $data) {
    data {
      id
      attributes {
        email
      }
    }
  }
}
    `;
export type CreateContactMutationFn = Apollo.MutationFunction<CreateContactMutation, CreateContactMutationVariables>;

/**
 * __useCreateContactMutation__
 *
 * To run a mutation, you first call `useCreateContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createContactMutation, { data, loading, error }] = useCreateContactMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateContactMutation(baseOptions?: Apollo.MutationHookOptions<CreateContactMutation, CreateContactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateContactMutation, CreateContactMutationVariables>(CreateContactDocument, options);
      }
export type CreateContactMutationHookResult = ReturnType<typeof useCreateContactMutation>;
export type CreateContactMutationResult = Apollo.MutationResult<CreateContactMutation>;
export type CreateContactMutationOptions = Apollo.BaseMutationOptions<CreateContactMutation, CreateContactMutationVariables>;
export const UploadFileDocument = gql`
    mutation UploadFile($file: Upload!) {
  upload(file: $file) {
    data {
      id
    }
  }
}
    `;
export type UploadFileMutationFn = Apollo.MutationFunction<UploadFileMutation, UploadFileMutationVariables>;

/**
 * __useUploadFileMutation__
 *
 * To run a mutation, you first call `useUploadFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadFileMutation, { data, loading, error }] = useUploadFileMutation({
 *   variables: {
 *      file: // value for 'file'
 *   },
 * });
 */
export function useUploadFileMutation(baseOptions?: Apollo.MutationHookOptions<UploadFileMutation, UploadFileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadFileMutation, UploadFileMutationVariables>(UploadFileDocument, options);
      }
export type UploadFileMutationHookResult = ReturnType<typeof useUploadFileMutation>;
export type UploadFileMutationResult = Apollo.MutationResult<UploadFileMutation>;
export type UploadFileMutationOptions = Apollo.BaseMutationOptions<UploadFileMutation, UploadFileMutationVariables>;
export const GetCampaignsDocument = gql`
    query GetCampaigns($filters: CampaignFiltersInput, $pagination: PaginationArg, $sort: [String], $crmCampaignMembersFilters: CrmCampaignMemberFiltersInput, $crmCampaignMembersPagination: PaginationArg, $crmCampaignMembersSort: [String], $usersWithRolesPagination: PaginationArg, $usersWithRolesFilters: ComponentCrmDataCrmAccountRoleFiltersInput) {
  campaigns(filters: $filters, pagination: $pagination, sort: $sort) {
    data {
      id
      attributes {
        createdAt
        crm_campaign_members(
          filters: $crmCampaignMembersFilters
          pagination: $crmCampaignMembersPagination
          sort: $crmCampaignMembersSort
        ) {
          data {
            id
          }
        }
        name
        slug
        users_with_roles(
          pagination: $usersWithRolesPagination
          filters: $usersWithRolesFilters
        ) {
          id
          user {
            data {
              id
              attributes {
                firstName
                lastName
              }
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetCampaignsQuery__
 *
 * To run a query within a React component, call `useGetCampaignsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCampaignsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCampaignsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      sort: // value for 'sort'
 *      crmCampaignMembersFilters: // value for 'crmCampaignMembersFilters'
 *      crmCampaignMembersPagination: // value for 'crmCampaignMembersPagination'
 *      crmCampaignMembersSort: // value for 'crmCampaignMembersSort'
 *      usersWithRolesPagination: // value for 'usersWithRolesPagination'
 *      usersWithRolesFilters: // value for 'usersWithRolesFilters'
 *   },
 * });
 */
export function useGetCampaignsQuery(baseOptions?: Apollo.QueryHookOptions<GetCampaignsQuery, GetCampaignsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCampaignsQuery, GetCampaignsQueryVariables>(GetCampaignsDocument, options);
      }
export function useGetCampaignsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCampaignsQuery, GetCampaignsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCampaignsQuery, GetCampaignsQueryVariables>(GetCampaignsDocument, options);
        }
export type GetCampaignsQueryHookResult = ReturnType<typeof useGetCampaignsQuery>;
export type GetCampaignsLazyQueryHookResult = ReturnType<typeof useGetCampaignsLazyQuery>;
export type GetCampaignsQueryResult = Apollo.QueryResult<GetCampaignsQuery, GetCampaignsQueryVariables>;
export const GetCampaignsListDocument = gql`
    query GetCampaignsList($filters: CampaignFiltersInput, $pagination: PaginationArg, $sort: [String], $crmCampaignMembersFilters: CrmCampaignMemberFiltersInput, $crmCampaignMembersPagination: PaginationArg, $crmCampaignMembersSort: [String], $usersWithRolesFilters2: ComponentCrmDataCrmAccountRoleFiltersInput, $usersWithRolesPagination2: PaginationArg, $usersWithRolesSort2: [String], $assignedFilters2: UsersPermissionsUserFiltersInput, $assignedUsersFilters2: ComponentCrmDataCrmAssignedUserFiltersInput, $assignedUsersPagination2: PaginationArg, $usersWithRatingFilters2: ComponentCrmDataCrmUserRatingFiltersInput, $usersWithRatingPagination2: PaginationArg) {
  campaigns(filters: $filters, pagination: $pagination, sort: $sort) {
    data {
      id
      attributes {
        createdAt
        crm_campaign_members(
          filters: $crmCampaignMembersFilters
          pagination: $crmCampaignMembersPagination
          sort: $crmCampaignMembersSort
        ) {
          data {
            id
          }
        }
        name
        slug
        users_with_roles(
          filters: $usersWithRolesFilters2
          pagination: $usersWithRolesPagination2
          sort: $usersWithRolesSort2
        ) {
          id
          user {
            data {
              id
              attributes {
                email
              }
            }
          }
          roles {
            data {
              id
              attributes {
                name
              }
            }
          }
        }
        schedule_meeting {
          id
          meetingDescription
          meetingDuration
          scheduleBuffer
          tags {
            data {
              id
            }
          }
          tasks {
            id
            info
            isDueInAfterCreationDate
            sendNotification
            status
            title
            type
            due_in
          }
          title
          assigned_users(
            filters: $assignedUsersFilters2
            pagination: $assignedUsersPagination2
          ) {
            id
            user {
              data {
                id
                attributes {
                  email
                }
              }
            }
            assigned(filters: $assignedFilters2) {
              data {
                id
                attributes {
                  email
                }
              }
            }
          }
          users_with_rating(
            filters: $usersWithRatingFilters2
            pagination: $usersWithRatingPagination2
          ) {
            id
            rating
            user {
              data {
                id
                attributes {
                  email
                }
              }
            }
          }
          crm_role {
            data {
              id
              attributes {
                name
              }
            }
          }
          crm_cm_status {
            data {
              id
              attributes {
                name
              }
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetCampaignsListQuery__
 *
 * To run a query within a React component, call `useGetCampaignsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCampaignsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCampaignsListQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      sort: // value for 'sort'
 *      crmCampaignMembersFilters: // value for 'crmCampaignMembersFilters'
 *      crmCampaignMembersPagination: // value for 'crmCampaignMembersPagination'
 *      crmCampaignMembersSort: // value for 'crmCampaignMembersSort'
 *      usersWithRolesFilters2: // value for 'usersWithRolesFilters2'
 *      usersWithRolesPagination2: // value for 'usersWithRolesPagination2'
 *      usersWithRolesSort2: // value for 'usersWithRolesSort2'
 *      assignedFilters2: // value for 'assignedFilters2'
 *      assignedUsersFilters2: // value for 'assignedUsersFilters2'
 *      assignedUsersPagination2: // value for 'assignedUsersPagination2'
 *      usersWithRatingFilters2: // value for 'usersWithRatingFilters2'
 *      usersWithRatingPagination2: // value for 'usersWithRatingPagination2'
 *   },
 * });
 */
export function useGetCampaignsListQuery(baseOptions?: Apollo.QueryHookOptions<GetCampaignsListQuery, GetCampaignsListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCampaignsListQuery, GetCampaignsListQueryVariables>(GetCampaignsListDocument, options);
      }
export function useGetCampaignsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCampaignsListQuery, GetCampaignsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCampaignsListQuery, GetCampaignsListQueryVariables>(GetCampaignsListDocument, options);
        }
export type GetCampaignsListQueryHookResult = ReturnType<typeof useGetCampaignsListQuery>;
export type GetCampaignsListLazyQueryHookResult = ReturnType<typeof useGetCampaignsListLazyQuery>;
export type GetCampaignsListQueryResult = Apollo.QueryResult<GetCampaignsListQuery, GetCampaignsListQueryVariables>;
export const GetCrmTasksFromCampaignsDocument = gql`
    query GetCrmTasksFromCampaigns($filters: CampaignFiltersInput, $pagination: PaginationArg, $sort: [String], $crmCampaignMembersFilters: CrmCampaignMemberFiltersInput, $crmCampaignMembersPagination: PaginationArg, $crmCampaignMembersSort: [String], $crmTasksFilters: CrmTaskFiltersInput, $crmTasksPagination: PaginationArg, $crmTasksSort: [String]) {
  campaigns(filters: $filters, pagination: $pagination, sort: $sort) {
    data {
      attributes {
        slug
        crm_campaign_members(
          filters: $crmCampaignMembersFilters
          pagination: $crmCampaignMembersPagination
          sort: $crmCampaignMembersSort
        ) {
          data {
            id
            attributes {
              crm_tasks(
                filters: $crmTasksFilters
                pagination: $crmTasksPagination
                sort: $crmTasksSort
              ) {
                data {
                  id
                  attributes {
                    assignee {
                      data {
                        id
                        attributes {
                          firstName
                          lastName
                        }
                      }
                    }
                    createdAt
                    crm_campaign_member {
                      data {
                        id
                        attributes {
                          crm_contact {
                            data {
                              id
                              attributes {
                                firstName
                                lastName
                              }
                            }
                          }
                        }
                      }
                    }
                    crm_link {
                      data {
                        id
                      }
                    }
                    status
                    type
                    dueDate
                    title
                    meeting_url
                    feedback {
                      data {
                        id
                        attributes {
                          crm_reports
                          name
                          task_type
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
      id
    }
  }
}
    `;

/**
 * __useGetCrmTasksFromCampaignsQuery__
 *
 * To run a query within a React component, call `useGetCrmTasksFromCampaignsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCrmTasksFromCampaignsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCrmTasksFromCampaignsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      sort: // value for 'sort'
 *      crmCampaignMembersFilters: // value for 'crmCampaignMembersFilters'
 *      crmCampaignMembersPagination: // value for 'crmCampaignMembersPagination'
 *      crmCampaignMembersSort: // value for 'crmCampaignMembersSort'
 *      crmTasksFilters: // value for 'crmTasksFilters'
 *      crmTasksPagination: // value for 'crmTasksPagination'
 *      crmTasksSort: // value for 'crmTasksSort'
 *   },
 * });
 */
export function useGetCrmTasksFromCampaignsQuery(baseOptions?: Apollo.QueryHookOptions<GetCrmTasksFromCampaignsQuery, GetCrmTasksFromCampaignsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCrmTasksFromCampaignsQuery, GetCrmTasksFromCampaignsQueryVariables>(GetCrmTasksFromCampaignsDocument, options);
      }
export function useGetCrmTasksFromCampaignsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCrmTasksFromCampaignsQuery, GetCrmTasksFromCampaignsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCrmTasksFromCampaignsQuery, GetCrmTasksFromCampaignsQueryVariables>(GetCrmTasksFromCampaignsDocument, options);
        }
export type GetCrmTasksFromCampaignsQueryHookResult = ReturnType<typeof useGetCrmTasksFromCampaignsQuery>;
export type GetCrmTasksFromCampaignsLazyQueryHookResult = ReturnType<typeof useGetCrmTasksFromCampaignsLazyQuery>;
export type GetCrmTasksFromCampaignsQueryResult = Apollo.QueryResult<GetCrmTasksFromCampaignsQuery, GetCrmTasksFromCampaignsQueryVariables>;
export const GetCrmSingleTaskDocument = gql`
    query GetCrmSingleTask($crmTaskId: ID!, $filters: ComponentCrmDataCrmAccountRoleFiltersInput, $pagination: PaginationArg, $sort: [String], $rolesFilters: CrmRoleFiltersInput, $rolesPagination: PaginationArg, $rolesSort: [String], $aiPromptsPagination: PaginationArg) {
  crmTask(id: $crmTaskId) {
    data {
      id
      attributes {
        calendarEventId
        duration
        assignee {
          data {
            id
            attributes {
              firstName
              lastName
              email
            }
          }
        }
        createdAt
        crm_campaign_member {
          data {
            id
            attributes {
              info
              crm_contact {
                data {
                  id
                  attributes {
                    email
                    firstName
                    lastName
                    phoneNumber
                  }
                }
              }
              users_with_roles(filters: $filters, pagination: $pagination, sort: $sort) {
                id
                user {
                  data {
                    id
                    attributes {
                      email
                    }
                  }
                }
                roles(filters: $rolesFilters, pagination: $rolesPagination, sort: $rolesSort) {
                  data {
                    id
                    attributes {
                      name
                      slug
                    }
                  }
                }
              }
            }
          }
        }
        crm_link {
          data {
            id
            attributes {
              identifier
              products {
                data {
                  id
                }
              }
            }
          }
        }
        dueDate
        info
        meeting_url
        meeting_recording_url
        status
        title
        type
        updatedAt
        feedback {
          data {
            id
            attributes {
              name
              task_type
              createdAt
            }
          }
        }
        ai_prompts(pagination: $aiPromptsPagination) {
          id
          prompt_type {
            data {
              id
              attributes {
                type
                prompt
              }
            }
          }
          prompt_text
          ai_answer
        }
        feedback_teamleader
        feedbackUpdatedAt
        questions
        crm_campaign {
          data {
            id
            attributes {
              name
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetCrmSingleTaskQuery__
 *
 * To run a query within a React component, call `useGetCrmSingleTaskQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCrmSingleTaskQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCrmSingleTaskQuery({
 *   variables: {
 *      crmTaskId: // value for 'crmTaskId'
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      sort: // value for 'sort'
 *      rolesFilters: // value for 'rolesFilters'
 *      rolesPagination: // value for 'rolesPagination'
 *      rolesSort: // value for 'rolesSort'
 *      aiPromptsPagination: // value for 'aiPromptsPagination'
 *   },
 * });
 */
export function useGetCrmSingleTaskQuery(baseOptions: Apollo.QueryHookOptions<GetCrmSingleTaskQuery, GetCrmSingleTaskQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCrmSingleTaskQuery, GetCrmSingleTaskQueryVariables>(GetCrmSingleTaskDocument, options);
      }
export function useGetCrmSingleTaskLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCrmSingleTaskQuery, GetCrmSingleTaskQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCrmSingleTaskQuery, GetCrmSingleTaskQueryVariables>(GetCrmSingleTaskDocument, options);
        }
export type GetCrmSingleTaskQueryHookResult = ReturnType<typeof useGetCrmSingleTaskQuery>;
export type GetCrmSingleTaskLazyQueryHookResult = ReturnType<typeof useGetCrmSingleTaskLazyQuery>;
export type GetCrmSingleTaskQueryResult = Apollo.QueryResult<GetCrmSingleTaskQuery, GetCrmSingleTaskQueryVariables>;
export const GetCrmTasksDocument = gql`
    query GetCrmTasks($filters: CrmTaskFiltersInput, $pagination: PaginationArg, $sort: [String]) {
  crmTasks(filters: $filters, pagination: $pagination, sort: $sort) {
    data {
      id
      attributes {
        assignee {
          data {
            id
            attributes {
              firstName
              lastName
            }
          }
        }
        createdAt
        crm_campaign_member {
          data {
            id
            attributes {
              crm_contact {
                data {
                  id
                  attributes {
                    firstName
                    lastName
                  }
                }
              }
            }
          }
        }
        crm_link {
          data {
            id
          }
        }
        status
        type
        dueDate
        title
        meeting_url
        feedback {
          data {
            id
            attributes {
              crm_reports
              name
              task_type
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetCrmTasksQuery__
 *
 * To run a query within a React component, call `useGetCrmTasksQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCrmTasksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCrmTasksQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetCrmTasksQuery(baseOptions?: Apollo.QueryHookOptions<GetCrmTasksQuery, GetCrmTasksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCrmTasksQuery, GetCrmTasksQueryVariables>(GetCrmTasksDocument, options);
      }
export function useGetCrmTasksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCrmTasksQuery, GetCrmTasksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCrmTasksQuery, GetCrmTasksQueryVariables>(GetCrmTasksDocument, options);
        }
export type GetCrmTasksQueryHookResult = ReturnType<typeof useGetCrmTasksQuery>;
export type GetCrmTasksLazyQueryHookResult = ReturnType<typeof useGetCrmTasksLazyQuery>;
export type GetCrmTasksQueryResult = Apollo.QueryResult<GetCrmTasksQuery, GetCrmTasksQueryVariables>;
export const GetAllCampaignMembersEmailsDocument = gql`
    query getAllCampaignMembersEmails($filters: CrmCampaignMemberFiltersInput, $pagination: PaginationArg, $sort: [String]) {
  crmCampaignMembers(filters: $filters, pagination: $pagination, sort: $sort) {
    data {
      id
      attributes {
        crm_contact {
          data {
            id
            attributes {
              email
              firstName
              lastName
              phoneNumber
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetAllCampaignMembersEmailsQuery__
 *
 * To run a query within a React component, call `useGetAllCampaignMembersEmailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllCampaignMembersEmailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllCampaignMembersEmailsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetAllCampaignMembersEmailsQuery(baseOptions?: Apollo.QueryHookOptions<GetAllCampaignMembersEmailsQuery, GetAllCampaignMembersEmailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllCampaignMembersEmailsQuery, GetAllCampaignMembersEmailsQueryVariables>(GetAllCampaignMembersEmailsDocument, options);
      }
export function useGetAllCampaignMembersEmailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllCampaignMembersEmailsQuery, GetAllCampaignMembersEmailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllCampaignMembersEmailsQuery, GetAllCampaignMembersEmailsQueryVariables>(GetAllCampaignMembersEmailsDocument, options);
        }
export type GetAllCampaignMembersEmailsQueryHookResult = ReturnType<typeof useGetAllCampaignMembersEmailsQuery>;
export type GetAllCampaignMembersEmailsLazyQueryHookResult = ReturnType<typeof useGetAllCampaignMembersEmailsLazyQuery>;
export type GetAllCampaignMembersEmailsQueryResult = Apollo.QueryResult<GetAllCampaignMembersEmailsQuery, GetAllCampaignMembersEmailsQueryVariables>;
export const GetCrmCampaignMembersListDocument = gql`
    query getCrmCampaignMembersList($filters: CrmCampaignMemberFiltersInput, $pagination: PaginationArg, $sort: [String], $reservationsSort: [String], $accountRolesFilters: ComponentCrmDataCrmAccountRoleFiltersInput, $accountRolesPagination: PaginationArg, $accountRolesSort: [String], $rolesFilters: CrmRoleFiltersInput, $rolesPagination: PaginationArg, $rolesSort: [String], $timeSlotsFilters: TimeSlotFiltersInput, $productsFilters: ComponentMenuProductWithQuantityFiltersInput, $reservationsPagination: PaginationArg, $timeSlotsPagination: PaginationArg, $productsPagination: PaginationArg) {
  crmCampaignMembers(filters: $filters, pagination: $pagination, sort: $sort) {
    meta {
      pagination {
        page
        pageCount
        total
      }
    }
    data {
      id
      attributes {
        statusUpdatedAt
        users_with_roles(
          filters: $accountRolesFilters
          pagination: $accountRolesPagination
          sort: $accountRolesSort
        ) {
          id
          user {
            data {
              id
              attributes {
                email
              }
            }
          }
          roles(filters: $rolesFilters, pagination: $rolesPagination, sort: $rolesSort) {
            data {
              id
              attributes {
                name
              }
            }
          }
        }
        crm_contact {
          data {
            id
            attributes {
              firstName
              lastName
              phoneNumber
              email
            }
          }
        }
        status {
          data {
            id
            attributes {
              createdAt
              description
              name
            }
          }
        }
        reservations(sort: $reservationsSort, pagination: $reservationsPagination) {
          data {
            id
            attributes {
              title
              type
              time_slots(filters: $timeSlotsFilters, pagination: $timeSlotsPagination) {
                data {
                  id
                  attributes {
                    info
                    additional_info
                    number_of_persons
                    room {
                      data {
                        id
                        attributes {
                          name
                        }
                      }
                    }
                    game {
                      data {
                        id
                        attributes {
                          name
                        }
                      }
                    }
                  }
                }
              }
              products(filters: $productsFilters, pagination: $productsPagination) {
                id
                info
                product {
                  data {
                    id
                    attributes {
                      title
                      price
                    }
                  }
                }
                quantity
                discount_percentage
                discount_amount
              }
              status
              start_date
            }
          }
        }
        info
      }
    }
  }
}
    `;

/**
 * __useGetCrmCampaignMembersListQuery__
 *
 * To run a query within a React component, call `useGetCrmCampaignMembersListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCrmCampaignMembersListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCrmCampaignMembersListQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      sort: // value for 'sort'
 *      reservationsSort: // value for 'reservationsSort'
 *      accountRolesFilters: // value for 'accountRolesFilters'
 *      accountRolesPagination: // value for 'accountRolesPagination'
 *      accountRolesSort: // value for 'accountRolesSort'
 *      rolesFilters: // value for 'rolesFilters'
 *      rolesPagination: // value for 'rolesPagination'
 *      rolesSort: // value for 'rolesSort'
 *      timeSlotsFilters: // value for 'timeSlotsFilters'
 *      productsFilters: // value for 'productsFilters'
 *      reservationsPagination: // value for 'reservationsPagination'
 *      timeSlotsPagination: // value for 'timeSlotsPagination'
 *      productsPagination: // value for 'productsPagination'
 *   },
 * });
 */
export function useGetCrmCampaignMembersListQuery(baseOptions?: Apollo.QueryHookOptions<GetCrmCampaignMembersListQuery, GetCrmCampaignMembersListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCrmCampaignMembersListQuery, GetCrmCampaignMembersListQueryVariables>(GetCrmCampaignMembersListDocument, options);
      }
export function useGetCrmCampaignMembersListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCrmCampaignMembersListQuery, GetCrmCampaignMembersListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCrmCampaignMembersListQuery, GetCrmCampaignMembersListQueryVariables>(GetCrmCampaignMembersListDocument, options);
        }
export type GetCrmCampaignMembersListQueryHookResult = ReturnType<typeof useGetCrmCampaignMembersListQuery>;
export type GetCrmCampaignMembersListLazyQueryHookResult = ReturnType<typeof useGetCrmCampaignMembersListLazyQuery>;
export type GetCrmCampaignMembersListQueryResult = Apollo.QueryResult<GetCrmCampaignMembersListQuery, GetCrmCampaignMembersListQueryVariables>;
export const GetCrmLinksIdentifiersDocument = gql`
    query GetCrmLinksIdentifiers($filters: CrmLinkFiltersInput, $pagination: PaginationArg, $sort: [String]) {
  crmLinks(filters: $filters, pagination: $pagination, sort: $sort) {
    data {
      id
      attributes {
        identifier
      }
    }
  }
}
    `;

/**
 * __useGetCrmLinksIdentifiersQuery__
 *
 * To run a query within a React component, call `useGetCrmLinksIdentifiersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCrmLinksIdentifiersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCrmLinksIdentifiersQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetCrmLinksIdentifiersQuery(baseOptions?: Apollo.QueryHookOptions<GetCrmLinksIdentifiersQuery, GetCrmLinksIdentifiersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCrmLinksIdentifiersQuery, GetCrmLinksIdentifiersQueryVariables>(GetCrmLinksIdentifiersDocument, options);
      }
export function useGetCrmLinksIdentifiersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCrmLinksIdentifiersQuery, GetCrmLinksIdentifiersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCrmLinksIdentifiersQuery, GetCrmLinksIdentifiersQueryVariables>(GetCrmLinksIdentifiersDocument, options);
        }
export type GetCrmLinksIdentifiersQueryHookResult = ReturnType<typeof useGetCrmLinksIdentifiersQuery>;
export type GetCrmLinksIdentifiersLazyQueryHookResult = ReturnType<typeof useGetCrmLinksIdentifiersLazyQuery>;
export type GetCrmLinksIdentifiersQueryResult = Apollo.QueryResult<GetCrmLinksIdentifiersQuery, GetCrmLinksIdentifiersQueryVariables>;
export const GetCrmCampaignUserTasksDocument = gql`
    query GetCrmCampaignUserTasks($filters: CampaignFiltersInput, $pagination: PaginationArg, $sort: [String], $crmTasksFilters: CrmTaskFiltersInput, $crmTasksPagination: PaginationArg, $crmTasksSort: [String], $usersWithRolesFilters: ComponentCrmDataCrmAccountRoleFiltersInput, $usersWithRolesPagination: PaginationArg, $usersWithRolesSort: [String]) {
  campaigns(filters: $filters, pagination: $pagination, sort: $sort) {
    data {
      id
      attributes {
        slug
        users_with_roles(
          filters: $usersWithRolesFilters
          pagination: $usersWithRolesPagination
          sort: $usersWithRolesSort
        ) {
          id
          user {
            data {
              id
              attributes {
                crm_tasks(
                  filters: $crmTasksFilters
                  pagination: $crmTasksPagination
                  sort: $crmTasksSort
                ) {
                  data {
                    id
                    attributes {
                      assignee {
                        data {
                          id
                          attributes {
                            firstName
                            lastName
                          }
                        }
                      }
                      createdAt
                      crm_campaign_member {
                        data {
                          id
                          attributes {
                            crm_contact {
                              data {
                                id
                                attributes {
                                  firstName
                                  lastName
                                  email
                                }
                              }
                            }
                          }
                        }
                      }
                      crm_link {
                        data {
                          id
                        }
                      }
                      status
                      type
                      dueDate
                      title
                      meeting_url
                      feedback {
                        data {
                          id
                          attributes {
                            createdAt
                            crm_reports
                            name
                            task_type
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
    meta {
      pagination {
        page
        pageCount
        pageSize
        total
      }
    }
  }
}
    `;

/**
 * __useGetCrmCampaignUserTasksQuery__
 *
 * To run a query within a React component, call `useGetCrmCampaignUserTasksQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCrmCampaignUserTasksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCrmCampaignUserTasksQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      sort: // value for 'sort'
 *      crmTasksFilters: // value for 'crmTasksFilters'
 *      crmTasksPagination: // value for 'crmTasksPagination'
 *      crmTasksSort: // value for 'crmTasksSort'
 *      usersWithRolesFilters: // value for 'usersWithRolesFilters'
 *      usersWithRolesPagination: // value for 'usersWithRolesPagination'
 *      usersWithRolesSort: // value for 'usersWithRolesSort'
 *   },
 * });
 */
export function useGetCrmCampaignUserTasksQuery(baseOptions?: Apollo.QueryHookOptions<GetCrmCampaignUserTasksQuery, GetCrmCampaignUserTasksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCrmCampaignUserTasksQuery, GetCrmCampaignUserTasksQueryVariables>(GetCrmCampaignUserTasksDocument, options);
      }
export function useGetCrmCampaignUserTasksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCrmCampaignUserTasksQuery, GetCrmCampaignUserTasksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCrmCampaignUserTasksQuery, GetCrmCampaignUserTasksQueryVariables>(GetCrmCampaignUserTasksDocument, options);
        }
export type GetCrmCampaignUserTasksQueryHookResult = ReturnType<typeof useGetCrmCampaignUserTasksQuery>;
export type GetCrmCampaignUserTasksLazyQueryHookResult = ReturnType<typeof useGetCrmCampaignUserTasksLazyQuery>;
export type GetCrmCampaignUserTasksQueryResult = Apollo.QueryResult<GetCrmCampaignUserTasksQuery, GetCrmCampaignUserTasksQueryVariables>;
export const GetCrmUsersDocument = gql`
    query GetCrmUsers($filters: CampaignFiltersInput, $pagination: PaginationArg, $sort: [String], $usersWithRolesFilters: ComponentCrmDataCrmAccountRoleFiltersInput, $usersWithRolesPagination: PaginationArg) {
  campaigns(filters: $filters, pagination: $pagination, sort: $sort) {
    data {
      id
      attributes {
        name
        users_with_roles(
          filters: $usersWithRolesFilters
          pagination: $usersWithRolesPagination
        ) {
          id
          user {
            data {
              id
              attributes {
                email
                firstName
                lastName
              }
            }
          }
          roles {
            data {
              id
              attributes {
                name
                permissions
                contact_sources {
                  data {
                    id
                    attributes {
                      name
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetCrmUsersQuery__
 *
 * To run a query within a React component, call `useGetCrmUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCrmUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCrmUsersQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      sort: // value for 'sort'
 *      usersWithRolesFilters: // value for 'usersWithRolesFilters'
 *      usersWithRolesPagination: // value for 'usersWithRolesPagination'
 *   },
 * });
 */
export function useGetCrmUsersQuery(baseOptions?: Apollo.QueryHookOptions<GetCrmUsersQuery, GetCrmUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCrmUsersQuery, GetCrmUsersQueryVariables>(GetCrmUsersDocument, options);
      }
export function useGetCrmUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCrmUsersQuery, GetCrmUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCrmUsersQuery, GetCrmUsersQueryVariables>(GetCrmUsersDocument, options);
        }
export type GetCrmUsersQueryHookResult = ReturnType<typeof useGetCrmUsersQuery>;
export type GetCrmUsersLazyQueryHookResult = ReturnType<typeof useGetCrmUsersLazyQuery>;
export type GetCrmUsersQueryResult = Apollo.QueryResult<GetCrmUsersQuery, GetCrmUsersQueryVariables>;
export const GetCrmSingleLinkDocument = gql`
    query GetCrmSingleLink($crmLinkId: ID!, $pagination: PaginationArg, $sort: [String], $ordersFilters: OrderFiltersInput, $ordersPagination: PaginationArg, $ordersSort: [String], $productsFilters: ProductFiltersInput, $productsPagination: PaginationArg, $productsSort: [String]) {
  crmLink(id: $crmLinkId) {
    data {
      id
      attributes {
        createdAt
        crm_campaign {
          data {
            id
          }
        }
        crm_campaign_member {
          data {
            id
          }
        }
        crm_campaign_member_account_roles(pagination: $pagination, sort: $sort) {
          id
          roles {
            data {
              id
              attributes {
                name
                slug
                sales_commision
              }
            }
          }
          user {
            data {
              id
            }
          }
        }
        crm_task {
          data {
            id
          }
        }
        identifier
        orders(
          filters: $ordersFilters
          pagination: $ordersPagination
          sort: $ordersSort
        ) {
          data {
            id
            attributes {
              total_price
            }
          }
        }
        updatedAt
        utm_data {
          id
          utm_campaign
          utm_id
          utm_medium
          utm_source
        }
        products(
          filters: $productsFilters
          pagination: $productsPagination
          sort: $productsSort
        ) {
          data {
            id
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetCrmSingleLinkQuery__
 *
 * To run a query within a React component, call `useGetCrmSingleLinkQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCrmSingleLinkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCrmSingleLinkQuery({
 *   variables: {
 *      crmLinkId: // value for 'crmLinkId'
 *      pagination: // value for 'pagination'
 *      sort: // value for 'sort'
 *      ordersFilters: // value for 'ordersFilters'
 *      ordersPagination: // value for 'ordersPagination'
 *      ordersSort: // value for 'ordersSort'
 *      productsFilters: // value for 'productsFilters'
 *      productsPagination: // value for 'productsPagination'
 *      productsSort: // value for 'productsSort'
 *   },
 * });
 */
export function useGetCrmSingleLinkQuery(baseOptions: Apollo.QueryHookOptions<GetCrmSingleLinkQuery, GetCrmSingleLinkQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCrmSingleLinkQuery, GetCrmSingleLinkQueryVariables>(GetCrmSingleLinkDocument, options);
      }
export function useGetCrmSingleLinkLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCrmSingleLinkQuery, GetCrmSingleLinkQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCrmSingleLinkQuery, GetCrmSingleLinkQueryVariables>(GetCrmSingleLinkDocument, options);
        }
export type GetCrmSingleLinkQueryHookResult = ReturnType<typeof useGetCrmSingleLinkQuery>;
export type GetCrmSingleLinkLazyQueryHookResult = ReturnType<typeof useGetCrmSingleLinkLazyQuery>;
export type GetCrmSingleLinkQueryResult = Apollo.QueryResult<GetCrmSingleLinkQuery, GetCrmSingleLinkQueryVariables>;
export const GetCrmCampaignMembersDocument = gql`
    query GetCRMCampaignMembers($filters: CampaignFiltersInput, $pagination: PaginationArg, $sort: [String], $crmCampaignMembersFilters: CrmCampaignMemberFiltersInput, $crmCampaignMembersPagination: PaginationArg, $crmCampaignMembersSort: [String], $accountRolesFilters: ComponentCrmDataCrmAccountRoleFiltersInput, $accountRolesPagination: PaginationArg, $accountRolesSort: [String], $rolesFilters: CrmRoleFiltersInput, $rolesPagination: PaginationArg, $rolesSort: [String]) {
  campaigns(filters: $filters, pagination: $pagination, sort: $sort) {
    data {
      id
      attributes {
        crm_campaign_members(
          filters: $crmCampaignMembersFilters
          pagination: $crmCampaignMembersPagination
          sort: $crmCampaignMembersSort
        ) {
          data {
            id
            attributes {
              statusUpdatedAt
              users_with_roles(
                filters: $accountRolesFilters
                pagination: $accountRolesPagination
                sort: $accountRolesSort
              ) {
                id
                user {
                  data {
                    id
                    attributes {
                      email
                    }
                  }
                }
                roles(filters: $rolesFilters, pagination: $rolesPagination, sort: $rolesSort) {
                  data {
                    id
                    attributes {
                      name
                    }
                  }
                }
              }
              crm_contact {
                data {
                  id
                  attributes {
                    firstName
                    lastName
                    phoneNumber
                    email
                  }
                }
              }
              status {
                data {
                  id
                  attributes {
                    createdAt
                    description
                    name
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetCrmCampaignMembersQuery__
 *
 * To run a query within a React component, call `useGetCrmCampaignMembersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCrmCampaignMembersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCrmCampaignMembersQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      sort: // value for 'sort'
 *      crmCampaignMembersFilters: // value for 'crmCampaignMembersFilters'
 *      crmCampaignMembersPagination: // value for 'crmCampaignMembersPagination'
 *      crmCampaignMembersSort: // value for 'crmCampaignMembersSort'
 *      accountRolesFilters: // value for 'accountRolesFilters'
 *      accountRolesPagination: // value for 'accountRolesPagination'
 *      accountRolesSort: // value for 'accountRolesSort'
 *      rolesFilters: // value for 'rolesFilters'
 *      rolesPagination: // value for 'rolesPagination'
 *      rolesSort: // value for 'rolesSort'
 *   },
 * });
 */
export function useGetCrmCampaignMembersQuery(baseOptions?: Apollo.QueryHookOptions<GetCrmCampaignMembersQuery, GetCrmCampaignMembersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCrmCampaignMembersQuery, GetCrmCampaignMembersQueryVariables>(GetCrmCampaignMembersDocument, options);
      }
export function useGetCrmCampaignMembersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCrmCampaignMembersQuery, GetCrmCampaignMembersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCrmCampaignMembersQuery, GetCrmCampaignMembersQueryVariables>(GetCrmCampaignMembersDocument, options);
        }
export type GetCrmCampaignMembersQueryHookResult = ReturnType<typeof useGetCrmCampaignMembersQuery>;
export type GetCrmCampaignMembersLazyQueryHookResult = ReturnType<typeof useGetCrmCampaignMembersLazyQuery>;
export type GetCrmCampaignMembersQueryResult = Apollo.QueryResult<GetCrmCampaignMembersQuery, GetCrmCampaignMembersQueryVariables>;
export const CrmSingleMemberDocument = gql`
    query CrmSingleMember($crmCampaignMemberId: ID!, $filters: CrmTaskFiltersInput, $pagination: PaginationArg, $sort: [String], $accountRolesFilters: ComponentCrmDataCrmAccountRoleFiltersInput, $accountRolesPagination: PaginationArg, $accountRolesSort: [String], $rolesFilters2: CrmRoleFiltersInput, $rolesPagination2: PaginationArg, $rolesSort2: [String], $completedActionsFilters: ComponentCrmDataCrmActionsFiltersInput, $completedActionsPagination: PaginationArg, $completedActionsSort: [String]) {
  crmCampaignMember(id: $crmCampaignMemberId) {
    data {
      id
      attributes {
        crm_contact {
          data {
            id
            attributes {
              email
              firstName
              lastName
              phoneNumber
              completed_actions(
                filters: $completedActionsFilters
                pagination: $completedActionsPagination
                sort: $completedActionsSort
              ) {
                action_date
                action_name
                action_info
                id
              }
            }
          }
        }
        crm_tasks(filters: $filters, pagination: $pagination, sort: $sort) {
          data {
            id
            attributes {
              title
              status
              feedback {
                data {
                  id
                  attributes {
                    name
                    task_type
                  }
                }
              }
            }
          }
        }
        users_with_roles(
          filters: $accountRolesFilters
          pagination: $accountRolesPagination
          sort: $accountRolesSort
        ) {
          id
          user {
            data {
              id
              attributes {
                email
              }
            }
          }
          roles(filters: $rolesFilters2, pagination: $rolesPagination2, sort: $rolesSort2) {
            data {
              id
              attributes {
                name
                slug
              }
            }
          }
        }
        crm_campaign {
          data {
            id
          }
        }
        status {
          data {
            id
            attributes {
              createdAt
              description
              name
            }
          }
        }
        info
        reservations {
          data {
            id
            attributes {
              title
              status
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useCrmSingleMemberQuery__
 *
 * To run a query within a React component, call `useCrmSingleMemberQuery` and pass it any options that fit your needs.
 * When your component renders, `useCrmSingleMemberQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCrmSingleMemberQuery({
 *   variables: {
 *      crmCampaignMemberId: // value for 'crmCampaignMemberId'
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      sort: // value for 'sort'
 *      accountRolesFilters: // value for 'accountRolesFilters'
 *      accountRolesPagination: // value for 'accountRolesPagination'
 *      accountRolesSort: // value for 'accountRolesSort'
 *      rolesFilters2: // value for 'rolesFilters2'
 *      rolesPagination2: // value for 'rolesPagination2'
 *      rolesSort2: // value for 'rolesSort2'
 *      completedActionsFilters: // value for 'completedActionsFilters'
 *      completedActionsPagination: // value for 'completedActionsPagination'
 *      completedActionsSort: // value for 'completedActionsSort'
 *   },
 * });
 */
export function useCrmSingleMemberQuery(baseOptions: Apollo.QueryHookOptions<CrmSingleMemberQuery, CrmSingleMemberQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CrmSingleMemberQuery, CrmSingleMemberQueryVariables>(CrmSingleMemberDocument, options);
      }
export function useCrmSingleMemberLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CrmSingleMemberQuery, CrmSingleMemberQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CrmSingleMemberQuery, CrmSingleMemberQueryVariables>(CrmSingleMemberDocument, options);
        }
export type CrmSingleMemberQueryHookResult = ReturnType<typeof useCrmSingleMemberQuery>;
export type CrmSingleMemberLazyQueryHookResult = ReturnType<typeof useCrmSingleMemberLazyQuery>;
export type CrmSingleMemberQueryResult = Apollo.QueryResult<CrmSingleMemberQuery, CrmSingleMemberQueryVariables>;
export const GetCrmRolesDocument = gql`
    query GetCrmRoles($filters: CrmRoleFiltersInput, $pagination: PaginationArg, $sort: [String]) {
  crmRoles(filters: $filters, pagination: $pagination, sort: $sort) {
    data {
      id
      attributes {
        name
        permissions
        sales_commision
        slug
      }
    }
  }
}
    `;

/**
 * __useGetCrmRolesQuery__
 *
 * To run a query within a React component, call `useGetCrmRolesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCrmRolesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCrmRolesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetCrmRolesQuery(baseOptions?: Apollo.QueryHookOptions<GetCrmRolesQuery, GetCrmRolesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCrmRolesQuery, GetCrmRolesQueryVariables>(GetCrmRolesDocument, options);
      }
export function useGetCrmRolesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCrmRolesQuery, GetCrmRolesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCrmRolesQuery, GetCrmRolesQueryVariables>(GetCrmRolesDocument, options);
        }
export type GetCrmRolesQueryHookResult = ReturnType<typeof useGetCrmRolesQuery>;
export type GetCrmRolesLazyQueryHookResult = ReturnType<typeof useGetCrmRolesLazyQuery>;
export type GetCrmRolesQueryResult = Apollo.QueryResult<GetCrmRolesQuery, GetCrmRolesQueryVariables>;
export const GetCrmSingleContactDocument = gql`
    query GetCRMSingleContact($contactId: ID!, $completedActionsfilters: ComponentCrmDataCrmActionsFiltersInput, $completedActionspagination: PaginationArg, $completedActionssort: [String], $campaignMembersFilters: CrmCampaignMemberFiltersInput, $campaignMembersPagination: PaginationArg) {
  contact(id: $contactId) {
    data {
      id
      attributes {
        acId
        age
        completed_actions(
          filters: $completedActionsfilters
          pagination: $completedActionspagination
          sort: $completedActionssort
        ) {
          action_info
          action_date
          action_name
          id
        }
        createdAt
        date
        email
        firstName
        info
        lastName
        phoneNumber
        contact_source {
          data {
            id
            attributes {
              name
            }
          }
        }
        updatedAt
        user {
          data {
            id
            attributes {
              email
            }
          }
        }
        crm_campaign_members(
          filters: $campaignMembersFilters
          pagination: $campaignMembersPagination
        ) {
          data {
            id
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetCrmSingleContactQuery__
 *
 * To run a query within a React component, call `useGetCrmSingleContactQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCrmSingleContactQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCrmSingleContactQuery({
 *   variables: {
 *      contactId: // value for 'contactId'
 *      completedActionsfilters: // value for 'completedActionsfilters'
 *      completedActionspagination: // value for 'completedActionspagination'
 *      completedActionssort: // value for 'completedActionssort'
 *      campaignMembersFilters: // value for 'campaignMembersFilters'
 *      campaignMembersPagination: // value for 'campaignMembersPagination'
 *   },
 * });
 */
export function useGetCrmSingleContactQuery(baseOptions: Apollo.QueryHookOptions<GetCrmSingleContactQuery, GetCrmSingleContactQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCrmSingleContactQuery, GetCrmSingleContactQueryVariables>(GetCrmSingleContactDocument, options);
      }
export function useGetCrmSingleContactLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCrmSingleContactQuery, GetCrmSingleContactQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCrmSingleContactQuery, GetCrmSingleContactQueryVariables>(GetCrmSingleContactDocument, options);
        }
export type GetCrmSingleContactQueryHookResult = ReturnType<typeof useGetCrmSingleContactQuery>;
export type GetCrmSingleContactLazyQueryHookResult = ReturnType<typeof useGetCrmSingleContactLazyQuery>;
export type GetCrmSingleContactQueryResult = Apollo.QueryResult<GetCrmSingleContactQuery, GetCrmSingleContactQueryVariables>;
export const GetCampaignsIdsDocument = gql`
    query GetCampaignsIds($filters: CampaignFiltersInput, $pagination: PaginationArg, $sort: [String]) {
  campaigns(filters: $filters, pagination: $pagination, sort: $sort) {
    data {
      id
      attributes {
        name
        slug
      }
    }
  }
}
    `;

/**
 * __useGetCampaignsIdsQuery__
 *
 * To run a query within a React component, call `useGetCampaignsIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCampaignsIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCampaignsIdsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetCampaignsIdsQuery(baseOptions?: Apollo.QueryHookOptions<GetCampaignsIdsQuery, GetCampaignsIdsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCampaignsIdsQuery, GetCampaignsIdsQueryVariables>(GetCampaignsIdsDocument, options);
      }
export function useGetCampaignsIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCampaignsIdsQuery, GetCampaignsIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCampaignsIdsQuery, GetCampaignsIdsQueryVariables>(GetCampaignsIdsDocument, options);
        }
export type GetCampaignsIdsQueryHookResult = ReturnType<typeof useGetCampaignsIdsQuery>;
export type GetCampaignsIdsLazyQueryHookResult = ReturnType<typeof useGetCampaignsIdsLazyQuery>;
export type GetCampaignsIdsQueryResult = Apollo.QueryResult<GetCampaignsIdsQuery, GetCampaignsIdsQueryVariables>;
export const GetProductsIdsDocument = gql`
    query GetProductsIds($filters: ProductFiltersInput, $pagination: PaginationArg, $sort: [String]) {
  products(filters: $filters, pagination: $pagination, sort: $sort) {
    data {
      id
      attributes {
        title
        price
      }
    }
  }
}
    `;

/**
 * __useGetProductsIdsQuery__
 *
 * To run a query within a React component, call `useGetProductsIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductsIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductsIdsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetProductsIdsQuery(baseOptions?: Apollo.QueryHookOptions<GetProductsIdsQuery, GetProductsIdsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProductsIdsQuery, GetProductsIdsQueryVariables>(GetProductsIdsDocument, options);
      }
export function useGetProductsIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProductsIdsQuery, GetProductsIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProductsIdsQuery, GetProductsIdsQueryVariables>(GetProductsIdsDocument, options);
        }
export type GetProductsIdsQueryHookResult = ReturnType<typeof useGetProductsIdsQuery>;
export type GetProductsIdsLazyQueryHookResult = ReturnType<typeof useGetProductsIdsLazyQuery>;
export type GetProductsIdsQueryResult = Apollo.QueryResult<GetProductsIdsQuery, GetProductsIdsQueryVariables>;
export const GetProductsFromCampaignDocument = gql`
    query GetProductsFromCampaign($campaignId: ID!, $filters: ProductFiltersInput, $pagination: PaginationArg, $sort: [String]) {
  campaign(id: $campaignId) {
    data {
      attributes {
        products(filters: $filters, pagination: $pagination, sort: $sort) {
          data {
            id
            attributes {
              title
              price
            }
          }
        }
      }
      id
    }
  }
}
    `;

/**
 * __useGetProductsFromCampaignQuery__
 *
 * To run a query within a React component, call `useGetProductsFromCampaignQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductsFromCampaignQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductsFromCampaignQuery({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetProductsFromCampaignQuery(baseOptions: Apollo.QueryHookOptions<GetProductsFromCampaignQuery, GetProductsFromCampaignQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProductsFromCampaignQuery, GetProductsFromCampaignQueryVariables>(GetProductsFromCampaignDocument, options);
      }
export function useGetProductsFromCampaignLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProductsFromCampaignQuery, GetProductsFromCampaignQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProductsFromCampaignQuery, GetProductsFromCampaignQueryVariables>(GetProductsFromCampaignDocument, options);
        }
export type GetProductsFromCampaignQueryHookResult = ReturnType<typeof useGetProductsFromCampaignQuery>;
export type GetProductsFromCampaignLazyQueryHookResult = ReturnType<typeof useGetProductsFromCampaignLazyQuery>;
export type GetProductsFromCampaignQueryResult = Apollo.QueryResult<GetProductsFromCampaignQuery, GetProductsFromCampaignQueryVariables>;
export const GetCrmTaskFeedbacksDocument = gql`
    query GetCrmTaskFeedbacks($filters: CrmTaskFeedbackFiltersInput, $pagination: PaginationArg, $sort: [String]) {
  crmTaskFeedbacks(filters: $filters, pagination: $pagination, sort: $sort) {
    data {
      id
      attributes {
        createdAt
        crm_reports
        name
        task_type
        updatedAt
      }
    }
  }
}
    `;

/**
 * __useGetCrmTaskFeedbacksQuery__
 *
 * To run a query within a React component, call `useGetCrmTaskFeedbacksQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCrmTaskFeedbacksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCrmTaskFeedbacksQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetCrmTaskFeedbacksQuery(baseOptions?: Apollo.QueryHookOptions<GetCrmTaskFeedbacksQuery, GetCrmTaskFeedbacksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCrmTaskFeedbacksQuery, GetCrmTaskFeedbacksQueryVariables>(GetCrmTaskFeedbacksDocument, options);
      }
export function useGetCrmTaskFeedbacksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCrmTaskFeedbacksQuery, GetCrmTaskFeedbacksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCrmTaskFeedbacksQuery, GetCrmTaskFeedbacksQueryVariables>(GetCrmTaskFeedbacksDocument, options);
        }
export type GetCrmTaskFeedbacksQueryHookResult = ReturnType<typeof useGetCrmTaskFeedbacksQuery>;
export type GetCrmTaskFeedbacksLazyQueryHookResult = ReturnType<typeof useGetCrmTaskFeedbacksLazyQuery>;
export type GetCrmTaskFeedbacksQueryResult = Apollo.QueryResult<GetCrmTaskFeedbacksQuery, GetCrmTaskFeedbacksQueryVariables>;
export const GetAllCampaignMemberStatusesDocument = gql`
    query GetAllCampaignMemberStatuses($filters: CrmCampaignMemberStatusFiltersInput, $pagination: PaginationArg, $sort: [String]) {
  crmCampaignMemberStatuses(
    filters: $filters
    pagination: $pagination
    sort: $sort
  ) {
    data {
      id
      attributes {
        auto_assign_on_action
        createdAt
        description
        name
      }
    }
  }
}
    `;

/**
 * __useGetAllCampaignMemberStatusesQuery__
 *
 * To run a query within a React component, call `useGetAllCampaignMemberStatusesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllCampaignMemberStatusesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllCampaignMemberStatusesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetAllCampaignMemberStatusesQuery(baseOptions?: Apollo.QueryHookOptions<GetAllCampaignMemberStatusesQuery, GetAllCampaignMemberStatusesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllCampaignMemberStatusesQuery, GetAllCampaignMemberStatusesQueryVariables>(GetAllCampaignMemberStatusesDocument, options);
      }
export function useGetAllCampaignMemberStatusesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllCampaignMemberStatusesQuery, GetAllCampaignMemberStatusesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllCampaignMemberStatusesQuery, GetAllCampaignMemberStatusesQueryVariables>(GetAllCampaignMemberStatusesDocument, options);
        }
export type GetAllCampaignMemberStatusesQueryHookResult = ReturnType<typeof useGetAllCampaignMemberStatusesQuery>;
export type GetAllCampaignMemberStatusesLazyQueryHookResult = ReturnType<typeof useGetAllCampaignMemberStatusesLazyQuery>;
export type GetAllCampaignMemberStatusesQueryResult = Apollo.QueryResult<GetAllCampaignMemberStatusesQuery, GetAllCampaignMemberStatusesQueryVariables>;
export const GetCrmContactsDocument = gql`
    query GetCRMContacts($pagination: PaginationArg, $sort: [String], $filters: ContactFiltersInput, $crmCampaignMembersPagination: PaginationArg, $crmCampaignMembersFilters: CrmCampaignMemberFiltersInput, $crmCampaignMembersSort: [String]) {
  contacts(sort: $sort, filters: $filters, pagination: $pagination) {
    meta {
      pagination {
        total
        page
        pageCount
        pageSize
      }
    }
    data {
      id
      attributes {
        firstName
        lastName
        info
        phoneNumber
        contact_source {
          data {
            id
            attributes {
              name
            }
          }
        }
        email
        age
        crm_campaign_members(
          pagination: $crmCampaignMembersPagination
          filters: $crmCampaignMembersFilters
          sort: $crmCampaignMembersSort
        ) {
          data {
            id
            attributes {
              crm_campaign {
                data {
                  id
                  attributes {
                    name
                  }
                }
              }
              statusUpdatedAt
              users_with_roles {
                id
                user {
                  data {
                    id
                    attributes {
                      firstName
                      lastName
                    }
                  }
                }
                roles {
                  data {
                    id
                    attributes {
                      name
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetCrmContactsQuery__
 *
 * To run a query within a React component, call `useGetCrmContactsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCrmContactsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCrmContactsQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      sort: // value for 'sort'
 *      filters: // value for 'filters'
 *      crmCampaignMembersPagination: // value for 'crmCampaignMembersPagination'
 *      crmCampaignMembersFilters: // value for 'crmCampaignMembersFilters'
 *      crmCampaignMembersSort: // value for 'crmCampaignMembersSort'
 *   },
 * });
 */
export function useGetCrmContactsQuery(baseOptions?: Apollo.QueryHookOptions<GetCrmContactsQuery, GetCrmContactsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCrmContactsQuery, GetCrmContactsQueryVariables>(GetCrmContactsDocument, options);
      }
export function useGetCrmContactsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCrmContactsQuery, GetCrmContactsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCrmContactsQuery, GetCrmContactsQueryVariables>(GetCrmContactsDocument, options);
        }
export type GetCrmContactsQueryHookResult = ReturnType<typeof useGetCrmContactsQuery>;
export type GetCrmContactsLazyQueryHookResult = ReturnType<typeof useGetCrmContactsLazyQuery>;
export type GetCrmContactsQueryResult = Apollo.QueryResult<GetCrmContactsQuery, GetCrmContactsQueryVariables>;
export const GetCrmFiltersContactsDocument = gql`
    query GetCRMFiltersContacts($pagination: PaginationArg, $sort: [String], $filters: ContactFiltersInput, $completedActionsPagination: PaginationArg, $completedActionsFilters: ComponentCrmDataCrmActionsFiltersInput) {
  contacts(sort: $sort, filters: $filters, pagination: $pagination) {
    meta {
      pagination {
        page
        pageCount
        total
      }
    }
    data {
      id
      attributes {
        firstName
        lastName
        info
        phoneNumber
        contact_source {
          data {
            id
            attributes {
              name
            }
          }
        }
        email
        completed_actions(
          pagination: $completedActionsPagination
          filters: $completedActionsFilters
        ) {
          id
          action_name
          action_info
          action_date
        }
      }
    }
  }
}
    `;

/**
 * __useGetCrmFiltersContactsQuery__
 *
 * To run a query within a React component, call `useGetCrmFiltersContactsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCrmFiltersContactsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCrmFiltersContactsQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      sort: // value for 'sort'
 *      filters: // value for 'filters'
 *      completedActionsPagination: // value for 'completedActionsPagination'
 *      completedActionsFilters: // value for 'completedActionsFilters'
 *   },
 * });
 */
export function useGetCrmFiltersContactsQuery(baseOptions?: Apollo.QueryHookOptions<GetCrmFiltersContactsQuery, GetCrmFiltersContactsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCrmFiltersContactsQuery, GetCrmFiltersContactsQueryVariables>(GetCrmFiltersContactsDocument, options);
      }
export function useGetCrmFiltersContactsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCrmFiltersContactsQuery, GetCrmFiltersContactsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCrmFiltersContactsQuery, GetCrmFiltersContactsQueryVariables>(GetCrmFiltersContactsDocument, options);
        }
export type GetCrmFiltersContactsQueryHookResult = ReturnType<typeof useGetCrmFiltersContactsQuery>;
export type GetCrmFiltersContactsLazyQueryHookResult = ReturnType<typeof useGetCrmFiltersContactsLazyQuery>;
export type GetCrmFiltersContactsQueryResult = Apollo.QueryResult<GetCrmFiltersContactsQuery, GetCrmFiltersContactsQueryVariables>;
export const GetCrmAllTasksDocument = gql`
    query GetCrmAllTasks($filters: CrmTaskFiltersInput, $pagination: PaginationArg, $sort: [String]) {
  crmTasks(filters: $filters, pagination: $pagination, sort: $sort) {
    data {
      id
      attributes {
        assignee {
          data {
            id
            attributes {
              firstName
              lastName
            }
          }
        }
        createdAt
        crm_campaign_member {
          data {
            id
            attributes {
              crm_contact {
                data {
                  id
                  attributes {
                    firstName
                    lastName
                    email
                  }
                }
              }
            }
          }
        }
        crm_link {
          data {
            id
          }
        }
        status
        type
        dueDate
        title
        meeting_url
        feedback {
          data {
            id
            attributes {
              createdAt
              crm_reports
              name
              task_type
            }
          }
        }
        meeting_recording_url
      }
    }
    meta {
      pagination {
        page
        pageCount
        pageSize
        total
      }
    }
  }
}
    `;

/**
 * __useGetCrmAllTasksQuery__
 *
 * To run a query within a React component, call `useGetCrmAllTasksQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCrmAllTasksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCrmAllTasksQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetCrmAllTasksQuery(baseOptions?: Apollo.QueryHookOptions<GetCrmAllTasksQuery, GetCrmAllTasksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCrmAllTasksQuery, GetCrmAllTasksQueryVariables>(GetCrmAllTasksDocument, options);
      }
export function useGetCrmAllTasksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCrmAllTasksQuery, GetCrmAllTasksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCrmAllTasksQuery, GetCrmAllTasksQueryVariables>(GetCrmAllTasksDocument, options);
        }
export type GetCrmAllTasksQueryHookResult = ReturnType<typeof useGetCrmAllTasksQuery>;
export type GetCrmAllTasksLazyQueryHookResult = ReturnType<typeof useGetCrmAllTasksLazyQuery>;
export type GetCrmAllTasksQueryResult = Apollo.QueryResult<GetCrmAllTasksQuery, GetCrmAllTasksQueryVariables>;
export const GetCrmContactSourcesDocument = gql`
    query GetCrmContactSources($filters: CrmContactSourceFiltersInput, $pagination: PaginationArg, $sort: [String]) {
  crmContactSources(filters: $filters, pagination: $pagination, sort: $sort) {
    data {
      id
      attributes {
        name
        crm_roles {
          data {
            id
            attributes {
              name
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetCrmContactSourcesQuery__
 *
 * To run a query within a React component, call `useGetCrmContactSourcesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCrmContactSourcesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCrmContactSourcesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetCrmContactSourcesQuery(baseOptions?: Apollo.QueryHookOptions<GetCrmContactSourcesQuery, GetCrmContactSourcesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCrmContactSourcesQuery, GetCrmContactSourcesQueryVariables>(GetCrmContactSourcesDocument, options);
      }
export function useGetCrmContactSourcesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCrmContactSourcesQuery, GetCrmContactSourcesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCrmContactSourcesQuery, GetCrmContactSourcesQueryVariables>(GetCrmContactSourcesDocument, options);
        }
export type GetCrmContactSourcesQueryHookResult = ReturnType<typeof useGetCrmContactSourcesQuery>;
export type GetCrmContactSourcesLazyQueryHookResult = ReturnType<typeof useGetCrmContactSourcesLazyQuery>;
export type GetCrmContactSourcesQueryResult = Apollo.QueryResult<GetCrmContactSourcesQuery, GetCrmContactSourcesQueryVariables>;
export const GetPromptTypesDocument = gql`
    query GetPromptTypes($filters: PromptTypeFiltersInput, $pagination: PaginationArg, $sort: [String]) {
  promptTypes(filters: $filters, pagination: $pagination, sort: $sort) {
    data {
      id
      attributes {
        type
        prompt
      }
    }
  }
}
    `;

/**
 * __useGetPromptTypesQuery__
 *
 * To run a query within a React component, call `useGetPromptTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPromptTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPromptTypesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetPromptTypesQuery(baseOptions?: Apollo.QueryHookOptions<GetPromptTypesQuery, GetPromptTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPromptTypesQuery, GetPromptTypesQueryVariables>(GetPromptTypesDocument, options);
      }
export function useGetPromptTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPromptTypesQuery, GetPromptTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPromptTypesQuery, GetPromptTypesQueryVariables>(GetPromptTypesDocument, options);
        }
export type GetPromptTypesQueryHookResult = ReturnType<typeof useGetPromptTypesQuery>;
export type GetPromptTypesLazyQueryHookResult = ReturnType<typeof useGetPromptTypesLazyQuery>;
export type GetPromptTypesQueryResult = Apollo.QueryResult<GetPromptTypesQuery, GetPromptTypesQueryVariables>;
export const GetAllCampaignMembersIdsDocument = gql`
    query GetAllCampaignMembersIds($filters: CrmCampaignMemberFiltersInput, $pagination: PaginationArg, $sort: [String]) {
  crmCampaignMembers(filters: $filters, pagination: $pagination, sort: $sort) {
    data {
      id
    }
  }
}
    `;

/**
 * __useGetAllCampaignMembersIdsQuery__
 *
 * To run a query within a React component, call `useGetAllCampaignMembersIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllCampaignMembersIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllCampaignMembersIdsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetAllCampaignMembersIdsQuery(baseOptions?: Apollo.QueryHookOptions<GetAllCampaignMembersIdsQuery, GetAllCampaignMembersIdsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllCampaignMembersIdsQuery, GetAllCampaignMembersIdsQueryVariables>(GetAllCampaignMembersIdsDocument, options);
      }
export function useGetAllCampaignMembersIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllCampaignMembersIdsQuery, GetAllCampaignMembersIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllCampaignMembersIdsQuery, GetAllCampaignMembersIdsQueryVariables>(GetAllCampaignMembersIdsDocument, options);
        }
export type GetAllCampaignMembersIdsQueryHookResult = ReturnType<typeof useGetAllCampaignMembersIdsQuery>;
export type GetAllCampaignMembersIdsLazyQueryHookResult = ReturnType<typeof useGetAllCampaignMembersIdsLazyQuery>;
export type GetAllCampaignMembersIdsQueryResult = Apollo.QueryResult<GetAllCampaignMembersIdsQuery, GetAllCampaignMembersIdsQueryVariables>;
export const UsersFromCampaignDocument = gql`
    query UsersFromCampaign($campaignId: ID, $filters: ComponentCrmDataCrmAccountRoleFiltersInput, $pagination: PaginationArg) {
  campaign(id: $campaignId) {
    data {
      id
      attributes {
        users_with_roles(filters: $filters, pagination: $pagination) {
          id
          user {
            data {
              id
              attributes {
                firstName
                lastName
              }
            }
          }
          roles {
            data {
              id
              attributes {
                name
              }
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useUsersFromCampaignQuery__
 *
 * To run a query within a React component, call `useUsersFromCampaignQuery` and pass it any options that fit your needs.
 * When your component renders, `useUsersFromCampaignQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUsersFromCampaignQuery({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useUsersFromCampaignQuery(baseOptions?: Apollo.QueryHookOptions<UsersFromCampaignQuery, UsersFromCampaignQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UsersFromCampaignQuery, UsersFromCampaignQueryVariables>(UsersFromCampaignDocument, options);
      }
export function useUsersFromCampaignLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UsersFromCampaignQuery, UsersFromCampaignQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UsersFromCampaignQuery, UsersFromCampaignQueryVariables>(UsersFromCampaignDocument, options);
        }
export type UsersFromCampaignQueryHookResult = ReturnType<typeof useUsersFromCampaignQuery>;
export type UsersFromCampaignLazyQueryHookResult = ReturnType<typeof useUsersFromCampaignLazyQuery>;
export type UsersFromCampaignQueryResult = Apollo.QueryResult<UsersFromCampaignQuery, UsersFromCampaignQueryVariables>;
export const CampaignUsersWithRolesDocument = gql`
    query CampaignUsersWithRoles($campaignId: ID, $filters: ComponentCrmDataCrmAccountRoleFiltersInput, $pagination: PaginationArg, $sort: [String]) {
  campaign(id: $campaignId) {
    data {
      id
      attributes {
        users_with_roles(filters: $filters, pagination: $pagination, sort: $sort) {
          ...UserWithRolesFields
        }
      }
    }
  }
}
    ${UserWithRolesFieldsFragmentDoc}`;

/**
 * __useCampaignUsersWithRolesQuery__
 *
 * To run a query within a React component, call `useCampaignUsersWithRolesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCampaignUsersWithRolesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCampaignUsersWithRolesQuery({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useCampaignUsersWithRolesQuery(baseOptions?: Apollo.QueryHookOptions<CampaignUsersWithRolesQuery, CampaignUsersWithRolesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CampaignUsersWithRolesQuery, CampaignUsersWithRolesQueryVariables>(CampaignUsersWithRolesDocument, options);
      }
export function useCampaignUsersWithRolesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CampaignUsersWithRolesQuery, CampaignUsersWithRolesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CampaignUsersWithRolesQuery, CampaignUsersWithRolesQueryVariables>(CampaignUsersWithRolesDocument, options);
        }
export type CampaignUsersWithRolesQueryHookResult = ReturnType<typeof useCampaignUsersWithRolesQuery>;
export type CampaignUsersWithRolesLazyQueryHookResult = ReturnType<typeof useCampaignUsersWithRolesLazyQuery>;
export type CampaignUsersWithRolesQueryResult = Apollo.QueryResult<CampaignUsersWithRolesQuery, CampaignUsersWithRolesQueryVariables>;
export const ReservationUsersWithRolesDocument = gql`
    query ReservationUsersWithRoles($reservationId: ID, $filters: ComponentCrmDataCrmAccountRoleFiltersInput, $pagination: PaginationArg, $sort: [String]) {
  reservation(id: $reservationId) {
    data {
      id
      attributes {
        crm_campaign_member {
          data {
            id
            attributes {
              users_with_roles(filters: $filters, pagination: $pagination, sort: $sort) {
                ...UserWithRolesFields
              }
            }
          }
        }
      }
    }
  }
}
    ${UserWithRolesFieldsFragmentDoc}`;

/**
 * __useReservationUsersWithRolesQuery__
 *
 * To run a query within a React component, call `useReservationUsersWithRolesQuery` and pass it any options that fit your needs.
 * When your component renders, `useReservationUsersWithRolesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReservationUsersWithRolesQuery({
 *   variables: {
 *      reservationId: // value for 'reservationId'
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useReservationUsersWithRolesQuery(baseOptions?: Apollo.QueryHookOptions<ReservationUsersWithRolesQuery, ReservationUsersWithRolesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReservationUsersWithRolesQuery, ReservationUsersWithRolesQueryVariables>(ReservationUsersWithRolesDocument, options);
      }
export function useReservationUsersWithRolesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReservationUsersWithRolesQuery, ReservationUsersWithRolesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReservationUsersWithRolesQuery, ReservationUsersWithRolesQueryVariables>(ReservationUsersWithRolesDocument, options);
        }
export type ReservationUsersWithRolesQueryHookResult = ReturnType<typeof useReservationUsersWithRolesQuery>;
export type ReservationUsersWithRolesLazyQueryHookResult = ReturnType<typeof useReservationUsersWithRolesLazyQuery>;
export type ReservationUsersWithRolesQueryResult = Apollo.QueryResult<ReservationUsersWithRolesQuery, ReservationUsersWithRolesQueryVariables>;
export const CrmCampaignMemberUsersWithRolesDocument = gql`
    query CrmCampaignMemberUsersWithRoles($crmCampaignMemberId: ID, $filters: ComponentCrmDataCrmAccountRoleFiltersInput, $pagination: PaginationArg, $sort: [String]) {
  crmCampaignMember(id: $crmCampaignMemberId) {
    data {
      id
      attributes {
        users_with_roles(filters: $filters, pagination: $pagination, sort: $sort) {
          ...UserWithRolesFields
        }
      }
    }
  }
}
    ${UserWithRolesFieldsFragmentDoc}`;

/**
 * __useCrmCampaignMemberUsersWithRolesQuery__
 *
 * To run a query within a React component, call `useCrmCampaignMemberUsersWithRolesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCrmCampaignMemberUsersWithRolesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCrmCampaignMemberUsersWithRolesQuery({
 *   variables: {
 *      crmCampaignMemberId: // value for 'crmCampaignMemberId'
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useCrmCampaignMemberUsersWithRolesQuery(baseOptions?: Apollo.QueryHookOptions<CrmCampaignMemberUsersWithRolesQuery, CrmCampaignMemberUsersWithRolesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CrmCampaignMemberUsersWithRolesQuery, CrmCampaignMemberUsersWithRolesQueryVariables>(CrmCampaignMemberUsersWithRolesDocument, options);
      }
export function useCrmCampaignMemberUsersWithRolesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CrmCampaignMemberUsersWithRolesQuery, CrmCampaignMemberUsersWithRolesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CrmCampaignMemberUsersWithRolesQuery, CrmCampaignMemberUsersWithRolesQueryVariables>(CrmCampaignMemberUsersWithRolesDocument, options);
        }
export type CrmCampaignMemberUsersWithRolesQueryHookResult = ReturnType<typeof useCrmCampaignMemberUsersWithRolesQuery>;
export type CrmCampaignMemberUsersWithRolesLazyQueryHookResult = ReturnType<typeof useCrmCampaignMemberUsersWithRolesLazyQuery>;
export type CrmCampaignMemberUsersWithRolesQueryResult = Apollo.QueryResult<CrmCampaignMemberUsersWithRolesQuery, CrmCampaignMemberUsersWithRolesQueryVariables>;
export const MeDocument = gql`
    query me {
  me {
    id
    username
    email
    confirmed
    blocked
    firstName
    lastName
    role {
      id
      name
      type
    }
  }
}
    `;

/**
 * __useMeQuery__
 *
 * To run a query within a React component, call `useMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useMeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMeQuery({
 *   variables: {
 *   },
 * });
 */
export function useMeQuery(baseOptions?: Apollo.QueryHookOptions<MeQuery, MeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MeQuery, MeQueryVariables>(MeDocument, options);
      }
export function useMeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MeQuery, MeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MeQuery, MeQueryVariables>(MeDocument, options);
        }
export type MeQueryHookResult = ReturnType<typeof useMeQuery>;
export type MeLazyQueryHookResult = ReturnType<typeof useMeLazyQuery>;
export type MeQueryResult = Apollo.QueryResult<MeQuery, MeQueryVariables>;
export const PermissionMatrixUsersPermissionsUserDocument = gql`
    query PermissionMatrixUsersPermissionsUser($usersPermissionsUserId: ID, $pagination: PaginationArg) {
  usersPermissionsUser(id: $usersPermissionsUserId) {
    data {
      id
      attributes {
        crm_profile {
          id
          crm_roles(pagination: $pagination) {
            data {
              id
              attributes {
                name
                permissions
              }
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __usePermissionMatrixUsersPermissionsUserQuery__
 *
 * To run a query within a React component, call `usePermissionMatrixUsersPermissionsUserQuery` and pass it any options that fit your needs.
 * When your component renders, `usePermissionMatrixUsersPermissionsUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePermissionMatrixUsersPermissionsUserQuery({
 *   variables: {
 *      usersPermissionsUserId: // value for 'usersPermissionsUserId'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function usePermissionMatrixUsersPermissionsUserQuery(baseOptions?: Apollo.QueryHookOptions<PermissionMatrixUsersPermissionsUserQuery, PermissionMatrixUsersPermissionsUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PermissionMatrixUsersPermissionsUserQuery, PermissionMatrixUsersPermissionsUserQueryVariables>(PermissionMatrixUsersPermissionsUserDocument, options);
      }
export function usePermissionMatrixUsersPermissionsUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PermissionMatrixUsersPermissionsUserQuery, PermissionMatrixUsersPermissionsUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PermissionMatrixUsersPermissionsUserQuery, PermissionMatrixUsersPermissionsUserQueryVariables>(PermissionMatrixUsersPermissionsUserDocument, options);
        }
export type PermissionMatrixUsersPermissionsUserQueryHookResult = ReturnType<typeof usePermissionMatrixUsersPermissionsUserQuery>;
export type PermissionMatrixUsersPermissionsUserLazyQueryHookResult = ReturnType<typeof usePermissionMatrixUsersPermissionsUserLazyQuery>;
export type PermissionMatrixUsersPermissionsUserQueryResult = Apollo.QueryResult<PermissionMatrixUsersPermissionsUserQuery, PermissionMatrixUsersPermissionsUserQueryVariables>;
export const UsersPermissionsUserDocument = gql`
    query usersPermissionsUser($id: ID!) {
  usersPermissionsUser(id: $id) {
    data {
      id
      attributes {
        username
        email
        confirmed
        blocked
        firstName
        lastName
        createdAt
        role {
          data {
            attributes {
              name
              type
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useUsersPermissionsUserQuery__
 *
 * To run a query within a React component, call `useUsersPermissionsUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useUsersPermissionsUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUsersPermissionsUserQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUsersPermissionsUserQuery(baseOptions: Apollo.QueryHookOptions<UsersPermissionsUserQuery, UsersPermissionsUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UsersPermissionsUserQuery, UsersPermissionsUserQueryVariables>(UsersPermissionsUserDocument, options);
      }
export function useUsersPermissionsUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UsersPermissionsUserQuery, UsersPermissionsUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UsersPermissionsUserQuery, UsersPermissionsUserQueryVariables>(UsersPermissionsUserDocument, options);
        }
export type UsersPermissionsUserQueryHookResult = ReturnType<typeof useUsersPermissionsUserQuery>;
export type UsersPermissionsUserLazyQueryHookResult = ReturnType<typeof useUsersPermissionsUserLazyQuery>;
export type UsersPermissionsUserQueryResult = Apollo.QueryResult<UsersPermissionsUserQuery, UsersPermissionsUserQueryVariables>;
export const CheckUsernameDocument = gql`
    query checkUsername($filters: UsersPermissionsUserFiltersInput) {
  usersPermissionsUsers(filters: $filters) {
    data {
      attributes {
        username
      }
    }
  }
}
    `;

/**
 * __useCheckUsernameQuery__
 *
 * To run a query within a React component, call `useCheckUsernameQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckUsernameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckUsernameQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useCheckUsernameQuery(baseOptions?: Apollo.QueryHookOptions<CheckUsernameQuery, CheckUsernameQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CheckUsernameQuery, CheckUsernameQueryVariables>(CheckUsernameDocument, options);
      }
export function useCheckUsernameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckUsernameQuery, CheckUsernameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CheckUsernameQuery, CheckUsernameQueryVariables>(CheckUsernameDocument, options);
        }
export type CheckUsernameQueryHookResult = ReturnType<typeof useCheckUsernameQuery>;
export type CheckUsernameLazyQueryHookResult = ReturnType<typeof useCheckUsernameLazyQuery>;
export type CheckUsernameQueryResult = Apollo.QueryResult<CheckUsernameQuery, CheckUsernameQueryVariables>;
export const PermissionUserDocument = gql`
    query PermissionUser($usersPermissionsUserId: ID) {
  usersPermissionsUser(id: $usersPermissionsUserId) {
    data {
      id
      attributes {
        crm_profile {
          id
          crm_roles {
            data {
              id
              attributes {
                permissions
              }
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __usePermissionUserQuery__
 *
 * To run a query within a React component, call `usePermissionUserQuery` and pass it any options that fit your needs.
 * When your component renders, `usePermissionUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePermissionUserQuery({
 *   variables: {
 *      usersPermissionsUserId: // value for 'usersPermissionsUserId'
 *   },
 * });
 */
export function usePermissionUserQuery(baseOptions?: Apollo.QueryHookOptions<PermissionUserQuery, PermissionUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PermissionUserQuery, PermissionUserQueryVariables>(PermissionUserDocument, options);
      }
export function usePermissionUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PermissionUserQuery, PermissionUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PermissionUserQuery, PermissionUserQueryVariables>(PermissionUserDocument, options);
        }
export type PermissionUserQueryHookResult = ReturnType<typeof usePermissionUserQuery>;
export type PermissionUserLazyQueryHookResult = ReturnType<typeof usePermissionUserLazyQuery>;
export type PermissionUserQueryResult = Apollo.QueryResult<PermissionUserQuery, PermissionUserQueryVariables>;
export const MenuDocument = gql`
    query Menu($menuId: ID, $filters: MenuPageFiltersInput, $pagination: PaginationArg) {
  menu(id: $menuId) {
    data {
      id
      attributes {
        title
        slug
        generate_nutritional_info_pages
        nutritional_information_dimension
        nutritional_information_background {
          data {
            id
            attributes {
              url
            }
          }
        }
        nutritional_information_background_2 {
          data {
            id
            attributes {
              url
            }
          }
        }
        print_catalog_pages(filters: $filters, pagination: $pagination) {
          data {
            id
            attributes {
              title_dimension
              description_dimension
              space_1
              space_2
              space_3
              space_4
              background_image {
                data {
                  id
                  attributes {
                    url
                    alternativeText
                  }
                }
              }
              alignement
              footer_text
              left_column_content {
                ... on ComponentMenuProductItem {
                  ...ProductItemFields
                }
                ... on ComponentMenuEmptySpace {
                  ...EmptySpaceFields
                }
                ... on ComponentMenuCategoryItem {
                  ...CategoryItemFields
                }
                ... on ComponentMenuPhoto {
                  ...MenuPhotoFields
                }
              }
              right_column_content {
                ... on ComponentMenuProductItem {
                  ...ProductItemFields
                }
                ... on ComponentMenuEmptySpace {
                  ...EmptySpaceFields
                }
                ... on ComponentMenuCategoryItem {
                  ...CategoryItemFields
                }
                ... on ComponentMenuPhoto {
                  ...MenuPhotoFields
                }
              }
            }
          }
        }
        title_dimension
        description_dimension
      }
    }
  }
}
    ${ProductItemFieldsFragmentDoc}
${EmptySpaceFieldsFragmentDoc}
${CategoryItemFieldsFragmentDoc}
${MenuPhotoFieldsFragmentDoc}`;

/**
 * __useMenuQuery__
 *
 * To run a query within a React component, call `useMenuQuery` and pass it any options that fit your needs.
 * When your component renders, `useMenuQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMenuQuery({
 *   variables: {
 *      menuId: // value for 'menuId'
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useMenuQuery(baseOptions?: Apollo.QueryHookOptions<MenuQuery, MenuQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MenuQuery, MenuQueryVariables>(MenuDocument, options);
      }
export function useMenuLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MenuQuery, MenuQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MenuQuery, MenuQueryVariables>(MenuDocument, options);
        }
export type MenuQueryHookResult = ReturnType<typeof useMenuQuery>;
export type MenuLazyQueryHookResult = ReturnType<typeof useMenuLazyQuery>;
export type MenuQueryResult = Apollo.QueryResult<MenuQuery, MenuQueryVariables>;
export const WebCatalogMenuDocument = gql`
    query WebCatalogMenu($menuId: ID, $filters: ProductFiltersInput, $pagination: PaginationArg) {
  menu(id: $menuId) {
    data {
      id
      attributes {
        title
        slug
        web_catalog_items(filters: $filters, pagination: $pagination) {
          data {
            id
            attributes {
              title
              description
              price
              media {
                data {
                  id
                  attributes {
                    url
                  }
                }
              }
              category {
                data {
                  id
                  attributes {
                    name
                  }
                }
              }
            }
          }
        }
        title_dimension
        description_dimension
        nutritional_information_dimension
        nutritional_information_background {
          data {
            id
            attributes {
              url
            }
          }
        }
        nutritional_information_background_2 {
          data {
            id
            attributes {
              url
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useWebCatalogMenuQuery__
 *
 * To run a query within a React component, call `useWebCatalogMenuQuery` and pass it any options that fit your needs.
 * When your component renders, `useWebCatalogMenuQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWebCatalogMenuQuery({
 *   variables: {
 *      menuId: // value for 'menuId'
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useWebCatalogMenuQuery(baseOptions?: Apollo.QueryHookOptions<WebCatalogMenuQuery, WebCatalogMenuQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WebCatalogMenuQuery, WebCatalogMenuQueryVariables>(WebCatalogMenuDocument, options);
      }
export function useWebCatalogMenuLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WebCatalogMenuQuery, WebCatalogMenuQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WebCatalogMenuQuery, WebCatalogMenuQueryVariables>(WebCatalogMenuDocument, options);
        }
export type WebCatalogMenuQueryHookResult = ReturnType<typeof useWebCatalogMenuQuery>;
export type WebCatalogMenuLazyQueryHookResult = ReturnType<typeof useWebCatalogMenuLazyQuery>;
export type WebCatalogMenuQueryResult = Apollo.QueryResult<WebCatalogMenuQuery, WebCatalogMenuQueryVariables>;
export const MenusDocument = gql`
    query Menus($filters: MenuFiltersInput, $pagination: PaginationArg) {
  menus(filters: $filters, pagination: $pagination) {
    data {
      id
      attributes {
        title
      }
    }
  }
}
    `;

/**
 * __useMenusQuery__
 *
 * To run a query within a React component, call `useMenusQuery` and pass it any options that fit your needs.
 * When your component renders, `useMenusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMenusQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useMenusQuery(baseOptions?: Apollo.QueryHookOptions<MenusQuery, MenusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MenusQuery, MenusQueryVariables>(MenusDocument, options);
      }
export function useMenusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MenusQuery, MenusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MenusQuery, MenusQueryVariables>(MenusDocument, options);
        }
export type MenusQueryHookResult = ReturnType<typeof useMenusQuery>;
export type MenusLazyQueryHookResult = ReturnType<typeof useMenusLazyQuery>;
export type MenusQueryResult = Apollo.QueryResult<MenusQuery, MenusQueryVariables>;
export const RegisterDocument = gql`
    mutation register($input: UsersPermissionsRegisterInput!) {
  register(input: $input) {
    jwt
    user {
      ...userBasicInfoMe
    }
  }
}
    ${UserBasicInfoMeFragmentDoc}`;
export type RegisterMutationFn = Apollo.MutationFunction<RegisterMutation, RegisterMutationVariables>;

/**
 * __useRegisterMutation__
 *
 * To run a mutation, you first call `useRegisterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerMutation, { data, loading, error }] = useRegisterMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRegisterMutation(baseOptions?: Apollo.MutationHookOptions<RegisterMutation, RegisterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RegisterMutation, RegisterMutationVariables>(RegisterDocument, options);
      }
export type RegisterMutationHookResult = ReturnType<typeof useRegisterMutation>;
export type RegisterMutationResult = Apollo.MutationResult<RegisterMutation>;
export type RegisterMutationOptions = Apollo.BaseMutationOptions<RegisterMutation, RegisterMutationVariables>;
export const ResetPasswordDocument = gql`
    mutation resetPassword($password: String!, $passwordConfirmation: String!, $code: String!) {
  resetPassword(
    password: $password
    passwordConfirmation: $passwordConfirmation
    code: $code
  ) {
    jwt
    user {
      ...userBasicInfoMe
    }
  }
}
    ${UserBasicInfoMeFragmentDoc}`;
export type ResetPasswordMutationFn = Apollo.MutationFunction<ResetPasswordMutation, ResetPasswordMutationVariables>;

/**
 * __useResetPasswordMutation__
 *
 * To run a mutation, you first call `useResetPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetPasswordMutation, { data, loading, error }] = useResetPasswordMutation({
 *   variables: {
 *      password: // value for 'password'
 *      passwordConfirmation: // value for 'passwordConfirmation'
 *      code: // value for 'code'
 *   },
 * });
 */
export function useResetPasswordMutation(baseOptions?: Apollo.MutationHookOptions<ResetPasswordMutation, ResetPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResetPasswordMutation, ResetPasswordMutationVariables>(ResetPasswordDocument, options);
      }
export type ResetPasswordMutationHookResult = ReturnType<typeof useResetPasswordMutation>;
export type ResetPasswordMutationResult = Apollo.MutationResult<ResetPasswordMutation>;
export type ResetPasswordMutationOptions = Apollo.BaseMutationOptions<ResetPasswordMutation, ResetPasswordMutationVariables>;
export const LoginDocument = gql`
    mutation login($input: UsersPermissionsLoginInput!) {
  login(input: $input) {
    jwt
    user {
      ...userBasicInfoMe
    }
  }
}
    ${UserBasicInfoMeFragmentDoc}`;
export type LoginMutationFn = Apollo.MutationFunction<LoginMutation, LoginMutationVariables>;

/**
 * __useLoginMutation__
 *
 * To run a mutation, you first call `useLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginMutation, { data, loading, error }] = useLoginMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLoginMutation(baseOptions?: Apollo.MutationHookOptions<LoginMutation, LoginMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LoginMutation, LoginMutationVariables>(LoginDocument, options);
      }
export type LoginMutationHookResult = ReturnType<typeof useLoginMutation>;
export type LoginMutationResult = Apollo.MutationResult<LoginMutation>;
export type LoginMutationOptions = Apollo.BaseMutationOptions<LoginMutation, LoginMutationVariables>;
export const ForgotPasswordDocument = gql`
    mutation forgotPassword($email: String!) {
  forgotPassword(email: $email) {
    ok
  }
}
    `;
export type ForgotPasswordMutationFn = Apollo.MutationFunction<ForgotPasswordMutation, ForgotPasswordMutationVariables>;

/**
 * __useForgotPasswordMutation__
 *
 * To run a mutation, you first call `useForgotPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useForgotPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [forgotPasswordMutation, { data, loading, error }] = useForgotPasswordMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useForgotPasswordMutation(baseOptions?: Apollo.MutationHookOptions<ForgotPasswordMutation, ForgotPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ForgotPasswordMutation, ForgotPasswordMutationVariables>(ForgotPasswordDocument, options);
      }
export type ForgotPasswordMutationHookResult = ReturnType<typeof useForgotPasswordMutation>;
export type ForgotPasswordMutationResult = Apollo.MutationResult<ForgotPasswordMutation>;
export type ForgotPasswordMutationOptions = Apollo.BaseMutationOptions<ForgotPasswordMutation, ForgotPasswordMutationVariables>;
export const EmailConfirmationDocument = gql`
    mutation emailConfirmation($confirmation: String!) {
  emailConfirmation(confirmation: $confirmation) {
    jwt
    user {
      ...userBasicInfoMe
    }
  }
}
    ${UserBasicInfoMeFragmentDoc}`;
export type EmailConfirmationMutationFn = Apollo.MutationFunction<EmailConfirmationMutation, EmailConfirmationMutationVariables>;

/**
 * __useEmailConfirmationMutation__
 *
 * To run a mutation, you first call `useEmailConfirmationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEmailConfirmationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [emailConfirmationMutation, { data, loading, error }] = useEmailConfirmationMutation({
 *   variables: {
 *      confirmation: // value for 'confirmation'
 *   },
 * });
 */
export function useEmailConfirmationMutation(baseOptions?: Apollo.MutationHookOptions<EmailConfirmationMutation, EmailConfirmationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EmailConfirmationMutation, EmailConfirmationMutationVariables>(EmailConfirmationDocument, options);
      }
export type EmailConfirmationMutationHookResult = ReturnType<typeof useEmailConfirmationMutation>;
export type EmailConfirmationMutationResult = Apollo.MutationResult<EmailConfirmationMutation>;
export type EmailConfirmationMutationOptions = Apollo.BaseMutationOptions<EmailConfirmationMutation, EmailConfirmationMutationVariables>;
export const SendEmailConfirmationDocument = gql`
    mutation sendEmailConfirmation($email: String!) {
  sendEmailConfirmation(email: $email)
}
    `;
export type SendEmailConfirmationMutationFn = Apollo.MutationFunction<SendEmailConfirmationMutation, SendEmailConfirmationMutationVariables>;

/**
 * __useSendEmailConfirmationMutation__
 *
 * To run a mutation, you first call `useSendEmailConfirmationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendEmailConfirmationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendEmailConfirmationMutation, { data, loading, error }] = useSendEmailConfirmationMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useSendEmailConfirmationMutation(baseOptions?: Apollo.MutationHookOptions<SendEmailConfirmationMutation, SendEmailConfirmationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendEmailConfirmationMutation, SendEmailConfirmationMutationVariables>(SendEmailConfirmationDocument, options);
      }
export type SendEmailConfirmationMutationHookResult = ReturnType<typeof useSendEmailConfirmationMutation>;
export type SendEmailConfirmationMutationResult = Apollo.MutationResult<SendEmailConfirmationMutation>;
export type SendEmailConfirmationMutationOptions = Apollo.BaseMutationOptions<SendEmailConfirmationMutation, SendEmailConfirmationMutationVariables>;
export const SaveCapturedContactDocument = gql`
    mutation saveCapturedContact($input: CapturedContactInput!, $recaptcha: String!) {
  saveCapturedContact(input: $input, recaptcha: $recaptcha)
}
    `;
export type SaveCapturedContactMutationFn = Apollo.MutationFunction<SaveCapturedContactMutation, SaveCapturedContactMutationVariables>;

/**
 * __useSaveCapturedContactMutation__
 *
 * To run a mutation, you first call `useSaveCapturedContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveCapturedContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveCapturedContactMutation, { data, loading, error }] = useSaveCapturedContactMutation({
 *   variables: {
 *      input: // value for 'input'
 *      recaptcha: // value for 'recaptcha'
 *   },
 * });
 */
export function useSaveCapturedContactMutation(baseOptions?: Apollo.MutationHookOptions<SaveCapturedContactMutation, SaveCapturedContactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveCapturedContactMutation, SaveCapturedContactMutationVariables>(SaveCapturedContactDocument, options);
      }
export type SaveCapturedContactMutationHookResult = ReturnType<typeof useSaveCapturedContactMutation>;
export type SaveCapturedContactMutationResult = Apollo.MutationResult<SaveCapturedContactMutation>;
export type SaveCapturedContactMutationOptions = Apollo.BaseMutationOptions<SaveCapturedContactMutation, SaveCapturedContactMutationVariables>;
export const ProcessFormQuestionDocument = gql`
    mutation processFormQuestion($rfid: String!, $questionId: ID!) {
  processFormQuestion(rfid: $rfid, questionId: $questionId)
}
    `;
export type ProcessFormQuestionMutationFn = Apollo.MutationFunction<ProcessFormQuestionMutation, ProcessFormQuestionMutationVariables>;

/**
 * __useProcessFormQuestionMutation__
 *
 * To run a mutation, you first call `useProcessFormQuestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProcessFormQuestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [processFormQuestionMutation, { data, loading, error }] = useProcessFormQuestionMutation({
 *   variables: {
 *      rfid: // value for 'rfid'
 *      questionId: // value for 'questionId'
 *   },
 * });
 */
export function useProcessFormQuestionMutation(baseOptions?: Apollo.MutationHookOptions<ProcessFormQuestionMutation, ProcessFormQuestionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProcessFormQuestionMutation, ProcessFormQuestionMutationVariables>(ProcessFormQuestionDocument, options);
      }
export type ProcessFormQuestionMutationHookResult = ReturnType<typeof useProcessFormQuestionMutation>;
export type ProcessFormQuestionMutationResult = Apollo.MutationResult<ProcessFormQuestionMutation>;
export type ProcessFormQuestionMutationOptions = Apollo.BaseMutationOptions<ProcessFormQuestionMutation, ProcessFormQuestionMutationVariables>;
export const LandingPagesDocument = gql`
    query LandingPages($filters: PageFiltersInput, $pagination: PaginationArg, $iconCardsFilters: ComponentCmsDataIconCardFiltersInput, $iconCardsPagination: PaginationArg, $boxesPagination: PaginationArg, $boxCardsPagination: PaginationArg, $sliderFilters: ComponentCmsDataSliderItemFiltersInput, $sliderPagination: PaginationArg, $faqItemsPagination: PaginationArg, $imageCardsItemsFilters: ComponentCmsDataImageCardFiltersInput, $imageCardsItemsPagination: PaginationArg, $authorsPagination: PaginationArg, $authorsFilters: UsersPermissionsUserFiltersInput, $reviewItemsPagination: PaginationArg, $reviewItemsFilters: ComponentCmsDataReviewItemFiltersInput, $priceItemsFilters: ComponentCmsDataPriceItemFiltersInput, $priceItemsPagination: PaginationArg, $priceBenefitsFilters: ComponentCmsDataPriceBenefitFiltersInput, $priceBenefitsPagination: PaginationArg, $imageGalleryFilters: ComponentCmsDataImageGalleryItemFiltersInput, $imageGalleryPagination: PaginationArg, $productsFilters: ProductFiltersInput, $productsPagination: PaginationArg, $menuFilters: ProductFiltersInput, $menuPagination: PaginationArg) {
  pages(filters: $filters, pagination: $pagination) {
    data {
      id
      attributes {
        title
        slug
        seo {
          ...SeoData
        }
        components {
          ...ProductList
          ...ImageGalleryComponent
          ...HeaderSectionComponent
          ...HeroSectionComponent
          ...IconCardsSectionComponent
          ...TextAndImageSectionComponent
          ...DarkTextBoxSectionComponent
          ...ScrollListSectionComponent
          ...AnimatedCardSectionComponent
          ...LightTopImgSectionComponent
          ...DarkBgImageSectionComponent
          ...FooterSectionComponent
          ...RichTextSectionComponent
          ...RichTextHtmlSectionComponent
          ...SliderSectionComponent
          ...HeroSectionTwoComponent
          ...FaqSectionComponent
          ...SingleTitleSectionComponent
          ...ImageCardsSectionComponent
          ...AuthorsListSectionComponent
          ...ReviewsSectionComponent
          ...PriceSectionComponent
          ...VideoSectionComponent
          ...DarkImageContentSectionComponent
          ...DarkVersusContentSectionComponent
          ...ScrollToSectionComponent
          ...HeroSectionSliderComponent
          ...FormGroupSectionComponent
          ...InteractiveImageMap
          ...ReusableComponent
        }
        hideMenu
      }
    }
  }
}
    ${SeoDataFragmentDoc}
${ProductListFragmentDoc}
${ImageGalleryComponentFragmentDoc}
${HeaderSectionComponentFragmentDoc}
${HeroSectionComponentFragmentDoc}
${IconCardsSectionComponentFragmentDoc}
${TextAndImageSectionComponentFragmentDoc}
${DarkTextBoxSectionComponentFragmentDoc}
${ScrollListSectionComponentFragmentDoc}
${AnimatedCardSectionComponentFragmentDoc}
${LightTopImgSectionComponentFragmentDoc}
${DarkBgImageSectionComponentFragmentDoc}
${FooterSectionComponentFragmentDoc}
${RichTextSectionComponentFragmentDoc}
${RichTextHtmlSectionComponentFragmentDoc}
${SliderSectionComponentFragmentDoc}
${HeroSectionTwoComponentFragmentDoc}
${FaqSectionComponentFragmentDoc}
${SingleTitleSectionComponentFragmentDoc}
${ImageCardsSectionComponentFragmentDoc}
${AuthorsListSectionComponentFragmentDoc}
${ReviewsSectionComponentFragmentDoc}
${PriceSectionComponentFragmentDoc}
${VideoSectionComponentFragmentDoc}
${DarkImageContentSectionComponentFragmentDoc}
${DarkVersusContentSectionComponentFragmentDoc}
${ScrollToSectionComponentFragmentDoc}
${HeroSectionSliderComponentFragmentDoc}
${FormGroupSectionComponentFragmentDoc}
${InteractiveImageMapFragmentDoc}
${ReusableComponentFragmentDoc}`;

/**
 * __useLandingPagesQuery__
 *
 * To run a query within a React component, call `useLandingPagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useLandingPagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLandingPagesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      iconCardsFilters: // value for 'iconCardsFilters'
 *      iconCardsPagination: // value for 'iconCardsPagination'
 *      boxesPagination: // value for 'boxesPagination'
 *      boxCardsPagination: // value for 'boxCardsPagination'
 *      sliderFilters: // value for 'sliderFilters'
 *      sliderPagination: // value for 'sliderPagination'
 *      faqItemsPagination: // value for 'faqItemsPagination'
 *      imageCardsItemsFilters: // value for 'imageCardsItemsFilters'
 *      imageCardsItemsPagination: // value for 'imageCardsItemsPagination'
 *      authorsPagination: // value for 'authorsPagination'
 *      authorsFilters: // value for 'authorsFilters'
 *      reviewItemsPagination: // value for 'reviewItemsPagination'
 *      reviewItemsFilters: // value for 'reviewItemsFilters'
 *      priceItemsFilters: // value for 'priceItemsFilters'
 *      priceItemsPagination: // value for 'priceItemsPagination'
 *      priceBenefitsFilters: // value for 'priceBenefitsFilters'
 *      priceBenefitsPagination: // value for 'priceBenefitsPagination'
 *      imageGalleryFilters: // value for 'imageGalleryFilters'
 *      imageGalleryPagination: // value for 'imageGalleryPagination'
 *      productsFilters: // value for 'productsFilters'
 *      productsPagination: // value for 'productsPagination'
 *      menuFilters: // value for 'menuFilters'
 *      menuPagination: // value for 'menuPagination'
 *   },
 * });
 */
export function useLandingPagesQuery(baseOptions?: Apollo.QueryHookOptions<LandingPagesQuery, LandingPagesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LandingPagesQuery, LandingPagesQueryVariables>(LandingPagesDocument, options);
      }
export function useLandingPagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LandingPagesQuery, LandingPagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LandingPagesQuery, LandingPagesQueryVariables>(LandingPagesDocument, options);
        }
export type LandingPagesQueryHookResult = ReturnType<typeof useLandingPagesQuery>;
export type LandingPagesLazyQueryHookResult = ReturnType<typeof useLandingPagesLazyQuery>;
export type LandingPagesQueryResult = Apollo.QueryResult<LandingPagesQuery, LandingPagesQueryVariables>;
export const GetPagesHeaderDocument = gql`
    query GetPagesHeader($filters: PageFiltersInput, $pagination: PaginationArg) {
  pages(filters: $filters, pagination: $pagination) {
    data {
      id
      attributes {
        components {
          ... on ComponentCmsDataHeaderSection {
            id
            button {
              url
              text
              id
            }
            image {
              data {
                id
                attributes {
                  alternativeText
                  url
                }
              }
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetPagesHeaderQuery__
 *
 * To run a query within a React component, call `useGetPagesHeaderQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPagesHeaderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPagesHeaderQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useGetPagesHeaderQuery(baseOptions?: Apollo.QueryHookOptions<GetPagesHeaderQuery, GetPagesHeaderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPagesHeaderQuery, GetPagesHeaderQueryVariables>(GetPagesHeaderDocument, options);
      }
export function useGetPagesHeaderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPagesHeaderQuery, GetPagesHeaderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPagesHeaderQuery, GetPagesHeaderQueryVariables>(GetPagesHeaderDocument, options);
        }
export type GetPagesHeaderQueryHookResult = ReturnType<typeof useGetPagesHeaderQuery>;
export type GetPagesHeaderLazyQueryHookResult = ReturnType<typeof useGetPagesHeaderLazyQuery>;
export type GetPagesHeaderQueryResult = Apollo.QueryResult<GetPagesHeaderQuery, GetPagesHeaderQueryVariables>;
export const GetLandingPageAuthorsDocument = gql`
    query GetLandingPageAuthors($filters: UsersPermissionsUserFiltersInput, $pagination: PaginationArg, $sort: [String]) {
  usersPermissionsUsers(filters: $filters, pagination: $pagination, sort: $sort) {
    data {
      id
      attributes {
        firstName
        lastName
        username
        email
      }
    }
  }
}
    `;

/**
 * __useGetLandingPageAuthorsQuery__
 *
 * To run a query within a React component, call `useGetLandingPageAuthorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLandingPageAuthorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLandingPageAuthorsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetLandingPageAuthorsQuery(baseOptions?: Apollo.QueryHookOptions<GetLandingPageAuthorsQuery, GetLandingPageAuthorsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLandingPageAuthorsQuery, GetLandingPageAuthorsQueryVariables>(GetLandingPageAuthorsDocument, options);
      }
export function useGetLandingPageAuthorsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLandingPageAuthorsQuery, GetLandingPageAuthorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLandingPageAuthorsQuery, GetLandingPageAuthorsQueryVariables>(GetLandingPageAuthorsDocument, options);
        }
export type GetLandingPageAuthorsQueryHookResult = ReturnType<typeof useGetLandingPageAuthorsQuery>;
export type GetLandingPageAuthorsLazyQueryHookResult = ReturnType<typeof useGetLandingPageAuthorsLazyQuery>;
export type GetLandingPageAuthorsQueryResult = Apollo.QueryResult<GetLandingPageAuthorsQuery, GetLandingPageAuthorsQueryVariables>;
export const PagesSeoDocument = gql`
    query PagesSeo($filters: PageFiltersInput) {
  pages(filters: $filters) {
    data {
      id
      attributes {
        title
        slug
        seo {
          ...SeoData
        }
      }
    }
  }
}
    ${SeoDataFragmentDoc}`;

/**
 * __usePagesSeoQuery__
 *
 * To run a query within a React component, call `usePagesSeoQuery` and pass it any options that fit your needs.
 * When your component renders, `usePagesSeoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePagesSeoQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function usePagesSeoQuery(baseOptions?: Apollo.QueryHookOptions<PagesSeoQuery, PagesSeoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PagesSeoQuery, PagesSeoQueryVariables>(PagesSeoDocument, options);
      }
export function usePagesSeoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PagesSeoQuery, PagesSeoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PagesSeoQuery, PagesSeoQueryVariables>(PagesSeoDocument, options);
        }
export type PagesSeoQueryHookResult = ReturnType<typeof usePagesSeoQuery>;
export type PagesSeoLazyQueryHookResult = ReturnType<typeof usePagesSeoLazyQuery>;
export type PagesSeoQueryResult = Apollo.QueryResult<PagesSeoQuery, PagesSeoQueryVariables>;
export const MainLayoutPageDocument = gql`
    query MainLayoutPage($filters: PageFiltersInput, $pagination: PaginationArg) {
  pages(filters: $filters, pagination: $pagination) {
    data {
      id
      attributes {
        title
        slug
        seo {
          ...SeoData
        }
        components {
          ...HeaderSectionComponent
        }
      }
    }
  }
}
    ${SeoDataFragmentDoc}
${HeaderSectionComponentFragmentDoc}`;

/**
 * __useMainLayoutPageQuery__
 *
 * To run a query within a React component, call `useMainLayoutPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useMainLayoutPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMainLayoutPageQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useMainLayoutPageQuery(baseOptions?: Apollo.QueryHookOptions<MainLayoutPageQuery, MainLayoutPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MainLayoutPageQuery, MainLayoutPageQueryVariables>(MainLayoutPageDocument, options);
      }
export function useMainLayoutPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MainLayoutPageQuery, MainLayoutPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MainLayoutPageQuery, MainLayoutPageQueryVariables>(MainLayoutPageDocument, options);
        }
export type MainLayoutPageQueryHookResult = ReturnType<typeof useMainLayoutPageQuery>;
export type MainLayoutPageLazyQueryHookResult = ReturnType<typeof useMainLayoutPageLazyQuery>;
export type MainLayoutPageQueryResult = Apollo.QueryResult<MainLayoutPageQuery, MainLayoutPageQueryVariables>;
export const GetPageSlugsDocument = gql`
    query GetPageSlugs($filters: PageFiltersInput, $pagination: PaginationArg) {
  pages(filters: $filters, pagination: $pagination) {
    data {
      id
      attributes {
        slug
        updatedAt
      }
    }
  }
}
    `;

/**
 * __useGetPageSlugsQuery__
 *
 * To run a query within a React component, call `useGetPageSlugsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPageSlugsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPageSlugsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useGetPageSlugsQuery(baseOptions?: Apollo.QueryHookOptions<GetPageSlugsQuery, GetPageSlugsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPageSlugsQuery, GetPageSlugsQueryVariables>(GetPageSlugsDocument, options);
      }
export function useGetPageSlugsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPageSlugsQuery, GetPageSlugsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPageSlugsQuery, GetPageSlugsQueryVariables>(GetPageSlugsDocument, options);
        }
export type GetPageSlugsQueryHookResult = ReturnType<typeof useGetPageSlugsQuery>;
export type GetPageSlugsLazyQueryHookResult = ReturnType<typeof useGetPageSlugsLazyQuery>;
export type GetPageSlugsQueryResult = Apollo.QueryResult<GetPageSlugsQuery, GetPageSlugsQueryVariables>;
export const UpdateUsersPermissionsUserDocument = gql`
    mutation UpdateUsersPermissionsUser($updateUsersPermissionsUserId: ID!, $data: UsersPermissionsUserInput!) {
  updateUsersPermissionsUser(id: $updateUsersPermissionsUserId, data: $data) {
    data {
      id
      attributes {
        firstName
        lastName
        username
      }
    }
  }
}
    `;
export type UpdateUsersPermissionsUserMutationFn = Apollo.MutationFunction<UpdateUsersPermissionsUserMutation, UpdateUsersPermissionsUserMutationVariables>;

/**
 * __useUpdateUsersPermissionsUserMutation__
 *
 * To run a mutation, you first call `useUpdateUsersPermissionsUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUsersPermissionsUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUsersPermissionsUserMutation, { data, loading, error }] = useUpdateUsersPermissionsUserMutation({
 *   variables: {
 *      updateUsersPermissionsUserId: // value for 'updateUsersPermissionsUserId'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateUsersPermissionsUserMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUsersPermissionsUserMutation, UpdateUsersPermissionsUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUsersPermissionsUserMutation, UpdateUsersPermissionsUserMutationVariables>(UpdateUsersPermissionsUserDocument, options);
      }
export type UpdateUsersPermissionsUserMutationHookResult = ReturnType<typeof useUpdateUsersPermissionsUserMutation>;
export type UpdateUsersPermissionsUserMutationResult = Apollo.MutationResult<UpdateUsersPermissionsUserMutation>;
export type UpdateUsersPermissionsUserMutationOptions = Apollo.BaseMutationOptions<UpdateUsersPermissionsUserMutation, UpdateUsersPermissionsUserMutationVariables>;
export const CreateCrmCampaignMemberDocument = gql`
    mutation CreateCrmCampaignMember($data: CrmCampaignMemberInput!) {
  createCrmCampaignMember(data: $data) {
    data {
      id
      attributes {
        info
      }
    }
  }
}
    `;
export type CreateCrmCampaignMemberMutationFn = Apollo.MutationFunction<CreateCrmCampaignMemberMutation, CreateCrmCampaignMemberMutationVariables>;

/**
 * __useCreateCrmCampaignMemberMutation__
 *
 * To run a mutation, you first call `useCreateCrmCampaignMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCrmCampaignMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCrmCampaignMemberMutation, { data, loading, error }] = useCreateCrmCampaignMemberMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateCrmCampaignMemberMutation(baseOptions?: Apollo.MutationHookOptions<CreateCrmCampaignMemberMutation, CreateCrmCampaignMemberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCrmCampaignMemberMutation, CreateCrmCampaignMemberMutationVariables>(CreateCrmCampaignMemberDocument, options);
      }
export type CreateCrmCampaignMemberMutationHookResult = ReturnType<typeof useCreateCrmCampaignMemberMutation>;
export type CreateCrmCampaignMemberMutationResult = Apollo.MutationResult<CreateCrmCampaignMemberMutation>;
export type CreateCrmCampaignMemberMutationOptions = Apollo.BaseMutationOptions<CreateCrmCampaignMemberMutation, CreateCrmCampaignMemberMutationVariables>;
export const CampaignsDocument = gql`
    query Campaigns($filters: CampaignFiltersInput) {
  campaigns(filters: $filters) {
    data {
      id
      attributes {
        name
      }
    }
  }
}
    `;

/**
 * __useCampaignsQuery__
 *
 * To run a query within a React component, call `useCampaignsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCampaignsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCampaignsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useCampaignsQuery(baseOptions?: Apollo.QueryHookOptions<CampaignsQuery, CampaignsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CampaignsQuery, CampaignsQueryVariables>(CampaignsDocument, options);
      }
export function useCampaignsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CampaignsQuery, CampaignsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CampaignsQuery, CampaignsQueryVariables>(CampaignsDocument, options);
        }
export type CampaignsQueryHookResult = ReturnType<typeof useCampaignsQuery>;
export type CampaignsLazyQueryHookResult = ReturnType<typeof useCampaignsLazyQuery>;
export type CampaignsQueryResult = Apollo.QueryResult<CampaignsQuery, CampaignsQueryVariables>;
export const ContactsDocument = gql`
    query Contacts($filters: ContactFiltersInput) {
  contacts(filters: $filters) {
    data {
      id
      attributes {
        email
      }
    }
  }
}
    `;

/**
 * __useContactsQuery__
 *
 * To run a query within a React component, call `useContactsQuery` and pass it any options that fit your needs.
 * When your component renders, `useContactsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContactsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useContactsQuery(baseOptions?: Apollo.QueryHookOptions<ContactsQuery, ContactsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContactsQuery, ContactsQueryVariables>(ContactsDocument, options);
      }
export function useContactsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContactsQuery, ContactsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContactsQuery, ContactsQueryVariables>(ContactsDocument, options);
        }
export type ContactsQueryHookResult = ReturnType<typeof useContactsQuery>;
export type ContactsLazyQueryHookResult = ReturnType<typeof useContactsLazyQuery>;
export type ContactsQueryResult = Apollo.QueryResult<ContactsQuery, ContactsQueryVariables>;
export const GamesDocument = gql`
    query Games($filters: GameFiltersInput, $pagination: PaginationArg) {
  games(filters: $filters, pagination: $pagination) {
    data {
      id
      attributes {
        name
      }
    }
  }
}
    `;

/**
 * __useGamesQuery__
 *
 * To run a query within a React component, call `useGamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGamesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useGamesQuery(baseOptions?: Apollo.QueryHookOptions<GamesQuery, GamesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GamesQuery, GamesQueryVariables>(GamesDocument, options);
      }
export function useGamesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GamesQuery, GamesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GamesQuery, GamesQueryVariables>(GamesDocument, options);
        }
export type GamesQueryHookResult = ReturnType<typeof useGamesQuery>;
export type GamesLazyQueryHookResult = ReturnType<typeof useGamesLazyQuery>;
export type GamesQueryResult = Apollo.QueryResult<GamesQuery, GamesQueryVariables>;
export const RoomsDocument = gql`
    query Rooms($filters: RoomFiltersInput, $pagination: PaginationArg) {
  rooms(filters: $filters, pagination: $pagination) {
    data {
      id
      attributes {
        name
        booking_slot_rules {
          ... on ComponentGeneralDailyBookingSlot {
            slot_length
            start_time
            end_time
            day_of_week
            active
            id
          }
          ... on ComponentGeneralCalendarBookingSlot {
            id
            day
            start_time
            end_time
            active
            slot_length
          }
          ... on Error {
            code
            message
          }
        }
      }
    }
  }
}
    `;

/**
 * __useRoomsQuery__
 *
 * To run a query within a React component, call `useRoomsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRoomsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRoomsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useRoomsQuery(baseOptions?: Apollo.QueryHookOptions<RoomsQuery, RoomsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RoomsQuery, RoomsQueryVariables>(RoomsDocument, options);
      }
export function useRoomsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RoomsQuery, RoomsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RoomsQuery, RoomsQueryVariables>(RoomsDocument, options);
        }
export type RoomsQueryHookResult = ReturnType<typeof useRoomsQuery>;
export type RoomsLazyQueryHookResult = ReturnType<typeof useRoomsLazyQuery>;
export type RoomsQueryResult = Apollo.QueryResult<RoomsQuery, RoomsQueryVariables>;
export const ProductsDocument = gql`
    query Products($filters: ProductFiltersInput, $pagination: PaginationArg, $sort: [String]) {
  products(filters: $filters, pagination: $pagination, sort: $sort) {
    data {
      id
      attributes {
        title
        description
        price
      }
    }
  }
}
    `;

/**
 * __useProductsQuery__
 *
 * To run a query within a React component, call `useProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useProductsQuery(baseOptions?: Apollo.QueryHookOptions<ProductsQuery, ProductsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductsQuery, ProductsQueryVariables>(ProductsDocument, options);
      }
export function useProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductsQuery, ProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductsQuery, ProductsQueryVariables>(ProductsDocument, options);
        }
export type ProductsQueryHookResult = ReturnType<typeof useProductsQuery>;
export type ProductsLazyQueryHookResult = ReturnType<typeof useProductsLazyQuery>;
export type ProductsQueryResult = Apollo.QueryResult<ProductsQuery, ProductsQueryVariables>;
export const CreateReservationDocument = gql`
    mutation CreateReservation($data: ReservationInput!) {
  createReservation(data: $data) {
    data {
      id
    }
  }
}
    `;
export type CreateReservationMutationFn = Apollo.MutationFunction<CreateReservationMutation, CreateReservationMutationVariables>;

/**
 * __useCreateReservationMutation__
 *
 * To run a mutation, you first call `useCreateReservationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateReservationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createReservationMutation, { data, loading, error }] = useCreateReservationMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateReservationMutation(baseOptions?: Apollo.MutationHookOptions<CreateReservationMutation, CreateReservationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateReservationMutation, CreateReservationMutationVariables>(CreateReservationDocument, options);
      }
export type CreateReservationMutationHookResult = ReturnType<typeof useCreateReservationMutation>;
export type CreateReservationMutationResult = Apollo.MutationResult<CreateReservationMutation>;
export type CreateReservationMutationOptions = Apollo.BaseMutationOptions<CreateReservationMutation, CreateReservationMutationVariables>;
export const UpdateReservationDocument = gql`
    mutation UpdateReservation($updateReservationId: ID!, $data: ReservationInput!) {
  updateReservation(id: $updateReservationId, data: $data) {
    data {
      id
    }
  }
}
    `;
export type UpdateReservationMutationFn = Apollo.MutationFunction<UpdateReservationMutation, UpdateReservationMutationVariables>;

/**
 * __useUpdateReservationMutation__
 *
 * To run a mutation, you first call `useUpdateReservationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateReservationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateReservationMutation, { data, loading, error }] = useUpdateReservationMutation({
 *   variables: {
 *      updateReservationId: // value for 'updateReservationId'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateReservationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateReservationMutation, UpdateReservationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateReservationMutation, UpdateReservationMutationVariables>(UpdateReservationDocument, options);
      }
export type UpdateReservationMutationHookResult = ReturnType<typeof useUpdateReservationMutation>;
export type UpdateReservationMutationResult = Apollo.MutationResult<UpdateReservationMutation>;
export type UpdateReservationMutationOptions = Apollo.BaseMutationOptions<UpdateReservationMutation, UpdateReservationMutationVariables>;
export const UpdateCrmCampaignMemberDocument = gql`
    mutation UpdateCrmCampaignMember($updateCrmCampaignMemberId: ID!, $data: CrmCampaignMemberInput!) {
  updateCrmCampaignMember(id: $updateCrmCampaignMemberId, data: $data) {
    data {
      id
    }
  }
}
    `;
export type UpdateCrmCampaignMemberMutationFn = Apollo.MutationFunction<UpdateCrmCampaignMemberMutation, UpdateCrmCampaignMemberMutationVariables>;

/**
 * __useUpdateCrmCampaignMemberMutation__
 *
 * To run a mutation, you first call `useUpdateCrmCampaignMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCrmCampaignMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCrmCampaignMemberMutation, { data, loading, error }] = useUpdateCrmCampaignMemberMutation({
 *   variables: {
 *      updateCrmCampaignMemberId: // value for 'updateCrmCampaignMemberId'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateCrmCampaignMemberMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCrmCampaignMemberMutation, UpdateCrmCampaignMemberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCrmCampaignMemberMutation, UpdateCrmCampaignMemberMutationVariables>(UpdateCrmCampaignMemberDocument, options);
      }
export type UpdateCrmCampaignMemberMutationHookResult = ReturnType<typeof useUpdateCrmCampaignMemberMutation>;
export type UpdateCrmCampaignMemberMutationResult = Apollo.MutationResult<UpdateCrmCampaignMemberMutation>;
export type UpdateCrmCampaignMemberMutationOptions = Apollo.BaseMutationOptions<UpdateCrmCampaignMemberMutation, UpdateCrmCampaignMemberMutationVariables>;
export const ReservationDocument = gql`
    query Reservation($reservationId: ID, $filters: ComponentMenuProductWithQuantityFiltersInput, $timeSlotsFilters: TimeSlotFiltersInput, $usersWithRolesFilters: ComponentCrmDataCrmAccountRoleFiltersInput, $pagination: PaginationArg) {
  reservation(id: $reservationId) {
    data {
      id
      attributes {
        first_name
        last_name
        email
        phone
        title
        status
        type
        products(filters: $filters, pagination: $pagination) {
          id
          quantity
          info
          discount_amount
          discount_percentage
          product {
            data {
              id
              attributes {
                title
                price
              }
            }
          }
        }
        start_date
        end_date
        time_slots(filters: $timeSlotsFilters) {
          data {
            id
            attributes {
              type
              info
              number_of_persons
              number_of_tables
              additional_info
              start_date
              end_date
              game {
                data {
                  id
                  attributes {
                    name
                  }
                }
              }
              room {
                data {
                  id
                  attributes {
                    name
                  }
                }
              }
            }
          }
        }
        crm_campaign_member {
          data {
            id
            attributes {
              info
              users_with_roles {
                id
                roles {
                  data {
                    id
                    attributes {
                      name
                    }
                  }
                }
                user {
                  data {
                    id
                    attributes {
                      firstName
                      lastName
                    }
                  }
                }
              }
              crm_campaign {
                data {
                  id
                  attributes {
                    users_with_roles(filters: $usersWithRolesFilters) {
                      id
                      user {
                        data {
                          id
                          attributes {
                            firstName
                            lastName
                          }
                        }
                      }
                      roles {
                        data {
                          id
                          attributes {
                            name
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useReservationQuery__
 *
 * To run a query within a React component, call `useReservationQuery` and pass it any options that fit your needs.
 * When your component renders, `useReservationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReservationQuery({
 *   variables: {
 *      reservationId: // value for 'reservationId'
 *      filters: // value for 'filters'
 *      timeSlotsFilters: // value for 'timeSlotsFilters'
 *      usersWithRolesFilters: // value for 'usersWithRolesFilters'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useReservationQuery(baseOptions?: Apollo.QueryHookOptions<ReservationQuery, ReservationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReservationQuery, ReservationQueryVariables>(ReservationDocument, options);
      }
export function useReservationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReservationQuery, ReservationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReservationQuery, ReservationQueryVariables>(ReservationDocument, options);
        }
export type ReservationQueryHookResult = ReturnType<typeof useReservationQuery>;
export type ReservationLazyQueryHookResult = ReturnType<typeof useReservationLazyQuery>;
export type ReservationQueryResult = Apollo.QueryResult<ReservationQuery, ReservationQueryVariables>;
export const ReservationsDocument = gql`
    query Reservations($filters: ReservationFiltersInput, $pagination: PaginationArg, $timeSlotsFilters: TimeSlotFiltersInput) {
  reservations(filters: $filters, pagination: $pagination) {
    data {
      id
      attributes {
        title
        start_date
        end_date
        status
        type
        time_slots(filters: $timeSlotsFilters) {
          data {
            id
            attributes {
              number_of_persons
              room {
                data {
                  id
                  attributes {
                    name
                    color
                  }
                }
              }
            }
          }
        }
        crm_campaign_member {
          data {
            id
            attributes {
              info
            }
          }
        }
      }
    }
    meta {
      pagination {
        page
        pageCount
        pageSize
        total
      }
    }
  }
}
    `;

/**
 * __useReservationsQuery__
 *
 * To run a query within a React component, call `useReservationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useReservationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReservationsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      timeSlotsFilters: // value for 'timeSlotsFilters'
 *   },
 * });
 */
export function useReservationsQuery(baseOptions?: Apollo.QueryHookOptions<ReservationsQuery, ReservationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReservationsQuery, ReservationsQueryVariables>(ReservationsDocument, options);
      }
export function useReservationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReservationsQuery, ReservationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReservationsQuery, ReservationsQueryVariables>(ReservationsDocument, options);
        }
export type ReservationsQueryHookResult = ReturnType<typeof useReservationsQuery>;
export type ReservationsLazyQueryHookResult = ReturnType<typeof useReservationsLazyQuery>;
export type ReservationsQueryResult = Apollo.QueryResult<ReservationsQuery, ReservationsQueryVariables>;
export const UpdateTimeSlotDocument = gql`
    mutation UpdateTimeSlot($updateTimeSlotId: ID!, $data: TimeSlotInput!) {
  updateTimeSlot(id: $updateTimeSlotId, data: $data) {
    data {
      id
    }
  }
}
    `;
export type UpdateTimeSlotMutationFn = Apollo.MutationFunction<UpdateTimeSlotMutation, UpdateTimeSlotMutationVariables>;

/**
 * __useUpdateTimeSlotMutation__
 *
 * To run a mutation, you first call `useUpdateTimeSlotMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTimeSlotMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTimeSlotMutation, { data, loading, error }] = useUpdateTimeSlotMutation({
 *   variables: {
 *      updateTimeSlotId: // value for 'updateTimeSlotId'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateTimeSlotMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTimeSlotMutation, UpdateTimeSlotMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTimeSlotMutation, UpdateTimeSlotMutationVariables>(UpdateTimeSlotDocument, options);
      }
export type UpdateTimeSlotMutationHookResult = ReturnType<typeof useUpdateTimeSlotMutation>;
export type UpdateTimeSlotMutationResult = Apollo.MutationResult<UpdateTimeSlotMutation>;
export type UpdateTimeSlotMutationOptions = Apollo.BaseMutationOptions<UpdateTimeSlotMutation, UpdateTimeSlotMutationVariables>;
export const CreateTimeSlotDocument = gql`
    mutation CreateTimeSlot($data: TimeSlotInput!) {
  createTimeSlot(data: $data) {
    data {
      id
    }
  }
}
    `;
export type CreateTimeSlotMutationFn = Apollo.MutationFunction<CreateTimeSlotMutation, CreateTimeSlotMutationVariables>;

/**
 * __useCreateTimeSlotMutation__
 *
 * To run a mutation, you first call `useCreateTimeSlotMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTimeSlotMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTimeSlotMutation, { data, loading, error }] = useCreateTimeSlotMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateTimeSlotMutation(baseOptions?: Apollo.MutationHookOptions<CreateTimeSlotMutation, CreateTimeSlotMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTimeSlotMutation, CreateTimeSlotMutationVariables>(CreateTimeSlotDocument, options);
      }
export type CreateTimeSlotMutationHookResult = ReturnType<typeof useCreateTimeSlotMutation>;
export type CreateTimeSlotMutationResult = Apollo.MutationResult<CreateTimeSlotMutation>;
export type CreateTimeSlotMutationOptions = Apollo.BaseMutationOptions<CreateTimeSlotMutation, CreateTimeSlotMutationVariables>;
export const TimeSlotsDocument = gql`
    query TimeSlots($filters: TimeSlotFiltersInput, $pagination: PaginationArg, $reservationsFilters: ReservationFiltersInput, $reservationsPagination: PaginationArg, $sort: [String]) {
  timeSlots(filters: $filters, pagination: $pagination) {
    data {
      id
      attributes {
        info
        number_of_persons
        number_of_tables
        additional_info
        start_date
        end_date
        type
        timesheet_type
        user {
          data {
            id
            attributes {
              firstName
              lastName
            }
          }
        }
        game {
          data {
            id
            attributes {
              name
              color
            }
          }
        }
        room {
          data {
            id
            attributes {
              name
              color
            }
          }
        }
        reservations(
          filters: $reservationsFilters
          pagination: $reservationsPagination
          sort: $sort
        ) {
          data {
            id
            attributes {
              title
              first_name
              last_name
              email
              phone
            }
          }
        }
      }
    }
    meta {
      pagination {
        page
        pageCount
        pageSize
        total
      }
    }
  }
}
    `;

/**
 * __useTimeSlotsQuery__
 *
 * To run a query within a React component, call `useTimeSlotsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTimeSlotsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTimeSlotsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      reservationsFilters: // value for 'reservationsFilters'
 *      reservationsPagination: // value for 'reservationsPagination'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useTimeSlotsQuery(baseOptions?: Apollo.QueryHookOptions<TimeSlotsQuery, TimeSlotsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TimeSlotsQuery, TimeSlotsQueryVariables>(TimeSlotsDocument, options);
      }
export function useTimeSlotsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TimeSlotsQuery, TimeSlotsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TimeSlotsQuery, TimeSlotsQueryVariables>(TimeSlotsDocument, options);
        }
export type TimeSlotsQueryHookResult = ReturnType<typeof useTimeSlotsQuery>;
export type TimeSlotsLazyQueryHookResult = ReturnType<typeof useTimeSlotsLazyQuery>;
export type TimeSlotsQueryResult = Apollo.QueryResult<TimeSlotsQuery, TimeSlotsQueryVariables>;